(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4800,557,2948,4557,2733,2031,9875,2188,261,876],{

/***/ 53592:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'HighlightOff');

/***/ }),

/***/ 73276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop",
      function () {
        return __webpack_require__(19315);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BackArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function BackArrow(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        height: props.height || 24,
        width: props.width || 24,
        viewBox: "0 0 447.243 447.243"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#000000",
            d: "M420.361 192.229a31.967 31.967 0 00-5.535-.41H99.305l6.88-3.2a63.998 63.998 0 0018.08-12.8l88.48-88.48c11.653-11.124 13.611-29.019 4.64-42.4-10.441-14.259-30.464-17.355-44.724-6.914a32.018 32.018 0 00-3.276 2.754l-160 160c-12.504 12.49-12.515 32.751-.025 45.255l.025.025 160 160c12.514 12.479 32.775 12.451 45.255-.063a32.084 32.084 0 002.745-3.137c8.971-13.381 7.013-31.276-4.64-42.4l-88.32-88.64a64.002 64.002 0 00-16-11.68l-9.6-4.32h314.24c16.347.607 30.689-10.812 33.76-26.88 2.829-17.445-9.019-33.88-26.464-36.71z"
        })
    }));
}


/***/ }),

/***/ 86350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ZeroCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function ZeroCart(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 226.768,
        height: props.height || 184.32,
        viewBox: "0 0 226.768 184.32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    children: ".prefix__b{fill:#bfbfbf}.prefix__c{fill:#b1b1b1}.prefix__d{fill:#28384f}.prefix__e{fill:#fff}"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                transform: "translate(8679.17 -11063)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M-8470.978 11105.794h-85.675a5.952 5.952 0 110-11.9h12.574a15.445 15.445 0 0015.445-15.445 15.453 15.453 0 00-15.445-15.449H-8649.3a15.453 15.453 0 00-15.445 15.445 15.445 15.445 0 0015.445 15.446h44.439a5.952 5.952 0 110 11.9h-12.087a18.576 18.576 0 00-18.576 18.576 18.576 18.576 0 0018.576 18.576h78.258a5.946 5.946 0 01.231 11.889h-123.9a16.816 16.816 0 00-16.811 16.82 16.816 16.816 0 0016.816 16.809h36.691a5.952 5.952 0 01.88 11.831h-5.93a16.814 16.814 0 100 33.629h117.85a16.814 16.814 0 100-33.629h-10.244a5.952 5.952 0 01.88-11.831h36.59a16.809 16.809 0 0016.809-16.809 16.816 16.816 0 00-16.809-16.816h-5.05a5.946 5.946 0 01.231-11.889h19.478a18.576 18.576 0 0018.578-18.577 18.576 18.576 0 00-18.578-18.576zm-93.5 88.618a5.944 5.944 0 01-5.05 5.88h-8.794a5.952 5.952 0 01.88-11.831h7.012a5.952 5.952 0 015.95 5.951z",
                        fill: "#f4f4f4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        className: "prefix__b",
                        width: 123.361,
                        height: 10.821,
                        rx: 5.411,
                        transform: "translate(-8627.467 11236.499)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        className: "prefix__b",
                        width: 23.929,
                        height: 10.821,
                        rx: 5.411,
                        transform: "translate(-8659.626 11236.499)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "prefix__c",
                        d: "M-8493.009 11247.32h.39a5.411 5.411 0 01-5.411-5.411 5.411 5.411 0 015.411-5.411h-.39a5.4 5.4 0 015.4 5.411 5.4 5.4 0 01-5.4 5.411z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        transform: "translate(-8657.581 11112.776)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M142.779 88.601h-93.68l-10.91-74.1h118.268zm-89.1-5.288h84.7l11.72-63.488H44.314z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M44.963 36.323h104.605v2.886H44.963zM49.298 64.062h95.933v2.886H49.298z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M95.821 17.147h2.886v68.808h-2.886zM62.018 17.293l2.87-.298L72.036 85.8l-2.87.298zM121.178 85.778l8.458-68.843 2.866.352-8.458 68.843zM39.407 21.571L26.766 9.011h-16.72v-9h20.42l15.283 15.184z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M136.697 113.521H51.044a17.025 17.025 0 110-34.051h.354v9h-.346a8.029 8.029 0 100 16.051h85.646z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__d",
                                cx: 16.01,
                                cy: 16.01,
                                r: 16.01,
                                transform: "rotate(-80.8 133.624 -5.902)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__e",
                                cx: 8.029,
                                cy: 8.029,
                                r: 8.029,
                                transform: "rotate(-89 126.043 -4.47)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__d",
                                cx: 15.965,
                                cy: 15.965,
                                r: 15.965,
                                transform: "rotate(-80.73 90.744 43.839)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__e",
                                cx: 8.029,
                                cy: 8.029,
                                r: 8.029,
                                transform: "rotate(-80.75 91.438 35.213)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M20.73 9.01H4.505a4.505 4.505 0 110-9.01h16.232a4.5 4.5 0 010 9z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}


/***/ }),

/***/ 67865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var _utils_deviceInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90864);
/* harmony import */ var _utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70145);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19372);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77733);
/* harmony import */ var _utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8824);
/* harmony import */ var src_utils_canDisablePlaceOrder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96930);
/**
 * Card Payment Input Component
 */ 













var CardPaymentBox = function(props) {
    var getCtaBtnText = function getCtaBtnText() {
        return props.isVerifyCard ? "VERIFY NOW" : "Pay";
    };
    var ref, ref1;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        cvv: "",
        expiry: "",
        number: "",
        cardType: "",
        isCardNumberValid: true,
        isCardMonthInvalid: false,
        cvvLength: 3
    }), state = ref2[0], setState = ref2[1];
    var ref3 = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return {
            store: state.storeReducer.store,
            orderDetails: state.orderReducer.orderDetails,
            loader: state.commonReducer.loader,
            storeData: state.storeReducer.store,
            paymentOptionsWithTxnCharge: state.paymentReducer.paymentOptionsWithTxnCharge,
            userData: state.userReducer.data
        };
    }), store = ref3.store, orderDetails = ref3.orderDetails, loader = ref3.loader, storeData = ref3.storeData, paymentOptionsWithTxnCharge = ref3.paymentOptionsWithTxnCharge, userData = ref3.userData;
    /**
   * UseEffect for prefilled card data
   */ (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        (store === null || store === void 0 ? void 0 : store.store_id) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) && dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .fetchPaymentMethods */ .F7)({
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
        }));
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        if (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("dscc")) {
            var cardDetails = JSON.parse((0,_utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_11__/* .getEncrypDecryptStr */ .v)(JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("dscc")), "decrypt"));
            newState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state), {
                cvv: (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .formatCvc */ .bX)(cardDetails.cCvv),
                expiry: cardDetails.cExpMonth + "/" + cardDetails.cExpYear.slice(-2),
                number: (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .cardNumberFormat */ .XW)(cardDetails.cNum),
                cardType: (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .getCardType */ .C1)(cardDetails.cNum),
                cvvLength: (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .getCardType */ .C1)(cardDetails.cNum) === "AMEX" ? 4 : 3
            });
        }
        setState(newState);
    }, []);
    var handleInputChange = function(key, value, event) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        if (key === "number") {
            newState[key] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .cardNumberFormat */ .XW)(value);
            newState["isCardNumberValid"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .isCardValid */ .TH)(value);
            newState["cardType"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .getCardType */ .C1)(value);
            newState["cvvLength"] = newState["cardType"] === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CARD_TYPE.AMEX */ .WK.AMEX ? 4 : 3;
        } else if (key === "expiry") {
            newState["expiry"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .formatExpiry */ .Tn)(event);
        } else if (key === "cvv") {
            newState["cvv"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .formatCvc */ .bX)(value);
        }
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevState, newState);
        });
    };
    /**
   * this function is written to check the exact card type in pascal,
   * as required by the enterprise team for the mdr check api
   * @param {*} cardInfo
   * @return {string}
   */ var returnCardTypeString = function(cardInfo) {
        if (cardInfo.card_type === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CARD_TYPE.AMEX */ .WK.AMEX && cardInfo.category === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD.toLowerCase */ .Mf.CREDIT_CARD.toLowerCase()) {
            return _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.AMEX_CARD */ .Mf.AMEX_CARD;
        } else {
            switch(cardInfo.category){
                case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.DEBIT_CARD.toLowerCase */ .Mf.DEBIT_CARD.toLowerCase():
                    return _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */ .Mf.DEBIT_CARD;
                case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD.toLowerCase */ .Mf.CREDIT_CARD.toLowerCase():
                    return _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */ .Mf.CREDIT_CARD;
                default:
                    return "";
            }
        }
    };
    var callForSpecificCardDetails = function(value, callback) {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .checkCardInfo */ .Jd)(value, function(status, data) {
            if (status && !!data) {
                if ((data === null || data === void 0 ? void 0 : data.card_type) === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CARD_TYPE.AMEX */ .WK.AMEX) {
                    var payment_modes = paymentOptionsWithTxnCharge.payment_modes;
                    if (payment_modes === null || payment_modes === void 0 ? void 0 : payment_modes.length) {
                        var amexCardData = payment_modes === null || payment_modes === void 0 ? void 0 : payment_modes.find(function(payment) {
                            return payment.payment_option_name === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PAYMENT_TYPE_CONSTANTS.AMEX_CARD */ .Mf.AMEX_CARD;
                        });
                        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .setCustomerTransactionPaymentMethod */ .j1)(amexCardData));
                    }
                }
                var payload = {
                    order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                    store_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.store_id,
                    payment_option: {
                        payment_option_name: returnCardTypeString(data)
                    }
                };
                dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .prePaymentCheckMDRTransactions */ .HV)(payload, callback));
            }
        }));
    };
    var validateAll = function() {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        var isAllValid = true;
        if (!state.number) {
            newState["isCardNumberValid"] = false;
            isAllValid = false;
        }
        if (!state.expiry) {
            newState["isCardMonthInvalid"] = "Enter a valid expiry";
            isAllValid = false;
        }
        if (state.cvvLength !== state.cvv.length) {
            newState["isCardCVVInvalid"] = "Enter a valid CVV";
            isAllValid = false;
        }
        setState(newState);
        return isAllValid;
    };
    var validateCardNumber = function(number) {
        var ref;
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        newState["isCardNumberValid"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .isCardValid */ .TH)(number);
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevState, newState);
        });
        if ((storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) && number.split(" ").join("").length >= 6) {
            var cardNo = newState["number"].trim().split(" ").join("").substring(0, 6);
            callForSpecificCardDetails(cardNo);
        }
    };
    var validateCardMonth = function(number) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        newState["isCardMonthInvalid"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_7__/* .isExpiryInvalid */ .G9)(number);
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevState, newState);
        });
    };
    var validateCardCVV = function(number) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state);
        newState["isCardCVVInvalid"] = number.length !== state.cvvLength ? "Enter valid CVV" : false;
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevState, newState);
        });
    };
    var checkForValidCardLogic = function() {
        var ref, ref1;
        return ((ref1 = (ref = state.number) === null || ref === void 0 ? void 0 : ref.split(" ")) === null || ref1 === void 0 ? void 0 : ref1.join("").length) >= 14 && state.isCardNumberValid && !state.isCardMonthInvalid;
    };
    var onPayBtnClick = function() {
        if ((0,src_utils_canDisablePlaceOrder__WEBPACK_IMPORTED_MODULE_8__/* .canDisablePlaceOrder */ .w)()) {
            return;
        }
        if (validateAll() && checkForValidCardLogic()) {
            var ref, ref1, ref2, ref3;
            var data = {
                orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                phone: userData === null || userData === void 0 ? void 0 : userData.phone,
                paymentMethod: "card",
                merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                deviceType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_2__/* .getDeviceInfo */ .d)().OSName,
                browserType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_2__/* .getDeviceInfo */ .d)().BrowserName,
                userAgent: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_2__/* .getDeviceInfo */ .d)().userAgent,
                source: "longtail",
                cNum: state.number.split(" ").join(""),
                cCvv: state.cvv,
                cName: "Dotpe",
                cExpMonth: state.expiry.split("/")[0].trim(),
                cExpYear: "20" + state.expiry.split("/")[1].trim(),
                merchantName: "Digital Showroom - ".concat(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.name)
            };
            var encryptCCDetails = (0,_utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_11__/* .getEncrypDecryptStr */ .v)(JSON.stringify(data), "encrypt");
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("dscc", JSON.stringify(encryptCCDetails));
            if (props.isVerifyCard) {
                props.onVerifyCard(data);
            } else {
                var ref4;
                if (storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.services) === null || ref4 === void 0 ? void 0 : ref4.mdr_flag) {
                    callForSpecificCardDetails(state.number.trim().split(" ").join("").substring(0, 6), function() {
                        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .initPayment */ .yK)(data, router));
                    });
                } else {
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .initPayment */ .yK)(data, router));
                }
            }
            /**
       * This was added as to fix bank redirection after confirming OTP on our temporary domains, as the redirection
       * only happens on domain i.e. showroom.dotpe.in & not on our path -> showroom.dotpe.in/${domain},
       * so redirection details are saved here.
       */ if ((storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain) && (storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.domain) === null || ref3 === void 0 ? void 0 : ref3.startsWith("d-temporary"))) {
                var ref5, ref6;
                sessionStorage.setItem("cardPaymentDetails", JSON.stringify({
                    paymentMethod: "card",
                    redirectionUrl: storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.store_info) === null || ref5 === void 0 ? void 0 : ref5.store_url,
                    storeDomain: storeData === null || storeData === void 0 ? void 0 : (ref6 = storeData.store_info) === null || ref6 === void 0 ? void 0 : ref6.domain
                }));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "card-payment-box",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "card-wrapper",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "top-wrap",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "icon-wrapper",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    loading: "lazy",
                                    src: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .cc_icons */ .P2[state.cardType] || _config__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CDN_SERVER_URL */ .Z.CDN_SERVER_URL + "image/ic-credit-card.svg",
                                    alt: "cardType"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "form-wrap",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            children: "Card Number"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "text",
                                            inputMode: "numeric",
                                            className: "form-control",
                                            placeholder: "XXXX XXXX XXXX XXXX",
                                            onChange: function(e) {
                                                return handleInputChange("number", e.target.value);
                                            },
                                            onBlur: function() {
                                                return validateCardNumber(state.number);
                                            },
                                            value: state.number,
                                            pattern: "[0-9.]+"
                                        }),
                                        !state.isCardNumberValid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                            className: "error",
                                            children: "Enter valid card number"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "inline-form-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: "Expires"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "text",
                                                    className: "form-control",
                                                    placeholder: "MM/YY",
                                                    value: state.expiry,
                                                    pattern: "\\d*",
                                                    maxLength: "7",
                                                    onChange: function(e) {
                                                        return handleInputChange("expiry", e.target.value, e);
                                                    },
                                                    onBlur: function() {
                                                        var ref;
                                                        return (state === null || state === void 0 ? void 0 : state.expiry) && validateCardMonth(state === null || state === void 0 ? void 0 : (ref = state.expiry) === null || ref === void 0 ? void 0 : ref.split(" ").join(""));
                                                    }
                                                }),
                                                state.isCardMonthInvalid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                    className: "error",
                                                    children: state.isCardMonthInvalid
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: "CVV"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "password",
                                                    value: state.cvv,
                                                    inputMode: "numeric",
                                                    pattern: "[0-9]*",
                                                    className: "form-control",
                                                    placeholder: state.cvvLength === 4 ? "* * * *" : "* * *",
                                                    maxLength: state.cvvLength,
                                                    onChange: function(e) {
                                                        return handleInputChange("cvv", e.target.value);
                                                    },
                                                    onBlur: function(e) {
                                                        return validateCardCVV(state.cvv);
                                                    }
                                                }),
                                                state.isCardCVVInvalid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                                                    className: "error",
                                                    children: state.isCardCVVInvalid
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: onPayBtnClick,
                    className: "cta-btn ".concat(((ref1 = (ref = state.number) === null || ref === void 0 ? void 0 : ref.split(" ")) === null || ref1 === void 0 ? void 0 : ref1.join("").length) < 14 ? "o-50" : "", " ").concat(checkForValidCardLogic() ? "o-100 pointer" : "o-50"),
                    disabled: loader || !checkForValidCardLogic(),
                    children: !loader ? getCtaBtnText() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/images/ellipLoader1.gif",
                        className: "img h1"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardPaymentBox);


/***/ }),

/***/ 29465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ESTIMATE_DELIVERY_FLAG; }
/* harmony export */ });
var ESTIMATE_DELIVERY_FLAG = {
    ACTIVE: 1,
    INACTIVE: 0
};


/***/ }),

/***/ 65700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var LoaderIcon = function(props) {
    var waterSplashLoader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "waterSplashLoader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var ellipsis = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "ds-ellipsis-loader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var _renderLoader = function(type) {
        switch(type){
            case "water_splash_loader":
                return waterSplashLoader();
            case "ellipsis":
            default:
                return ellipsis();
        }
    };
    return _renderLoader(props.type || "");
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderIcon);


/***/ }),

/***/ 11110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _components_PaymentPromoCouponDetailModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64109);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68615);
/* harmony import */ var _components_CardPaymentBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67865);
/* harmony import */ var _components_Common_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72651);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13886);
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40804);
/* harmony import */ var src_components_CouponsAndVouchers_Common_PromosContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69708);
/* harmony import */ var src_components_CouponsAndVouchers_Common_CartPromosContainer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62856);
/* harmony import */ var src_containers_Cart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17305);
/**
 * This component renders the list of payment promotions
 */ 













var BankOffers = function(props) {
    var onVerifyCard = function onVerifyCard(cardData) {
        var dataToSend = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
            card_number: cardData.cNum
        }, state.cardCouponData);
        dispatchVerifyCoupon(dataToSend);
    };
    var ref;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_containers_Cart__WEBPACK_IMPORTED_MODULE_10__.CartContext), _showAuthModal = ref1.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        showPromoDetailsModal: false,
        promoDataToBeViewed: {},
        cardCouponData: {}
    }), state = ref2[0], setState = ref2[1];
    var isUserLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.userReducer.isLogin;
    });
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showCardVerifyModal = ref3[0], setShowCardVerifyModal = ref3[1];
    var isCartPage = props === null || props === void 0 ? void 0 : props.isCartPage;
    var getAmtToAvailTheOffer = function(minOrderValue, cartPayAmount) {
        return minOrderValue - cartPayAmount;
    };
    var onApplyCoupon = function(promoId) {
        var ref, ref1;
        if (!isUserLoggedIn) {
            showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal();
            return;
        }
        var coupon = props === null || props === void 0 ? void 0 : (ref = props.paymentOffersList) === null || ref === void 0 ? void 0 : ref.find(function(offer) {
            return (offer === null || offer === void 0 ? void 0 : offer.promo_id) === promoId;
        });
        if (getAmtToAvailTheOffer(coupon.min_order_price, (ref1 = props.cartData) === null || ref1 === void 0 ? void 0 : ref1.pay_amount) <= 0) {
            if (coupon.payment_method === _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */ .Mf.DEBIT_CARD || coupon.payment_method === _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */ .Mf.CREDIT_CARD || coupon.payment_method === _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .PAYMENT_TYPE_CONSTANTS.CARD */ .Mf.CARD) {
                setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, state), {
                    cardCouponData: coupon
                }));
                setShowCardVerifyModal(true);
            } else {
                dispatchVerifyCoupon(coupon);
            }
        }
    };
    var dispatchVerifyCoupon = function(couponData) {
        var ref;
        var dataToPost = {
            promo_code: couponData.promo_code,
            pay_amount: (ref = props.cartData) === null || ref === void 0 ? void 0 : ref.pay_amount,
            promo_id: couponData.promo_id,
            payment_method: couponData.payment_method
        };
        if (couponData.card_number) {
            dataToPost["card_number"] = couponData.card_number;
        }
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_13__/* .verifyPaymentOffer */ .hI)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props === null || props === void 0 ? void 0 : props.cartData), {
            payment_offer: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, dataToPost)
        }), function(resp) {
            if (resp.status) {
                props === null || props === void 0 ? void 0 : props.setSuccessPopupState({
                    show: true,
                    appliedPromoCode: couponData.promo_code
                });
            } else {
                (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_7__/* .toastNotifyError */ .Lu)(resp.message);
            }
        }));
    };
    var togglePromoDetailsModal = function(promoId) {
        var ref;
        var promoData = props === null || props === void 0 ? void 0 : (ref = props.paymentOffersList) === null || ref === void 0 ? void 0 : ref.find(function(offer) {
            return (offer === null || offer === void 0 ? void 0 : offer.promo_id) === promoId;
        });
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, state), {
                showPromoDetailsModal: !state.showPromoDetailsModal,
                promoDataToBeViewed: promoData
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "paymentPromotionMainContainer",
        children: [
            isCartPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_CouponsAndVouchers_Common_CartPromosContainer__WEBPACK_IMPORTED_MODULE_9__/* .CartPromosContainer */ .e, {
                promos: props.showAllPromos ? props.paymentOffersList : props.paymentOffersList.slice(0, 3),
                onDetailClick: togglePromoDetailsModal,
                onApplyClick: onApplyCoupon,
                isStorePromos: false,
                cartPayAmount: props === null || props === void 0 ? void 0 : (ref = props.cartData) === null || ref === void 0 ? void 0 : ref.pay_amount
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_CouponsAndVouchers_Common_PromosContainer__WEBPACK_IMPORTED_MODULE_8__/* .PromosContainer */ .$, {
                promos: props.paymentOffersList,
                onPromoClick: togglePromoDetailsModal,
                customClasses: "tw-flex tw-flex-col md:tw-px-[24px] md:tw-py-[21px]",
                primaryTextClasses: "tw-text-[13px]/[18px] tw-font-medium md:tw-text-[16px]/[20px] md:tw-font-semibold",
                secondaryTextClasses: "tw-text-[12px]/[20px] tw-font-normal md:tw-text-[15px]/[20px]",
                isStorePromos: false
            }),
            state.showPromoDetailsModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PaymentPromoCouponDetailModal__WEBPACK_IMPORTED_MODULE_3__/* .PaymentPromoCouponDetailsModal */ .f, {
                onClose: togglePromoDetailsModal,
                promoData: state.promoDataToBeViewed
            }),
            showCardVerifyModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                visible: true,
                height: 200,
                animation: "slideUp",
                onClose: function() {
                    return setShowCardVerifyModal(false);
                },
                className: "bottom-modal cardVerifyModal",
                customMaskStyles: {
                    background: "#000000e6"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "close-icon flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/images/cancel_white.png",
                            className: "img h2 ",
                            onClick: function() {
                                return setShowCardVerifyModal(false);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "f4 b mb3",
                        children: "Verify Card"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardPaymentBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        isVerifyCard: true,
                        onVerifyCard: onVerifyCard
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BankOffers);


/***/ }),

/***/ 53149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13508);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92134);



var CartPromoStrip = function(param) {
    var _promoId = param.promoId, promoId = _promoId === void 0 ? null : _promoId, _primaryText = param.primaryText, primaryText = _primaryText === void 0 ? "" : _primaryText, _secondaryText = param.secondaryText, secondaryText = _secondaryText === void 0 ? "" : _secondaryText, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#ffffff" : _bgColor, _showHoverEffect = param.showHoverEffect, showHoverEffect = _showHoverEffect === void 0 ? true : _showHoverEffect, _errorText = param.errorText, errorText = _errorText === void 0 ? "" : _errorText, _savingAmount = param.savingAmount, savingAmount = _savingAmount === void 0 ? 0 : _savingAmount, _onDetailClick = param.onDetailClick, onDetailClick = _onDetailClick === void 0 ? null : _onDetailClick, _onApplyOrRemoveClick = param.onApplyOrRemoveClick, onApplyOrRemoveClick = _onApplyOrRemoveClick === void 0 ? null : _onApplyOrRemoveClick, _isApplyButtonDisabled = param.isApplyButtonDisabled, isApplyButtonDisabled = _isApplyButtonDisabled === void 0 ? false : _isApplyButtonDisabled, _isOfferApplied = param.isOfferApplied, isOfferApplied = _isOfferApplied === void 0 ? false : _isOfferApplied, _primaryButtonText = param.primaryButtonText, primaryButtonText = _primaryButtonText === void 0 ? "" : _primaryButtonText, _primaryButtonClasses = param.primaryButtonClasses, primaryButtonClasses = _primaryButtonClasses === void 0 ? "" : _primaryButtonClasses, _secondaryButtonText = param.secondaryButtonText, secondaryButtonText = _secondaryButtonText === void 0 ? "" : _secondaryButtonText, _secondaryButtonClasses = param.secondaryButtonClasses, secondaryButtonClasses = _secondaryButtonClasses === void 0 ? "" : _secondaryButtonClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripContainer */ .P6, {
        showHoverEffect: showHoverEffect,
        bgColor: bgColor,
        customClasses: "!tw-flex-row tw-justify-between tw-items-start tw-border-none ".concat(src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_1__/* .IS_DESKTOP */ .yn ? "tw-px-0" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripIconInfoWrapper */ .To, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripOfferIcon */ .YT, {
                        iconSize: src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_1__/* .IS_DESKTOP */ .yn ? 14 : 12,
                        customClasses: "tw-pt-[2px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "tw-m-0 tw-flex tw-gap-[8px] tw-text-[14px]/[20px] tw-font-medium",
                                children: [
                                    primaryText,
                                    " ",
                                    !!savingAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "tw-text-[12px]/[20px] tw-font-semibold tw-text-[#0D9738] md:tw-text-[14px]/[20px]",
                                        children: [
                                            isOfferApplied ? "Saved" : "Save",
                                            " ₹",
                                            savingAmount
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-gap-[4px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "tw-m-0 tw-text-[12px]/[20px] tw-font-normal tw-text-[#646464]",
                                        children: secondaryText
                                    }),
                                    errorText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "tw-m-0 tw-text-[13px]/[20px] tw-text-[#F63D60]",
                                        children: errorText
                                    }) : null,
                                    !!onDetailClick && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripCTA */ .iQ, {
                                        ctaTextOrIcon: secondaryButtonText || "Details",
                                        onClick: function() {
                                            return onDetailClick(promoId);
                                        },
                                        customClasses: "!tw-text-[13px]/[20px] !tw-ml-0 $ ".concat(secondaryButtonClasses)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripCTA */ .iQ, {
                ctaTextOrIcon: primaryButtonText || "Apply",
                onClick: function() {
                    return isOfferApplied ? onApplyOrRemoveClick() : onApplyOrRemoveClick(promoId);
                },
                customClasses: "tw-pr-[17px] ".concat(primaryButtonClasses),
                isDisabled: !!errorText || isApplyButtonDisabled
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CartPromoStrip);


/***/ }),

/***/ 62856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ CartPromosContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _CartPromoStrip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53149);


var CartPromosContainer = function(param) {
    var promos = param.promos, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _onDetailClick = param.onDetailClick, onDetailClick = _onDetailClick === void 0 ? null : _onDetailClick, _onApplyClick = param.onApplyClick, onApplyClick = _onApplyClick === void 0 ? null : _onApplyClick, _isStorePromos = param.isStorePromos, isStorePromos = _isStorePromos === void 0 ? true : _isStorePromos, _cartPayAmount = param.cartPayAmount, cartPayAmount = _cartPayAmount === void 0 ? null : _cartPayAmount;
    return !!(promos === null || promos === void 0 ? void 0 : promos.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-flex-col tw-gap-[20px] tw-transition-all md:tw-gap-[16px]" + customClasses,
        children: isStorePromos ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: promos.map(function(param, index) {
                var id = param.id, code = param.code, description = param.description, error_text = param.error_text, discount = param.discount;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CartPromoStrip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    primaryText: code,
                    secondaryText: description,
                    promoId: id,
                    onDetailClick: onDetailClick,
                    onApplyOrRemoveClick: onApplyClick,
                    errorText: error_text,
                    savingAmount: discount
                }, index);
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: promos.map(function(param, index) {
                var promo_id = param.promo_id, promo_code = param.promo_code, offer_callout = param.offer_callout, description = param.description, min_order_price = param.min_order_price;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CartPromoStrip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    primaryText: promo_code || offer_callout,
                    secondaryText: description,
                    promoId: promo_id,
                    onApplyOrRemoveClick: onApplyClick,
                    onDetailClick: onDetailClick,
                    isApplyButtonDisabled: min_order_price > cartPayAmount
                }, index);
            })
        })
    });
};


/***/ }),

/***/ 69708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PromosContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BasicPromoStrip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45305);


var PromosContainer = function(param) {
    var promos = param.promos, onPromoClick = param.onPromoClick, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _primaryTextClasses = param.primaryTextClasses, primaryTextClasses = _primaryTextClasses === void 0 ? "" : _primaryTextClasses, _secondaryTextClasses = param.secondaryTextClasses, secondaryTextClasses = _secondaryTextClasses === void 0 ? "" : _secondaryTextClasses, _offerStripContainerClasses = param.offerStripContainerClasses, offerStripContainerClasses = _offerStripContainerClasses === void 0 ? "" : _offerStripContainerClasses, _offerStripCtaTextOrIcon = param.offerStripCtaTextOrIcon, offerStripCtaTextOrIcon = _offerStripCtaTextOrIcon === void 0 ? null : _offerStripCtaTextOrIcon, _isStorePromos = param.isStorePromos, isStorePromos = _isStorePromos === void 0 ? true : _isStorePromos;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: customClasses || "",
        children: isStorePromos ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: promos.map(function(param, index) {
                var id = param.id, description = param.description, code = param.code;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BasicPromoStrip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    primaryText: description,
                    secondaryText: code,
                    ctaTextOrIcon: offerStripCtaTextOrIcon || "Details",
                    onCtaClick: onPromoClick,
                    promoId: id,
                    primaryTextClasses: primaryTextClasses,
                    secondaryTextClasses: secondaryTextClasses,
                    customClasses: "tw-p-[16px] " + offerStripContainerClasses
                }, index);
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: promos.map(function(param, index) {
                var promo_id = param.promo_id, promo_code = param.promo_code, description = param.description;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BasicPromoStrip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    primaryText: description,
                    secondaryText: promo_code,
                    ctaTextOrIcon: offerStripCtaTextOrIcon || "Details",
                    onCtaClick: onPromoClick,
                    promoId: promo_id,
                    primaryTextClasses: primaryTextClasses,
                    secondaryTextClasses: secondaryTextClasses,
                    customClasses: "tw-p-[16px] " + offerStripContainerClasses
                }, index);
            })
        })
    });
};


/***/ }),

/***/ 90042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponsAndVouchers_PromosDrawerAndButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconBlack.js
var CloseIconBlack = __webpack_require__(23483);
;// CONCATENATED MODULE: ./src/components/FloatingButtonAndDrawer/index.tsx






var FloatingButtonAndDrawer = function(param) {
    var buttonConfig = param.buttonConfig, showDrawer = param.showDrawer, onClose = param.onClose, drawerHeading = param.drawerHeading, additionalHeaderComponent = param.additionalHeaderComponent, children = param.children, showCloseIcon = param.showCloseIcon;
    var renderFloatingButton = function renderFloatingButton() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-fixed  tw-bottom-1/2 tw-right-0 tw-origin-bottom-right -tw-rotate-90 ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "tw-flex tw-cursor-pointer tw-items-center tw-gap-[4px] tw-border-none tw-px-[28px] tw-py-[8px] tw-text-[15px]/[20px] tw-font-bold tw-text-white md:tw-py-[12px]  ",
                style: {
                    backgroundColor: themeColor
                },
                onClick: onButtonClick,
                children: [
                    buttonConfig.icon || null,
                    " ",
                    buttonConfig.text
                ]
            })
        });
    };
    var renderDrawerHeader = function renderDrawerHeader() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-sticky tw-top-0 tw-z-50 tw-border-b tw-border-solid tw-border-[#E3E3E3] tw-bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[12px] tw-px-[20px] tw-py-[32px] tw-text-[18px]/[20px] tw-font-semibold md:tw-px-[24px]",
                    children: [
                        (showCloseIcon !== null && showCloseIcon !== void 0 ? showCloseIcon : true) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-flex tw-cursor-pointer",
                            onClick: onCloseFinal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconBlack/* default */.Z, {
                                size: checkClientDeviceType/* IS_DESKTOP */.yn ? 16 : 12
                            })
                        }),
                        drawerHeading
                    ]
                }),
                additionalHeaderComponent
            ]
        });
    };
    var renderDrawerContent = function renderDrawerContent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-flex-col",
            children: children
        });
    };
    var ref = (0,react.useState)(false), openDrawer = ref[0], setOpenDrawer = ref[1];
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var onCloseDrawer = function() {
        return setOpenDrawer(false);
    };
    var onOpenDrawer = function() {
        return setOpenDrawer(true);
    };
    var showFinal = showDrawer !== null && showDrawer !== void 0 ? showDrawer : openDrawer;
    var onCloseFinal = onClose !== null && onClose !== void 0 ? onClose : onCloseDrawer;
    var _onClick;
    var onButtonClick = (_onClick = buttonConfig.onClick) !== null && _onClick !== void 0 ? _onClick : onOpenDrawer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderFloatingButton(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                open: showFinal,
                onClose: onCloseFinal,
                classes: {
                    paper: checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-w-[40%] tw-min-w-[596px]" : "tw-h-full"
                },
                anchor: checkClientDeviceType/* IS_DESKTOP */.yn ? "right" : "bottom",
                transitionDuration: checkClientDeviceType/* IS_DESKTOP */.yn ? 300 : 400,
                children: [
                    renderDrawerHeader(),
                    renderDrawerContent()
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FloatingButtonAndDrawer = (FloatingButtonAndDrawer);

// EXTERNAL MODULE: ./src/assets/svgExports/OfferIcon.js
var OfferIcon = __webpack_require__(93757);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/TabsContainer/index.tsx
var TabsContainer = __webpack_require__(1325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(68615);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/PromosContainer.tsx
var PromosContainer = __webpack_require__(69708);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/PromosSections/StoreOffersSection.tsx


var StoreOffersSection = function(param) {
    var storePromos = param.storePromos, onPromoClick = param.onPromoClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosContainer/* PromosContainer */.$, {
        promos: storePromos,
        onPromoClick: onPromoClick,
        customClasses: "tw-flex tw-flex-col md:tw-px-[24px] md:tw-py-[21px]",
        primaryTextClasses: "tw-text-[13px]/[18px] tw-font-medium md:tw-text-[16px]/[20px] md:tw-font-semibold",
        secondaryTextClasses: "tw-text-[12px]/[20px] tw-font-normal md:tw-text-[15px]/[20px]"
    });
};
/* harmony default export */ var PromosSections_StoreOffersSection = (StoreOffersSection);

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/BankOffers/index.tsx
var BankOffers = __webpack_require__(11110);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/PromosSections/BankOffersSection.tsx


var BankOffersSection = function(param) {
    var paymentOffersList = param.paymentOffersList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BankOffers/* default */.Z, {
        showAllPromos: true,
        paymentOffersList: paymentOffersList,
        isCartPage: false
    });
};
/* harmony default export */ var PromosSections_BankOffersSection = (BankOffersSection);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/index.tsx











var PromosDrawerAndButton = function() {
    var getPromos = function getPromos() {
        var data = {
            storeId: storeId,
            userId: userId
        };
        dispatch((0,promo/* getAllPromos */.mv)(data, function(allPromos) {
            return dispatch((0,promo/* saveCouponsList */.Kp)({
                coupons: allPromos
            }));
        }));
        dispatch((0,promo/* getPaymentOffersList */.Xu)(storeId));
    };
    var openPromoModal = function openPromoModal(promoId) {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoId
        }));
        checkClientDeviceType/* IS_DESKTOP */.yn && setShowPromos(false);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            storeId: state.storeReducer.store.store_id,
            userId: ((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.user_id) || 0,
            paymentOffersList: state.promoReducer.paymentOffersList || [],
            promos: state === null || state === void 0 ? void 0 : (ref1 = state.promoReducer) === null || ref1 === void 0 ? void 0 : ref1.couponsList
        };
    }), storeId = ref.storeId, userId = ref.userId, paymentOffersList = ref.paymentOffersList, promos = ref.promos;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    var ref1 = (0,react.useState)(0), activeTabIndex = ref1[0], setActiveTabIndex = ref1[1];
    var ref2 = (0,react.useState)(false), showPromos = ref2[0], setShowPromos = ref2[1];
    var tabsData = [
        {
            text: "Store Offers"
        },
        {
            text: "Bank Offers"
        }, 
    ];
    (0,react.useEffect)(function() {
        if (storeId && !isCouponsFeatureLocked && !promos.length) {
            getPromos();
        }
    }, [
        storeId,
        isCouponsFeatureLocked
    ]);
    var showStoreOffers = activeTabIndex === 0;
    return !isCouponsFeatureLocked && !!promos.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FloatingButtonAndDrawer, {
            buttonConfig: {
                text: "Offers",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferIcon/* default */.Z, {}),
                onClick: function() {
                    return setShowPromos(true);
                }
            },
            showDrawer: showPromos,
            onClose: function() {
                return setShowPromos(false);
            },
            drawerHeading: "Offers",
            additionalHeaderComponent: !!(paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer/* default */.Z, {
                activeTabIndex: activeTabIndex,
                setActiveTabIndex: setActiveTabIndex,
                tabsData: tabsData,
                tabClasses: "!tw-text-[14px]/[20px] md:!tw-text-[18px]/[20px] !tw-px-[20px] md:!tw-px-[32px] tw-pb-[18px]"
            }),
            children: showStoreOffers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosSections_StoreOffersSection, {
                storePromos: promos,
                onPromoClick: openPromoModal
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosSections_BankOffersSection, {
                paymentOffersList: paymentOffersList
            })
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromosDrawerAndButton = (PromosDrawerAndButton);


/***/ }),

/***/ 1325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92134);



var TabsContainer = function(param) {
    var activeTabIndex = param.activeTabIndex, setActiveTabIndex = param.setActiveTabIndex, tabsData = param.tabsData, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _tabClasses = param.tabClasses, tabClasses = _tabClasses === void 0 ? "" : _tabClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-px-[18px] tw-transition-all ".concat(customClasses),
        children: tabsData.map(function(param, index) {
            var text = param.text;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
                text: text,
                isActive: index === activeTabIndex,
                onClick: function() {
                    return setActiveTabIndex(index);
                },
                customClasses: tabClasses
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TabsContainer);


/***/ }),

/***/ 43388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var CustomRadio = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        className: "custom-radio ".concat(className ? className : ""),
        type: "radio"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomRadio);


/***/ }),

/***/ 28110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__": function() { return /* binding */ _getCODCharges; },
  "ZP": function() { return /* binding */ components_DesktopPaymentModal; }
});

// UNUSED EXPORTS: getItemTotal

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(24762);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
// EXTERNAL MODULE: ./src/utils/checkIfObjectExists.ts
var checkIfObjectExists = __webpack_require__(31891);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/deviceInfo.js
var deviceInfo = __webpack_require__(90864);
// EXTERNAL MODULE: ./node_modules/react-qr-code/lib/index.js
var lib = __webpack_require__(1653);
// EXTERNAL MODULE: ./src/redux/actions/payment.js
var payment = __webpack_require__(19372);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/components/QRPaymentUPI/index.js
/**
 * QR payment for UPI
 */ 











var initialState = {
    otp: "",
    minutes: 3,
    seconds: 0,
    isTimeUp: false,
    qrText: "",
    showGenerateQr: true
};
var QRPaymentUPI = function(props) {
    var ref;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var timerID = null;
    var ref1 = (0,react.useState)(initialState), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(false), isTimerStarted = ref2[0], setIsTimerStarted = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return {
            orderDetails: state.orderReducer.orderDetails,
            storeInfo: state.storeReducer.store,
            loader: state.commonReducer.loader,
            userData: state.userReducer.data
        };
    }), orderDetails = ref3.orderDetails, storeInfo = ref3.storeInfo, loader = ref3.loader, userData = ref3.userData;
    var checkIfMDRActive = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) === 1;
    (0,react.useEffect)(function() {
        setState(initialState);
        return function() {
            setIsTimerStarted(false);
        };
    }, [
        props.partial_payment
    ]);
    // useEffect for timer
    (0,react.useEffect)(function() {
        if (isTimerStarted) {
            timerID = setInterval(function() {
                _timer(state);
            }, 1000);
        }
        return function() {
            clearTimer();
        };
    }, [
        state.minutes,
        state.seconds,
        isTimerStarted
    ]);
    var clearTimer = function() {
        timerID && clearInterval(timerID);
    };
    /**
   * Function update the state for timer
   * @param {Object} state
   */ var _timer = function(state) {
        if (state.seconds > 0) {
            setState(function(preState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, preState), {
                    seconds: preState.seconds - 1
                });
            });
        }
        if (state.seconds === 0) {
            if (state.minutes === 0) {
                clearTimer();
                setState(function(preState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, preState), {
                        isTimeUp: true
                    });
                });
            } else {
                setState(function(preState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, preState), {
                        minutes: preState.minutes - 1,
                        seconds: 59
                    });
                });
            }
        }
    };
    var initiatePayment = function(payload) {
        setIsTimerStarted(true);
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showGenerateQr: false
            });
        });
        // Intiate payment
        dispatch((0,payment/* initPaymentForQR */.qI)(payload, function(_intPay) {
            // If payment initiated successfully
            if (_intPay.status) {
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        minutes: 3,
                        seconds: 0,
                        isTimeUp: false,
                        showGenerateQr: false,
                        qrText: _intPay.intentLink
                    });
                });
                // Initiate the payment varification process
                if (_intPay.transactionId) {
                    dispatch((0,payment/* pollPayment */.ru)(_intPay.transactionId, router));
                }
            } else {
                setState(initialState);
                clearTimer();
                (0,Toast/* toastNotifyError */.Lu)("error: ".concat((_intPay === null || _intPay === void 0 ? void 0 : _intPay.message) || "Unable to initiate payment!"));
            }
        }));
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("orderID", orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash);
    };
    /**
   * Function to initiate a payment and
   * set the state with the new QR data
   */ var createNewQR = function() {
        var ref;
        var payload = {
            orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
            paymentMethod: constants/* PAYMENT_TYPE_CONSTANTS.DUPI */.Mf.DUPI,
            merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
            deviceType: (0,deviceInfo/* getDeviceInfo */.d)().OSName,
            browserType: (0,deviceInfo/* getDeviceInfo */.d)().BrowserName,
            userAgent: (0,deviceInfo/* getDeviceInfo */.d)().userAgent,
            phone: userData === null || userData === void 0 ? void 0 : userData.phone,
            source: "longtail",
            merchantName: "Digital Showroom - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name)
        };
        dispatch((0,payment/* savePaymentInfo */.YI)(payload));
        if (checkIfMDRActive && (0,checkIfObjectExists/* checkIfObjectExists */.L)(props.txnData)) {
            var mdrPld = {
                order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                store_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.store_id,
                payment_option: props.txnData
            };
            dispatch((0,payment/* prePaymentCheckMDRTransactions */.HV)(mdrPld, function() {
                setTimeout(function() {
                    return initiatePayment(payload);
                }, 100);
            }));
        } else {
            initiatePayment(payload);
        }
    };
    var QrPlaceholder = function(param) {
        var children = param.children, classNameExtension = param.classNameExtension;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    size: 150,
                    value: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-black-80 absolute w-100 top-0 left-0 right-0 bottom-0  flex justify-center items-center ".concat(classNameExtension),
                    children: children
                })
            ]
        });
    };
    var _renderQR = function() {
        if (state.isTimeUp) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(QrPlaceholder, {
                classNameExtension: "bg-black-90",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex justify-center items-center pb2 fw6 f5 white ",
                    onClick: createNewQR,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/images/twotone_refresh_white_24dp.png",
                            className: "mr2 img h2"
                        }),
                        "Refresh"
                    ]
                })
            });
        }
        if (state.showGenerateQr) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(QrPlaceholder, {
                classNameExtension: "bg-black-70",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    style: {
                        cursor: "pointer"
                    },
                    className: "pa1 bg-white br2 bw0",
                    onClick: createNewQR,
                    children: "Generate Code"
                })
            });
        }
        return state.qrText && !loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
            size: 150,
            value: state.qrText
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QrPlaceholder, {
            classNameExtension: "bg-black-70",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/assets/images/ellipLoader1.gif",
                className: "h2 img"
            })
        });
    };
    var _renderQrTimerMessage = function() {
        return state.isTimeUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "f7 fw3",
                children: "This QR code has expired"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: "f7 fw3",
            children: [
                "This QR code will expire in 0",
                state.minutes,
                ":",
                state.seconds < 10 ? "0".concat(state.seconds) : state.seconds,
                " Minutes"
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ph4 pt4 pb3 flex flex-column flex-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "flex flex-column justify-center items-center",
                children: [
                    _renderQR(),
                    isTimerStarted ? _renderQrTimerMessage() : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "ba b--black-10 pv3 ph4 br3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                        className: "tc fw5 f5 pb2 lh-copy",
                        children: "Scan this QR code with any of your UPI App and pay."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "flex justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/images/ic_paytm@2x.png",
                                className: "img h2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/images/ic_gpay@2x.png",
                                className: "img h2 mh3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/images/ic_phonep@2x.png",
                                className: "img h2"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_QRPaymentUPI = (QRPaymentUPI);

// EXTERNAL MODULE: ./src/components/CardPaymentBox/index.js
var CardPaymentBox = __webpack_require__(67865);
// EXTERNAL MODULE: ./src/components/EmiCardPayment/index.js
var EmiCardPayment = __webpack_require__(29875);
// EXTERNAL MODULE: ./src/components/CustomRadio/index.js
var CustomRadio = __webpack_require__(43388);
// EXTERNAL MODULE: ./src/components/LazyPayAuth/lazyPayAuth.js
var lazyPayAuth = __webpack_require__(14456);
// EXTERNAL MODULE: ./src/redux/store/index.js + 43 modules
var store = __webpack_require__(24686);
;// CONCATENATED MODULE: ./src/utils/checkForInvalidAmount.js


function checkForInvalidAmount() {
    var ref, ref1;
    var storeInfo = store/* default.getState */.Z.getState().storeReducer.store;
    var orderDetails = store/* default.getState */.Z.getState().orderReducer.orderDetails;
    if (((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) === constants/* PREPAID_POSTPAID_METHODS.BOTH */.R9.BOTH || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.payment_method) === constants/* PREPAID_POSTPAID_METHODS.POSTPAID */.R9.POSTPAID) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) < constants/* MINIMUM_ORDER_AMOUNT */.BI) {
        return true;
    }
    return false;
}

// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(4160);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/getPrepaidInvalidAmountMessage.js
var getPrepaidInvalidAmountMessage = __webpack_require__(37202);
// EXTERNAL MODULE: ./src/utils/orderGSTStatus.js
var orderGSTStatus = __webpack_require__(14723);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/encryptionDecryption.js
var encryptionDecryption = __webpack_require__(70145);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(36623);
;// CONCATENATED MODULE: ./src/components/MobikwikPayment/index.js

var BTN_STYLES = {
    backgroundColor: "#0C4BFF",
    padding: "14px",
    lineHeight: "24px",
    borderRadius: 12
};
var MobikwikPayment = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pa4 flex flex-column items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://cdn.dotpe.in/kiranaStatic/icons/mobikwik_icon.png",
                width: "50%",
                className: "mx-auto"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "w-100 white fw7 ttu f18px bn mt5 pointer",
                style: BTN_STYLES,
                onClick: onClick,
                children: "Pay using Mobikwik"
            })
        ]
    });
};
/* harmony default export */ var components_MobikwikPayment = (MobikwikPayment);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/components/DesignSystem/AuthPopUp/index.js + 4 modules
var AuthPopUp = __webpack_require__(93973);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/utils/isCodDisabledForOrder.js

function isCodDisabledForOrder() {
    var ref;
    var paymentReducer = store/* default.getState */.Z.getState().paymentReducer;
    if (paymentReducer === null || paymentReducer === void 0 ? void 0 : (ref = paymentReducer.otherMethods) === null || ref === void 0 ? void 0 : ref.length) {
        return !(paymentReducer === null || paymentReducer === void 0 ? void 0 : paymentReducer.otherMethods.some(function(method) {
            return method === "cod";
        }));
    } else {
        var ref1, ref2, ref3;
        return (paymentReducer === null || paymentReducer === void 0 ? void 0 : (ref1 = paymentReducer.paymentOptionsWithTxnCharge) === null || ref1 === void 0 ? void 0 : ref1.others) ? !(paymentReducer === null || paymentReducer === void 0 ? void 0 : (ref2 = paymentReducer.paymentOptionsWithTxnCharge) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.others) === null || ref3 === void 0 ? void 0 : ref3.some(function(method) {
            return (method === null || method === void 0 ? void 0 : method.payment_option_name) === "cod";
        })) : true;
    }
}

// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts + 6 modules
var WidgetDndContext = __webpack_require__(17502);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(79220);
// EXTERNAL MODULE: ./src/hooks/useUnselectablePaymentOptions.tsx
var useUnselectablePaymentOptions = __webpack_require__(8623);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(99375);
// EXTERNAL MODULE: ./src/utils/getWhatsAppRedirectionUrl.js
var getWhatsAppRedirectionUrl = __webpack_require__(30066);
// EXTERNAL MODULE: ./src/utils/canDisablePlaceOrder.ts
var canDisablePlaceOrder = __webpack_require__(96930);
;// CONCATENATED MODULE: ./src/components/DesktopPaymentModal/index.js
/**
 * Desktop Payment Modal
 */ 



























// import LoaderIcon from '@/components/Common/LoaderIcon';











var DesktopPaymentModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref7 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref7.widgetContextState.globalStyle;
    var orderHashFromParams = router.query.hash;
    var isPaymentPage = router.pathname.includes("/payment/");
    var isOnPendingPaymentPage = orderHashFromParams && isPaymentPage;
    var ref8 = (0,react.useState)({
        payOnDelivery: false,
        selectedOption: null,
        activePaymentMethods: [],
        modalVisible: false,
        showAuthModal: false
    }), state = ref8[0], setState = ref8[1];
    var ref9 = (0,react.useState)(false), toggleState = ref9[0], setToggleState = ref9[1];
    var ref10 = (0,react.useState)(0), payAmount = ref10[0], setPayAmount = ref10[1];
    var ref11 = (0,react.useState)(0), codCharge = ref11[0], setCodCharge = ref11[1];
    var ref12 = (0,react.useState)(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT), selectedPartialPaymentMode = ref12[0], setSelectedPartialPaymentMode = ref12[1];
    var partialPaymentFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().partialPaymentFeatureStatus;
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var partialPaymentFeatureVisible = partialPaymentFeatureStatus === null || partialPaymentFeatureStatus === void 0 ? void 0 : partialPaymentFeatureStatus.isVisible;
    var ref13 = (0,es/* useSelector */.v9)(function(state) {
        var userReducer = state.userReducer;
        return {
            theme: state.storeReducer.store.theme,
            services: state.storeReducer.store.services,
            paymentModalVisibility: state.commonReducer.paymentModalVisibility,
            orderDetails: state.orderReducer.orderDetails,
            storeInfo: state.storeReducer.store,
            paymentMethods: state.paymentReducer.methods,
            downPaymentMethods: state.paymentReducer.downPaymentMethods,
            otherMethods: state.paymentReducer.otherMethods,
            cart: state.cartReducer,
            paymentOptionsWithTxnCharge: state.paymentReducer.paymentOptionsWithTxnCharge,
            paymentMethod: state.paymentReducer.selectedPaymentOptionForMobilePayment,
            minEmiAmount: state.paymentReducer.min_emi_amount,
            userData: state.userReducer.data,
            userReducer: userReducer,
            partial_payment_amount: state.paymentReducer.partial_payment_amount,
            paymentModalOptionsVisibility: state.commonReducer.paymentModalOptionsVisibility
        };
    }), theme = ref13.theme, paymentModalVisibility = ref13.paymentModalVisibility, orderDetails = ref13.orderDetails, storeInfo = ref13.storeInfo, paymentMethods = ref13.paymentMethods, downPaymentMethods = ref13.downPaymentMethods, otherMethods = ref13.otherMethods, cart = ref13.cart, paymentOptionsWithTxnCharge = ref13.paymentOptionsWithTxnCharge, paymentMethod = ref13.paymentMethod, minEmiAmount = ref13.minEmiAmount, userReducer = ref13.userReducer, userData = ref13.userData, partial_payment_amount = ref13.partial_payment_amount, paymentModalOptionsVisibility = ref13.paymentModalOptionsVisibility, services = ref13.services;
    var finalUnselectablePaymentOptions = (0,useUnselectablePaymentOptions/* default */.Z)().finalUnselectablePaymentOptions;
    var checkIfMDRActive = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) === 1;
    var requireUserLogin = (0,react.useMemo)(function() {
        if (!isOnPendingPaymentPage || checkRenderEnv/* IS_SERVER */.W6 || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.phone) == "0000000000") return false;
        var authToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token");
        if (authToken && !(userData === null || userData === void 0 ? void 0 : userData.phone)) return false;
        if (!(userReducer === null || userReducer === void 0 ? void 0 : userReducer.isLogin)) return true;
        if (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.phone) return (userData === null || userData === void 0 ? void 0 : userData.phone) !== (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.phone);
        return false;
    }, [
        orderDetails,
        userReducer,
        checkRenderEnv/* IS_SERVER */.W6
    ]);
    (0,react.useEffect)(function() {
        if (isOnPendingPaymentPage) {
            var authToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token");
            if (authToken && !(userData === null || userData === void 0 ? void 0 : userData.phone)) {
                var authData = {
                    auth_token: authToken,
                    service: ""
                };
                dispatch((0,auth/* authenticateUser */.So)(authData));
            }
        }
        setCodCharge(_getCODCharges(orderDetails, services));
    }, []);
    (0,react.useEffect)(function() {
        if (requireUserLogin && !state.showAuthModal) {
            toggleAuthModal();
        }
    }, [
        requireUserLogin,
        state.showAuthModal
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
        if (paymentModalVisibility && !state.modalVisible) {
            (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) && dispatch((0,payment/* fetchPaymentMethods */.F7)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
            }));
            if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_id) !== 0 && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.partial_payment_type) > 0) {
                dispatch((0,order/* fetchOrderDetailByID */.GW)({
                    order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_id
                }));
            }
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    modalVisible: true
                });
            });
        }
        if (!paymentModalVisibility) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    modalVisible: false
                });
            });
        }
        setCodCharge(_getCODCharges(orderDetails, services));
    }, [
        paymentModalVisibility,
        storeInfo,
        orderDetails
    ]);
    (0,react.useEffect)(function() {
        if (paymentMethod && Object.keys(paymentMethod).length) {
            setPayAmount(paymentMethod.pay_amount);
        }
    }, [
        paymentMethod
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (paymentModalVisibility && ((ref = cart.payment_offer) === null || ref === void 0 ? void 0 : ref.payment_method)) {
            var ref1, ref2, ref3;
            var paymentMethod = ((ref1 = cart.payment_offer) === null || ref1 === void 0 ? void 0 : ref1.payment_method) === constants/* PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */.Mf.DEBIT_CARD || ((ref2 = cart.payment_offer) === null || ref2 === void 0 ? void 0 : ref2.payment_method) === constants/* PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */.Mf.CREDIT_CARD ? constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD : (ref3 = cart.payment_offer) === null || ref3 === void 0 ? void 0 : ref3.payment_method;
            submitPayment(paymentMethod, true); // UPI payment activation
        }
    }, [
        paymentModalVisibility
    ]);
    (0,react.useEffect)(function() {
        var tempState = {};
        tempState.activePaymentMethods = [];
        tempState.selectedOption = null;
        var methods = [];
        /**
     * If mdr_flag == 1 (customer pays transaction charges)
     * get payment methods from paymentOptionsWithTxnCharge key in paymentReducer
     * otherwise go with normal flow
     */ if (checkIfMDRActive && (0,checkIfObjectExists/* checkIfObjectExists */.L)(paymentOptionsWithTxnCharge !== null && paymentOptionsWithTxnCharge !== void 0 ? paymentOptionsWithTxnCharge : {})) {
            var down_payment_modes = paymentOptionsWithTxnCharge.down_payment_modes, others = paymentOptionsWithTxnCharge.others, payment_modes = paymentOptionsWithTxnCharge.payment_modes;
            /**
       * Take all the keys from paymentOptionsWithTxnCharge
       * and take out only the value of 'payment_option_name' key
       */ methods = (0,_to_consumable_array/* default */.Z)(payment_modes || []).concat((0,_to_consumable_array/* default */.Z)(down_payment_modes || []), (0,_to_consumable_array/* default */.Z)(others || [])).map(function(method) {
                if (method.hasOwnProperty("payment_option_name")) return method["payment_option_name"];
            });
        } else if ((paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) || (downPaymentMethods === null || downPaymentMethods === void 0 ? void 0 : downPaymentMethods.length) || (otherMethods === null || otherMethods === void 0 ? void 0 : otherMethods.length)) {
            methods = (0,_to_consumable_array/* default */.Z)(paymentMethods).concat((0,_to_consumable_array/* default */.Z)(downPaymentMethods), (0,_to_consumable_array/* default */.Z)(otherMethods));
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.GOOGLE_PAY */.Mf.GOOGLE_PAY) || methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.PHONEPE */.Mf.PHONEPE) || methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.PAYTM_UPI */.Mf.PAYTM_UPI)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI);
            if (paymentModalVisibility && checkForInvalidAmount()) {
                tempState.selectedOption = constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH;
            } else tempState.selectedOption = constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI;
            /**
       * If mdr_flag == 1, send data of first payment_method
       * to reducer to be used later
       */ if (checkIfMDRActive) {
                var payment_modes1 = paymentOptionsWithTxnCharge.payment_modes;
                var ref;
                if (payment_modes1 === null || payment_modes1 === void 0 ? void 0 : payment_modes1.length) dispatch((0,payment/* setCustomerTransactionPaymentMethod */.j1)((ref = payment_modes1[0]) !== null && ref !== void 0 ? ref : {}));
            }
        }
        /**
     * if mdr_flag == 1, show CC and DC
     * otherwise show common CC-DC component
     */ if (checkIfMDRActive && (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */.Mf.CREDIT_CARD) || methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */.Mf.DEBIT_CARD))) {
            /**
       * when mdr_flag == 1, CC and DC have separate txnm charges
       * so have to be shown separately
       */ if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */.Mf.CREDIT_CARD)) tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD);
            if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */.Mf.DEBIT_CARD)) tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD);
        } else {
            if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD)) {
                tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD);
            }
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.LAZYPAY */.Mf.LAZYPAY)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY);
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.COD */.Mf.COD)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH);
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.EMI */.Mf.EMI)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI);
        }
        if (methods.includes(constants/* PAYMENT_TYPE_CONSTANTS.MOBIKWIK */.Mf.MOBIKWIK)) {
            tempState.activePaymentMethods.push(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK);
        }
        setState(function(state) {
            return (0,_object_spread/* default */.Z)({}, state, tempState);
        });
    }, [
        paymentMethods,
        downPaymentMethods,
        otherMethods,
        paymentOptionsWithTxnCharge
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (paymentModalVisibility && !(cart === null || cart === void 0 ? void 0 : (ref = cart.payment_offer) === null || ref === void 0 ? void 0 : ref.payment_method)) {
            var ref1;
            dispatch((0,logs/* pushEventsLog */.U)({
                event_name: "Cx_Payment_Init",
                data: {
                    store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                    domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain,
                    device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                    cx_number: userData === null || userData === void 0 ? void 0 : userData.phone
                }
            }));
        }
    }, [
        paymentModalVisibility,
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.payment_offer) === null || ref1 === void 0 ? void 0 : ref1.payment_method
    ]);
    var toggleAuthModal = function() {
        if (!requireUserLogin) {
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showAuthModal: false
            }));
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModal: !state.showAuthModal
                });
            });
        }
    };
    var submitPayment = function(method) {
        var isPaymentPromoPresent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        var payload = {
            orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
            paymentMethod: method,
            phone: userData === null || userData === void 0 ? void 0 : userData.phone,
            merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
            deviceType: (0,deviceInfo/* getDeviceInfo */.d)().OSName,
            browserType: (0,deviceInfo/* getDeviceInfo */.d)().BrowserName,
            userAgent: (0,deviceInfo/* getDeviceInfo */.d)().userAgent,
            source: "longtail",
            merchantName: "Digital Showroom - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name)
        };
        dispatch((0,payment/* savePaymentInfo */.YI)(payload));
        if (isPaymentPromoPresent) {
            var ref1;
            payload["promoCode"] = cart === null || cart === void 0 ? void 0 : (ref1 = cart.payment_offer) === null || ref1 === void 0 ? void 0 : ref1.promo_code;
        }
        if (method === constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD && !isPaymentPromoPresent) {
            var ref2;
            router.push((0,routes.getRoute)(routes.PATH.cardPayment(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash), storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            return;
        }
        if (method === constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD && isPaymentPromoPresent) {
            var cardDetails = JSON.parse((0,encryptionDecryption/* getEncrypDecryptStr */.v)(JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("dscc")), "decrypt"));
            payload["cNum"] = cardDetails.cNum;
            payload["cCvv"] = cardDetails.cCvv;
            payload["cName"] = cardDetails.cName;
            payload["cExpMonth"] = cardDetails.cExpMonth;
            payload["cExpYear"] = cardDetails.cExpYear;
        }
        dispatch((0,payment/* initPayment */.yK)(payload, router));
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("orderID", orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash);
    };
    var onClose = function() {
        if (props.behaveAsPaymentPage) {
            return;
        }
        setSelectedPartialPaymentMode(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT);
        dispatch((0,common/* setPaymentModalVisiblity */.Tc)(false));
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
    };
    var toggleSelectedOption = function(option, txnType) {
        var mdrValid = true;
        if (option === state.selectedOption) return;
        if (checkForInvalidAmount()) {
            (0,Toast/* toastNotifyError */.Lu)((0,getPrepaidInvalidAmountMessage/* getPrepaidInvalidAmountMessage */.a)((0,getStoreType/* getStoreType */.K)()));
            return;
        }
        /*
      MDR and ERI options are exclusive now.
      So if EMI option is selected then, 
      prePaymentCheckMDRTransactions is now not required.

      if emi payment method selected, then we can avoid using the 
      prePaymentCheckMDRTransactions api.
    */ if (checkIfMDRActive && (0,checkIfObjectExists/* checkIfObjectExists */.L)(txnType)) {
            var payload = {
                order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                store_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.store_id,
                payment_option: txnType
            };
            var callback = function(status) {
                mdrValid = status;
                var oldSelectedState = (0,_object_spread/* default */.Z)({}, state);
                if (!mdrValid) {
                    setState(oldSelectedState);
                }
            };
            (0,es/* batch */.dC)(function() {
                dispatch((0,payment/* setCustomerTransactionPaymentMethod */.j1)(txnType));
                dispatch((0,payment/* prePaymentCheckMDRTransactions */.HV)(payload, callback));
            });
        }
        if (mdrValid) {
            if (option === constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY) {
                var ref;
                var payload1 = {
                    orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                    paymentMethod: "lazyPay",
                    merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                    deviceType: (0,deviceInfo/* getDeviceInfo */.d)().OSName,
                    browserType: (0,deviceInfo/* getDeviceInfo */.d)().BrowserName,
                    userAgent: (0,deviceInfo/* getDeviceInfo */.d)().userAgent,
                    source: "longtail",
                    merchantName: "Digital Showroom - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name)
                };
                dispatch((0,payment/* savePaymentInfo */.YI)(payload1));
                payload1.phone = orderDetails.phone;
                payload1.amount = checkIfMDRActive ? txnType.pay_amount : orderDetails.amount;
                payload1.store_id = orderDetails.store_id;
                dispatch((0,payment/* initLazyPayPayment */.q)(payload1));
            }
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    selectedOption: option
                });
            });
        }
    };
    // const paymentActivation = () => {
    // }
    /**
   * onHandler function for
   * Payment of type CASH
   */ var onCashOptionHandle = function() {
        var ref;
        if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
            return;
        }
        if (isCodDisabledForOrder() && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) <= constants/* MINIMUM_ORDER_AMOUNT */.BI) {
            (0,Toast/* toastNotifyError */.Lu)("Cannot place order below ".concat(constants/* MINIMUM_ORDER_AMOUNT */.BI));
            return;
        }
        // Check if the payment is for prepaid order
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) === constants/* PREPAID_POSTPAID_METHODS.BOTH */.R9.BOTH && orderDetails.prepaid_flag === 1) {
            dispatch((0,order/* updateOrderState */.oW)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash, router));
        } else {
            dispatch((0,common/* setPaymentModalVisiblity */.Tc)(false));
            if (storePhone) {
                // Create whatsapp intent for web and open in next tab
                window.open((0,getWhatsAppRedirectionUrl/* getWhatAppRedirectionUrlCODRequest */.eo)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value, orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id), "_blank");
            }
        }
    };
    /**
   * function return payment amount strip
   * @return {JSX}
   */ var _renderPaymentAmtStrip = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "pv3 bg-black-10 fw6 f4 br--top br4 tc flex flex-column items-center justiyf-center",
            children: [
                "Pay ₹ ",
                checkIfMDRActive ? payAmount : orderDetails.buyer_pay_value,
                [
                    constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD
                ].includes(state.selectedOption) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-payment-exceptions mt2",
                    children: "For Amex Cards, convenience fee will be 2.7%"
                })
            ]
        });
    };
    var returnTransactionPercent = function(value) {
        var payment_modes = paymentOptionsWithTxnCharge.payment_modes, others = paymentOptionsWithTxnCharge.others;
        var combinedArr = (0,_to_consumable_array/* default */.Z)(payment_modes || []).concat((0,_to_consumable_array/* default */.Z)(others || []));
        var txnType = combinedArr.find(function(item) {
            return item.payment_option_name.toLowerCase() === value.toLowerCase();
        });
        return (txnType === null || txnType === void 0 ? void 0 : txnType.transaction_charge) || "0";
    };
    var sendTransactionTypeToState = function(value) {
        var searchValue = value === constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI ? constants/* PAYMENT_TYPE_CONSTANTS.GOOGLE_PAY */.Mf.GOOGLE_PAY : value.toLowerCase();
        if (paymentOptionsWithTxnCharge && Object.keys(paymentOptionsWithTxnCharge).length) {
            var payment_modes = paymentOptionsWithTxnCharge.payment_modes, others = paymentOptionsWithTxnCharge.others;
            var combinedArr = (0,_to_consumable_array/* default */.Z)(payment_modes || []).concat((0,_to_consumable_array/* default */.Z)(others || []));
            var txnType = combinedArr.find(function(item) {
                return item.payment_option_name.toLowerCase() === searchValue;
            });
            return txnType || null;
        }
    };
    var CashPayment = function() {
        var ref, ref1;
        if (Number(services === null || services === void 0 ? void 0 : services.cod_charge_flag) > constants/* COD_CHARGE_TYPE.FREE */.VV.FREE) {
            var ref2;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "extra-cod-charge-container ".concat(state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH ? "db" : "dn"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-text",
                            children: "Total amount to be paid: ₹".concat(Number(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount) + Number(codCharge))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cost-breakup",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cost-breakup-info",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cost-breakup-sub-info",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Item total"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat((ref2 = getItemTotal(orderDetails)) === null || ref2 === void 0 ? void 0 : ref2.toFixed(2))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Delivery Fees"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat(Number(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.delivery_charge))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Extra Charges for Cash On Delivery"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat(codCharge)
                                                })
                                            ]
                                        }),
                                        (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charges) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: [
                                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charge_name.substr(0, 20),
                                                        (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charge_name.length) > 20 && "..."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charges)
                                                })
                                            ]
                                        }),
                                        (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Discount"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "- ₹ ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.discount)
                                                })
                                            ]
                                        }),
                                        (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.promo_discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "Promo Discount"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "- ₹ ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.promo_discount)
                                                })
                                            ]
                                        }),
                                        (0,orderGSTStatus/* isOrderGstExcluded */.e)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cost-breakup-sub-info-detail",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-text",
                                                    children: "GST"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cost-breakup-sub-info-detail-value",
                                                    children: "₹ ".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.total_gst_paid)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "break-line",
                                    style: {
                                        backgroundColor: "black",
                                        height: "1px",
                                        width: "100%"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grand-total",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grand-total-text",
                                            children: [
                                                "Grand Total",
                                                (0,orderGSTStatus/* isOrderGstIncluded */.S)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "incl-gst responsive-minor-text fw4 ml6px",
                                                    children: [
                                                        "(Incl. ₹ ",
                                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.total_gst_paid,
                                                        " GST)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grand-total-value",
                                            children: "₹ ".concat(Number(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount) + Number(codCharge))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "confirm-cod-btn pointer",
                        onClick: function() {
                            return onCashOptionHandle();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "confirm-cod-btn-text",
                            children: "Place Cash on Delivery Order"
                        })
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH ? "flex" : "dn", " flex-column justify-center items-center h-100"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tc f6 pb3",
                    children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "You have to Pay"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "fw6 mh2",
                                children: [
                                    "₹ ",
                                    orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "at the time of",
                                    " ",
                                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "Service" : orderDetails.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY ? "Delivery" : "Pick Up"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "pv3 bn white fw6 w-70",
                    onClick: onCashOptionHandle,
                    style: {
                        backgroundColor: (theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color) ? theme === null || theme === void 0 ? void 0 : (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color : "#EA5151",
                        borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"
                    },
                    children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 1 ? (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "Confirm Booking" : "Place Order" : "Request Cash Payment"
                })
            ]
        });
    };
    /**
   * Function check which payment option
   * is checked and return thier view
   * @param {String} type
   * @return {JSX}
   */ var _renderPaymentBlock = function(type) {
        switch(type){
            case constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        !checkForInvalidAmount() && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QRPaymentUPI, {
                            partial_payment: toggleState,
                            txnData: sendTransactionTypeToState(constants/* PAYMENT_TYPE_CONSTANTS.PHONEPE */.Mf.PHONEPE) // Use any UPI company for transaction amount
                        })
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPaymentBox/* default */.Z, {})
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPaymentBox/* default */.Z, {})
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPaymentBox/* default */.Z, {})
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pa3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazyPayAuth/* default */.Z, {
                                isDesktop: true
                            })
                        })
                    ]
                });
            case constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CashPayment, {});
            case constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI ? "db" : "dn",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pa4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmiCardPayment/* default */.Z, {})
                    })
                });
            case constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedOption === constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK ? "db" : "dn",
                    children: [
                        _renderPaymentAmtStrip(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobikwikPayment, {
                            onClick: function() {
                                submitPayment(constants/* PAYMENT_TYPE_CONSTANTS.MOBIKWIK */.Mf.MOBIKWIK);
                            }
                        })
                    ]
                });
            default:
                return null;
        }
    };
    /**
   * Function for getting the
   * Payment option item card
   * @param {Object} param
   * @return {JSX}
   */ var _renderPaymentOptionItem = function(param) {
        var title = param.title, option = param.option, images = param.images, hasImages = param.hasImages, _transactionAmt = param.transactionAmt, transactionAmt = _transactionAmt === void 0 ? false : _transactionAmt, _txnType = param.txnType, txnType = _txnType === void 0 ? null : _txnType, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "option-card ".concat(customClasses, " ").concat(state.selectedOption === option ? "selected" : ""),
            onClick: function() {
                return toggleSelectedOption(option, txnType);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "input-wrap",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                className: "slimy-green-color",
                                type: "radio",
                                checked: state.selectedOption === option,
                                "aria-checked": state.selectedOption === option
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    className: "fw5",
                                    children: title
                                }),
                                option === constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH && (services === null || services === void 0 ? void 0 : services.cod_charge_flag) > constants/* COD_CHARGE_TYPE.FREE */.VV.FREE && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "extra-cod-charges",
                                    style: {
                                        marginTop: "4px"
                                    },
                                    children: "Extra Charges ₹ ".concat(codCharge)
                                }),
                                hasImages && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    className: "icons-wrap",
                                    children: images.map(function(image, idx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: image
                                            })
                                        }, "option-icons-".concat(idx));
                                    })
                                })
                            ]
                        })
                    ]
                }),
                minEmiAmount > 0 && constants/* ACTIVE_PAYMENT_METHOD.EMI.substring */.Tb.EMI.substring(1).toLowerCase() === title.toLowerCase() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "transaction-charge-text",
                    style: {
                        marginTop: 0
                    },
                    children: [
                        "EMI starts at ₹",
                        minEmiAmount,
                        "/month"
                    ]
                }) : null,
                checkIfMDRActive && (transactionAmt || transactionAmt === 0) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "transaction-charge-text",
                    children: [
                        transactionAmt,
                        "% convenience fee"
                    ]
                }) : null
            ]
        });
    };
    var _renderUnselectablePaymentOptions = function() {
        var isCodDisabledDueToCoupon = finalUnselectablePaymentOptions === null || finalUnselectablePaymentOptions === void 0 ? void 0 : finalUnselectablePaymentOptions.includes(constants/* PAYMENT_TYPE_CONSTANTS.COD */.Mf.COD);
        return !!finalUnselectablePaymentOptions.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "f6 pb3",
                    children: "Other Modes"
                }),
                finalUnselectablePaymentOptions.map(function(paymentOption, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-pointer-events-none tw-opacity-40",
                        children: [
                            _renderPaymentOptionItem({
                                title: (0,getCustomCtaText/* default */.Z)("other_payment_modes_cta"),
                                option: paymentOption,
                                customClasses: "!tw-m-0"
                            }),
                            isCodDisabledDueToCoupon && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-pt-[8px] tw-text-[11px]/[15px] tw-text-[#111C36CC] ",
                                children: "You cannot select this option, the applied offer is not applicable on ‘Pay on Delivery’ orders."
                            })
                        ]
                    }, index);
                })
            ]
        });
    };
    var cardRenderSection = function() {
        if (checkIfMDRActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD) && _renderPaymentOptionItem({
                        title: "Credit Card",
                        option: constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD,
                        hasImages: true,
                        images: [
                            "/assets/images/mastercard@2x.png",
                            "/assets/images/visa-logo-png-transparent@2x.png", 
                        ],
                        transactionAmt: returnTransactionPercent(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD),
                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD)
                    }),
                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD) && _renderPaymentOptionItem({
                        title: "Debit Card",
                        option: constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD,
                        hasImages: true,
                        images: [
                            "/assets/images/mastercard@2x.png",
                            "/assets/images/visa-logo-png-transparent@2x.png", 
                        ],
                        transactionAmt: returnTransactionPercent(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD),
                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD)
                    })
                ]
            });
        } else {
            return state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD) && _renderPaymentOptionItem({
                title: "Credit & Debit Cards",
                option: constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD,
                hasImages: true,
                images: [
                    "/assets/images/mastercard@2x.png",
                    "/assets/images/visa-logo-png-transparent@2x.png", 
                ]
            });
        }
    };
    var checkForCashPayment = function() {
        var ref;
        return state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH) && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) !== constants/* PREPAID_POSTPAID_METHODS.PREPAID */.R9.PREPAID && selectedPartialPaymentMode !== constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT;
    };
    var handleInputRadioClick = function(type) {
        // if user is clicking same input radio again n again, don't allow any network call.
        if (type === selectedPartialPaymentMode) return;
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(false));
        var payload = {
            store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
            order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id,
            part_payment_option: type,
            pay_amount: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount
        };
        dispatch((0,payment/* togglePartialPaymentMode */.bj)(payload, function() {
            setToggleState(!toggleState);
            dispatch((0,order/* fetchOrderByHash */.yZ)({
                order_hash: orderDetails.order_hash,
                isPrepaid: 1
            }));
            dispatch((0,payment/* fetchPaymentMethods */.F7)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
            }));
            dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
        }, function() {
            setSelectedPartialPaymentMode(type);
        }));
    };
    var isPartialPaymentToggleNotAllowed = function() {
        if (partial_payment_amount < constants/* MINIMUM_ORDER_AMOUNT */.BI) {
            return true;
        }
        if (checkIfMDRActive) {
            return partial_payment_amount >= payAmount;
        } else {
            return partial_payment_amount >= orderDetails.buyer_pay_value;
        }
    };
    var renderPartialPaymentComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "partial-payment-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "title",
                    children: "Select a payment method"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "radio-input-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "radio-input-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                    type: "radio",
                                    checked: selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT,
                                    "aria-checked": selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT,
                                    style: {
                                        width: "20px",
                                        height: "20px",
                                        color: "#3D6AFD",
                                        cursor: "pointer",
                                        border: selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT ? "" : "0.15em solid #D4D4D5"
                                    },
                                    onClick: function() {
                                        return handleInputRadioClick(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "radio-content-wrap",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                        className: "fw5",
                                        children: "Full Payment"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "radio-input-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                    type: "radio",
                                    checked: selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT,
                                    "aria-checked": selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT,
                                    style: {
                                        width: "20px",
                                        height: "20px",
                                        color: "#3D6AFD",
                                        cursor: "".concat(isPartialPaymentToggleNotAllowed() ? "not-allowed" : "pointer"),
                                        border: selectedPartialPaymentMode === constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT ? "" : "0.15em solid #D4D4D5"
                                    },
                                    onClick: function() {
                                        return handleInputRadioClick(constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT);
                                    },
                                    disabled: isPartialPaymentToggleNotAllowed()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "radio-content-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                            className: "fw5",
                                            children: [
                                                storeInfo.services.partial_payment_flag === 1 ? "".concat(storeInfo.services.partial_payment_value, "% ") : "",
                                                "Partial Payment - Rs. ",
                                                partial_payment_amount
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: "/assets/icons/tooltipGrayIcon.svg",
                                            "data-tip": true,
                                            "data-for": "partial-payment-info"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            id: "partial-payment-info",
                                            place: "bottom",
                                            effect: "solid",
                                            multiline: true,
                                            padding: "8px",
                                            disable: false,
                                            arrowColor: "#4F4F4F",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mv0 fw5 f12px",
                                                children: [
                                                    "Choose this option to make a partial ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " payment. The remaining amount will be ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " collected at the time of delivery/pickup"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            paymentModalVisibility && !(cart === null || cart === void 0 ? void 0 : (ref2 = cart.payment_offer) === null || ref2 === void 0 ? void 0 : ref2.payment_method) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                visible: paymentModalVisibility,
                className: "bottom-modal desktopPaymentModal " + (props.behaveAsPaymentPage ? "desktopPaymentPage" : ""),
                animation: "slideUp",
                customStyles: {
                    maxWidth: "1000px",
                    width: "100%"
                },
                onClose: onClose,
                children: [
                    props.behaveAsPaymentPage ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "closeicon pointer",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "/assets/images/cancel.png",
                            alt: "cancel"
                        })
                    }),
                    partialPaymentFeatureVisible && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.partial_payment_flag) && orderDetails.prepaid_flag > 0 && !(orderDetails.parent_order_id !== 0 && orderDetails.partial_payment_type > 0) ? renderPartialPaymentComponent() : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "f4 fw6 pv3 ph2",
                        children: "Select Payment Method"
                    }),
                    !paymentModalOptionsVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "492px",
                            background: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                            type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref4 = globalStyle.appLoader) === null || ref4 === void 0 ? void 0 : ref4.loaderId) || "ellipsis",
                            color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref5 = globalStyle.appLoader) === null || ref5 === void 0 ? void 0 : ref5.color
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-grid pb4 ph2 pt3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "pv2 overflow-y-auto",
                                children: [
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI) && _renderPaymentOptionItem({
                                        title: "UPI Payments",
                                        option: constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI,
                                        hasImages: true,
                                        images: [
                                            "/assets/images/ic_paytm@2x.png",
                                            "/assets/images/ic_gpay@2x.png",
                                            "/assets/images/ic_phonep@2x.png", 
                                        ],
                                        transactionAmt: returnTransactionPercent(constants/* PAYMENT_TYPE_CONSTANTS.PHONEPE */.Mf.PHONEPE // Use any UPI company for transaction amount
                                        ),
                                        txnType: sendTransactionTypeToState(constants/* PAYMENT_TYPE_CONSTANTS.PHONEPE */.Mf.PHONEPE)
                                    }),
                                    cardRenderSection(),
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY) && _renderPaymentOptionItem({
                                        title: "LazyPay",
                                        option: constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY,
                                        hasImages: true,
                                        images: [
                                            "/assets/images/lazypay_.png"
                                        ],
                                        transactionAmt: returnTransactionPercent(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY),
                                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY)
                                    }),
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK) && _renderPaymentOptionItem({
                                        title: "Mobikwik",
                                        option: constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK,
                                        hasImages: true,
                                        images: [
                                            "https://cdn.dotpe.in/kiranaStatic/icons/mobikwik_icon.png"
                                        ],
                                        transactionAmt: returnTransactionPercent(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK),
                                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK)
                                    }),
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI) && _renderPaymentOptionItem({
                                        title: "EMI",
                                        option: constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI,
                                        hasImages: true,
                                        images: [],
                                        transactionAmt: 0,
                                        txnType: sendTransactionTypeToState(constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI)
                                    }),
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH) && ((ref6 = storeInfo.services) === null || ref6 === void 0 ? void 0 : ref6.payment_method) !== 1 && checkForCashPayment() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "f6 pb3",
                                                children: "Other Modes"
                                            }),
                                            _renderPaymentOptionItem({
                                                title: (0,getCustomCtaText/* default */.Z)("other_payment_modes_cta"),
                                                option: constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH,
                                                txnType: sendTransactionTypeToState(constants/* PAYMENT_TYPE_CONSTANTS.COD */.Mf.COD),
                                                customClasses: "!tw-m-0"
                                            })
                                        ]
                                    }) : null,
                                    _renderUnselectablePaymentOptions()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "br4 ba b--black-10 mh-100 overflow-y-auto",
                                children: [
                                    state.activePaymentMethods.includes(constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI) && _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.UPI */.Tb.UPI),
                                    checkIfMDRActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.CREDIT_CARD */.Tb.CREDIT_CARD),
                                            _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.DEBIT_CARD */.Tb.DEBIT_CARD)
                                        ]
                                    }) : _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.CARD */.Tb.CARD),
                                    _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.LAZYPAY */.Tb.LAZYPAY),
                                    _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.CASH */.Tb.CASH),
                                    _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.EMI */.Tb.EMI),
                                    _renderPaymentBlock(constants/* ACTIVE_PAYMENT_METHOD.MOBIKWIK */.Tb.MOBIKWIK)
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthPopUp["default"], {
                isVisible: state.showAuthModal,
                toggleModal: toggleAuthModal,
                prefilledPhone: isOnPendingPaymentPage && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.phone) || null,
                sendOTPBeforeHand: isOnPendingPaymentPage
            })
        ]
    });
};
var getItemTotal = function(orderDetails) {
    var ref;
    return orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.items) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, curr) {
        if (curr.item_status === 1) acc = acc + curr.amount;
        return acc;
    }, 0);
};
function _getCODCharges(orderDetails, services) {
    var itemsTotal = getItemTotal(orderDetails);
    if ((services === null || services === void 0 ? void 0 : services.cod_charge_flag) === 0 || (services === null || services === void 0 ? void 0 : services.cod_charge_offset_value) !== 0 && (services === null || services === void 0 ? void 0 : services.cod_charge_offset_value) < itemsTotal) {
        return 0;
    }
    if ((services === null || services === void 0 ? void 0 : services.cod_charge_flag) === 1) {
        return services === null || services === void 0 ? void 0 : services.cod_charge_value;
    } else if ((services === null || services === void 0 ? void 0 : services.cod_charge_flag) === 2) {
        return (itemsTotal * (services === null || services === void 0 ? void 0 : services.cod_charge_value) / 100).toFixed(0);
    }
    return 0;
}
/* harmony default export */ var components_DesktopPaymentModal = (DesktopPaymentModal);


/***/ }),

/***/ 29875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58165);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19372);
/* harmony import */ var _utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8824);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74118);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/* harmony import */ var src_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77733);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70145);
/* harmony import */ var _utils_deviceInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90864);
/* harmony import */ var _assets_svgExports_BackArrow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85946);
/* harmony import */ var _CustomRadio__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43388);
/* harmony import */ var _Common_Toast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40804);
// styling for this component is in emiCardPayment.scss


















var rangeOfYears = function() {
    var result = [];
    var min = new Date().getUTCFullYear();
    var max = min + 20;
    while(min <= max){
        result.push("" + min);
        min++;
    }
    return result;
};
var EmiCardPayment = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? true : _isDesktop;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        cardInformation: {
            cardNumber: "",
            monthSelected: "01",
            yearSelected: rangeOfYears()[0],
            cvv: ""
        },
        cvvLength: 3,
        selectedEmi: {},
        step: 1,
        completedSteps: [],
        cardType: "",
        emiAvailable: true
    }), emiInformation = ref[0], setEmiInformation = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), openEmiOption = ref1[0], setOpenEmiOption = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        isCardNumberValid: true,
        isCardCVVInvalid: false
    }), cardValidation = ref2[0], setCardValidation = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), showCvvShowcase = ref3[0], setShowCvvShowcase = ref3[1];
    var ref4 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return {
            store: state.storeReducer.store,
            orderDetails: state.orderReducer.orderDetails,
            emiOptionsForCard: state.emiReducer.emiOptionsForCard,
            userData: state.userReducer
        };
    }), emiOptionsForCard = ref4.emiOptionsForCard, userData = ref4.userData, orderDetails = ref4.orderDetails, store = ref4.store;
    var toggleCvvPopup = function() {
        setShowCvvShowcase(function(s) {
            return !s;
        });
    };
    var inputChange = function(value, type) {
        var tempState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, emiInformation), {
            cardInformation: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, emiInformation.cardInformation)
        });
        var tempCardValidation = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, cardValidation);
        switch(type){
            case "cardNo":
                {
                    tempCardValidation.isCardNumberValid = true;
                    if (value.length <= 20) {
                        tempState.cardInformation.cardNumber = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__/* .cardNumberFormat */ .XW)(value.trim());
                        tempState.cardType = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__/* .getCardType */ .C1)(value.trim());
                        tempState.emiAvailable = true;
                        tempState.cvvLength = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__/* .getCardType */ .C1)(tempState.cardInformation.cardNumber) === _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .CARD_TYPE.AMEX */ .WK.AMEX ? 4 : 3;
                        debounceOnChange(value.trim());
                    }
                    break;
                }
            case "cardMonth":
                {
                    tempState.cardInformation.monthSelected = value;
                    break;
                }
            case "cardYear":
                {
                    tempState.cardInformation.yearSelected = value;
                    break;
                }
            case "cvv":
                {
                    tempCardValidation.isCardCVVInvalid = false;
                    if (value.length <= emiInformation.cvvLength) {
                        tempState.cardInformation.cvv = value;
                    }
                }
            default:
                break;
        }
        setEmiInformation(function(state) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state, tempState);
        });
        setCardValidation(function(state) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state, tempCardValidation);
        });
    };
    var validateCardNumber = function(number) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, cardValidation);
        newState["isCardNumberValid"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__/* .isCardValid */ .TH)(number);
        setCardValidation(newState);
    };
    var validateCardCVV = function(number) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, cardValidation);
        newState["isCardCVVInvalid"] = number.length !== emiInformation.cvvLength ? "Enter valid CVV" : false;
        setCardValidation(newState);
    };
    var validateAll = function() {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, cardValidation);
        var isAllValid = true;
        if (!emiInformation.cardInformation.cardNumber) {
            newState["isCardNumberValid"] = false;
            isAllValid = false;
        }
        if (emiInformation.cvvLength !== emiInformation.cardInformation.cvv.length) {
            newState["isCardCVVInvalid"] = "Enter a valid CVV";
            isAllValid = false;
        }
        setCardValidation(newState);
        return isAllValid;
    };
    var handleCardNumberChange = function(value) {
        if (value.length >= 6) {
            var callback = function(emiOptionAvailable) {
                setEmiInformation(function(state) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                        emiAvailable: emiOptionAvailable
                    });
                });
            };
            /**
       * change card_number in obj to allow only the first 6 digits
       * in card number to be sent as payload for initiatePayment api
       */ dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_13__/* .getEmiOptionsSpecificToCard */ .L1)({
                store_id: store === null || store === void 0 ? void 0 : store.store_id,
                hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                card_number: value.substring(0, 6)
            }, callback));
        }
    };
    var debounceOnChange = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((0,_utils_debounce__WEBPACK_IMPORTED_MODULE_14__/* .debounce */ .D)(handleCardNumberChange, 500), []);
    var completeEmiSteps = function(step) {
        if (!emiInformation.emiAvailable || emiInformation.cardInformation.cardNumber === "" || emiInformation.cardInformation.cardNumber.split(" ").join("").length < 14) return;
        var tempCompletedSteps = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(emiInformation.completedSteps);
        tempCompletedSteps.push(step);
        var newStepCount = emiInformation.step === 3 ? 3 : emiInformation.step + 1;
        setEmiInformation(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                completedSteps: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(new Set(tempCompletedSteps)),
                step: newStepCount
            });
        });
    };
    var editEmiSteps = function(step) {
        setEmiInformation(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                completedSteps: step === 1 ? [] : [
                    1
                ],
                step: step
            });
        });
    };
    var selectEmiPlanBtnClick = function(emiPlan) {
        setEmiInformation(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                selectedEmi: emiPlan
            });
        });
        var payload = {
            order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            emi_option: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, emiPlan)
        };
        var callback = function(status) {
            if (status) {
                completeEmiSteps(2);
            } else {
                (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_10__/* .toastNotifyError */ .Lu)("Cannot select emi plan currently");
            }
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_13__/* .setEmiOptions */ .ZZ)(payload, callback));
    };
    var emiStepCompletionForMobile = function() {
        switch(emiInformation.step){
            case 1:
                completeEmiSteps(1);
                break;
            case 3:
                completeEmiPaymentInit();
                break;
            default:
                break;
        }
    };
    var disabilityOfMobileButton = function() {
        switch(emiInformation.step){
            case 1:
                return !(emiInformation.cardInformation.cardNumber.length >= 16) || !emiInformation.emiAvailable;
            case 3:
                return emiInformation.cardInformation.cvv.length !== emiInformation.cvvLength;
            default:
                return true;
        }
    };
    var CompletedStepComponent = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "emi-step-completed",
            children: children
        });
    };
    var completeEmiPaymentInit = function() {
        if (validateAll()) {
            var ref, ref1;
            var data = {
                orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                paymentMethod: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .PAYMENT_TYPE_CONSTANTS.EMI */ .Mf.EMI,
                merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                deviceType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_7__/* .getDeviceInfo */ .d)().OSName,
                browserType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_7__/* .getDeviceInfo */ .d)().BrowserName,
                userAgent: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_7__/* .getDeviceInfo */ .d)().userAgent,
                source: "longtail",
                cNum: emiInformation.cardInformation.cardNumber.split(" ").join(""),
                cCvv: emiInformation.cardInformation.cvv,
                cName: "DOTPE",
                cExpMonth: emiInformation.cardInformation.monthSelected,
                cExpYear: emiInformation.cardInformation.yearSelected,
                merchantName: "Digital Showroom - ".concat(store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.name),
                emiCode: emiInformation.selectedEmi.emi_code,
                phone: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            };
            var encryptCCDetails = (0,_utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_16__/* .getEncrypDecryptStr */ .v)(JSON.stringify(data), "encrypt");
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("dscc", JSON.stringify(encryptCCDetails));
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .initPayment */ .yK)(data, router));
        }
    };
    var cardBaseErrorMessage = function() {
        if (!emiInformation.emiAvailable) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                className: "error",
                children: "No EMI option available for this Bank, please try different card"
            });
        }
        if (!cardValidation.isCardNumberValid) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                className: "error",
                children: "Enter valid card number"
            });
        }
        return null;
    };
    var affirmationButton = function(param) {
        var _onClick = param.onClick, onClick = _onClick === void 0 ? null : _onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _label = param.label, label = _label === void 0 ? "Continue" : _label, _showButton = param.showButton, showButton = _showButton === void 0 ? true : _showButton;
        if (!showButton) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            disabled: disabled,
            className: "pointer dib affirmation-btn fw6-ns fw5 br-pill ".concat(disabled ? "o-30" : ""),
            onClick: onClick,
            children: label
        });
    };
    var EditButton = function(param) {
        var _onClick = param.onClick, onClick = _onClick === void 0 ? undefined : _onClick, _label = param.label, label = _label === void 0 ? "" : _label, _customStyle = param.customStyle, customStyle = _customStyle === void 0 ? {} : _customStyle;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "relative pointer dib edit-btn br-pill",
            onClick: onClick,
            style: customStyle,
            children: label !== null && label !== void 0 ? label : "Edit"
        });
    };
    /**
   * Function to change all characters in the card number
   * after the 6th digit into 'X', 1st step is completed
   * @return {string} morphed car number
   */ var cardNumberRenderAfterStep1 = function() {
        // here slice starts at 7th inex due to 1 space between card number blocks
        var firstSixChar = emiInformation.cardInformation.cardNumber.substring(0, 7);
        var mappedLastChars = emiInformation.cardInformation.cardNumber.slice(7).split(" ");
        var morphString = mappedLastChars.map(function(value) {
            return value.replace(/./gi, "X");
        });
        return "".concat(firstSixChar).concat(morphString.join(" "));
    };
    var cardInformationSection = function() {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mb4-ns",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "emiCardPayment__header",
                    children: "Enter Credit or Debit card details"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "card-information-section flex ".concat(isDesktop ? "flex-row" : "flex-column"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "card-information-section--first",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "card-header-text",
                                            children: "Card Number"
                                        }),
                                        !isDesktop && emiInformation.completedSteps.includes(1) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "card-header-edit dib",
                                            onClick: function() {
                                                return editEmiSteps(1);
                                            },
                                            children: "Edit Card"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        emiInformation.completedSteps.includes(1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompletedStepComponent, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mv0",
                                                children: cardNumberRenderAfterStep1()
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "tel",
                                                    className: "emi-input w-100 ".concat(!emiInformation.emiAvailable || !cardValidation.isCardNumberValid ? "invalid" : ""),
                                                    value: emiInformation.cardInformation.cardNumber,
                                                    placeholder: "XXXX XXXX XXXX XXXX",
                                                    onChange: function(e) {
                                                        return inputChange(e.target.value.replace(/[^0-9]/g, ""), "cardNo");
                                                    },
                                                    onBlur: function(e) {
                                                        return validateCardNumber(e.target.value.replace(/[^0-9]/g, ""));
                                                    }
                                                }),
                                                cardBaseErrorMessage()
                                            ]
                                        }),
                                        (emiInformation === null || emiInformation === void 0 ? void 0 : emiInformation.cardType) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "card-image",
                                            loading: "lazy",
                                            src: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .cc_icons */ .P2[emiInformation.cardType] || src_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"].CDN_SERVER_URL */ .Z.CDN_SERVER_URL + "image/ic-credit-card.svg",
                                            alt: "cardType"
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "card-information-section--second flex flex-column justify-end",
                            children: emiInformation.completedSteps.includes(1) ? isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditButton, {
                                label: "Edit Card",
                                customStyle: {
                                    bottom: 8
                                },
                                onClick: function() {
                                    return editEmiSteps(1);
                                }
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card-header-text",
                                        children: "Expiry Date"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "relative mr3",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                                        value: emiInformation.cardInformation.monthSelected,
                                                        className: "emi-select",
                                                        onChange: function(e) {
                                                            return inputChange(e.target.value, "cardMonth");
                                                        },
                                                        children: Array.from(Array(12).keys()).map(function(arr) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                children: "".concat(+arr + 1 < 10 ? "0" : "").concat(arr + 1)
                                                            }, arr);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        alt: "dropdown button",
                                                        src: "/assets/images/down-arrow-thin.svg"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                                        value: emiInformation.cardInformation.yearSelected,
                                                        className: "emi-select",
                                                        onChange: function(e) {
                                                            return inputChange(e.target.value, "cardYear");
                                                        },
                                                        children: (ref = rangeOfYears()) === null || ref === void 0 ? void 0 : ref.map(function(range) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                children: range
                                                            }, range);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        alt: "dropdown button",
                                                        src: "/assets/images/down-arrow-thin.svg"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                (!emiInformation.completedSteps.includes(1) || emiInformation.step === 1) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    style: {
                        marginTop: 25
                    },
                    children: affirmationButton({
                        showButton: isDesktop,
                        disabled: !(emiInformation.cardInformation.cardNumber.length >= 16) || !emiInformation.emiAvailable,
                        onClick: function() {
                            return completeEmiSteps(1);
                        }
                    })
                })
            ]
        });
    };
    var emiSelectionComponent = function() {
        var ref, ref1, ref2;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "emi-selection-section mb4-ns",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "emiCardPayment__header",
                            children: "Select EMI Tenure"
                        }),
                        !isDesktop && emiInformation.completedSteps.includes(2) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "card-header-edit dib",
                            onClick: function() {
                                return editEmiSteps(2);
                            },
                            children: "Edit Tenure"
                        })
                    ]
                }),
                emiInformation.completedSteps.includes(2) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "card-information-section--first",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompletedStepComponent, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "mv0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                            children: [
                                                src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                (emiInformation === null || emiInformation === void 0 ? void 0 : (ref = emiInformation.selectedEmi) === null || ref === void 0 ? void 0 : ref.payable_emi_value) || ""
                                            ]
                                        }),
                                        " ",
                                        "X ",
                                        emiInformation === null || emiInformation === void 0 ? void 0 : (ref1 = emiInformation.selectedEmi) === null || ref1 === void 0 ? void 0 : ref1.tenure,
                                        " | Total Cost - ",
                                        src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                        emiInformation === null || emiInformation === void 0 ? void 0 : (ref2 = emiInformation.selectedEmi) === null || ref2 === void 0 ? void 0 : ref2.total_payable_amount
                                    ]
                                })
                            })
                        }),
                        isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "card-information-section--second flex flex-column justify-end",
                            style: {
                                paddingLeft: 0
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditButton, {
                                label: "Edit Tenure",
                                onClick: function() {
                                    return editEmiSteps(2);
                                }
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "overflow-hidden",
                    style: {
                        border: "0.4px solid #D6D6D6",
                        borderRadius: 7
                    },
                    children: (emiOptionsForCard === null || emiOptionsForCard === void 0 ? void 0 : emiOptionsForCard.length) > 0 && (emiOptionsForCard === null || emiOptionsForCard === void 0 ? void 0 : emiOptionsForCard.map(function(emi, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "emi-option-accordion",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "emi-option-accordion__header flex items-center pointer",
                                    onClick: function() {
                                        return setOpenEmiOption(index);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomRadio__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            readOnly: true,
                                            className: "mr3 ultramarine-blue-color",
                                            type: "radio",
                                            checked: openEmiOption === index,
                                            onChange: undefined
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "mv0",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                    className: "fw6",
                                                    children: [
                                                        src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                        emi.payable_emi_value
                                                    ]
                                                }),
                                                " ",
                                                "X ",
                                                emi.tenure,
                                                " | Total Cost - ",
                                                src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                emi.total_payable_amount
                                            ]
                                        })
                                    ]
                                }),
                                openEmiOption === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "emi-option-accordion__body",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                            className: "emi-table w-100",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: isDesktop ? "EMI per month" : "EMI Plan"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: isDesktop ? "Interest" : "Interest(pa)"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: isDesktop ? "Total EMI Cost" : "Total Cost"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                                    className: "fw6",
                                                                    children: [
                                                                        src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                                        emi.payable_emi_value
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                                children: [
                                                                    src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                                    emi.total_emi_interest_paid,
                                                                    "(",
                                                                    emi.emi_bank_interest,
                                                                    "%)"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                                children: [
                                                                    src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                                    emi.total_payable_amount
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tr-ns tc pt24px",
                                            children: affirmationButton({
                                                label: "Select EMI Plan",
                                                onClick: function() {
                                                    return selectEmiPlanBtnClick(emi);
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    }))
                })
            ]
        });
    };
    var cvvShowcasePopup = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "cvvShowcasePopup z-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "The CVV number is the last three digits at the back of your card."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/assets/images/cvv-showcase-mobile.png"
                })
            ]
        });
    };
    var checkForValidCVV = function() {
        return emiInformation.cardInformation.cvv.length !== 0 && cardValidation.isCardCVVInvalid;
    };
    var cardCvvInput = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mb4 relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                    className: "emiCardPayment__header relative flex items-center",
                    children: [
                        "Enter CVV",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/images/info-icon-grey.svg",
                            onMouseOver: toggleCvvPopup,
                            onMouseOut: toggleCvvPopup
                        })
                    ]
                }),
                showCvvShowcase && cvvShowcasePopup(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "tel",
                            className: "emi-input mr3 w-20-ns w-40 ".concat(checkForValidCVV() ? "invalid" : ""),
                            value: emiInformation.cardInformation.cvv,
                            onChange: function(e) {
                                return inputChange(e.target.value.replace(/[^0-9]/g, ""), "cvv");
                            },
                            onBlur: function(e) {
                                return validateCardCVV(e.target.value);
                            }
                        }),
                        checkForValidCVV() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                            className: "error",
                            children: cardValidation.isCardCVVInvalid
                        }),
                        affirmationButton({
                            showButton: isDesktop,
                            disabled: emiInformation.cardInformation.cvv.length !== emiInformation.cvvLength,
                            onClick: completeEmiPaymentInit
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "emiCardPayment",
        children: [
            !isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "page-header flex items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_BackArrow__WEBPACK_IMPORTED_MODULE_8__/* .BackArrow */ .D, {
                        onClick: function() {
                            return router.back();
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "header-text ml3 fw6",
                        children: "EMI"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "emiCardPayment__body",
                children: [
                    cardInformationSection(),
                    emiInformation.step >= 2 && emiSelectionComponent(),
                    emiInformation.step === 3 && cardCvvInput()
                ]
            }),
            !isDesktop && emiInformation.step !== 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mobile-affirm-btn-container",
                children: affirmationButton({
                    showButton: !isDesktop,
                    disabled: disabilityOfMobileButton(),
                    onClick: emiStepCompletionForMobile
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmiCardPayment);


/***/ }),

/***/ 15241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FullPageLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79220);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17502);



// import interLoader from '../../../public/assets/images/inter-loader.gif';


function FullPageLoader() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var globalLoader = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            globalLoader: state.commonReducer.globalLoader
        };
    }).globalLoader;
    return globalLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "global-loader",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__/* .GlobalCfeLoader */ .I, {
            type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.appLoader) === null || ref === void 0 ? void 0 : ref.loaderId) || "ellipsis",
            color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.color
        })
    });
}


/***/ }),

/***/ 557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_operatingSystem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55311);
/* harmony import */ var _useInstallAppOverlayActions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41771);




function InstallAppInstructionsOverlay() {
    var ref = (0,_useInstallAppOverlayActions__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), showInstallAppOverlay = ref.showInstallAppOverlay, closeIntallAppOverlay = ref.closeIntallAppOverlay;
    if (!showInstallAppOverlay) return;
    var os = (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_2__/* .getMobileOperatingSystem */ .HG)();
    var getScreenText = function() {
        var pageContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: "Feature not supported for the device type."
        });
        if (os === _utils_operatingSystem__WEBPACK_IMPORTED_MODULE_2__/* .OS_ENUMS.ios */ .wo.ios) {
            pageContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Click ("
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "tw-h-[20px] tw-w-[20px]",
                        alt: "share logo",
                        src: "/assets/images/ios_share_icon.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: ") then 'Add to Home screen' from browser menu to add your store app for easy access."
                    })
                ]
            });
        } else if (os === _utils_operatingSystem__WEBPACK_IMPORTED_MODULE_2__/* .OS_ENUMS.android */ .wo.android) {
            pageContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Click ("
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "tw-h-[20px] tw-w-[20px]",
                        alt: "3 dots logo",
                        src: "/assets/images/3_dots_white_icon.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: ") then 'Add to home screen'/'Install App' from browser menu to add your store app for easy access."
                    })
                ]
            });
        }
        return pageContent;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[999] tw-flex tw-flex-col tw-items-center tw-justify-start tw-bg-[#000000df]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "tw-m-0 tw-mb-2 tw-mt-48 tw-w-[70%] tw-text-left tw-text-white",
                children: "Add your store app"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-w-[70%] tw-text-left tw-text-white",
                children: getScreenText()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-mt-3 tw-flex tw-w-[60%] tw-justify-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: function() {
                        closeIntallAppOverlay();
                    },
                    type: "button",
                    className: "tw-rounded-lg tw-bg-white tw-px-3 tw-py-2 tw-text-center tw-text-xs tw-font-medium tw-text-black hover:tw-opacity-70",
                    children: "Okay"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (InstallAppInstructionsOverlay);


/***/ }),

/***/ 95350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ItemSchedulingInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/assets/svgExports/DateIcon.js

var DateIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_4_1343)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.66667 10H6.5C5.85658 10 5.33333 10.5232 5.33333 11.1667V12.3333C5.33333 12.9767 5.85658 13.5 6.5 13.5H7.66667C8.31008 13.5 8.83333 12.9767 8.83333 12.3333V11.1667C8.83333 10.5232 8.31008 10 7.66667 10ZM6.5 12.3333V11.1667H7.66667V12.3333H6.5ZM14.0833 4.16667H13.5V3.58333C13.5 3.26133 13.2392 3 12.9167 3C12.5941 3 12.3333 3.26133 12.3333 3.58333V4.16667H7.66667V3.58333C7.66667 3.26133 7.40592 3 7.08333 3C6.76075 3 6.5 3.26133 6.5 3.58333V4.16667H5.91667C4.30842 4.16667 3 5.47508 3 7.08333V14.0833C3 15.6916 4.30842 17 5.91667 17H14.0833C15.6916 17 17 15.6916 17 14.0833V7.08333C17 5.47508 15.6916 4.16667 14.0833 4.16667ZM5.91667 5.33333H14.0833C15.0482 5.33333 15.8333 6.1185 15.8333 7.08333V7.66667H4.16667V7.08333C4.16667 6.1185 4.95183 5.33333 5.91667 5.33333ZM14.0833 15.8333H5.91667C4.95183 15.8333 4.16667 15.0482 4.16667 14.0833V8.83333H15.8333V14.0833C15.8333 15.0482 15.0482 15.8333 14.0833 15.8333Z",
                    fill: "#4E4E4E"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4_1343",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(3 3)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var svgExports_DateIcon = (DateIcon);

;// CONCATENATED MODULE: ./src/assets/svgExports/TimeIcon.js

var TimeIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.5591 13.3357L13.3357 12.5591L10.5526 9.776V6.31579H9.44737V10.2238L12.5591 13.3357ZM10.0013 17C9.03308 17 8.12302 16.8163 7.2711 16.4488C6.41919 16.0814 5.67818 15.5827 5.04805 14.9529C4.41793 14.323 3.91903 13.5823 3.55134 12.7307C3.18378 11.8792 3 10.9694 3 10.0013C3 9.03308 3.18372 8.12302 3.55116 7.2711C3.9186 6.41919 4.41725 5.67818 5.04713 5.04805C5.67701 4.41793 6.41772 3.91903 7.26926 3.55134C8.12081 3.18378 9.03062 3 9.99871 3C10.9669 3 11.877 3.18372 12.7289 3.55116C13.5808 3.9186 14.3218 4.41725 14.9519 5.04713C15.5821 5.67701 16.081 6.41772 16.4487 7.26926C16.8162 8.12081 17 9.03062 17 9.99871C17 10.9669 16.8163 11.877 16.4488 12.7289C16.0814 13.5808 15.5827 14.3218 14.9529 14.9519C14.323 15.5821 13.5823 16.081 12.7307 16.4487C11.8792 16.8162 10.9694 17 10.0013 17ZM10 15.8947C11.6333 15.8947 13.0241 15.3206 14.1724 14.1724C15.3206 13.0241 15.8947 11.6333 15.8947 10C15.8947 8.36667 15.3206 6.97588 14.1724 5.82763C13.0241 4.67939 11.6333 4.10526 10 4.10526C8.36667 4.10526 6.97588 4.67939 5.82763 5.82763C4.67939 6.97588 4.10526 8.36667 4.10526 10C4.10526 11.6333 4.67939 13.0241 5.82763 14.1724C6.97588 15.3206 8.36667 15.8947 10 15.8947Z",
            fill: "#4E4E4E"
        })
    });
};
/* harmony default export */ var svgExports_TimeIcon = (TimeIcon);

// EXTERNAL MODULE: ./src/components/ProductScheduler/utils.ts
var utils = __webpack_require__(97713);
;// CONCATENATED MODULE: ./src/components/ItemSchedulingInfo/index.tsx




var ItemSchedulingInfo = function(param) {
    var schedulingInfo = param.schedulingInfo, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _headingClasses = param.headingClasses, headingClasses = _headingClasses === void 0 ? "" : _headingClasses, _paraClasses = param.paraClasses, paraClasses = _paraClasses === void 0 ? "" : _paraClasses;
    var ref = schedulingInfo || {}, date = ref.date, time = ref.time;
    var infoList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_DateIcon, {}),
            infoName: "Date",
            infoData: date || ""
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_TimeIcon, {}),
            infoName: "Slot time",
            infoData: (time === null || time === void 0 ? void 0 : time.from) && (time === null || time === void 0 ? void 0 : time.to) ? "".concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.from), " - ").concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.to)) : ""
        }, 
    ];
    return !!date && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[12px] tw-pb-[8px] tw-pt-[24px] ".concat(customClasses),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-flex tw-text-[14px]/[15px]  tw-font-normal ".concat(headingClasses),
                children: "Booking details"
            }),
            infoList.map(function(info, index) {
                return !!info.infoData && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[8px] tw-text-[12px]/[15px] tw-font-normal  tw-text-[#4E4E4E] ".concat(paraClasses),
                    children: [
                        info.icon,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "tw-flex tw-items-center tw-gap-[4px]",
                            children: [
                                info.infoName,
                                ":",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-flex tw-items-center tw-font-normal tw-text-[#6B6B6B]",
                                    children: info.infoData
                                })
                            ]
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var components_ItemSchedulingInfo = (ItemSchedulingInfo);


/***/ }),

/***/ 22855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72651);
/* harmony import */ var _lazyPayAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14456);





var LazyPayAuthModal = function(props) {
    var lazyPayAuthModal = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            lazyPayAuthModal: state.commonReducer.lazyPayAuthModal
        };
    }).lazyPayAuthModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: lazyPayAuthModal.show,
        className: "bottom-modal",
        animation: "slideUp",
        onClose: props.onClose,
        height: "auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lazyPayAuth__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            onClose: props.onClose
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyPayAuthModal);


/***/ }),

/***/ 14456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19372);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_otp_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71470);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25617);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86812);










var LazyPayAuth = function(props) {
    var timerID = null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        phone: "",
        OTP: "",
        OTPsent: false,
        timer: 59,
        isTimeUp: false,
        showIncorrectOtpErr: false
    }), state = ref[0], setState = ref[1];
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return {
            lazyPayAuthModal: state.commonReducer.lazyPayAuthModal,
            paymentInfo: state.paymentReducer.paymentInfo
        };
    }), lazyPayAuthModal = ref1.lazyPayAuthModal, paymentInfo = ref1.paymentInfo;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (lazyPayAuthModal.show && lazyPayAuthModal.view === _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LAZYPAY_AUTH_MODAL_VIEWS.OTP */ .eS.OTP) {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    OTPsent: true
                });
            });
        }
    }, [
        lazyPayAuthModal.show
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (state.OTPsent) {
            startTimer();
        }
        return function() {
            /** Clear the Inteeval if any */ if (timerID != null) {
                clearInterval(timerID);
            }
        };
    }, [
        state.OTPsent
    ]);
    // Start the timmer
    var startTimer = function() {
        var seconds = state.timer;
        timerID = setInterval(function() {
            return tick(--seconds);
        }, 1000);
    };
    // Increase the timing (second) tick
    var tick = function(seconds) {
        var updatedTime;
        if (seconds > 0) {
            updatedTime = (seconds < 10 ? "0" : "") + String(seconds);
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    timer: updatedTime
                });
            });
        } else {
            clearInterval(timerID);
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    timer: 59,
                    isTimeUp: true
                });
            });
        }
    };
    var resendOTP = function() {
        if (!state.isTimeUp) return;
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                isTimeUp: false
            });
        });
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .initLazyPayPayment */ .q)(paymentInfo));
        var seconds = state.timer;
        timerID = setInterval(function() {
            return tick(--seconds);
        }, 1000);
    };
    var handleChange = function(val) {
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                OTP: val
            });
        });
    };
    var onPayBtnHandle = function() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .verifyLazyPayOtp */ .NZ)({
            transactionId: sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .TRANSACTION_ID_CONSTANT */ .eC),
            otp: state.OTP,
            requestType: "pay"
        }, router));
    };
    var _renderNotEligibleView = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mv0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/images/lazypay_.png",
                        loading: "lazy",
                        alt: "lazypay image",
                        className: "h3"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "f16px lh-copy",
                    children: "Currently we don’t have LazyPay method eligible for you. Please select another payment method"
                }),
                _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_6__/* .deviceWidth */ .o < 799 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "bg-amaranth-color white w-100 mt3 br4 bn fw6 f16px pv16px",
                    onClick: props.onClose,
                    children: "CHOOSE ANOTHER METHOD"
                }) : "Choose another method"
            ]
        });
    };
    var _renderOTPView = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "w-60 fw6 f20px lh-copy mt0",
                    children: [
                        "Enter OTP sent to ‘",
                        paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.phone,
                        "’ & Pay"
                    ]
                }),
                !props.isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "closeicon",
                    onClick: props.onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        loading: "lazy",
                        src: "/assets/images/cancel.png",
                        alt: "cancel"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_otp_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    value: state.OTP,
                    onChange: function(otp) {
                        return handleChange(otp);
                    },
                    numInputs: 4,
                    separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: " "
                    }),
                    isInputNum: true,
                    containerStyle: {
                        display: "grid",
                        gridTemplateColumns: "repeat(4,1fr)",
                        gridColumnGap: 0,
                        width: "fit-content",
                        marginTop: 20
                    },
                    shouldAutoFocus: true,
                    inputStyle: {
                        width: 44,
                        height: 44,
                        border: "1px solid #707070",
                        borderRadius: 4,
                        boxShadow: "none",
                        outline: "none",
                        marginRight: 20
                    }
                }),
                state.showIncorrectOtpErr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "f14px red",
                    children: "Incorrect OTP, entered please enter again."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "timer f14px mb2",
                    style: {
                        marginTop: "20px",
                        display: "block"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                            className: "fw5 mr2 ".concat(state.isTimeUp ? "amaranth-color " : "black-30"),
                            onClick: resendOTP,
                            children: "Resend OTP"
                        }),
                        !state.isTimeUp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                            className: "fw5 o-30",
                            children: [
                                "in ",
                                "0:".concat(state.timer, " s")
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "bg-amaranth-color white w-100 mt3 br4 bn fw6 f16px pv16px mt4",
                    onClick: onPayBtnHandle,
                    children: "CONFIRM & PAY"
                })
            ]
        });
    };
    var _renderEligibleView = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mv0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/images/lazypay_.png",
                        loading: "lazy",
                        alt: "lazypay image",
                        className: "h3"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "f20px fw6",
                    children: "Confirm your payment with LazyPay"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "f16px fw6",
                    children: [
                        "₹ ",
                        paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.amount
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "bg-amaranth-color white w-100 mt3 br4 bn fw6 f16px pv16px",
                    onClick: props.onClose,
                    children: "CONFIRM & PAY"
                })
            ]
        });
    };
    var _renderView = function(type) {
        switch(type){
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LAZYPAY_AUTH_MODAL_VIEWS.OTP */ .eS.OTP:
                return _renderOTPView();
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LAZYPAY_AUTH_MODAL_VIEWS.ELIGIBLE */ .eS.ELIGIBLE:
                return _renderEligibleView();
            case _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .LAZYPAY_AUTH_MODAL_VIEWS.NONELIGIBLE */ .eS.NONELIGIBLE:
                return _renderNotEligibleView();
        }
    };
    return _renderView(lazyPayAuthModal.view);
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyPayAuth);


/***/ }),

/***/ 22084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ PaymentOrPlaceOrderCTA; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
// EXTERNAL MODULE: ./src/utils/isStoreServiceBased.js
var isStoreServiceBased = __webpack_require__(66466);
;// CONCATENATED MODULE: ./src/components/PaymentModal/components/CommonCTA/index.js

var CommonCTA = function(param) {
    var text = param.text, onClick = param.onClick, bgColor = param.bgColor, borderRadius = param.borderRadius, isDisable = param.isDisable;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "w-100 white bn f16px fw6 shadow-4 tw-p-3",
        style: {
            backgroundColor: bgColor,
            borderRadius: borderRadius
        },
        onClick: onClick,
        disabled: isDisable,
        children: text
    });
};
/* harmony default export */ var components_CommonCTA = (CommonCTA);

;// CONCATENATED MODULE: ./src/components/PaymentModal/components/PlaceOrderButton/index.js





var PlaceOrderButton = function(param) {
    var onClick = param.onClick;
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme,
            loader: state.commonReducer.loader
        };
    }), theme = ref1.theme, loader = ref1.loader;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommonCTA, {
        text: (0,isStoreServiceBased/* isStoreServiceBased */.A)() ? "Confirm Booking" : "Place Order",
        bgColor: (theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color) || "#EA5151",
        borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px",
        onClick: onClick,
        isDisable: loader
    });
};
/* harmony default export */ var components_PlaceOrderButton = (PlaceOrderButton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/utils/getPaymentMethodName.js
var getPaymentMethodName = __webpack_require__(94604);
;// CONCATENATED MODULE: ./src/components/PaymentModal/components/ProceedToPayButton/index.js






var ProceedToPayButton = function(param) {
    var paymentData = param.paymentData, onClick = param.onClick;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme,
            loader: state.commonReducer.loader
        };
    }), theme = ref.theme, loader = ref.loader;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommonCTA, {
        text: "Pay using " + (0,getPaymentMethodName/* getPaymentMethodName */.d)(paymentData.selectedPaymentMethod.payment_option_name || paymentData.method),
        bgColor: "#2b74d8",
        borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px",
        onClick: function() {
            return onClick.apply(void 0, (0,_to_consumable_array/* default */.Z)(Object.values(paymentData)));
        },
        isDisable: loader
    });
};
/* harmony default export */ var components_ProceedToPayButton = (ProceedToPayButton);

;// CONCATENATED MODULE: ./src/components/PaymentModal/components/PaymentOrPlaceOrderCTA/index.js



var PaymentOrPlaceOrderCTA = function(param) {
    var state = param.state, onProceedToPay = param.onProceedToPay, onPlaceOrder = param.onPlaceOrder, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    if (!(state.payOnDelivery || state.selectedPaymentData)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: customClasses || "fixed bottom-0 left-0 right-0 w-100 pa20px bg-white shadow-3 z-999",
        children: [
            !!state.selectedPaymentData && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProceedToPayButton, {
                paymentData: state.selectedPaymentData,
                onClick: onProceedToPay
            }),
            !!state.payOnDelivery && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PlaceOrderButton, {
                onClick: onPlaceOrder
            })
        ]
    });
};


/***/ }),

/***/ 28721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36623);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20155);




var SelectCashOnDelivery = function(param) {
    var isSelectedCOD = param.isSelectedCOD, toggleCOD = param.toggleCOD, codCharge = param.codCharge, ctaType = param.ctaType, _unselectablePaymentOptions = param.unselectablePaymentOptions, unselectablePaymentOptions = _unselectablePaymentOptions === void 0 ? [] : _unselectablePaymentOptions;
    var ref;
    var storeInfo = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_3__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var isCodDisabledDueToCoupon = unselectablePaymentOptions === null || unselectablePaymentOptions === void 0 ? void 0 : unselectablePaymentOptions.includes(_utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .PAYMENT_TYPE_CONSTANTS.COD */ .Mf.COD);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pt2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "fw6 black-40",
                children: "OR"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "shadow-4 pa3 br3 ".concat(isCodDisabledDueToCoupon ? "tw-cursor-not-allowed tw-opacity-40" : ""),
                onClick: !isCodDisabledDueToCoupon && toggleCOD,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "radio",
                        checked: isSelectedCOD,
                        disabled: isCodDisabledDueToCoupon
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml2",
                        children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ctaType)
                    }),
                    (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.cod_charge_flag) > _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .COD_CHARGE_TYPE.FREE */ .VV.FREE && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "extra-cod-charges",
                        style: {
                            marginTop: "4px",
                            marginLeft: "21px"
                        },
                        children: "Extra delivery fees ₹ ".concat(codCharge)
                    })
                ]
            }),
            isCodDisabledDueToCoupon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "tw-m-0 tw-pt-[8px] tw-text-[11px]/[15px] tw-text-[#111C36CC] ",
                children: "You cannot select this option, the applied offer is not applicable on ‘Pay on Delivery’ orders."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectCashOnDelivery);


/***/ }),

/***/ 59400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TotalAmountSaved; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/assets/svgExports/GreatIcon.js

var GreatIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        id: "greatIcon",
        width: "9",
        height: "14",
        viewBox: "0 0 9 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.0448 14H6.45968C6.68576 14 6.8687 13.8166 6.8687 13.5898V13.1475C6.86911 12.5123 7.18863 11.8713 7.74626 11.4363C8.50799 10.8427 8.91222 10.2783 8.98292 9.71116C9.05761 9.10995 8.84312 8.74904 8.6502 8.55239C8.51585 8.4157 8.22329 8.32243 7.96618 8.43177C7.78733 8.50779 7.65423 8.66337 7.60638 8.85218C7.34177 9.89639 6.44825 10.6641 5.31696 10.6641C3.96157 10.6641 2.86284 9.56227 2.86284 8.20312C2.86284 6.84398 3.96157 5.74219 5.31696 5.74219C6.08152 5.74219 6.76047 6.09457 7.20837 6.64511C7.41629 6.90066 7.76189 6.99743 8.07176 6.88693C8.38158 6.77644 8.58904 6.48249 8.58912 6.15234C8.58912 4.7116 6.24843 4.10156 5.31696 4.10156C4.2261 4.10156 3.19957 4.52854 2.42587 5.304C1.01777 6.71677 1.26158 8.41228 1.23196 8.58725C1.22596 9.77927 1.21797 11.4662 1.64297 13.6668C1.6797 13.8602 1.84866 14 2.0448 14Z",
                fill: "#0E0E0E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.74777 3.50666C7.48322 2.84871 7.22215 3.10085 7.61994 2.77075C7.97014 2.49177 8.03591 1.97617 7.75134 1.6172C7.47853 1.27355 6.94328 1.21344 6.60298 1.48582C6.4169 1.64703 5.72478 2.11212 4.62305 3.33557C4.85142 3.30316 5.08219 3.28104 5.31683 3.28104C5.71543 3.28104 6.2251 3.3558 6.74777 3.50666Z",
                fill: "#0E0E0E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.45597 0.0840805C4.06214 -0.116212 3.55406 0.0552329 3.35795 0.450979C3.22163 0.775467 2.40635 2.03292 1.89551 4.67983C2.28162 4.30292 2.71919 4.00006 3.19087 3.77169C3.52545 3.35158 3.86161 2.95463 4.20129 2.58918C4.57972 1.58812 4.65195 1.55006 4.82186 1.18316C5.02737 0.769342 4.85068 0.281147 4.45597 0.0840805Z",
                fill: "#0E0E0E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.854387 6.18259C0.987509 4.83194 1.25842 3.52518 1.67641 2.30182C1.65203 1.9451 1.63106 1.58804 1.64096 1.22968L1.65135 0.843145C1.66408 0.406055 1.33002 0.0125781 0.832927 0C0.38595 0 0.0272666 0.350875 0.0160867 0.798273L0.0056975 1.18519C-0.0411489 2.88654 0.202518 4.91189 0.676654 6.65591C0.728163 6.49351 0.787389 6.33574 0.854387 6.18259Z",
                fill: "#0E0E0E"
            })
        ]
    });
};
/* harmony default export */ var svgExports_GreatIcon = (GreatIcon);

;// CONCATENATED MODULE: ./src/components/PaymentModal/components/TotalAmountSaved/index.js


var TotalAmountSaved = function(param) {
    var amount = param.amount;
    return !!amount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        class: "flex items-center justify-center pv6px ph12px br3 mb3 tw-w-max tw-bg-[#cdffe4]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_GreatIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                class: "f13px fw5 ml8px tw-text-xs",
                children: [
                    "Great! You’re saving ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        class: "fw7",
                        children: [
                            "₹ ",
                            amount
                        ]
                    }),
                    " on this order!"
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TotalAmountSaved = (TotalAmountSaved);


/***/ }),

/***/ 16307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PaymentModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
// EXTERNAL MODULE: ./src/components/PaymentOptions/index.js
var PaymentOptions = __webpack_require__(68102);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/redux/actions/payment.js
var payment = __webpack_require__(19372);
// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(4160);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/codMethodRender.js
var codMethodRender = __webpack_require__(42490);
// EXTERNAL MODULE: ./src/utils/deviceInfo.js
var deviceInfo = __webpack_require__(90864);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/components/LazyPayAuth/index.js
var LazyPayAuth = __webpack_require__(22855);
// EXTERNAL MODULE: ./src/components/DesktopPaymentModal/index.js + 4 modules
var DesktopPaymentModal = __webpack_require__(28110);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/encryptionDecryption.js
var encryptionDecryption = __webpack_require__(70145);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/PaymentModal/components/TotalAmountSaved/index.js + 1 modules
var TotalAmountSaved = __webpack_require__(59400);
// EXTERNAL MODULE: ./src/components/CustomRadio/index.js
var CustomRadio = __webpack_require__(43388);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(24762);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
;// CONCATENATED MODULE: ./src/components/PaymentModal/components/SelectPartialPaymentType/index.js







var SelectPartialOrFullPayment = function(param) {
    var selectedType = param.selectedType, setSelectedType = param.setSelectedType;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            partial_payment_amount: state.paymentReducer.partial_payment_amount,
            orderDetails: state.orderReducer.orderDetails,
            paymentModalOptionsVisibility: state.commonReducer.paymentModalOptionsVisibility
        };
    }), partial_payment_amount = ref.partial_payment_amount, orderDetails = ref.orderDetails, paymentModalOptionsVisibility = ref.paymentModalOptionsVisibility;
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var isPartialPaymentToggleNotAllowed = partial_payment_amount < constants/* MINIMUM_ORDER_AMOUNT */.BI || partial_payment_amount >= orderDetails.buyer_pay_value;
    var isFullPayment = selectedType === constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "partial-payment-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "title",
                        children: "Select a payment method"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "radio-input-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "radio-input-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                        type: "radio",
                                        checked: isFullPayment,
                                        "aria-checked": isFullPayment,
                                        onClick: function() {
                                            return setSelectedType(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "radio-content-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                            className: "fw5",
                                            children: "Full Payment"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "radio-input-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRadio/* default */.Z, {
                                        type: "radio",
                                        checked: !isFullPayment,
                                        "aria-checked": !isFullPayment,
                                        className: isPartialPaymentToggleNotAllowed ? "tw-cursor-not-allowed" : "tw-cursor-pointer",
                                        onClick: function() {
                                            return setSelectedType(constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT);
                                        },
                                        disabled: isPartialPaymentToggleNotAllowed
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "radio-content-wrap mobile-radio-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                className: "",
                                                children: [
                                                    storeInfo.services.partial_payment_flag === constants/* PARTIAL_PAYMENT_OPTION.PARTIAL_PAYMENT */.j6.PARTIAL_PAYMENT ? "".concat(storeInfo.services.partial_payment_value, "% ") : "",
                                                    "Partial Payment - Rs. ",
                                                    partial_payment_amount
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                loading: "lazy",
                                                src: "/assets/icons/tooltipGrayIcon.svg",
                                                "data-tip": true,
                                                "data-for": "partial-payment-info"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                                id: "partial-payment-info",
                                                place: "bottom",
                                                effect: "solid",
                                                multiline: true,
                                                padding: "8px",
                                                disable: false,
                                                arrowColor: "#4F4F4F",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mv0 fw5 f12px",
                                                    children: "Choose this option to make a partial payment. The remaining amount will be collected at the time of delivery/pickup."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalAmountSaved/* default */.Z, {
                amount: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.amount_saved
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "f4 fw6 pv3 ".concat(!paymentModalOptionsVisibility ? "dn" : ""),
                style: {
                    paddingTop: "0px"
                },
                children: [
                    "Pay ₹",
                    orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value
                ]
            })
        ]
    });
};
/* harmony default export */ var SelectPartialPaymentType = (SelectPartialOrFullPayment);

// EXTERNAL MODULE: ./src/components/PaymentModal/components/SelectCashOnDelivery/index.js
var SelectCashOnDelivery = __webpack_require__(28721);
// EXTERNAL MODULE: ./src/components/PaymentModal/components/PaymentOrPlaceOrderCTA/index.js + 3 modules
var PaymentOrPlaceOrderCTA = __webpack_require__(22084);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts + 6 modules
var WidgetDndContext = __webpack_require__(17502);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(79220);
// EXTERNAL MODULE: ./src/hooks/useUnselectablePaymentOptions.tsx
var useUnselectablePaymentOptions = __webpack_require__(8623);
// EXTERNAL MODULE: ./src/utils/canDisablePlaceOrder.ts
var canDisablePlaceOrder = __webpack_require__(96930);
;// CONCATENATED MODULE: ./src/components/PaymentModal/index.js
/**
 * Payment Modal
 * Component
 */ 







// import LoaderIcon from '@/components/Common/LoaderIcon';




















var PaymentModal = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref6.widgetContextState.globalStyle;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)({
        payOnDelivery: false,
        selectedPaymentData: null
    }), state = ref7[0], setState = ref7[1];
    var partialPaymentFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().partialPaymentFeatureStatus;
    var partialPaymentFeatureVisible = partialPaymentFeatureStatus === null || partialPaymentFeatureStatus === void 0 ? void 0 : partialPaymentFeatureStatus.isVisible;
    var ref8 = (0,react.useState)(0), codCharge = ref8[0], setCodCharge = ref8[1];
    var ref9 = (0,react.useState)(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT), selectedPartialPaymentMode = ref9[0], setSelectedPartialPaymentMode = ref9[1];
    var ref10 = (0,es/* useSelector */.v9)(function(state) {
        return {
            paymentModalVisibility: state.commonReducer.paymentModalVisibility,
            orderDetails: state.orderReducer.orderDetails,
            storeInfo: state.storeReducer.store,
            loader: state.commonReducer.loader,
            cart: state.cartReducer,
            otherMethods: state.paymentReducer.otherMethods,
            paymentOptionsWithTxnCharge: state.paymentReducer.paymentOptionsWithTxnCharge,
            userData: state.userReducer.data,
            partial_payment_amount: state.paymentReducer.partial_payment_amount,
            paymentModalOptionsVisibility: state.commonReducer.paymentModalOptionsVisibility
        };
    }), paymentModalVisibility = ref10.paymentModalVisibility, orderDetails = ref10.orderDetails, storeInfo = ref10.storeInfo, loader = ref10.loader, cart = ref10.cart, otherMethods = ref10.otherMethods, paymentOptionsWithTxnCharge = ref10.paymentOptionsWithTxnCharge, userData = ref10.userData, paymentModalOptionsVisibility = ref10.paymentModalOptionsVisibility;
    var finalUnselectablePaymentOptions = (0,useUnselectablePaymentOptions/* default */.Z)().finalUnselectablePaymentOptions;
    var isPartialPaymentEnabled = partialPaymentFeatureVisible && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.partial_payment_flag) && orderDetails.prepaid_flag > 0;
    var isChildOrder = orderDetails.parent_order_id !== 0 && orderDetails.partial_payment_type > 0;
    var showPartialPayment = isPartialPaymentEnabled && !isChildOrder;
    (0,react.useEffect)(function() {
        setCodCharge((0,DesktopPaymentModal/* _getCODCharges */.__)(orderDetails, storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.services));
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
        if (paymentModalVisibility) {
            var ref;
            var paymentMethod = (ref = cart.payment_offer) === null || ref === void 0 ? void 0 : ref.payment_method;
            if (paymentMethod && paymentMethod !== constants/* PAYMENT_TYPE_CONSTANTS.LAZYPAY */.Mf.LAZYPAY) {
                var isCardTypeMethod = paymentMethod === constants/* PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */.Mf.DEBIT_CARD || paymentMethod === constants/* PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */.Mf.CREDIT_CARD;
                var finalPaymentMethod = isCardTypeMethod ? constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD : paymentMethod;
                debouncedSubmitPayment(finalPaymentMethod, true);
            } else {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "scroll";
        }
        clearSelectedPaymentMode();
    }, [
        paymentModalVisibility
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (paymentModalVisibility && !(cart === null || cart === void 0 ? void 0 : (ref = cart.payment_offer) === null || ref === void 0 ? void 0 : ref.payment_method)) {
            var ref1;
            dispatch((0,logs/* pushEventsLog */.U)({
                event_name: "Cx_Payment_Init",
                data: {
                    store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                    domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain,
                    device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                    cx_number: userData === null || userData === void 0 ? void 0 : userData.phone
                }
            }));
        }
    }, [
        paymentModalVisibility,
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.payment_offer) === null || ref1 === void 0 ? void 0 : ref1.payment_method
    ]);
    var submitPayment = function(method) {
        var isPaymentPromoPresent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, selectedPaymentMethod = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, orderHash = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash;
        if (loader) {
            (0,Toast/* toastNotifyInfo */.lU)("Payment initiation in progress.");
            return;
        }
        /**
     * if payment method is emi
     * reroute to /emi-payment page for emi payment
     * through card
     */ if (method === constants/* PAYMENT_TYPE_CONSTANTS.EMI */.Mf.EMI) {
            var ref;
            router.push({
                pathname: (0,routes.getRoute)(routes.PATH.EMI_PAYMENT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain),
                query: {
                    emiPrice: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value
                }
            });
        } else {
            var ref1;
            var payload = {
                orderID: orderHash,
                paymentMethod: method,
                merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                deviceType: (0,deviceInfo/* getDeviceInfo */.d)().OSName,
                browserType: (0,deviceInfo/* getDeviceInfo */.d)().BrowserName,
                userAgent: (0,deviceInfo/* getDeviceInfo */.d)().userAgent,
                source: "longtail",
                merchantName: "Digital Showroom - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.name),
                phone: userData === null || userData === void 0 ? void 0 : userData.phone
            };
            dispatch((0,payment/* savePaymentInfo */.YI)(payload));
            if (isPaymentPromoPresent) {
                var ref2;
                payload["promoCode"] = cart === null || cart === void 0 ? void 0 : (ref2 = cart.payment_offer) === null || ref2 === void 0 ? void 0 : ref2.promo_code;
            }
            if (method === constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD && !isPaymentPromoPresent) {
                var ref3;
                router.push((0,routes.getRoute)(routes.PATH.cardPayment(orderHash), storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.store_info) === null || ref3 === void 0 ? void 0 : ref3.domain));
                return;
            }
            if (method === constants/* PAYMENT_TYPE_CONSTANTS.CARD */.Mf.CARD && isPaymentPromoPresent) {
                var cardDetails = JSON.parse((0,encryptionDecryption/* getEncrypDecryptStr */.v)(JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("dscc")), "decrypt"));
                payload["cNum"] = cardDetails.cNum;
                payload["cCvv"] = cardDetails.cCvv;
                payload["cName"] = cardDetails.cName;
                payload["cExpMonth"] = cardDetails.cExpMonth;
                payload["cExpYear"] = cardDetails.cExpYear;
            }
            if (method === constants/* PAYMENT_TYPE_CONSTANTS.LAZYPAY */.Mf.LAZYPAY) {
                var ref4;
                payload.phone = orderDetails.phone;
                payload.amount = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.services) === null || ref4 === void 0 ? void 0 : ref4.mdr_flag) ? selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.pay_amount : orderDetails.amount;
                payload.store_id = orderDetails.store_id;
                dispatch((0,payment/* initLazyPayPayment */.q)(payload));
            } else {
                dispatch((0,payment/* initPayment */.yK)(payload, router));
            }
        }
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("orderID", orderHash);
    };
    var onSelectPaymentMode = function(method) {
        var isPaymentPromoPresent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, selectedPaymentMethod = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, orderHash = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash;
        state.payOnDelivery && togglePayOnDeliveryCheckbox();
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedPaymentData: {
                    method: method,
                    isPaymentPromoPresent: isPaymentPromoPresent,
                    selectedPaymentMethod: selectedPaymentMethod,
                    orderHash: orderHash
                }
            });
        });
    };
    var debouncedSubmitPayment = debounce_default()(submitPayment, 1500, {
        leading: true,
        trailing: false
    });
    var onClose = function() {
        setSelectedPartialPaymentMode(constants/* PARTIAL_PAYMENT_OPTION.FULL_PAYMENT */.j6.FULL_PAYMENT);
        dispatch((0,common/* setPaymentModalVisiblity */.Tc)(false));
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
    };
    var clearSelectedPaymentMode = function() {
        state.selectedPaymentData && setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedPaymentData: null
            });
        });
    };
    var togglePayOnDeliveryCheckbox = function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                payOnDelivery: !state.payOnDelivery
            });
        });
        clearSelectedPaymentMode();
    };
    var onPlaceOrderBtnClick = function() {
        if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
            return;
        }
        dispatch((0,order/* updateOrderState */.oW)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash, router));
    };
    var onCloseLazyPayAuthModal = function() {
        dispatch((0,common/* toggleLazyPayAuthModal */.zk)({
            show: false
        }));
    };
    var handleInputRadioClick = function(type) {
        // if user is clicking same input radio again n again, don't allow any network call.
        if (type === selectedPartialPaymentMode) return;
        dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(false));
        var payload = {
            store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
            order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id,
            part_payment_option: type,
            pay_amount: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount
        };
        dispatch((0,payment/* togglePartialPaymentMode */.bj)(payload, function() {
            dispatch((0,payment/* fetchPaymentMethods */.F7)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
            }));
            dispatch((0,order/* fetchOrderByHash */.yZ)({
                order_hash: orderDetails.order_hash,
                isPrepaid: 1
            }));
            dispatch((0,common/* setPaymentModalOptionsVisiblity */.O1)(true));
            setSelectedPartialPaymentMode(type);
        }));
    };
    var renderUnselectablePaymentOption = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: finalUnselectablePaymentOptions.map(function(paymentOption) {
                switch(paymentOption){
                    case constants/* PAYMENT_TYPE_CONSTANTS.COD */.Mf.COD:
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCashOnDelivery/* default */.Z, {
                                isSelectedCOD: state.payOnDelivery,
                                toggleCOD: togglePayOnDeliveryCheckbox,
                                codCharge: codCharge,
                                ctaType: "cart_confirm_cta",
                                unselectablePaymentOptions: finalUnselectablePaymentOptions
                            });
                        }
                    default:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                }
            })
        });
    };
    return paymentModalVisibility && !(cart === null || cart === void 0 ? void 0 : (ref2 = cart.payment_offer) === null || ref2 === void 0 ? void 0 : ref2.payment_method) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                visible: paymentModalVisibility,
                className: "bottom-modal cartValidationErrorMsgModal",
                animation: "slideUp",
                onClose: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: state.selectedPaymentData || state.payOnDelivery ? "tw-pb-[5.0625rem]" : "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "closeicon",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "/assets/images/cancel.png",
                                alt: "cancel"
                            })
                        }),
                        showPartialPayment ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPartialPaymentType, {
                            selectedType: selectedPartialPaymentMode,
                            setSelectedType: handleInputRadioClick
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalAmountSaved/* default */.Z, {
                                    amount: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.amount_saved
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "f4 fw6 pv3",
                                    children: [
                                        "Pay ₹",
                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "f6 fw6 pv3 o-50",
                                    children: "Choose a Payment Method"
                                })
                            ]
                        }),
                        !paymentModalOptionsVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center items-center bg-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                                type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref3 = globalStyle.appLoader) === null || ref3 === void 0 ? void 0 : ref3.loaderId) || "ellipsis",
                                color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref4 = globalStyle.appLoader) === null || ref4 === void 0 ? void 0 : ref4.color
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOptions/* default */.Z, {
                                    onSelect: onSelectPaymentMode
                                }),
                                ((ref5 = (0,codMethodRender/* codMethodRender */.a)(otherMethods, paymentOptionsWithTxnCharge, storeInfo)) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCashOnDelivery/* default */.Z, {
                                    isSelectedCOD: state.payOnDelivery,
                                    toggleCOD: togglePayOnDeliveryCheckbox,
                                    codCharge: codCharge,
                                    ctaType: "cart_confirm_cta"
                                }),
                                renderUnselectablePaymentOption()
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOrPlaceOrderCTA/* PaymentOrPlaceOrderCTA */.G, {
                state: state,
                onProceedToPay: debouncedSubmitPayment,
                onPlaceOrder: onPlaceOrderBtnClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyPayAuth/* default */.Z, {
                onClose: onCloseLazyPayAuthModal
            })
        ]
    });
};
/* harmony default export */ var components_PaymentModal = (PaymentModal);


/***/ }),

/***/ 68102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_getPrepaidInvalidAmountMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37202);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66871);
/* harmony import */ var _utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31891);
/* harmony import */ var _utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94604);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86812);
/* harmony import */ var _utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55311);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25617);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19372);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13886);
/* harmony import */ var _Common_Toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40804);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6337);














var PaymentOptionsGrid = function(param) {
    var onSelect = param.onSelect;
    var ref;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return {
            store: state.storeReducer.store,
            orderDetails: state.orderReducer.orderDetails,
            methods: state.paymentReducer.methods,
            downPaymentMethods: state.paymentReducer.downPaymentMethods,
            paymentOptionsWithTxnCharge: state.paymentReducer.paymentOptionsWithTxnCharge
        };
    }), store = ref1.store, orderDetails = ref1.orderDetails, methods = ref1.methods, downPaymentMethods = ref1.downPaymentMethods, paymentOptionsWithTxnCharge = ref1.paymentOptionsWithTxnCharge;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (store === null || store === void 0 ? void 0 : store.store_id) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) && dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .fetchPaymentMethods */ .F7)({
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
        }));
    }, [
        store,
        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash
    ]);
    var tapOptionForCustomerPayment = function(option, item) {
        /*
      MDR and EMI options are exclusive now.
      So if EMI option is selected then, 
      prePaymentCheckMDRTransactions is now not required.

      if emi payment method selected, then we can avoid using the 
      prePaymentCheckMDRTransactions api.

      Here we can go directly to initPayment for payment using emi
    */ // if (option === PAYMENT_TYPE_CONSTANTS.EMI) {
        //   onTapOption(option, item);
        //   return;
        // }
        if (item && (0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_11__/* .checkIfObjectExists */ .L)(item)) {
            var payload = {
                order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                store_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.store_id,
                payment_option: item
            };
            var callback = function(isTrue) {
                if (isTrue) {
                    onTapOption(option, item);
                    return;
                }
                return;
            };
            (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .batch */ .dC)(function() {
                dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .setCustomerTransactionPaymentMethod */ .j1)(item));
                dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_10__/* .prePaymentCheckMDRTransactions */ .HV)(payload, callback));
            });
        }
    };
    var onTapOption = function(option) {
        var selectedPaymentMethod = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) < _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .MINIMUM_ORDER_AMOUNT */ .BI) {
            (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_8__/* .toastNotifyError */ .Lu)((0,_utils_getPrepaidInvalidAmountMessage__WEBPACK_IMPORTED_MODULE_2__/* .getPrepaidInvalidAmountMessage */ .a)((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_3__/* .getStoreType */ .K)()));
        } else {
            onSelect(option, false, selectedPaymentMethod);
        }
    };
    /**
   * Function to return `card` if item is of type
   * debitCard or creditCard
   * otherwise return as it is
   * @param {*} item
   * @return {*} string
   */ var returnCardForCCAndDC = function(item) {
        if (item === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */ .Mf.DEBIT_CARD || item === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */ .Mf.CREDIT_CARD) {
            return _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.CARD */ .Mf.CARD;
        }
        return item;
    };
    var removePaytmFromMethods = function() {
        var methods = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], isObject = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        // removing paytm form react native webview environment as it is not working properly in webview
        var modes = methods || [];
        var indexOfPaytm = isObject ? modes.findIndex(function(ele) {
            return (ele === null || ele === void 0 ? void 0 : ele.payment_option_name) === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM;
        }) : modes.indexOf(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM);
        if (indexOfPaytm > -1 && _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_WEBVIEW */ .x5) {
            modes.splice(indexOfPaytm, 1);
        }
        return modes;
    };
    /**
   * render component when mdr_flag is 1
   * @return {*}
   */ var renderPaymentOptionOnCustomerTransaction = function() {
        if ((0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_11__/* .checkIfObjectExists */ .L)(paymentOptionsWithTxnCharge)) {
            var ref;
            var down_payment_modes = paymentOptionsWithTxnCharge.down_payment_modes, payment_modes = paymentOptionsWithTxnCharge.payment_modes;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        children: (ref = removePaytmFromMethods(payment_modes, true)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o > 990 && item.payment_option_name !== _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                            else if (item === "whatsapp" && !_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__/* .getMobileOperatingSystem */ .HG)() !== "Android") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                            else return item.payment_option_name !== _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.AMEX_CARD */ .Mf.AMEX_CARD && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: item.payment_option_name,
                                onClick: function() {
                                    return tapOptionForCustomerPayment(returnCardForCCAndDC(item.payment_option_name), item);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "logo-wrap",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (item === null || item === void 0 ? void 0 : item.payment_option_name) === "paytmupi" ? "https://cdn.dotpe.in/kiranaStatic/custom_website/paytmupilogo21august2023.png" : "//cdn.dotpe.in/cfe/image/".concat(returnCardForCCAndDC(item.payment_option_name), ".png"),
                                            alt: "logo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: (0,_utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__/* .getPaymentMethodName */ .d)(item.payment_option_name)
                                    }),
                                    !!item.transaction_charge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "transaction-charge-text",
                                        children: [
                                            item.transaction_charge,
                                            "% convenience fee"
                                        ]
                                    })
                                ]
                            });
                        })
                    }),
                    down_payment_modes && down_payment_modes.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "pt4 pb3 f7 fw6 black-70 lh-title",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "red",
                                        children: "Please Note:"
                                    }),
                                    " The Payment methods below have",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "red",
                                        children: "lower success rate"
                                    }),
                                    " at the moment"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                children: down_payment_modes === null || down_payment_modes === void 0 ? void 0 : down_payment_modes.map(function(item) {
                                    if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o > 990 && item !== "paytm") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                    else if (item.payment_option_name === "whatsapp" && !_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__/* .getMobileOperatingSystem */ .HG)() !== "Android") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                    else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: item.payment_option_name,
                                        onClick: function() {
                                            item === "paytm" ? onSelect(item.payment_option_name, 2) : onSelect(item.payment_option_name, 1);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "logo-wrap",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "//cdn.dotpe.in/cfe/image/".concat(item, ".png"),
                                                    alt: "logo"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: (0,_utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__/* .getPaymentMethodName */ .d)(item.payment_option_name)
                                            })
                                        ]
                                    }, item.payment_option_name);
                                })
                            })
                        ]
                    })
                ]
            });
        }
        return null;
    };
    var renderPaymentOptionOnNormalTransaction = function() {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: (ref = removePaytmFromMethods(methods, false)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o > 990 && item !== _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                        else if (item === "whatsapp" && !_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__/* .getMobileOperatingSystem */ .HG)() !== "Android") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                        else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: item,
                            onClick: function() {
                                return onTapOption(item);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "logo-wrap",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: item === "paytmupi" ? "https://cdn.dotpe.in/kiranaStatic/custom_website/paytmupilogo21august2023.png" : "//cdn.dotpe.in/cfe/image/".concat(item, ".png"),
                                        alt: "logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: (0,_utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__/* .getPaymentMethodName */ .d)(item)
                                })
                            ]
                        }, item);
                    })
                }),
                downPaymentMethods && downPaymentMethods.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "pt4 pb3 f7 fw6 black-70 lh-title",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "red",
                                    children: "Please Note:"
                                }),
                                " The Payment methods below have",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "red",
                                    children: "lower success rate"
                                }),
                                " at the moment"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            children: downPaymentMethods === null || downPaymentMethods === void 0 ? void 0 : downPaymentMethods.map(function(item) {
                                if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o > 990 && item !== "paytm") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                else if (item === "whatsapp" && !_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_9__/* .IS_SERVER */ .W6 && (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_5__/* .getMobileOperatingSystem */ .HG)() !== "Android") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: item,
                                    onClick: function() {
                                        item === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_TYPE_CONSTANTS.PAYTM */ .Mf.PAYTM ? onSelect(item, 2) : onSelect(item, 1);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "logo-wrap",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "//cdn.dotpe.in/cfe/image/".concat(item, ".png"),
                                                alt: "logo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: (0,_utils_getPaymentMethodName__WEBPACK_IMPORTED_MODULE_12__/* .getPaymentMethodName */ .d)(item)
                                        })
                                    ]
                                }, item);
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "paymentOptions-wrapper " + (orderDetails.payment_status === 0 || orderDetails.payment_status === 3 ? "" : "disabled"),
        children: (store === null || store === void 0 ? void 0 : (ref = store.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) ? renderPaymentOptionOnCustomerTransaction() : renderPaymentOptionOnNormalTransaction()
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PaymentOptionsGrid);


/***/ }),

/***/ 64109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ PaymentPromoCouponDetailsModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72651);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86812);
/**
 * This component renders the list of payment promotions
 */ 



var PaymentPromoCouponDetailsModal = function(props) {
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        visible: true,
        height: "auto",
        animation: "slideUp",
        onClose: props.onClose,
        className: "bottom-modal paymentPromoDetailsModal",
        customMaskStyles: {
            background: "#000000e6"
        },
        customStyles: {
            maxWidth: "450px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pb4 vh-75 overflow-scroll",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "close-icon flex justify-center items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assets/images/cancel_white.png",
                        className: "img h2 ",
                        onClick: props.onClose
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "f4 b mv3",
                    children: "Offer Details"
                }),
                ((ref = props.promoData) === null || ref === void 0 ? void 0 : ref.image_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center logo-coupon-desc",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.promoData.image_url,
                            alt: "",
                            width: "60px",
                            height: "60px",
                            className: "mv3 mr3"
                        }),
                        ((ref1 = props.promoData) === null || ref1 === void 0 ? void 0 : ref1.description) && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o > 990 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "f6 b",
                            children: props.promoData.description
                        }) : null
                    ]
                }) : null,
                ((ref2 = props.promoData) === null || ref2 === void 0 ? void 0 : ref2.description) && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o < 990 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "f6 b",
                    children: props.promoData.description
                }) : null,
                props.promoData.promo_code ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "promoCodeBox fw4",
                    children: props.promoData.promo_code
                }) : null,
                props.promoData.notes.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "notesList",
                    children: props.promoData.notes.map(function(data, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "f4",
                            children: data
                        }, index);
                    })
                }) : null
            ]
        })
    });
};


/***/ }),

/***/ 19976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42194);



var ReadMoreReadLess = function(param) {
    var text = param.text, color = param.color, maxChar = param.maxChar;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isReadMore = ref[0], setIsReadMore = ref[1];
    var toggleReadMore = function() {
        return setIsReadMore(!isReadMore);
    };
    var isLongText = (text === null || text === void 0 ? void 0 : text.length) > (maxChar !== null && maxChar !== void 0 ? maxChar : _utils_constant__WEBPACK_IMPORTED_MODULE_2__/* .READ_MORE_TEXT_LIMIT */ .d);
    var displayedText = isReadMore && isLongText ? "".concat(text === null || text === void 0 ? void 0 : text.substring(0, maxChar || _utils_constant__WEBPACK_IMPORTED_MODULE_2__/* .READ_MORE_TEXT_LIMIT */ .d), "...") : text;
    var toggleText = isReadMore ? "Read More" : "Read Less";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "tw-break-all tw-text-[0.75rem] tw-font-normal tw-leading-4 md:tw-text-[0.875rem] tw-text-[".concat(color, "] ").concat(maxChar ? "md:tw-text-[12px]" : "md:tw-text-[0.875rem]"),
        children: [
            displayedText,
            isLongText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                onClick: toggleReadMore,
                className: "tw-cursor-pointer tw-text-[0.75rem] tw-font-medium tw-text-[#0E0E0E] tw-underline md:tw-text-[0.875rem] ".concat(isReadMore ? "" : "tw-pl-[6px]"),
                children: toggleText
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMoreReadLess);


/***/ }),

/***/ 24648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ProductCustomizationPopUp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/utils/SvgExport.js

var PlusIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_115_1132)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
                    fill: color || "#2F80ED"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_115_1132",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var CancelIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_115_1154)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
                    fill: "#0E0E0E"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_115_1154",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ErrorIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_117_1656)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9.16675 12.4998H10.8334V14.1665H9.16675V12.4998ZM9.16675 5.83317H10.8334V10.8332H9.16675V5.83317ZM9.99175 1.6665C5.39175 1.6665 1.66675 5.39984 1.66675 9.99984C1.66675 14.5998 5.39175 18.3332 9.99175 18.3332C14.6001 18.3332 18.3334 14.5998 18.3334 9.99984C18.3334 5.39984 14.6001 1.6665 9.99175 1.6665ZM10.0001 16.6665C6.31675 16.6665 3.33341 13.6832 3.33341 9.99984C3.33341 6.3165 6.31675 3.33317 10.0001 3.33317C13.6834 3.33317 16.6667 6.3165 16.6667 9.99984C16.6667 13.6832 13.6834 16.6665 10.0001 16.6665Z",
                    fill: "#9A0C00"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_117_1656",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var RemoveIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.26667 12.6668L3.33333 11.7335L7.06667 8.00016L3.33333 4.26683L4.26667 3.3335L8 7.06683L11.7333 3.3335L12.6667 4.26683L8.93333 8.00016L12.6667 11.7335L11.7333 12.6668L8 8.9335L4.26667 12.6668Z",
            fill: "#E8EAED"
        })
    });
};
var CartPlusIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? "#0E0E0E" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_286_2302)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.6666 9.16683H8.66659V13.1668H7.33325V9.16683H3.33325V7.8335H7.33325V3.8335H8.66659V7.8335H12.6666V9.16683Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_286_2302",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var CartMinusIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.33325 9.16683V7.8335H12.6666V9.16683H3.33325Z",
            fill: "#0E0E0E"
        })
    });
};
var RightArrowIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_286_2296)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.15845 13.9925L10.9751 10.1675L7.15845 6.34248L8.33345 5.16748L13.3334 10.1675L8.33345 15.1675L7.15845 13.9925Z",
                    fill: "#6B6B6B"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_286_2296",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.16748)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/ImageUploadSection.js


var ImageUpload = function(props) {
    var tempImages = props.tempImages, handleImageUpload = props.handleImageUpload, handleImageRemove = props.handleImageRemove, allImageMandatory = props.allImageMandatory;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pp-image-upload tw-mt-4 tw-flex tw-flex-col tw-gap-[0.75rem]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-[0.5rem]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-text-[0.875rem] tw-font-medium tw-text-[#222] md:tw-text-[1rem]",
                        children: [
                            "Images",
                            !!allImageMandatory && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-ml-[2px] tw-text-[#222]",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-[0.875rem] tw-font-normal tw-text-[#999] md:tw-text-[1rem]",
                        children: "(JPG, PNG up to 5 MB)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-relative tw-grid tw-grid-cols-4 tw-gap-3 md:tw-grid-cols-5",
                children: tempImages === null || tempImages === void 0 ? void 0 : tempImages.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-relative",
                        children: image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-relative tw-h-[70px] tw-w-full md:tw-h-[100px] md:tw-w-[100px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image,
                                    alt: "Upload ".concat(index),
                                    className: "tw-h-full tw-w-full tw-border tw-border-solid tw-border-[#0000001A] tw-object-cover"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-absolute tw-right-[0.25rem] tw-top-[0.25rem] tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-bg-[#000000A6]",
                                    onClick: function() {
                                        return handleImageRemove(index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveIcon, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-h-[70px] tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-border tw-border-solid tw-border-[#E9E9E9] tw-bg-[#F7F7F7] md:tw-h-[100px] md:tw-w-[100px]",
                            onClick: function() {
                                return document.getElementById("upload-".concat(index)).click();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                        color: "#0E0E0E"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "file",
                                    id: "upload-".concat(index),
                                    className: "tw-hidden",
                                    accept: "image/*",
                                    onChange: function(e) {
                                        return handleImageUpload(e, index);
                                    }
                                })
                            ]
                        }, index)
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var ImageUploadSection = (ImageUpload);

;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/TextBox.js

var TextBox = function(props) {
    var textCount = props.textCount, textData = props.textData, handleTextDataChange = props.handleTextDataChange;
    var currentTextLength = (textData === null || textData === void 0 ? void 0 : textData.length) || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pp-text-box tw-flex tw-flex-col tw-gap-[0.75rem]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-gap-[0.5rem]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tw-text-[0.875rem] tw-font-medium tw-text-[#222] md:tw-text-[1rem]",
                    children: "Text"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-gap-[6px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        placeholder: "Enter custom text",
                        className: "personalization__input--textbox tw-h-[105px] tw-resize-none tw-rounded-[4px] tw-border-[#D2D2D2] tw-px-[0.75rem] tw-py-[0.625rem] tw-text-[0.875rem] tw-font-medium tw-leading-5 tw-text-[#0E0E0E] md:tw-text-[1rem]",
                        value: textData || "",
                        onChange: handleTextDataChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-flex tw-justify-end tw-text-[0.75rem] tw-font-normal tw-text-[#6B6B6B] md:tw-text-[0.875rem]",
                        children: [
                            currentTextLength,
                            "/",
                            textCount
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TextBox = (TextBox);

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(36623);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/RenderProductCTA.js



var RenderProductCTA = function(param) {
    var storeInfo = param.storeInfo, checkIsCtaActive = param.checkIsCtaActive, handleAddToCart = param.handleAddToCart, onBuyNowClick = param.onBuyNowClick, source = param.source;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var isCartPage = function() {
        if (true) {
            var pathname = window.location.pathname;
            return pathname.includes("/cart");
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pp-action-cta tw-mt-[16px] tw-flex tw-justify-center tw-gap-[16px] md:tw-gap-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                label: "Add to Cart",
                variant: isCartPage() ? "" : "outline",
                borderColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
                fontSize: "14",
                fontWeight: 500,
                px: "12px",
                py: "12px",
                width: "100%",
                roundness: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness) || "4px",
                className: "".concat(checkIsCtaActive() ? "tw-cursor-pointer tw-opacity-100" : "tw-pointer-events-none tw-opacity-50"),
                onClick: function() {
                    return handleAddToCart("add");
                }
            }),
            !isCartPage() && /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                borderColor: "#EDEDED",
                borderWidth: "0px",
                label: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.cta_config) === null || ref6 === void 0 ? void 0 : ref6.pdp_cta) || (0,getCustomCtaText/* default */.Z)("buy_now_cta"),
                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color,
                fontSize: "14",
                fontWeight: 500,
                px: "12px",
                py: "12px",
                width: "100%",
                roundness: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref9 = storeInfo.theme) === null || ref9 === void 0 ? void 0 : ref9.roundness) || "4px",
                className: "".concat(checkIsCtaActive() ? "tw-cursor-pointer tw-opacity-100" : "tw-pointer-events-none tw-opacity-50"),
                onClick: onBuyNowClick
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetsComponents/CommonComponents/canvasUtils.js
var canvasUtils = __webpack_require__(29616);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/store/index.js + 43 modules
var store = __webpack_require__(24686);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(73175);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/utils/common.js








function readFile(file) {
    return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.addEventListener("load", function() {
            return resolve(reader.result);
        }, false);
        reader.readAsDataURL(file);
    });
}
var validatePersonalization = function(images, textData, productCustomizationCount) {
    var hasNullImages = images === null || images === void 0 ? void 0 : images.some(function(image) {
        return image === null;
    });
    var noImagesUploaded = images === null || images === void 0 ? void 0 : images.every(function(image) {
        return image === null;
    });
    var validationStatus = {
        status: true,
        images: true,
        text: true
    };
    // Check if image is required and cx uploads no image
    if ((productCustomizationCount === null || productCustomizationCount === void 0 ? void 0 : productCustomizationCount.imageCount) && noImagesUploaded) {
        validationStatus.status = false;
        validationStatus.images = false;
    } else if ((productCustomizationCount === null || productCustomizationCount === void 0 ? void 0 : productCustomizationCount.imageCount) && (productCustomizationCount === null || productCustomizationCount === void 0 ? void 0 : productCustomizationCount.allImageMandatory) && hasNullImages) {
        // Check if image count is mandatory and all images must be uploaded
        validationStatus.status = false;
        validationStatus.images = false;
    }
    if ((productCustomizationCount === null || productCustomizationCount === void 0 ? void 0 : productCustomizationCount.textCount) > 0 && (textData === null || textData === void 0 ? void 0 : textData.length) === 0) {
        validationStatus.status = false;
        validationStatus.text = false;
    }
    return validationStatus;
};
var getHeadingText = function(showInitialScreen, personalizedProduct) {
    if (showInitialScreen() && (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.editPersonalizationPopUp)) {
        return "Edit personalisation";
    } else if (showInitialScreen() && !(personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.editPersonalizationPopUp)) {
        return "Personalise this product";
    }
    return (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.actionType) === "inc" ? "Repeat last used personalisation?" : "Your personalisations";
};
var filterNull = function(item, checkType) {
    var ref;
    return item === null || item === void 0 ? void 0 : (ref = item.filter) === null || ref === void 0 ? void 0 : ref.call(item, function(ele) {
        return ele !== checkType;
    });
};
var initializeState = function(personalizedProduct, imageCount) {
    var ref, ref1;
    var ref2;
    var newImages = (ref2 = personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.editableData) === null || ref === void 0 ? void 0 : ref.images) !== null && ref2 !== void 0 ? ref2 : Array.from({
        length: imageCount
    }, function() {
        return null;
    });
    var ref3;
    var newTextData = (ref3 = personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref1 = personalizedProduct.editableData) === null || ref1 === void 0 ? void 0 : ref1.texts) !== null && ref3 !== void 0 ? ref3 : [
        ""
    ];
    return {
        newImages: newImages,
        newTextData: newTextData
    };
};
function blobToByteArray(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        // Event handler for when the Blob has been read successfully
        reader.onload = function(event) {
            var arrayBuffer = event.target.result;
            // Create a byte array from the ArrayBuffer
            var byteArray = new Uint8Array(arrayBuffer);
            resolve(byteArray);
        };
        // Event handler for errors
        reader.onerror = function(error) {
            reject(error);
        };
        // Read the Blob as an ArrayBuffer
        reader.readAsArrayBuffer(blob);
    });
}
function byteArrayToBase64(byteArray) {
    // Convert the byte array to a string
    var binary = "";
    var len = byteArray.byteLength;
    for(var i = 0; i < len; i++){
        binary += String.fromCharCode(byteArray[i]);
    }
    // Convert the binary string to a base64 encoded string
    return btoa(binary);
}
var handleImageUpload = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(e, idx, images, setImages, setErrorState, tempImages, setTempImages) {
        var ref, ref1, file, fileSizeInMB, imageDataUrl, imageType, convertImageToBlob, formData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(e.target.files && e.target.files.length > 0)) return [
                        3,
                        3
                    ];
                    file = e.target.files[0];
                    fileSizeInMB = file.size / (1024 * 1024);
                    if (fileSizeInMB >= 5) {
                        (0,Toast/* toastNotifyError */.Lu)("File size should be less than 5MB");
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        readFile(file)
                    ];
                case 1:
                    imageDataUrl = _state.sent();
                    imageType = (ref = imageDataUrl === null || imageDataUrl === void 0 ? void 0 : imageDataUrl.split(";")[0]) === null || ref === void 0 ? void 0 : ref.split(":")[1];
                    return [
                        4,
                        (0,canvasUtils/* resizedataURL */.YE)(imageDataUrl, 0, 0, imageType)
                    ];
                case 2:
                    convertImageToBlob = _state.sent();
                    formData = new FormData();
                    formData.append("media_type", "store_logo");
                    formData.append("store_id", (ref1 = store/* default.getState */.Z.getState().storeReducer.store) === null || ref1 === void 0 ? void 0 : ref1.store_id);
                    formData.append("media", convertImageToBlob);
                    blobToByteArray(convertImageToBlob).then(function(byteArray) {
                        var str = byteArrayToBase64(byteArray);
                        var newImages = (0,_to_consumable_array/* default */.Z)(images);
                        newImages[idx] = str;
                        setImages(newImages);
                        var newTempImages = (0,_to_consumable_array/* default */.Z)(tempImages);
                        newTempImages[idx] = imageDataUrl;
                        setTempImages(newTempImages);
                        setErrorState("");
                    }).catch(function(error) {
                        console.error("Error:", error);
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleImageUpload(e, idx, images, setImages, setErrorState, tempImages, setTempImages) {
        return _ref.apply(this, arguments);
    };
}();
var handleImageRemove = function(idx, images, setImages, tempImages, setTempImages) {
    var newImageList = (0,_to_consumable_array/* default */.Z)(images);
    newImageList[idx] = null;
    var newTempImageList = (0,_to_consumable_array/* default */.Z)(tempImages);
    newTempImageList[idx] = null;
    setTempImages(newTempImageList);
    setImages(newImageList);
};
var handleTextDataChange = function(e, textCount, setTextData, setErrorState) {
    var newText = e.target.value;
    // Truncate the text if it exceeds textCount
    if (newText.length > textCount) {
        newText = newText.slice(0, textCount);
    }
    setTextData([
        newText
    ]);
    setErrorState("");
};
var checkIsCtaActive = function(images, textData) {
    var ref;
    var hasNonNullImages = images.some(function(image) {
        return image !== null;
    });
    var hasTextData = ((ref = textData[0]) === null || ref === void 0 ? void 0 : ref.length) > 0;
    return hasNonNullImages || hasTextData;
};
var checkIfIncrementAllowed = function(type, productData, cartData) {
    var ref, ref1, ref2;
    var isIncrementAction = type === "add" || type === "inc";
    if (!isIncrementAction) return true;
    var hasVariants = (productData === null || productData === void 0 ? void 0 : productData.variants_count) || (productData === null || productData === void 0 ? void 0 : (ref = productData.variants) === null || ref === void 0 ? void 0 : ref.length) > 0;
    // Variants case
    if (hasVariants) {
        var ref3;
        var activeVariantId = localStorage.getItem("activeVariantId");
        var activeVariant = productData === null || productData === void 0 ? void 0 : (ref3 = productData.variants) === null || ref3 === void 0 ? void 0 : ref3.find(function(el) {
            return "".concat(el === null || el === void 0 ? void 0 : el.variant_id) === activeVariantId;
        });
        if ((0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(activeVariant)) {
            (0,Toast/* toastNotifyInfo */.lU)("No more items available for purchase");
            return false;
        }
        return true;
    }
    // Case of item with no variants
    var itemIndexInCart = cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(el) {
        return (el.id || el.item_id) === ((productData === null || productData === void 0 ? void 0 : productData.id) || (productData === null || productData === void 0 ? void 0 : productData.item_id));
    });
    var productItem = cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : ref2[itemIndexInCart];
    if ((0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(productItem)) {
        (0,Toast/* toastNotifyInfo */.lU)("No more items available for purchase");
        return false;
    }
    return true;
};
var handleCartUpdate = function(type, data, ppIdx, handleAddPersonalizationToLocalState, images, textData, imageCount, textCount, allImageMandatory, personalizedProduct, handleCart, dispatch, productData, source, setImages, setTextData, setErrorState, cartData, scheduleInfo) {
    var ref, ref1;
    var imageData = (data === null || data === void 0 ? void 0 : data.images) || images;
    var text = (data === null || data === void 0 ? void 0 : (ref = data.texts) === null || ref === void 0 ? void 0 : ref[0]) || (textData === null || textData === void 0 ? void 0 : textData[0]);
    var ref2 = validatePersonalization(imageData, text, {
        imageCount: imageCount,
        textCount: textCount,
        allImageMandatory: allImageMandatory
    }), status = ref2.status, imageStatus = ref2.images, textStatus = ref2.text;
    if (!status) {
        if (!imageStatus && !textStatus) {
            setErrorState("Please complete all personalisation details");
        } else if (!imageStatus) {
            var errorText = allImageMandatory ? "Please upload all images." : "At least one image is required";
            setErrorState(errorText);
        } else {
            setErrorState("Please enter text for personalisation");
        }
        return;
    }
    if (!checkIfIncrementAllowed(type, productData, cartData)) {
        dispatch((0,catalog/* closeProductPersonalizationPopUp */.xS)());
        return;
    }
    var ref3;
    var productPersonalizationPayload = {
        images: (data === null || data === void 0 ? void 0 : data.images) || images.filter(function(ele) {
            return ele !== null;
        }),
        texts: (data === null || data === void 0 ? void 0 : data.texts) || textData.filter(function(ele) {
            return ele !== "";
        }),
        quantity: (ref3 = data === null || data === void 0 ? void 0 : (ref1 = data[ppIdx]) === null || ref1 === void 0 ? void 0 : ref1.quantity) !== null && ref3 !== void 0 ? ref3 : 1
    };
    if (type === "add") {
        handleAddPersonalizationToLocalState(productPersonalizationPayload);
    }
    handleCart(type, productPersonalizationPayload, ppIdx, productData, source, null, scheduleInfo);
    if (type === "save") {
        dispatch((0,catalog/* closeProductPersonalizationPopUp */.xS)());
        setImages(Array.from({
            length: imageCount
        }, function() {
            return null;
        }));
        setTextData([
            ""
        ]);
    }
};
var handleByNowClick = function(images, textData, imageCount, textCount, allImageMandatory, onBuyNowClick, setImages, setTextData, setErrorState, scheduleInfo) {
    var ref = validatePersonalization(images, textData[0], {
        imageCount: imageCount,
        textCount: textCount,
        allImageMandatory: allImageMandatory
    }), status = ref.status, imageStatus = ref.images, textStatus = ref.text;
    if (!status) {
        if (!imageStatus && !textStatus) {
            setErrorState("Please complete all personalisation details");
        } else if (!imageStatus) {
            setErrorState("Please upload all images.");
        } else {
            setErrorState("Please enter text for personalisation");
        }
        return;
    }
    var productPersonalizationPayload = {
        images: images.filter(function(ele) {
            return ele !== null;
        }),
        texts: textData.filter(function(ele) {
            return ele !== "";
        }),
        quantity: 1
    };
    onBuyNowClick(productPersonalizationPayload, scheduleInfo);
    setImages(Array.from({
        length: imageCount
    }, function() {
        return null;
    }));
    setTextData([
        ""
    ]);
};

// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/utils/constant.js
var constant = __webpack_require__(42194);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/InitialInputScreen.js









var InitialInputScreen = function(param) {
    var imageCount = param.imageCount, textCount = param.textCount, images = param.images, setImages = param.setImages, tempImages = param.tempImages, setTempImages = param.setTempImages, textData = param.textData, setTextData = param.setTextData, errorState = param.errorState, setErrorState = param.setErrorState, storeInfo = param.storeInfo, personalizedProduct = param.personalizedProduct, handleCart = param.handleCart, productData = param.productData, source = param.source, allImageMandatory = param.allImageMandatory, onBuyNowClick = param.onBuyNowClick, cartData = param.cartData, handleAddPersonalizationToLocalState = param.handleAddPersonalizationToLocalState, personalizationLocalState = param.personalizationLocalState, _scheduleInfo = param.scheduleInfo, scheduleInfo = _scheduleInfo === void 0 ? null : _scheduleInfo;
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!imageCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploadSection, {
                images: images,
                tempImages: tempImages,
                allImageMandatory: allImageMandatory,
                setImages: setImages,
                handleImageUpload: function(e, idx) {
                    return handleImageUpload(e, idx, images, setImages, setErrorState, tempImages, setTempImages);
                },
                handleImageRemove: function(idx) {
                    return handleImageRemove(idx, images, setImages, tempImages, setTempImages);
                }
            }),
            !!textCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextBox, {
                textCount: textCount,
                textData: textData[0],
                handleTextDataChange: function(e) {
                    return handleTextDataChange(e, textCount, setTextData, setErrorState);
                }
            }),
            errorState && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-[0.875rem] tw-font-medium tw-text-[#9A0C00]",
                        children: errorState
                    })
                ]
            }),
            (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.editPersonalizationPopUp) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-border-none tw-bg-black tw-py-[0.75rem] tw-text-[0.875rem] tw-font-medium tw-text-[#fff]",
                style: {
                    backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) || "black"
                },
                onClick: function() {
                    var ref;
                    return handleCartUpdate(constant/* OPERATION_TYPE.SAVE */.f.SAVE, personalizationLocalState, personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.personalizationData) === null || ref === void 0 ? void 0 : ref.index, null, images, textData, imageCount, textCount, allImageMandatory, personalizedProduct, handleCart, dispatch, productData, source, setImages, setTextData, setErrorState, cartData);
                },
                children: "Save Changes"
            }) : (!!imageCount || !!textCount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderProductCTA, {
                storeInfo: storeInfo,
                checkIsCtaActive: function() {
                    return checkIsCtaActive(images, textData);
                },
                handleAddToCart: function() {
                    return handleCartUpdate("add", personalizationLocalState, null, handleAddPersonalizationToLocalState, images, textData, imageCount, textCount, allImageMandatory, personalizedProduct, handleCart, dispatch, productData, source, setImages, setTextData, setErrorState, cartData, scheduleInfo);
                },
                onBuyNowClick: function() {
                    return handleByNowClick(images, textData, imageCount, textCount, allImageMandatory, onBuyNowClick, setImages, setTextData, setErrorState, scheduleInfo);
                },
                source: source
            })
        ]
    });
};
/* harmony default export */ var components_InitialInputScreen = (InitialInputScreen);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/components/ReadMoreReadLess.js
var ReadMoreReadLess = __webpack_require__(19976);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(68037);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/CartItemInput.tsx
var CartItemInput = __webpack_require__(98221);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/IncrementProductPersonalizationScreen.js













var IncrementProductPersonalizationScreen = function(param) {
    var cartData = param.cartData, personalizedProduct = param.personalizedProduct, setImages = param.setImages, setTempImages = param.setTempImages, setTextData = param.setTextData, imageCount = param.imageCount, handleCart = param.handleCart, productData = param.productData, source = param.source, personalizationLocalState = param.personalizationLocalState, setPersonalizationLocalState = param.setPersonalizationLocalState, storeData = param.storeData;
    var getPersonalizationTotalQuantity = function getPersonalizationTotalQuantity(newState) {
        var ref;
        return (ref = newState || personalizationLocalState) === null || ref === void 0 ? void 0 : ref.reduce(function(sum, item) {
            return sum + (item.quantity || 0);
        }, 0);
    };
    var addNewPersonalization = function addNewPersonalization() {
        if (!allowItemAddition()) {
            (0,Toast/* toastNotifyInfo */.lU)("Unable to add new personalization as item limits exceeded");
            return;
        }
        dispatch((0,catalog/* openProductPersonalizationPopUp */.w4)());
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var ref9 = (0,react.useState)(false), showConfirmCTA = ref9[0], setShowConfirmCTA = ref9[1];
    var isEditable = !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.custom_cart_item_quantity_flag);
    var handleEditPersonalization = function(param) {
        var _data = param.data, data = _data === void 0 ? {} : _data, _personalizedProductData = param.personalizedProductData, personalizedProductData = _personalizedProductData === void 0 ? {} : _personalizedProductData, _idx = param.idx, idx = _idx === void 0 ? null : _idx;
        var filledImages = new Array(imageCount).fill(null).map(function(_, i) {
            return (data === null || data === void 0 ? void 0 : data.images[i]) || null;
        });
        setImages(filledImages);
        setTempImages(filledImages);
        setTextData(data === null || data === void 0 ? void 0 : data.texts);
        dispatch((0,catalog/* editProductPersonalization */.Ux)({
            personalizedProductData: personalizedProductData ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, personalizedProductData), {
                index: idx
            }) : {}
        }));
    };
    var allowItemAddition = function() {
        var newState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var ref, ref1;
        var itemIndexInCart = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.findIndex(function(el) {
            return ((el === null || el === void 0 ? void 0 : el.id) || (el === null || el === void 0 ? void 0 : el.item_id)) === ((productData === null || productData === void 0 ? void 0 : productData.id) || (productData === null || productData === void 0 ? void 0 : productData.item_id));
        });
        var productItem = (cartData === null || cartData === void 0 ? void 0 : cartData.items) && cartData.items[itemIndexInCart] || null;
        var totalQuantity = getPersonalizationTotalQuantity(newState);
        if ((productItem === null || productItem === void 0 ? void 0 : productItem.variants_count) || !!(productItem === null || productItem === void 0 ? void 0 : (ref1 = productItem.variants_selected) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            var variantsPresentInCart = (productItem === null || productItem === void 0 ? void 0 : productItem.variants_selected) || [];
            var activeVariantId = checkRenderEnv/* IS_CLIENT */.kc && localStorage.getItem("activeVariantId");
            var activeVariant = variantsPresentInCart === null || variantsPresentInCart === void 0 ? void 0 : variantsPresentInCart.find(function(variant) {
                return "".concat(variant === null || variant === void 0 ? void 0 : variant.variant_id) === activeVariantId;
            });
            if (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.managed_inventory) {
                return totalQuantity < (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.available_quantity);
            }
        } else {
            if ((productItem === null || productItem === void 0 ? void 0 : productItem.managed_inventory) && totalQuantity >= (productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity)) {
                return false;
            }
        }
        return true;
    };
    var updateLocalQuantity = function(idx, type) {
        var count = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        setPersonalizationLocalState(function(prevState) {
            var newState = (0,_to_consumable_array/* default */.Z)(prevState);
            var item = (0,_object_spread/* default */.Z)({}, newState[idx]);
            if (type === "inc") {
                if (allowItemAddition()) {
                    item.quantity = (item.quantity || 0) + 1;
                    setShowConfirmCTA(true);
                } else {
                    (0,Toast/* toastNotifyInfo */.lU)("No more units available for purchase");
                }
            } else if (type === "dec") {
                item.quantity = Math.max((item.quantity || 0) - 1, 0);
                setShowConfirmCTA(true);
            } else if (type === "custom") {
                var currentQuantity = item.quantity;
                item.quantity = count;
                newState[idx] = item;
                if (allowItemAddition(newState)) {
                    setShowConfirmCTA(true);
                } else {
                    item.quantity = currentQuantity;
                }
            }
            newState[idx] = item;
            return newState;
        });
    };
    var handleConfirmChanges = function() {
        handleCart("confirm", null, null, productData, source, personalizationLocalState);
        dispatch((0,catalog/* closeProductPersonalizationPopUp */.xS)());
        setShowConfirmCTA(false);
        setPersonalizationLocalState([]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[1.5rem] tw-rounded-lg tw-shadow-[2px_2px_8px_0px_#0000000a]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " tw-flex tw-flex-col tw-rounded-[8px] tw-bg-[#fff] tw-pb-[1.25rem]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex-tw-flex-col",
                        children: personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : personalizationLocalState.map(function(data, idx) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                            var text = data === null || data === void 0 ? void 0 : (ref = data.texts) === null || ref === void 0 ? void 0 : ref[0];
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-gap-[1.5rem] tw-border-b tw-border-solid tw-border-[#d9d9d9] tw-pb-[1.125rem] tw-pt-[1.25rem]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-w-[75%] tw-flex-col tw-gap-[0.5rem] tw-pl-[1rem] md:tw-gap-[0.75rem]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-[0.75rem] tw-font-semibold tw-leading-5 tw-text-[#0E0E0E] md:tw-text-[14px]",
                                                children: personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref1 = personalizedProduct.personalizationData) === null || ref1 === void 0 ? void 0 : ref1.item_name
                                            }),
                                            !!(data === null || data === void 0 ? void 0 : (ref2 = data.images) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tw-flex tw-flex-wrap tw-gap-[0.75rem]",
                                                children: data === null || data === void 0 ? void 0 : (ref3 = data.images) === null || ref3 === void 0 ? void 0 : ref3.map(function(imageDataUrl, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: imageDataUrl,
                                                        alt: "product-image",
                                                        width: "46px",
                                                        height: "48px",
                                                        className: "tw-rounded tw-border tw-border-solid tw-border-[#0000001A]"
                                                    }, idx);
                                                })
                                            }),
                                            !!(text === null || text === void 0 ? void 0 : text.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreReadLess/* default */.Z, {
                                                    text: text,
                                                    color: "#4E4E4E"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-flex tw-items-center",
                                                onClick: function() {
                                                    return handleEditPersonalization({
                                                        data: data,
                                                        personalizedProductData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationData), {
                                                            quantity: data === null || data === void 0 ? void 0 : data.quantity
                                                        }),
                                                        idx: idx
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-flex tw-cursor-pointer tw-items-center tw-text-[0.875rem] tw-font-semibold tw-text-[#4E4E4E]",
                                                        children: "Edit personalisation"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-flex tw-items-center tw-pt-[2px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIcon, {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-fl-col tw-flex tw-w-[25%] tw-flex-col tw-gap-[1.125rem] tw-pr-[1rem]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-flex ".concat(isEditable ? "tw-w-[120px]" : "tw-w-[92px]", " tw-items-center tw-justify-between tw-gap-[0.625rem] tw-self-end tw-rounded tw-border tw-border-solid tw-border-[#000] tw-p-[0.5rem] tw-text-[0.875rem] tw-font-normal"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-flex tw-cursor-pointer tw-items-center tw-justify-center",
                                                        onClick: function() {
                                                            return updateLocalQuantity(idx, "dec");
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMinusIcon, {})
                                                    }),
                                                    isEditable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemInput/* default */.Z, {
                                                        value: personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : (ref4 = personalizationLocalState[idx]) === null || ref4 === void 0 ? void 0 : ref4.quantity,
                                                        onChange: function(value) {
                                                            return updateLocalQuantity(idx, "custom", value || 1);
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : (ref5 = personalizationLocalState[idx]) === null || ref5 === void 0 ? void 0 : ref5.quantity
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-flex tw-cursor-pointer tw-items-center tw-justify-center",
                                                        onClick: function() {
                                                            return updateLocalQuantity(idx, "inc");
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPlusIcon, {
                                                            color: allowItemAddition() ? "#0E0E0E" : "#ccc"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "tw-self-end tw-text-[0.875rem] tw-font-normal tw-leading-5",
                                                children: [
                                                    "₹",
                                                    (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref6 = personalizedProduct.personalizationData) === null || ref6 === void 0 ? void 0 : ref6.discounted_price) * (personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : (ref7 = personalizationLocalState[idx]) === null || ref7 === void 0 ? void 0 : ref7.quantity)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, idx);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-[1.125rem] tw-flex tw-items-center tw-justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-[0.5rem]",
                            onClick: addNewPersonalization,
                            style: !allowItemAddition() ? {
                                opacity: 0.3,
                                color: (storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color) || "#1F1F1F"
                            } : {
                                color: (storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color) || "#1F1F1F"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                    color: (storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.colors) === null || ref6 === void 0 ? void 0 : ref6.primary_color) || "#000"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-[0.875rem] tw-font-semibold",
                                    children: "Add a new personalisation"
                                })
                            ]
                        })
                    })
                ]
            }),
            showConfirmCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-border-none tw-bg-black tw-py-[0.75rem] tw-text-[0.875rem] tw-font-medium tw-text-[#fff]",
                onClick: handleConfirmChanges,
                style: {
                    backgroundColor: (storeData === null || storeData === void 0 ? void 0 : (ref7 = storeData.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color) || "black"
                },
                children: "Confirm"
            })
        ]
    });
};
/* harmony default export */ var components_IncrementProductPersonalizationScreen = (IncrementProductPersonalizationScreen);

// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(91240);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/index.js












var ProductCustomizationPopUp = function(props) {
    var ref, ref1;
    var _scheduleInfoFromProps = props.scheduleInfoFromProps, scheduleInfoFromProps = _scheduleInfoFromProps === void 0 ? null : _scheduleInfoFromProps;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2, ref3, ref4;
        return {
            productData: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.personalizedProduct) === null || ref1 === void 0 ? void 0 : ref1.productData,
            productCustomizationCount: (ref2 = state.catalogReducer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.personalizedProduct) === null || ref3 === void 0 ? void 0 : ref3.productCustomizationCount,
            personalizedProduct: (ref4 = state.catalogReducer) === null || ref4 === void 0 ? void 0 : ref4.personalizedProduct,
            storeInfo: state.storeReducer.store,
            cartData: state.cartReducer,
            scheduleInfo: state.commonReducer.scheduleInfo
        };
    }), productData = ref2.productData, productCustomizationCount = ref2.productCustomizationCount, personalizedProduct = ref2.personalizedProduct, storeInfo = ref2.storeInfo, cartData = ref2.cartData, scheduleInfo = ref2.scheduleInfo;
    var ref3 = productCustomizationCount || {}, _imageCount = ref3.imageCount, imageCount = _imageCount === void 0 ? 0 : _imageCount, _textCount = ref3.textCount, textCount = _textCount === void 0 ? 0 : _textCount, _allImageMandatory = ref3.allImageMandatory, allImageMandatory = _allImageMandatory === void 0 ? false : _allImageMandatory;
    var ref4 = (0,react.useState)(Array.from({
        length: imageCount
    }, function() {
        return null;
    })), images = ref4[0], setImages = ref4[1];
    var ref5 = (0,react.useState)(Array.from({
        length: imageCount
    }, function() {
        return null;
    })), tempImages = ref5[0], setTempImages = ref5[1];
    var ref6 = (0,react.useState)([
        ""
    ]), textData = ref6[0], setTextData = ref6[1]; // Initialize as an array with one empty string
    var ref7 = (0,react.useState)(""), errorState = ref7[0], setErrorState = ref7[1];
    var ref8;
    // Usecase : To keep track of updated quantity and personalisations in popup, before user clicks on confirm changes.
    var ref9 = (0,react.useState)((ref8 = personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.personalizationData) === null || ref === void 0 ? void 0 : (ref1 = ref.personalization_info) === null || ref1 === void 0 ? void 0 : ref1.personalizations) !== null && ref8 !== void 0 ? ref8 : []), personalizationLocalState = ref9[0], setPersonalizationLocalState = ref9[1];
    var ref10 = (0,react.useState)(productData), product = ref10[0], setProduct = ref10[1];
    var ref11 = (0,useCartHandler/* useCartHandlers */.u)(), handleCart = ref11.handleCart, onBuyNowClick = ref11.onBuyNowClick;
    (0,react.useEffect)(function() {
        var ref;
        var ref1;
        var newTextData = (ref1 = personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.editableData) === null || ref === void 0 ? void 0 : ref.texts) !== null && ref1 !== void 0 ? ref1 : [
            ""
        ];
        var filledImages = new Array(imageCount).fill(null).map(function(_, i) {
            var ref, ref1;
            return (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.editableData) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1[i]) || null;
        });
        setImages(filledImages);
        setTempImages(filledImages);
        setTextData(newTextData);
        setProduct(productData);
    }, [
        personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.editableData,
        productData,
        personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp, 
    ]);
    (0,react.useEffect)(function() {
        setPersonalizationLocalState(function() {
            var ref, ref1;
            return (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.personalizationData) === null || ref === void 0 ? void 0 : (ref1 = ref.personalization_info) === null || ref1 === void 0 ? void 0 : ref1.personalizations) || [];
        });
    }, [
        personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationData
    ]);
    var handleModalClose = function() {
        checkRenderEnv/* IS_CLIENT */.kc && localStorage.removeItem("activeVariantId");
        dispatch((0,catalog/* closeProductPersonalizationPopUp */.xS)());
    };
    var showInitialScreen = function() {
        return personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.showInitialInputScreen;
    };
    var handleAddPersonalizationToLocalState = function(data) {
        setPersonalizationLocalState(function(prevLocalState) {
            return (0,_to_consumable_array/* default */.Z)(prevLocalState).concat([
                data
            ]);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp,
        className: "bottom-modal !tw-z-[999] ".concat(showInitialScreen() ? "product-customization-modal-initial " : "product-customization-modal-card "),
        animation: "slideUp",
        onClose: handleModalClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-h-full tw-w-full md:tw-px-[0.75rem] md:tw-py-[0.75rem]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-relative tw-flex tw-flex-col ".concat(showInitialScreen() ? "tw-gap-[2rem]" : "tw-gap-[1.5rem]", " "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-[0px] tw-text-[1rem] tw-font-bold tw-text-[#000] md:tw-text-[1.5rem]",
                        children: getHeadingText(showInitialScreen, personalizedProduct)
                    }),
                    showInitialScreen() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InitialInputScreen, {
                        imageCount: imageCount,
                        textCount: textCount,
                        images: images,
                        tempImages: tempImages,
                        setTempImages: setTempImages,
                        setImages: setImages,
                        textData: textData,
                        setTextData: setTextData,
                        errorState: errorState,
                        setErrorState: setErrorState,
                        storeInfo: storeInfo,
                        personalizedProduct: personalizedProduct,
                        handleCart: handleCart,
                        productData: product,
                        source: "",
                        allImageMandatory: allImageMandatory,
                        onBuyNowClick: onBuyNowClick,
                        cartData: cartData,
                        handleAddPersonalizationToLocalState: handleAddPersonalizationToLocalState,
                        personalizationLocalState: personalizationLocalState,
                        scheduleInfo: scheduleInfoFromProps || scheduleInfo
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IncrementProductPersonalizationScreen, {
                        personalizedProduct: personalizedProduct,
                        storeData: storeInfo,
                        cartData: cartData,
                        setImages: setImages,
                        setTempImages: setTempImages,
                        setTextData: setTextData,
                        imageCount: imageCount,
                        handleCart: handleCart,
                        productData: product,
                        source: "",
                        personalizationLocalState: personalizationLocalState,
                        setPersonalizationLocalState: setPersonalizationLocalState
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-absolute tw-right-[-8px] tw-top-[-0.7rem] tw-cursor-pointer md:tw-right-[-16px] md:tw-top-[-1rem]",
                        onClick: handleModalClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelIcon, {})
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 42194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ READ_MORE_TEXT_LIMIT; },
/* harmony export */   "f": function() { return /* binding */ OPERATION_TYPE; }
/* harmony export */ });
var READ_MORE_TEXT_LIMIT = 50;
var OPERATION_TYPE = {
    ADD: "add",
    INC: "inc",
    DEC: "dec",
    SAVE: "save"
};


/***/ }),

/***/ 97713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pi": function() { return /* binding */ parseFormattedDate; },
/* harmony export */   "YZ": function() { return /* binding */ convertTo12HourFormat; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

function formatDate(date) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(date).format("Do MMMM, YYYY");
}
function parseFormattedDate(formattedDate) {
    if (!formattedDate) {
        return null;
    }
    var date = moment__WEBPACK_IMPORTED_MODULE_0___default()(formattedDate, "Do MMMM, YYYY", true);
    return date.isValid() ? date.toDate() : null;
}
function convertTo12HourFormat(time24) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(time24, "HH:mm").format("h:mm A");
}


/***/ }),

/***/ 27913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _BasicModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75868);
/* harmony import */ var src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70758);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31024);






var QuntityUnavailableAlert = function() {
    var closeModal = function closeModal() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .setUnavailableQuantityAlertState */ .K6)({
            show: false,
            availableQuantity: null,
            onConfirm: null,
            onCancel: null
        }));
    };
    var onClose = function onClose() {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        show && closeModal();
    };
    var onConfirmClick = function onConfirmClick() {
        onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
        closeModal();
    };
    var themeColor = (0,src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_3__/* .getThemeColor */ .p)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer.unavailableQuantityAlertState;
    }), availableQuantity = ref.availableQuantity, onConfirm = ref.onConfirm, onCancel = ref.onCancel, show = ref.show;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            return onClose();
        };
    }, []);
    if (!show) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BasicModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        show: true,
        showCloseIcon: false,
        onClose: onClose,
        heading: "Item quantity not available",
        headingClasses: "!tw-border-none !tw-pt-[32px] !tw-px-[16px] md:!tw-px-[24px]",
        customClasses: "!tw-max-w-[440px] !tw-min-w-[300px]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[24px] tw-px-[16px] tw-pb-[22px] md:tw-px-[24px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "tw-m-0 tw-text-sm tw-text-[#606060]",
                    children: [
                        "We only have ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                            children: [
                                availableQuantity,
                                " quantity"
                            ]
                        }),
                        " available for this item, Do you wish to purchase this quantity?"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-justify-end tw-gap-[16px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: onClose,
                            className: "tw-cursor-pointer tw-border tw-border-solid tw-border-[#383838] tw-bg-transparent tw-p-[12px]",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: onConfirmClick,
                            className: "tw-cursor-pointer tw-border-none tw-p-[12px] tw-text-white",
                            style: {
                                backgroundColor: themeColor || "#000000"
                            },
                            children: "Update Quantity"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QuntityUnavailableAlert);


/***/ }),

/***/ 25269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_UserAddressCard; }
});

// UNUSED EXPORTS: renderAddressTypeIcon

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/InfoOutlined.js
var InfoOutlined = __webpack_require__(36804);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/assets/svgExports/HomeDarkIcon.js

function HomeDarkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "11",
        viewBox: "0 0 10 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.73138 4.84952C9.73115 4.84929 9.73092 4.84906 9.73069 4.84883L5.65107 0.769775C5.47718 0.595825 5.24598 0.5 5.00006 0.5C4.75414 0.5 4.52295 0.595749 4.34898 0.769699L0.271492 4.84669C0.270118 4.84807 0.268745 4.84952 0.267372 4.85089C-0.0897206 5.21001 -0.0891102 5.79266 0.269126 6.15086C0.432794 6.31459 0.648956 6.40942 0.880074 6.41934C0.889459 6.42026 0.898921 6.42072 0.908459 6.42072H1.07106V9.42265C1.07106 10.0167 1.55443 10.5 2.14867 10.5H3.74475C3.90651 10.5 4.03774 10.3689 4.03774 10.207V7.85352C4.03774 7.58244 4.25826 7.36195 4.52936 7.36195H5.47077C5.74187 7.36195 5.96238 7.58244 5.96238 7.85352V10.207C5.96238 10.3689 6.09354 10.5 6.25538 10.5H7.85146C8.44569 10.5 8.92907 10.0167 8.92907 9.42265V6.42072H9.07984C9.32568 6.42072 9.55688 6.32497 9.73092 6.15102C10.0895 5.79221 10.0897 5.20856 9.73138 4.84952Z",
            fill: "black"
        })
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/OtherDarkIcon.js

function OtherDarkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "11",
        height: "11",
        viewBox: "0 0 11 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_10_4884)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.125 0C6.21857 0.00145065 7.26694 0.436513 8.04021 1.20979C8.81349 1.98306 9.24855 3.03143 9.25 4.125C9.25 7.0864 5.40688 10.7955 5.24359 10.9519C5.21183 10.9827 5.16929 11 5.125 11C5.08071 11 5.03817 10.9827 5.00641 10.9519C4.84313 10.7955 1 7.0864 1 4.125C1.00145 3.03143 1.43651 1.98306 2.20979 1.20979C2.98306 0.436513 4.03143 0.00145065 5.125 0ZM5.125 6.01562C5.49893 6.01562 5.86446 5.90474 6.17537 5.69699C6.48629 5.48925 6.72861 5.19398 6.87171 4.84851C7.01481 4.50304 7.05225 4.1229 6.9793 3.75616C6.90635 3.38941 6.72628 3.05253 6.46187 2.78813C6.19747 2.52372 5.86059 2.34365 5.49384 2.2707C5.1271 2.19775 4.74696 2.23519 4.40149 2.37829C4.05602 2.52139 3.76075 2.76371 3.553 3.07462C3.34526 3.38554 3.23438 3.75107 3.23438 4.125C3.23468 4.62633 3.43396 5.10704 3.78846 5.46154C4.14295 5.81604 4.62367 6.01532 5.125 6.01562Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_10_4884",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "11",
                        height: "11",
                        fill: "white",
                        transform: "matrix(-1 0 0 1 11 0)"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/WorkDarkIcon.js

function WorkDarkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.714286 2.5H2.85714V0.375C2.85714 0.168 3.01714 0 3.21429 0H6.78571C6.98286 0 7.14286 0.168 7.14286 0.375V2.5H9.28571C9.68 2.5 10 2.836 10 3.25V9.25C10 9.664 9.68 10 9.28571 10H0.714286C0.32 10 0 9.664 0 9.25V3.25C0 2.836 0.32 2.5 0.714286 2.5ZM3.57143 2.5H6.42857V0.75H3.57143V2.5Z",
            fill: "black"
        })
    });
}

// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
;// CONCATENATED MODULE: ./src/components/UserAddressCard/index.tsx







var renderAddressTypeIcon = function(type) {
    switch(type){
        case "home":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeDarkIcon, {});
        case "work":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkDarkIcon, {});
        case "others":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherDarkIcon, {});
    }
};
var UserAddressCard = function(param) {
    var _onEditClick = param.onEditClick, onEditClick = _onEditClick === void 0 ? null : _onEditClick, _onDeliverClick = param.onDeliverClick, onDeliverClick = _onDeliverClick === void 0 ? null : _onDeliverClick, _estimatedDeliveryTime = param.estimatedDeliveryTime, estimatedDeliveryTime = _estimatedDeliveryTime === void 0 ? null : _estimatedDeliveryTime, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _userName = param.userName, userName = _userName === void 0 ? "" : _userName, _addressType = param.addressType, addressType = _addressType === void 0 ? "home" : _addressType, _addressName = param.addressName, addressName = _addressName === void 0 ? "" : _addressName, _alternatePhone = param.alternatePhone, alternatePhone = _alternatePhone === void 0 ? "" : _alternatePhone, _address1 = param.address1, address1 = _address1 === void 0 ? "" : _address1, _address2 = param.address2, address2 = _address2 === void 0 ? "" : _address2, _city = param.city, city = _city === void 0 ? "" : _city, _state = param.state, state = _state === void 0 ? "" : _state, _pincode = param.pincode, pincode = _pincode === void 0 ? "" : _pincode, _isIncomplete = param.isIncomplete, isIncomplete = _isIncomplete === void 0 ? false : _isIncomplete, _isUnserviceable = param.isUnserviceable, isUnserviceable = _isUnserviceable === void 0 ? false : _isUnserviceable;
    var getTrimmedString = function getTrimmedString(str) {
        return str.length > 6 ? str.slice(0, 6) + "..." : str;
    };
    var buttonsData = [
        {
            text: isIncomplete ? "Add missing details" : onDeliverClick ? "Edit" : "Edit Address",
            onClick: onEditClick,
            show: !!onEditClick
        },
        {
            text: "Deliver Here",
            onClick: onDeliverClick,
            show: !isSelected && !!onDeliverClick
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw- tw-flex tw-flex-col tw-gap-[12px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E2E2E2] tw-pt-[12px] md:tw-border-none md:tw-p-0 " + customClasses,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-gap-[4px] tw-px-[16px] md:tw-p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-sm",
                                children: userName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-flex tw-items-center tw-gap-[4px] tw-text-xs",
                                children: [
                                    renderAddressTypeIcon(addressType),
                                    getTrimmedString((0,lodash.capitalize)(addressName || addressType))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-sm tw-text-[#7D7D7D]",
                        children: alternatePhone
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-sm tw-text-[#7D7D7D]",
                        children: [
                            address1,
                            address2,
                            city,
                            state,
                            pincode
                        ].filter(function(data) {
                            return !!data;
                        }).join(", ")
                    }),
                    isIncomplete && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-m-0 tw-flex tw-items-center tw-text-sm tw-text-[#E2574C] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                fontSize: "small"
                            }),
                            " Incomplete address"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col-reverse tw-justify-between tw-gap-[12px] md:tw-flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-divide-x tw-border-t tw-border-solid tw-border-[#E2E2E2] md:tw-flex-row-reverse md:tw-gap-[16px] md:tw-border-none",
                        children: buttonsData.map(function(data, index) {
                            return data.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-flex tw-flex-1 tw-cursor-pointer tw-justify-center tw-border-r tw-border-solid tw-border-[#E2E2E2] tw-px-[16px] tw-py-[12px] tw-text-sm tw-font-semibold last:tw-border-none md:tw-flex-none md:tw-border-none md:tw-p-0",
                                style: {
                                    color: (0,getThemeColor/* getThemeColor */.p)()
                                },
                                onClick: data.onClick,
                                children: data.text
                            }, index);
                        })
                    }),
                    !!estimatedDeliveryTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-px-[16px] tw-text-xs tw-italic md:tw-p-0",
                        children: estimatedDeliveryTime
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_UserAddressCard = (UserAddressCard);


/***/ }),

/***/ 32948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52388);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31024);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96031);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66162);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72651);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59186);









var VariantChooseRepeatModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        repeatIndex: null,
        theme: null
    }), state = ref14[0], setState = ref14[1];
    var ref15 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }), chooseRepeatModal = ref15.variant.chooseRepeatModal, productLoaderId = ref15.productLoaderId;
    var cartData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.cartReducer;
    });
    var ref16 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }), theme = ref16.theme, store_id = ref16.store_id;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            var productIndex = cartData.items.findIndex(function(el) {
                return el.id === productLoaderId;
            });
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    repeatIndex: productIndex
                });
            });
        }
    }, [
        chooseRepeatModal,
        cartData,
        productLoaderId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    theme: theme
                });
            });
        }
    }, [
        chooseRepeatModal,
        theme
    ]);
    var onClose = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .setChooseAndRepeatModalVisibility */ .uT)(false));
    };
    var onIWillChooseBtnHandle = function() {
        /** get the details item for this item id */ dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchCatalogItemById */ .eP)({
            store_id: store_id,
            item_id: productLoaderId,
            src: "variant_choose_repeat_modal"
        }, true));
        onClose();
    };
    var onRepeatBtnHandle = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__/* .mutateVariantItemWithCartData */ .I)("repeat", cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[state.repeatIndex], cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[state.repeatIndex]) === null || ref2 === void 0 ? void 0 : ref2.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref3 = cartData.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[state.repeatIndex]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.variants_selected) === null || ref5 === void 0 ? void 0 : ref5.length) - 1], cartData);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .saveCart */ .FP)(newCart));
        onClose();
    };
    return chooseRepeatModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: chooseRepeatModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modal variantChooseRepeatModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "closeicon",
                onClick: onClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    loading: "lazy",
                    src: "/assets/images/cancel.png",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "title",
                children: "Choose a Variant"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sub-title",
                children: "Your Last Choice"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                className: "variant-name",
                children: (ref5 = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.repeatIndex]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.repeatIndex]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants_selected) === null || ref4 === void 0 ? void 0 : ref4.length) - 1]) === null || ref5 === void 0 ? void 0 : ref5.variant_name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "choose_btn pointer",
                        style: {
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref6 = state.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness)) : "8px"),
                            borderColor: "".concat(state.theme ? (ref7 = state.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color : "#EA5151"),
                            color: "".concat(state.theme ? (ref9 = state.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color : "#EA5151")
                        },
                        onClick: onIWillChooseBtnHandle,
                        children: "I’LL CHOOSE"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "repeat_btn pointer",
                        style: {
                            backgroundColor: "".concat(state.theme ? (ref11 = state.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color : "#EA5151"),
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref13 = state.theme) === null || ref13 === void 0 ? void 0 : ref13.roundness)) : "8px"),
                            color: "#ffffff"
                        },
                        onClick: onRepeatBtnHandle,
                        children: "REPEAT"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VariantChooseRepeatModal);


/***/ }),

/***/ 40261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72651);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86812);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/* harmony import */ var _components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(52388);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96031);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(31024);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(66162);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(67936);
/* harmony import */ var _VariantRadioGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16873);
/* harmony import */ var _utils_selectedVariantFromVariantList__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(82983);
/* harmony import */ var _utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(48670);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44541);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Common_Toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40804);
/* harmony import */ var _DesignSystem_AtomicComponents__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38855);
/* harmony import */ var _DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51592);
/* harmony import */ var _assets_svgExports_MinusIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82513);
/* harmony import */ var _assets_svgExports_PlusIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8886);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36623);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13886);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59186);
/* harmony import */ var _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44779);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6337);
/* harmony import */ var _hooks_useCartHandler__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(91240);

























var VariantModal = function(props) {
    var ref, ref1, ref2, ref3;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        variantIndex: -1,
        variantId: -1
    }), activeVariant = ref4[0], setActiveVariant = ref4[1];
    var ref5 = (0,_hooks_useCartHandler__WEBPACK_IMPORTED_MODULE_18__/* .useCartHandlers */ .u)(), handleIncreamentClick = ref5.handleIncreamentClick, handleDecreamentClick = ref5.handleDecreamentClick, handleSetProductData = ref5.handleSetProductData, handleSetState = ref5.handleSetState, onPersonalizeProductClick = ref5.onPersonalizeProductClick, handleSetProductCustomizationCount = ref5.handleSetProductCustomizationCount;
    /*
   state created to handle cart changes that are not saved.
   for eg, if user adds quantity of variant but does't save the change/ add to cart,
   then global cart data will not get changed
   */ var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), localCartData = ref6[0], setLocalCartData = ref6[1];
    var ref7 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }), store_info = ref7.store_info, theme = ref7.theme, store_id = ref7.store_id;
    var ref8 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return {
            userData: state.userReducer,
            storeInfo: state.storeReducer.store,
            cartData: state.cartReducer
        };
    }), userData = ref8.userData, storeInfo = ref8.storeInfo, cartData = ref8.cartData;
    var ref9 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }), variantModal = ref9.variant.variantModal, detailedItem = ref9.detailedItem, productLoaderId = ref9.productLoaderId;
    /*
    below useEffect is for saving index and id of first available
    variant of the specific item
  */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (variantModal && detailedItem) {
            var ref;
            var activeVariantIndex = detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : ref.findIndex(function(el) {
                return el.available === 1 && el.status !== 2;
            });
            var ref1;
            setActiveVariant(function(state) {
                var ref, ref2;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, state), {
                    variantIndex: activeVariantIndex,
                    variantId: (ref1 = detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : (ref2 = ref[activeVariantIndex]) === null || ref2 === void 0 ? void 0 : ref2.variant_id) !== null && ref1 !== void 0 ? ref1 : -1
                });
            });
            handleSetState === null || handleSetState === void 0 ? void 0 : handleSetState(activeVariantIndex);
            // store cartData in local state
            if (cartData) {
                setLocalCartData(cartData);
            }
        }
    }, [
        variantModal,
        detailedItem
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (variantModal && detailedItem === null) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_21__/* .fetchCatalogItemById */ .eP)({
                store_id: store_id,
                item_id: productLoaderId,
                src: "variant_modal"
            }, true));
        }
        if (variantModal === false) {
            setActiveVariant({
                variantIndex: -1,
                variantId: -1
            });
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "scroll";
            }
        } else {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        }
    }, [
        variantModal,
        detailedItem
    ]);
    var itemIndexInCart = (0,_utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_22__/* .itemIndexFromCart */ .R)(localCartData, detailedItem);
    var onVariantSelect = function(selectedInd, item) {
        if (item.available) {
            setActiveVariant(function(state) {
                var ref;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, state), {
                    variantIndex: selectedInd,
                    variantId: detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : ref[selectedInd].variant_id
                });
            });
            handleSetState(selectedInd);
        } else (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_8__/* .toastNotifyInfo */ .lU)("Variant not available!");
    };
    var onClose = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveDetailedItemById */ .VY)(null));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveProductLoaderId */ .XG)(null));
    };
    var onAddToCartBtnHandle = function() {
        if (activeVariant.variantIndex === -1) return;
        if (!getCombinedQuantityOfSelectedVariants()) {
            handleCart("add");
        }
        props.isRedirect && router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_6__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_6__.PATH.CART, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    var handleCart = function(type) {
        var ref, ref1;
        if (type === "inc" && !qtyLessThanAvailQty()) {
            (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_8__/* .toastNotifyInfo */ .lU)("No more units available for purchase");
            return;
        }
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveProductLoaderId */ .XG)(detailedItem.id));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveDetailedItemById */ .VY)(detailedItem));
        var newCart = [];
        type = type === "add" || type === "inc" ? "inc" : "dec";
        newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_15__/* .mutateVariantItemWithCartData */ .I)(type, detailedItem, detailedItem.variants[activeVariant.variantIndex], localCartData);
        setLocalCartData(newCart);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_24__/* .saveCart */ .FP)(newCart));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_25__/* .pushEventsLog */ .U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_14__/* .MAX_MOBILE_WIDTH */ .Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
    };
    // get sum of all quantity of selected variant
    var getCombinedQuantityOfSelectedVariants = function() {
        var ref, ref1, ref2;
        var sumVariantQuantity = 0;
        if (Object.keys(localCartData).length && (localCartData === null || localCartData === void 0 ? void 0 : (ref = localCartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.length)) {
            var ref3;
            sumVariantQuantity = (ref3 = localCartData === null || localCartData === void 0 ? void 0 : localCartData.items[itemIndexInCart]) === null || ref3 === void 0 ? void 0 : ref3.variants_selected.reduce(function(acc, curr) {
                return acc + curr.quantity;
            }, 0);
        }
        return sumVariantQuantity;
    };
    /**
   * utility function to get quantity and current item data of product
   * @return {*} obj
   */ var returnItemData = function() {
        var itemData = {
            quantity: 0,
            selectedItem: null
        };
        if (itemIndexInCart >= 0) {
            var ref, ref1, ref2;
            if (localCartData === null || localCartData === void 0 ? void 0 : (ref = localCartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.length) {
                var selectedVariant = (0,_utils_selectedVariantFromVariantList__WEBPACK_IMPORTED_MODULE_26__/* .selectedVariantFromVariantList */ .m)(localCartData, itemIndexInCart, activeVariant.variantId);
                var ref3;
                itemData = {
                    quantity: (ref3 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantity) !== null && ref3 !== void 0 ? ref3 : 0,
                    selectedItem: selectedVariant ? selectedVariant : null
                };
            } else {
                var ref4, ref5, ref6;
                itemData = {
                    quantity: localCartData === null || localCartData === void 0 ? void 0 : (ref4 = localCartData.items) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[itemIndexInCart]) === null || ref5 === void 0 ? void 0 : ref5.quantity,
                    selectedItem: localCartData === null || localCartData === void 0 ? void 0 : (ref6 = localCartData.items) === null || ref6 === void 0 ? void 0 : ref6[itemIndexInCart]
                };
            }
        }
        return itemData;
    };
    /**
   * Check if quantity is less than available qty
   * @return {*} boolean
   */ var qtyLessThanAvailQty = function() {
        var selectedItem = returnItemData().selectedItem;
        if (selectedItem && !!Object.keys(selectedItem).length) {
            // only work if available qty is not 0
            if (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.available_quantity) {
                return selectedItem.quantity < selectedItem.available_quantity;
            }
        }
        return true;
    };
    var LeftCartButton = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__/* .InteractionComponent */ .$1, {
            position: "left:14px;",
            width: "30px",
            onClick: function(e) {
                e.stopPropagation();
                if (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) {
                    _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
                    handleSetProductData(detailedItem);
                    handleDecreamentClick("dec", detailedItem);
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
                } else {
                    handleCart("dec");
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_MinusIcon__WEBPACK_IMPORTED_MODULE_11__/* .MinusIcon */ .V, {})
        });
    };
    var RightCartButton = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__/* .InteractionComponent */ .$1, {
            position: "right:14px;",
            width: "30px",
            onClick: function(e) {
                e.stopPropagation();
                if (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) {
                    _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
                    handleSetProductData(detailedItem);
                    handleIncreamentClick("inc", detailedItem);
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
                } else {
                    handleCart("inc");
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: qtyLessThanAvailQty() ? "o-100" : "o-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_PlusIcon__WEBPACK_IMPORTED_MODULE_12__/* .PlusIcon */ .p, {})
            })
        });
    };
    var handlePPAddToCart = function() {
        _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
        handleSetProductData(detailedItem);
        handleSetProductCustomizationCount(detailedItem);
        onPersonalizeProductClick();
    };
    return variantModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        visible: variantModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0,
            maxWidth: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o <= 766 ? "100%" : 480
        },
        animation: "slideUp",
        className: "bottom-modal",
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "variantModal",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "variantModal-section",
                    style: {
                        border: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "variantModal-closeicon",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                loading: "lazy",
                                src: "/assets/images/cancel.png",
                                alt: "cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Choose One"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "variant-list",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VariantRadioGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        itemLowQty: detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.low_quantity,
                        itemList: (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.variants) || [],
                        activeIdx: activeVariant.variantIndex,
                        onChange: onVariantSelect
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "add-to-cart flex justify-between",
                    children: itemIndexInCart === -1 && (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-flex tw-w-full tw-cursor-pointer tw-justify-center tw-py-[0.875rem] tw-text-[15px]",
                        onClick: handlePPAddToCart,
                        style: {
                            backgroundColor: theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color,
                            borderRadius: theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme.roundness)) : "8px",
                            color: "#FFFF"
                        },
                        children: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta_config) === null || ref2 === void 0 ? void 0 : ref2.pdp_personalized_cta) || "Personalise and buy"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-100 mr1 flex justify-center left-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents__WEBPACK_IMPORTED_MODULE_9__/* .CartButton */ .WE, {
                                    leftButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftCartButton, {}),
                                    rightButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightCartButton, {}),
                                    fontSize: "15",
                                    roundness: theme === null || theme === void 0 ? void 0 : theme.roundness,
                                    onChange: function(type) {
                                        (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) ? handlePPAddToCart() : handleCart(type);
                                    },
                                    // sending null to handle 0 quantity issue during render
                                    quantity: returnItemData().quantity,
                                    px: "5px",
                                    py: "14px",
                                    label: "Add to Cart",
                                    borderColor: "#00000000",
                                    style: {
                                        justifyContent: "center",
                                        width: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o > 540 ? "75%" : "100%"
                                    },
                                    wrapperClasses: "tw-w-full"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-100 ml1 right-0",
                                children: !getCombinedQuantityOfSelectedVariants() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "pointer",
                                    style: {
                                        backgroundColor: "".concat(theme ? theme === null || theme === void 0 ? void 0 : (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#EA5151"),
                                        borderRadius: "".concat(theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"),
                                        opacity: "1"
                                    },
                                    onClick: onAddToCartBtnHandle,
                                    children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("buy_now_cta")
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "pointer",
                                    style: {
                                        backgroundColor: "#369d00",
                                        borderRadius: "".concat(theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"),
                                        opacity: "1"
                                    },
                                    onClick: function() {
                                        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
                                        router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_6__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_6__.PATH.CART, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                    },
                                    children: "Go to Cart"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VariantModal);


/***/ }),

/***/ 84557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_VariantSelectedListModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
;// CONCATENATED MODULE: ./src/components/Common/IncDecButton/index.js
/**
 * Increament Decreament Button for Catalog Items
 */ 

var IncDecButton = function(param) {
    var quantity = param.quantity, onChangeEventhandle = param.onChangeEventhandle, _showAddAction = param.showAddAction, showAddAction = _showAddAction === void 0 ? -1 : _showAddAction, catalogCta = param.catalogCta, showLoader = param.showLoader, _disableAddition = param.disableAddition, disableAddition = _disableAddition === void 0 ? false : _disableAddition;
    var styleClass = catalogCta ? "addtocart" : "pdp-addtocart";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(styleClass, "-btn"),
        style: !catalogCta ? {
            backgroundColor: "".concat(quantity <= 0 ? "#EA5151" : "#ffffff")
        } : {
            backgroundColor: "#ffffff"
        },
        children: [
            showAddAction < 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(styleClass, "-btn__changeIcon"),
                onClick: function() {
                    return onChangeEventhandle("add");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "ADD",
                            !catalogCta && "+"
                        ]
                    }),
                    catalogCta && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        src: "/assets/images/cta-icon-add@2x.png",
                        alt: "Add Item button"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__changeIcon"),
                        onClick: function() {
                            return onChangeEventhandle("dec");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "/assets/images/cta-icon-remove@2x.png",
                            alt: "Decreament button"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__text"),
                        children: quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__changeIcon"),
                        onClick: function() {
                            return onChangeEventhandle("inc");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "din ".concat(disableAddition ? "o-20" : "o-100"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "/assets/images/cta-icon-add@2x.png",
                                alt: "Increment button"
                            })
                        })
                    })
                ]
            }),
            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-wrapper"
            })
        ]
    });
};
/* harmony default export */ var Common_IncDecButton = (IncDecButton);

// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(73175);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/mutateVariantItemWithCartData.js
var mutateVariantItemWithCartData = __webpack_require__(59186);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(44779);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(91240);
;// CONCATENATED MODULE: ./src/components/VariantSelectedListModal/index.js

















var VariantSelectedListModal = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,useCartHandler/* useCartHandlers */.u)(), handleIncreamentClick = ref3.handleIncreamentClick, handleDecreamentClick = ref3.handleDecreamentClick, handleSetProductData = ref3.handleSetProductData;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)({
        itemCartIndex: null
    }), state = ref4[0], setState = ref4[1];
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return state.commonReducer;
    }), selectedVariantsModal = ref5.variant.selectedVariantsModal, productLoaderId = ref5.productLoaderId;
    var ref6 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            pdpData: state.catalogReducer.pdpData
        };
    }), userData = ref6.userData, storeData = ref6.storeData, cartData = ref6.cartData, pdpData = ref6.pdpData;
    (0,react.useEffect)(function() {
        if (selectedVariantsModal) {
            var ref;
            var productIndex = cartData.items.findIndex(function(el) {
                return el.item_id === productLoaderId;
            });
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    itemCartIndex: productIndex
                });
            });
            if (productLoaderId) {
                dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                    store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                    item_id: productLoaderId,
                    src: "variant_selected_modal"
                }, false, function(data) {
                    handleSetProductData(data);
                    dispatch((0,catalog/* savePDPData */.zP)(data));
                }));
            }
            if (cartData && !(cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[productIndex])) {
                onClose();
            }
        }
    }, [
        selectedVariantsModal,
        cartData,
        productLoaderId
    ]);
    (0,react.useEffect)(function() {
        if (selectedVariantsModal) {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        } else {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "scroll";
            }
        }
    }, [
        selectedVariantsModal
    ]);
    var onClose = function() {
        dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(false));
    };
    var handleAddRemoveItem = function(type, variantType) {
        var ref, ref1, ref2;
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
        var newCart = (0,mutateVariantItemWithCartData/* mutateVariantItemWithCartData */.I)(type, cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : ref2[state.itemCartIndex], variantType, cartData);
        dispatch((0,cart/* saveCart */.FP)(newCart));
    };
    var handleOnChange = function(type, variant) {
        if (pdpData === null || pdpData === void 0 ? void 0 : pdpData.product_personalization) {
            handleSetProductData(pdpData);
            checkRenderEnv/* IS_CLIENT */.kc && LocalStorageHelper/* default.add */.Z.add("activeVariantId", variant === null || variant === void 0 ? void 0 : variant.variant_id);
            if (type === "inc") {
                handleIncreamentClick(type, pdpData);
            } else if (type === "dec") {
                handleDecreamentClick(type, pdpData);
            }
            dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(false));
        } else {
            handleAddRemoveItem(type, variant);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: selectedVariantsModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modalVvariantSelectedListModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "closeicon pointer",
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: "/assets/images/cancel.png",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "title",
                children: "Choose Item to remove"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "item-list",
                children: cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.itemCartIndex]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.map(function(variant, ind) {
                    var ref, ref1, ref2, ref3;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start justify-start",
                                children: [
                                    variant.images && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: variant === null || variant === void 0 ? void 0 : (ref = variant.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url,
                                        className: "img h3",
                                        alt: "variant image ".concat(ind + 1)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                        className: "left ml2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-name",
                                                children: cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.itemCartIndex]) === null || ref3 === void 0 ? void 0 : ref3.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "variant-name",
                                                children: variant.variant_name
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                className: "right",
                                style: {
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_IncDecButton, {
                                    disableAddition: (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(variant),
                                    catalogCta: true,
                                    showAddAction: 1,
                                    quantity: variant.quantity,
                                    onChangeEventhandle: function(change) {
                                        return handleOnChange(change, variant);
                                    }
                                })
                            })
                        ]
                    }, "items-variant-".concat(ind));
                })
            })
        ]
    });
};
/* harmony default export */ var components_VariantSelectedListModal = (VariantSelectedListModal);


/***/ }),

/***/ 79220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GlobalCfeLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _globalLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25480);


var GlobalCfeLoader = function(param) {
    var type = param.type, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globalLoader__WEBPACK_IMPORTED_MODULE_1__/* .GlobalLoader */ .k, {
        type: type,
        color: color
    });
};


/***/ }),

/***/ 25480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GlobalLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85134);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98388);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20155);
/* harmony import */ var src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65700);







var GlobalLoader = function(props) {
    var type = props.type, color = props.color;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.setProperty("--loader-color", color);
    }, [
        color
    ]);
    switch(type){
        case "logo1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo1)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "logo2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo2)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "loader1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    version: "1.1",
                    id: "L9",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "65px",
                    height: "65px",
                    viewBox: "0 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: color,
                        d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 50 50",
                            to: "360 50 50",
                            repeatCount: "indefinite"
                        })
                    })
                });
            }
        case "loader2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L5",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 15 ; 0 -15; 0 15",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "30",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 10 ; 0 -10; 0 10",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "54",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader3":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader3), "tw-h-[35px] tw-w-[35px]")
                });
            }
        case "loader4":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "26",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "46",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader5":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader5), "tw-h-[16px] tw-w-[35px]")
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
            }
    }
};


/***/ }),

/***/ 29616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YE": function() { return /* binding */ resizedataURL; },
/* harmony export */   "m4": function() { return /* binding */ getCroppedImg; }
/* harmony export */ });
/* unused harmony exports IMAGE_TYPE, default, resizeImageIntoDataUrl */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var blob_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87013);



var IMAGE_TYPE = {
    PNG: "image/png",
    JPEG: "image/jpeg",
    JPG: "image/jpg"
};
function checkImageType(type) {
    return [
        IMAGE_TYPE.JPEG,
        IMAGE_TYPE.JPG,
        IMAGE_TYPE.PNG
    ].some(function(i) {
        return i === type;
    });
}
// get the image type for the base64 image
function returnImageType(image) {
    var imageType = image.src.split(";")[0].split(":")[1];
    if (!checkImageType(imageType)) {
        imageType = IMAGE_TYPE.JPEG;
    }
    return imageType;
}
var createImage = function(url) {
    return new Promise(function(resolve, reject) {
        var image = new Image();
        image.addEventListener("load", function() {
            return resolve(image);
        });
        image.addEventListener("error", function(error) {
            return reject(error);
        });
        image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
        image.src = url;
    });
};
// function getRadianAngle(degreeValue: any) {
//   return (degreeValue * Math.PI) / 180;
// }
/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop
 * @param {Boolean} compress - If true then compresses the image by 0.8 and into JPEG
 * Object provided by react-easy-crop
 */ function getCroppedImg(imageSrc, pixelCrop) {
    return _getCroppedImg.apply(this, arguments);
}
function _getCroppedImg() {
    _getCroppedImg = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(imageSrc, pixelCrop) {
        var compress, image, canvas, ctx, safeArea, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    compress = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    return [
                        4,
                        createImage(imageSrc)
                    ];
                case 1:
                    image = _state.sent();
                    canvas = document.createElement("canvas");
                    ctx = canvas.getContext("2d");
                    safeArea = compress ? Math.max(image.width, image.height) : 2 * (Math.max(image.width, image.height) / 2 * Math.sqrt(2));
                    // set each dimensions to double largest dimension to allow for a safe area for the
                    // image to rotate in without being clipped by canvas context
                    canvas.width = safeArea;
                    canvas.height = safeArea;
                    // translate canvas context to a central location on image to allow rotating around the center.
                    ctx.translate(safeArea / 2, safeArea / 2);
                    ctx.translate(-safeArea / 2, -safeArea / 2);
                    // draw rotated image and store data.
                    ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);
                    data = ctx.getImageData(0, 0, safeArea, safeArea);
                    // set canvas width to final desired crop size - this will clear existing context
                    canvas.width = pixelCrop.width;
                    canvas.height = pixelCrop.height;
                    // paste generated rotate image with correct offsets for x,y crop values.
                    ctx.putImageData(data, Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x), Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y));
                    // Return image based on compression flag
                    return [
                        2,
                        Promise.resolve(canvas.toDataURL(compress ? "image/jpeg" : returnImageType(image), compress ? 0.9 : 0.8))
                    ];
            }
        });
    });
    return _getCroppedImg.apply(this, arguments);
}
function resizedataURL(datas, wantedWidth, wantedHeight, imageType) {
    return _resizedataURL.apply(this, arguments);
}
function _resizedataURL() {
    _resizedataURL = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(datas, wantedWidth, wantedHeight, imageType) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    // We create an image to receive the Data URI
                    var img = document.createElement("img");
                    // putting cropped image to img src to calculate cropped image width and height
                    // to draw on canvas.
                    img.src = datas;
                    // When the event "onload" is triggered we can resize the image.
                    img.onload = function() {
                        // We create a canvas and get its context.
                        var canvas = document.createElement("canvas");
                        var ctx = canvas.getContext("2d");
                        // We set the dimensions at the wanted size.
                        canvas.width = wantedWidth || img.width; // width of cropped image
                        canvas.height = wantedHeight || img.height; // height of cropped image
                        // We resize the image with the canvas method drawImage();
                        ctx.drawImage(this, 0, 0, img.width, img.height);
                        var dataURI = imageType ? canvas === null || canvas === void 0 ? void 0 : canvas.toDataURL(imageType) : canvas === null || canvas === void 0 ? void 0 : canvas.toDataURL("image/jpeg");
                        var dataBlob = blob_util__WEBPACK_IMPORTED_MODULE_2__/* .dataURLToBlob */ .rw(dataURI);
                        resolve(dataBlob);
                    };
                    // We put the Data URI in the image's src attribute
                    img.src = datas;
                })
            ];
        });
    });
    return _resizedataURL.apply(this, arguments);
}
/**
 * function to convert upload image from MIME type to base64 for upload purpose
 * @param datas
 * @param wantedWidth
 * @param wantedHeight
 * @returns base64 image format
 */ function resizeImageIntoDataUrl(datas, wantedWidth, wantedHeight) {
    return _resizeImageIntoDataUrl.apply(this, arguments);
}
function _resizeImageIntoDataUrl() {
    _resizeImageIntoDataUrl = _async_to_generator(function(datas, wantedWidth, wantedHeight) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    // We create an image to receive the Data URI
                    var img = document.createElement("img");
                    // putting cropped image to img src to calculate cropped image width and height
                    // to draw on canvas.
                    img.src = datas;
                    // When the event "onload" is triggered we can resize the image.
                    img.onload = /*#__PURE__*/ _async_to_generator(function() {
                        var canvas, ctx, dataURI;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    canvas = document.createElement("canvas");
                                    ctx = canvas.getContext("2d");
                                    // We set the dimensions at the wanted size.
                                    canvas.width = wantedWidth; // width of cropped image
                                    canvas.height = wantedHeight; // height of cropped image
                                    // We resize the image with the canvas method drawImage();
                                    return [
                                        4,
                                        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight)
                                    ];
                                case 1:
                                    _state.sent();
                                    dataURI = canvas === null || canvas === void 0 ? void 0 : canvas.toDataURL(returnImageType(img));
                                    resolve(dataURI);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    // We put the Data URI in the image's src attribute
                    img.src = datas;
                })
            ];
        });
    });
    return _resizeImageIntoDataUrl.apply(this, arguments);
}


/***/ }),

/***/ 17305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Cart; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/containers/Cart/cart.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100vh;\n  box-sizing: border-box;\n  margin: 0 auto;\n  @media screen and (max-width: 766px) {\n    & > .cart-update-notifier {\n      top: 66px;\n      position: relative;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  position: fixed;\n  top: 0;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  left: 0;\n  height: 66px;\n  z-index: 10;\n  background: #ffffff;\n  transition-property: box-shadow;\n  transition-duration: 0.2s;\n  transition-timing-function: linear;\n  border-bottom: 1px solid #e9e9e9;\n  @media screen and (max-width: 766px) {\n    padding: 10px 20px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n  height: auto;\n  flex-direction: row;\n  justify-content: space-between;\n  @media screen and (max-width: 766px) {\n    overflow: scroll;\n    padding-top: 66px;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 auto;\n  display: flex;\n  height: 24px;\n  width: 24px;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  height: 100%;\n  padding-left: 10px;\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  justify-content: space-between;\n  align-items: center;\n  transition-property: top;\n  transition-duration: 0.2s;\n  transition-timing-function: linear;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin: 0;\n  padding-right: 10px;\n  color: #000000;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-items: space-between;\n  flex: 1;\n  box-sizing: border-box;\n  justify-content: space-between;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  position: relative;\n  @media screen and (max-width: 766px) {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  color: #000000;\n  font-size: 28px;\n  font-weight: 500;\n  margin-right: 10px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-top: 1px solid rgba(112, 112, 112, 0.5);\n  border-bottom: 1px solid rgba(112, 112, 112, 0.5);\n  color: ",
        ";\n  cursor: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 10px;\n\n  @media screen and (min-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #606060;\n  font-size: 12px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  border-top: 1px solid rgba(112, 112, 112, 0.2);\n  padding: 20px 32px;\n  background: #fafafa;\n  margin-top: auto;\n  ",
        ";\n  ",
        ";\n\n  @media screen and (max-width: 766px) {\n    background: white;\n    position: static;\n    border: none;\n    padding-top: 0px;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: relative;\n  margin-right: 15px;\n  cursor: pointer;\n  & > svg {\n    top: 3px;\n    position: relative;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0px 24px;\n  border-top: 1px solid #eaeaec;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 26.875vw;\n  ",
        ";\n  @media screen and (max-width: 767px) {\n    min-width: 88.875vw;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  display: flex;\n  color: #000000;\n  font-weight: ",
        ";\n  margin-left: ",
        "px;\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: auto;\n  width: 100%;\n  padding: 2rem 20px;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  max-width: 1000px;\n  margin: 0 auto;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 90%;\n\n  @media screen and (min-width: 767px) {\n    font-size: 20px;\n    padding: 40px 0;\n    margin: 0 auto;\n  }\n\n  @media screen and (max-width: 766px) {\n    padding: 30px 0;\n    margin: 0 auto;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  cursor: pointer;\n  width: 100%;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: fit-content;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: 0 0 10px 0;\n  justify-content: space-between;\n  font-weight: 600;\n  color: gray;\n\n  @media screen and (min-width: 767px) {\n    font-size: 15px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 14px;\n  height: 14px;\n  margin-left: 20px;\n  font-size: 12px;\n  cursor: pointer;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  width: auto;\n  height: auto;\n  font-weight: 600;\n  padding: 3px 5px;\n  background-color: transparent;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: 0;\n  color: #000;\n  font-size: 15px;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: relative;\n  height: 12px;\n  width: 12px;\n  margin-left: 7px;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background-color: #343638;\n  box-shadow: 3px 5px 12px 1px #0000002f;\n  z-index: 999;\n  width: fit-content;\n  padding: 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #ebebeb;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n  width: 35%;\n  background: #fafafa;\n  min-width: 560px;\n  @media screen and (max-width: 767px) {\n    overflow: visible;\n    min-width: 100%;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  border-bottom: ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 32px 30px 0px;\n  background: #fafafa;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  @media screen and (max-width: 767px) {\n    overflow: visible;\n    height: auto;\n    padding: 0 16px;\n    background: ",
        "\n      ",
        ";\n  }\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 16px;\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        ";\n  margin-top: 2px;\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 8px;\n  margin-top: 6px;\n  cursor: pointer;\n  ",
        ";\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 10px;\n  margin-top: 4px;\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 8px;\n  color: black;\n  opacity: 0.49;\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 6px;\n  font-size: 14px;\n  color: #797a7c;\n  font-weight: 400;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n    align-items: center;\n  }\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}




var OuterPadding = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "OuterPadding",
    componentId: "sc-63ac9aa1-0"
})(_templateObject());
var CartPage = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartPage",
    componentId: "sc-63ac9aa1-1"
})(_templateObject1());
var CartHeader = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CartHeader",
    componentId: "sc-63ac9aa1-2"
})(_templateObject2());
var CartBody = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartBody",
    componentId: "sc-63ac9aa1-3"
})(_templateObject3());
var CartHeaderBack = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CartHeaderBack",
    componentId: "sc-63ac9aa1-4"
})(_templateObject4());
var CartHeaderData = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartHeaderData",
    componentId: "sc-63ac9aa1-5"
})(_templateObject5());
var CardHeaderInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardHeaderInner",
    componentId: "sc-63ac9aa1-6"
})(_templateObject6());
var CartHeaderText = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "CartHeaderText",
    componentId: "sc-63ac9aa1-7"
})(_templateObject7());
var CartInfo = (0,styled_components_browser_esm/* default */.ZP)(OuterPadding).withConfig({
    displayName: "CartInfo",
    componentId: "sc-63ac9aa1-8"
})(_templateObject8());
var CartOption = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartOption",
    componentId: "sc-63ac9aa1-9"
})(_templateObject9());
var Text = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Text",
    componentId: "sc-63ac9aa1-10"
})(_templateObject10());
var MidContent = (0,styled_components_browser_esm/* default */.ZP)(OuterPadding).withConfig({
    displayName: "MidContent",
    componentId: "sc-63ac9aa1-11"
})(_templateObject11(), function(props) {
    return props.fontColor || "#6E03FF";
}, function(props) {
    return props.cursor ? props.cursor : "default";
});
var ItemContainer = (0,styled_components_browser_esm/* default */.ZP)(OuterPadding).withConfig({
    displayName: "ItemContainer",
    componentId: "sc-63ac9aa1-12"
})(_templateObject12());
var ItemPrecursor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemPrecursor",
    componentId: "sc-63ac9aa1-13"
})(_templateObject13());
var ItemPrecursorText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ItemPrecursorText",
    componentId: "sc-63ac9aa1-14"
})(_templateObject14());
var ItemList = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ItemList",
    componentId: "sc-63ac9aa1-15"
})(_templateObject15());
var BottomContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "BottomContainer",
    componentId: "sc-63ac9aa1-16"
})(_templateObject16(), function(props) {
    return props.showScrollDownShadow && "box-shadow: rgb(0 0 0 / 20%) 0px -2px 10px -5px";
}, function(props) {
    return props.storeUnserviceable && "min-height: 15vh";
});
var CTAbutton = (0,styled_components_browser_esm/* default */.ZP)(AtomicComponents/* Button */.zx).withConfig({
    displayName: "CTAbutton",
    componentId: "sc-63ac9aa1-17"
})(_templateObject17());
var IconContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "IconContainer",
    componentId: "sc-63ac9aa1-18"
})(_templateObject18());
var AmountContainer = (0,styled_components_browser_esm/* default */.ZP)(OuterPadding).withConfig({
    displayName: "AmountContainer",
    componentId: "sc-63ac9aa1-19"
})(_templateObject19());
var AmountRow = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "AmountRow",
    componentId: "sc-63ac9aa1-20"
})(_templateObject20(), function(props) {
    return props.marginRight && "margin-right : ".concat(props.marginRight, "vw");
});
var TotalText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "TotalText",
    componentId: "sc-63ac9aa1-21"
})(_templateObject21(), function(props) {
    return props.fontWeight;
}, function(props) {
    return props.marginRight || 0;
});
var NoItemInCart = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "NoItemInCart",
    componentId: "sc-63ac9aa1-22"
})(_templateObject22());
var NoItemInCartSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NoItemInCartSection",
    componentId: "sc-63ac9aa1-23"
})(_templateObject23());
var NoItemInCartText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "NoItemInCartText",
    componentId: "sc-63ac9aa1-24"
})(_templateObject24());
var MidContentInner = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "MidContentInner",
    componentId: "sc-63ac9aa1-25"
})(_templateObject25());
var OrderInstructionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionContainer",
    componentId: "sc-63ac9aa1-26"
})(_templateObject26());
var OrderInstructionTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "OrderInstructionTitle",
    componentId: "sc-63ac9aa1-27"
})(_templateObject27());
var OrderInstructionEdit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "OrderInstructionEdit",
    componentId: "sc-63ac9aa1-28"
})(_templateObject28(), function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return props.color;
}, function(props) {
    return props.color;
});
var OrderInstructionDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "OrderInstructionDescription",
    componentId: "sc-63ac9aa1-29"
})(_templateObject29());
var SVGBox = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SVGBox",
    componentId: "sc-63ac9aa1-30"
})(_templateObject30());
var CartDeliveryTooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartDeliveryTooltip",
    componentId: "sc-63ac9aa1-31"
})(_templateObject31());
var CartBodyRightSection = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartBodyRightSection",
    componentId: "sc-63ac9aa1-32"
})(_templateObject32());
var ItemHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemHeading",
    componentId: "sc-63ac9aa1-33"
})(_templateObject33(), function(props) {
    return props.showDropdown ? "28px 0px" : "24px 0px";
}, function(props) {
    return props.showDropdown ? "#fafafa" : "white";
}, function(props) {
    return !props.showSummery ? "1px solid #eaeaec" : "none";
});
var GrandTotal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GrandTotal",
    componentId: "sc-63ac9aa1-34"
})(_templateObject34());
var GrandTotalText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GrandTotalText",
    componentId: "sc-63ac9aa1-35"
})(_templateObject35());
var GrandTotalValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GrandTotalValue",
    componentId: "sc-63ac9aa1-36"
})(_templateObject36());
var ItemAmountContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemAmountContainer",
    componentId: "sc-63ac9aa1-37"
})(_templateObject37(), function(props) {
    return !props.showDropdown ? "white" : "#fafafa";
}, function(props) {
    return !props.showOrderSummary && "background : white ; visibility : hidden ; height : 50vh ; overflow: hidden;";
});
var OrderSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderSummary",
    componentId: "sc-63ac9aa1-38"
})(_templateObject38());
var DropDownArrowSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropDownArrowSummary",
    componentId: "sc-63ac9aa1-39"
})(_templateObject39(), function(props) {
    return props.showOrderSummary ? "transform : rotateZ(180deg);" : "transform: rotateZ(360deg);";
});
var OrderSummaryText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderSummaryText",
    componentId: "sc-63ac9aa1-40"
})(_templateObject40(), deviceWidth/* deviceWidth */.o < 767 ? "16px" : "0px");
var DropDownArrowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropDownArrowContainer",
    componentId: "sc-63ac9aa1-41"
})(_templateObject41(), function(props) {
    return props.showDeliveryChargeList && "transform : rotate(180deg); margin-bottom : 4px";
});
var DeliveryChargeDropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryChargeDropDownContainer",
    componentId: "sc-63ac9aa1-42"
})(_templateObject42());
var MobileGrandTotal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileGrandTotal",
    componentId: "sc-63ac9aa1-43"
})(_templateObject43());
var TotalDropDownArrowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TotalDropDownArrowContainer",
    componentId: "sc-63ac9aa1-44"
})(_templateObject44());
var TotalItemsInCart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TotalItemsInCart",
    componentId: "sc-63ac9aa1-45"
})(_templateObject45());
var GstExcludesContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "GstExcludesContainer",
    componentId: "sc-63ac9aa1-46"
})(_templateObject46());
var GstIncludesContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "GstIncludesContainer",
    componentId: "sc-63ac9aa1-47"
})(_templateObject47());

// EXTERNAL MODULE: ./src/redux/actions/cart.js
var actions_cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(4160);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./src/redux/actions/user.js
var user = __webpack_require__(56173);
// EXTERNAL MODULE: ./src/redux/actions/error.js
var error = __webpack_require__(12256);
// EXTERNAL MODULE: ./src/utils/getAuthToken.js
var getAuthToken = __webpack_require__(61305);
// EXTERNAL MODULE: ./src/utils/addDeliveryInfoInCart.js
var addDeliveryInfoInCart = __webpack_require__(68068);
// EXTERNAL MODULE: ./src/utils/isDeliveryPincodeBased.js
var isDeliveryPincodeBased = __webpack_require__(84110);
// EXTERNAL MODULE: ./src/utils/getStringifyAddress.js
var getStringifyAddress = __webpack_require__(97978);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartValidationErrorMsgModal/index.js
/**
 * Cart Validation
 * Error message Component
 */ 






var CartValidationErrorMsgModal = function() {
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            theme: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.theme,
            store_info: state.storeReducer.store.store_info,
            cartValidationErrorMsgModal: state.errorReducer.cart.cartValidationErrorMsgModal,
            cartValidationData: state.errorReducer.cart.cartValidationData
        };
    }), theme = ref1.theme, cartValidationErrorMsgModal = ref1.cartValidationErrorMsgModal, cartValidationData = ref1.cartValidationData;
    (0,react.useEffect)(function() {
        if (cartValidationErrorMsgModal) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "scroll";
        }
    }, [
        cartValidationErrorMsgModal
    ]);
    var onClose = function() {
        dispatch((0,error/* setCartValidationErrorMsgModalVisibility */.sn)(false));
        dispatch((0,error/* saveCartValidationData */.as)(null));
    };
    return cartValidationErrorMsgModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: cartValidationErrorMsgModal,
        className: "bottom-modal cartValidationErrorMsgModal",
        animation: "slideUp",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "closeicon",
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: "/assets/images/cancel.png",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f4 fw6 pv3",
                children: "Note"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pt2 pb5 overflow-y-scroll h5",
                children: cartValidationData === null || cartValidationData === void 0 ? void 0 : (ref = cartValidationData.message_list) === null || ref === void 0 ? void 0 : ref.map(function(el, ind) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "flex pb3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center items-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/information@2x.png",
                                    className: "info-icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "f6 fw4 ph2 w-90",
                                children: el
                            })
                        ]
                    }, "list-error-cartvalidation-".concat(ind));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f4 fw6 pa3 absolute bottom-0 left-0 w-100 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "f5 fw6 pv3 w-100 br-pill bn white",
                    style: {
                        backgroundColor: themeColor || "#EA5151",
                        borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"
                    },
                    onClick: onClose,
                    children: "View Cart"
                })
            })
        ]
    });
};
/* harmony default export */ var Components_CartValidationErrorMsgModal = (CartValidationErrorMsgModal);

// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(99375);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/NotAcceptingOrderPopUp/index.js
/**
 * Not accepting orders because
 * store is closed for now information component
 */ 








var NotAcceptingOrdersPopUp = function() {
    var router = (0,next_router.useRouter)();
    var primaryColor = (0,getThemeColor/* getThemeColor */.p)() || "#EA5151";
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme,
            store_info: state.storeReducer.store.store_info,
            notAcceptingOrdersPopUp: state.errorReducer.common.notAcceptingOrdersPopUp
        };
    }), theme = ref.theme, store_info = ref.store_info, notAcceptingOrdersPopUp = ref.notAcceptingOrdersPopUp;
    (0,react.useEffect)(function() {
        if (notAcceptingOrdersPopUp) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "scroll";
        }
    }, [
        notAcceptingOrdersPopUp
    ]);
    var onClickExploreBtn = function(e) {
        onClose();
        router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    var onClickCallUsBtn = function(e) {
        onClose();
        window.open("tel:".concat(storePhone), "_self");
        router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    var onClose = function() {
        dispatch((0,error/* setNotAcceptingOrdersModalVisibility */.$G)(false));
    };
    return notAcceptingOrdersPopUp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center items-center fixed left-0 bottom-0 top-0 right-0 w-100 bg-black-50 z-999",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pa3 bg-white br3 z1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "ph2",
                    children: "Note"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "f7 ph2",
                    children: "We are not accepting online orders right now"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "f7 ph2",
                    children: "You can explore our store or call us for any queries."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex pt4 ph2",
                    children: [
                        !!storePhone && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            style: {
                                borderColor: primaryColor,
                                color: primaryColor,
                                borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"
                            },
                            className: "ba pv3 bg-white flex-auto mr3",
                            onClick: onClickCallUsBtn,
                            children: "Call Us"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            style: {
                                backgroundColor: primaryColor,
                                borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"
                            },
                            className: "white bn pv3 flex-auto",
                            onClick: onClickExploreBtn,
                            children: "Explore"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var NotAcceptingOrderPopUp = (NotAcceptingOrdersPopUp);

// EXTERNAL MODULE: ./src/components/PaymentModal/index.js + 1 modules
var PaymentModal = __webpack_require__(16307);
// EXTERNAL MODULE: ./src/components/DesktopPaymentModal/index.js + 4 modules
var DesktopPaymentModal = __webpack_require__(28110);
// EXTERNAL MODULE: ./src/components/DesignSystem/AuthPopUp/index.js + 4 modules
var AuthPopUp = __webpack_require__(93973);
// EXTERNAL MODULE: ./src/components/DesignSystem/OrderConfirmLoader/index.js
var OrderConfirmLoader = __webpack_require__(38173);
// EXTERNAL MODULE: ./src/utils/customHooks.js
var customHooks = __webpack_require__(30077);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/localStorageFunctions.js
var localStorageFunctions = __webpack_require__(74943);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(67313);
;// CONCATENATED MODULE: ./src/components/CartError/CartError.styles.js

function CartError_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "px;\n  ",
        "px;\n  ",
        "px;\n  ",
        "px;\n  ",
        ";\n\n  @media screen and (max-width: 767px) {\n    ",
        ";\n    margin-top: 0px;\n    margin-bottom: 12px;\n  }\n"
    ]);
    CartError_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartError_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "px;\n  ",
        "px;\n  ",
        "px;\n  ",
        "px;\n  @media screen and (max-width: 767px) {\n    ",
        ";\n  }\n"
    ]);
    CartError_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartError_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #fc3d3d;\n  font-size: ",
        "px;\n  @media screen and (max-width: 767px) {\n    ",
        ";\n  }\n"
    ]);
    CartError_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CartErrorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartErrorContainer",
    componentId: "sc-c612a4e3-0"
})(CartError_styles_templateObject(), function(props) {
    return props.customStyles.mb && "margin-bottom: ".concat(props.customStyles.mb);
}, function(props) {
    return props.customStyles.mt && "margin-top: ".concat(props.customStyles.mt);
}, function(props) {
    return props.customStyles.mr && "margin-right: ".concat(props.customStyles.mr);
}, function(props) {
    return props.customStyles.ml && "margin-left: ".concat(props.customStyles.ml);
}, function(props) {
    return props.customStyles.width && "max-width: ".concat(props.customStyles.width);
}, function(props) {
    return props.customStyles.mobileMb && "margin-bottom : ".concat(props.customStyles.mobileMb);
});
var CartError_styles_IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IconContainer",
    componentId: "sc-c612a4e3-1"
})(CartError_styles_templateObject1(), function(props) {
    return props.customStyles.mbi && "margin-bottom: ".concat(props.customStyles.mbi);
}, function(props) {
    return props.customStyles.mti && "margin-top: ".concat(props.customStyles.mti);
}, function(props) {
    return props.customStyles.mri && "margin-right: ".concat(props.customStyles.mri);
}, function(props) {
    return props.customStyles.mli && "margin-left: ".concat(props.customStyles.mli);
}, function(props) {
    return props.customStyles.transXi && "transform : translateX(".concat(props.customStyles.transXi, ")");
});
var ErrorText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorText",
    componentId: "sc-c612a4e3-2"
})(CartError_styles_templateObject2(), function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.transX && "transform : translateX(".concat(props.transX, ")");
});

;// CONCATENATED MODULE: ./src/components/CartError/CartError.js



function CartError(props) {
    var cartErrorContainerStyles = {
        mb: props.mb ? props.mb : 0,
        mt: props.mt ? props.mt : 0,
        ml: props.ml ? props.ml : 0,
        mr: props.mr ? props.mr : 0,
        mobileMb: props.mobileMb ? props.mobileMb : "0px",
        width: props.width ? props.width : "auto"
    };
    var iconContainerStyles = {
        mbi: props.mbi ? props.mbi : 0,
        mti: props.mti ? props.mti : 0,
        mli: props.mli ? props.mli : 0,
        mri: props.mri ? props.mri : 0,
        transXi: props.transXi ? props.transXi : "0px"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartErrorContainer, {
        customStyles: cartErrorContainerStyles,
        className: (props === null || props === void 0 ? void 0 : props.customClasses) || "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError_styles_IconContainer, {
                customStyles: iconContainerStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                    secondaryColor: "#FC3D3D",
                    height: props.iconHeight,
                    width: props.iconWidth
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                fontSize: props.fontSize,
                transX: props.transX,
                children: props.text
            })
        ]
    });
}
/* harmony default export */ var CartError_CartError = (CartError);

// EXTERNAL MODULE: ./src/containers/AddDelivery/index.js + 11 modules
var AddDelivery = __webpack_require__(70274);
// EXTERNAL MODULE: ./src/containers/DeliveryList/index.js + 3 modules
var DeliveryList = __webpack_require__(30876);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/actions/delivery.js
var delivery = __webpack_require__(79977);
;// CONCATENATED MODULE: ./src/assets/svgExports/ShippingTruck.js

var ShippingTruck = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "18.938",
        height: props.height || "13.752",
        viewBox: "0 0 18.938 13.752",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "local_shipping_FILL0_wght400_GRAD0_opsz48",
            d: "M5.96,21.752A2.535,2.535,0,0,1,3.42,19.212H2V9.291a1.239,1.239,0,0,1,.387-.9A1.239,1.239,0,0,1,3.291,8h12.46v3.594h2.26l2.927,3.9v3.723H19.41a2.541,2.541,0,0,1-4.336,1.8,2.448,2.448,0,0,1-.742-1.8H8.5A2.535,2.535,0,0,1,5.96,21.752Zm0-1.291a1.248,1.248,0,1,0-.882-2.131A1.248,1.248,0,0,0,5.96,20.46ZM3.291,17.921h.473A2.851,2.851,0,0,1,4.69,17a2.422,2.422,0,0,1,2.507.011,3,3,0,0,1,.936.915H14.46V9.291H3.291ZM16.871,20.46a1.249,1.249,0,1,0-.882-.366A1.2,1.2,0,0,0,16.871,20.46Zm-1.119-4.39h4l-2.389-3.185H15.752ZM8.887,13.832Z",
            transform: "translate(-2 -8)"
        })
    });
};

// EXTERNAL MODULE: ./src/utils/triggerGetItemDeliveryChages.js + 1 modules
var triggerGetItemDeliveryChages = __webpack_require__(8527);
// EXTERNAL MODULE: ./src/utils/triggerGetServiceableAddressId.js + 2 modules
var triggerGetServiceableAddressId = __webpack_require__(67058);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/CheckoutInfoTab.styles.js

function CheckoutInfoTab_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  min-height: ",
        "px;\n  border: ",
        ";\n  border-radius: ",
        ";\n  margin-top: ",
        ";\n  justify-content: space-between;\n  ",
        ";\n  @media screen and (max-width: 767px) {\n    width: 100vw;\n    border: 0px;\n    border-radius: 0px;\n    margin-top: 0px;\n    min-height: ",
        "px;\n    border-top: 1px solid #e8e8eb;\n  }\n"
    ]);
    CheckoutInfoTab_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckoutInfoTab_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    CheckoutInfoTab_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckoutInfoTab_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  margin-left: 8px;\n  font-size: ",
        "px;\n  flex-direction: column;\n  justify-content: center;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n    margin-left: 16px;\n    ",
        ";\n  }\n"
    ]);
    CheckoutInfoTab_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckoutInfoTab_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n  cursor: pointer;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    CheckoutInfoTab_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CheckoutInfoTab_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n  margin-bottom: ",
        "px;\n"
    ]);
    CheckoutInfoTab_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var CheckoutInfoTabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabContainer",
    componentId: "sc-cb63d9de-0"
})(CheckoutInfoTab_styles_templateObject(), function(props) {
    return props.isPromoApplied ? "88" : "64";
}, function(props) {
    return props.instructionPopup ? "none" : "1px solid #e8e8eb";
}, function(props) {
    return props.instructionPopup ? "0px" : "8px";
}, function(props) {
    return props.instructionPopup ? "0px" : "16px";
}, function(props) {
    return props.toggleAddDeliveryForm && "border-bottom-right-radius : 0px;\n  border-bottom-left-radius : 0px";
}, function(props) {
    return props.isPromoApplied ? "76" : "52";
});
var CheckoutInfoTabLeftContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabLeftContainer",
    componentId: "sc-cb63d9de-1"
})(CheckoutInfoTab_styles_templateObject1());
var CheckoutInfoTabMiddleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabMiddleContainer",
    componentId: "sc-cb63d9de-2"
})(CheckoutInfoTab_styles_templateObject2(), function(props) {
    return props.fontSize || "14";
}, function(props) {
    return props.cartError && "margin-top : 20px";
});
var CheckoutInfoTabRightContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabRightContainer",
    componentId: "sc-cb63d9de-3"
})(CheckoutInfoTab_styles_templateObject3());
var CheckoutInfoTabLeftIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabLeftIcon",
    componentId: "sc-cb63d9de-4"
})(CheckoutInfoTab_styles_templateObject4(), function(props) {
    return props.isPromoApplied ? "10" : "0";
});

// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabAddress/TabAddress.styles.js

function TabAddress_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e8e8eb;\n  border-radius: 8px;\n  @media screen and (max-width: 767px) {\n    border: none;\n    border-top: ",
        ";\n    border-radius: 0px;\n    margin-top: 0px;\n  }\n"
    ]);
    TabAddress_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 600;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    TabAddress_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: ",
        ";\n  margin-top: ",
        ";\n  justify-content: space-between;\n  min-height: 64px;\n  @media screen and (max-width: 767px) {\n    width: 100vw;\n    border-left: none;\n    border-right: none;\n    border-bottom: none;\n    border-radius: 0px;\n    margin-top: 0px;\n  }\n"
    ]);
    TabAddress_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n"
    ]);
    TabAddress_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  ",
        ";\n"
    ]);
    TabAddress_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #7f7f7f;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabAddress_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 700;\n  font-size: 14px;\n  margin-left: 6px;\n  flex-direction: column;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n    margin-top: 8px;\n    margin-left: 0px;\n  }\n"
    ]);
    TabAddress_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n  }\n"
    ]);
    TabAddress_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var AddressFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressFormContainer",
    componentId: "sc-5d327f6e-0"
})(TabAddress_styles_templateObject(), function(props) {
    return props.showBorderTop ? "1px solid #e8e8eb" : "none";
});
var AddressCtaText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressCtaText",
    componentId: "sc-5d327f6e-1"
})(TabAddress_styles_templateObject1(), function(props) {
    return props.color || "#000000";
});
var AddressTabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressTabContainer",
    componentId: "sc-5d327f6e-2"
})(TabAddress_styles_templateObject2(), function(props) {
    return props.instructionPopup ? "0px" : "8px";
}, function(props) {
    return props.instructionPopup || checkClientDeviceType/* IS_DESKTOP */.yn ? "0px" : "16px";
});
var AddressTabLeftIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressTabLeftIcon",
    componentId: "sc-5d327f6e-3"
})(TabAddress_styles_templateObject3());
var AddressLineContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressLineContainer",
    componentId: "sc-5d327f6e-4"
})(TabAddress_styles_templateObject4(), function(props) {
    return !props.toggleAddDeliveryForm && "padding-top : 20px ; padding-bottom : 20px";
});
var AddressLineOneContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressLineOneContainer",
    componentId: "sc-5d327f6e-5"
})(TabAddress_styles_templateObject5());
var AddressLineTwoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressLineTwoContainer",
    componentId: "sc-5d327f6e-6"
})(TabAddress_styles_templateObject6());
var AddressMainLineContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressMainLineContainer",
    componentId: "sc-5d327f6e-7"
})(TabAddress_styles_templateObject7());

// EXTERNAL MODULE: ./src/components/UserAddressCard/index.tsx + 3 modules
var UserAddressCard = __webpack_require__(25269);
// EXTERNAL MODULE: ./src/context/CartContext.ts
var CartContext = __webpack_require__(52271);
// EXTERNAL MODULE: ./src/components/CheckItemDelivery/constants.js
var CheckItemDelivery_constants = __webpack_require__(29465);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabAddress/TabAddress.js



















function CheckoutInfoTabAddress(props) {
    var toggleShowDeliveryList = function toggleShowDeliveryList() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setShowDeliveryList(!showDeliveryList);
    };
    var handleEditId = function handleEditId(edit_id) {
        setEditId(edit_id);
    };
    var renderSelectedAddress = function renderSelectedAddress() {
        var addressDetails = (0,getStringifyAddress/* getStringifyAddress */.H)();
        return !newUser && !toggleAddDeliveryForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-px-[16px] tw-pb-[24px] md:tw-border-t md:tw-border-solid md:tw-border-[#EAEAEC] md:tw-pl-[46px] md:tw-pr-[32px] md:tw-pt-[24px] ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAddressCard/* default */.Z, {
                onEditClick: function() {
                    handleAddDeliveryForm(true);
                    setEditId((addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address_id) || 0);
                },
                estimatedDeliveryTime: estimatedDeliveryTime.deliveryTime || "",
                userName: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.user_name,
                addressType: (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address_type) || (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.addressType),
                addressName: (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address_name) || (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.addressName),
                alternatePhone: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.alternate_phone,
                address1: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address1,
                address2: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address2,
                city: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.city,
                state: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.state,
                pincode: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.pincode
            })
        });
    };
    var handleAddDeliveryForm = function handleAddDeliveryForm(flag) {
        dispatch((0,common/* setAddDeliveryForm */.r_)(flag));
    };
    var handleAddressCta = function handleAddressCta() {
        if (userData === null || userData === void 0 ? void 0 : userData.isLogin) {
            newUser ? dispatch((0,common/* setAddDeliveryForm */.r_)(true)) : toggleShowDeliveryList();
        } else {
            showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal();
        }
    };
    var renderAddressCta = function renderAddressCta() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressCtaText, {
            toggleAddDeliveryForm: toggleAddDeliveryForm,
            color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
            children: [
                !newUser && (checkClientDeviceType/* IS_DESKTOP */.yn ? "Select from saved addresses" : "Saved addresses"),
                newUser && toggleAddDeliveryForm && "",
                newUser && !toggleAddDeliveryForm && "Add address"
            ]
        });
    };
    var getErrorText = function getErrorText() {
        if (cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable) {
            return "Sorry, we are currently unserviceable at this pincode";
        }
        if (cartData === null || cartData === void 0 ? void 0 : cartData.is_cart_unserviceable) {
            return "Some items in your cart can't be delivered to this address";
        }
    };
    var renderCartNotServicable = function renderCartNotServicable() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: ((cartData === null || cartData === void 0 ? void 0 : cartData.is_cart_unserviceable) || (cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable)) && !toggleAddDeliveryForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError_CartError, {
                text: getErrorText(),
                iconWidth: 14,
                iconHeight: 14,
                mri: 8,
                width: deviceWidth/* deviceWidth */.o < 767 ? "100vw" : "34.48vw",
                fontSize: 12,
                mt: 12,
                mb: deviceWidth/* deviceWidth */.o > 767 ? 16 : 0,
                transXi: "-35px",
                transX: "-24px",
                mobileMb: "18px"
            })
        });
    };
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useContext)(CartContext/* CartContext */.A), _showAuthModal = ref1.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal, showAddressError = ref1.showAddressError;
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            toggleAddDeliveryForm: state.commonReducer.toggleAddDeliveryForm
        };
    }), userData = ref2.userData, storeData = ref2.storeData, cartData = ref2.cartData, toggleAddDeliveryForm = ref2.toggleAddDeliveryForm;
    var ref3 = (0,react.useState)(false), newUser = ref3[0], setNewUser = ref3[1];
    var ref4 = (0,react.useState)(false), showDeliveryList = ref4[0], setShowDeliveryList = ref4[1];
    var ref5 = (0,react.useState)(0), editId = ref5[0], setEditId = ref5[1];
    var ref6 = (0,react.useState)({}), fetchedLatestSavedAddress = ref6[0], setFetchedLatestSavedAddress = ref6[1];
    var ref7 = (0,react.useState)({
        pincode: "",
        deliveryTime: ""
    }), estimatedDeliveryTime = ref7[0], setEstimatedDeliveryTime = ref7[1];
    var selectedAddressPincode = userData === null || userData === void 0 ? void 0 : (ref = userData.savedAddress) === null || ref === void 0 ? void 0 : ref.pincode;
    (0,react.useEffect)(function() {
        var ref;
        if (!!(fetchedLatestSavedAddress === null || fetchedLatestSavedAddress === void 0 ? void 0 : (ref = fetchedLatestSavedAddress.missing_fields) === null || ref === void 0 ? void 0 : ref.length)) {
            setEditId(fetchedLatestSavedAddress === null || fetchedLatestSavedAddress === void 0 ? void 0 : fetchedLatestSavedAddress.address_id);
            dispatch((0,common/* setAddDeliveryForm */.r_)(true));
        } else {
            dispatch((0,common/* setAddDeliveryForm */.r_)(false));
        }
    }, [
        fetchedLatestSavedAddress
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        // get Estimated delivery time
        if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && selectedAddressPincode && selectedAddressPincode !== estimatedDeliveryTime.pincode && (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.delivery_estimate_flag) === CheckItemDelivery_constants/* ESTIMATE_DELIVERY_FLAG.ACTIVE */.F.ACTIVE) {
            var payload = {
                id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                text: selectedAddressPincode
            };
            dispatch((0,delivery/* getEstimatedDeliveryTime */.k4)(payload, function(data) {
                setEstimatedDeliveryTime({
                    pincode: selectedAddressPincode,
                    deliveryTime: data
                });
            }));
        }
        // if user has no saved address save the first address in Address List
        if (!((ref1 = (0,getStringifyAddress/* getStringifyAddress */.H)(userData === null || userData === void 0 ? void 0 : userData.savedAddress)) === null || ref1 === void 0 ? void 0 : ref1.address1)) {
            var ref7, ref8, ref9;
            dispatch((0,auth/* saveSelectedAddress */.z)(userData === null || userData === void 0 ? void 0 : (ref7 = userData.addressList) === null || ref7 === void 0 ? void 0 : ref7[0]));
            dispatch((0,common/* setAddDeliveryForm */.r_)(false));
            var ref10;
            setEditId((ref10 = userData === null || userData === void 0 ? void 0 : (ref8 = userData.addressList) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.address_id) !== null && ref10 !== void 0 ? ref10 : 0);
        } else {
            var ref11;
            // Else update the saved address to latest fetched address
            var savedAddress = userData === null || userData === void 0 ? void 0 : userData.savedAddress;
            var selectedSavedAddress = userData === null || userData === void 0 ? void 0 : (ref11 = userData.addressList) === null || ref11 === void 0 ? void 0 : ref11.find(function(add) {
                return (add === null || add === void 0 ? void 0 : add.address_id) === (savedAddress === null || savedAddress === void 0 ? void 0 : savedAddress.address_id);
            });
            if (selectedSavedAddress) {
                setFetchedLatestSavedAddress(selectedSavedAddress);
                var ref12;
                setEditId((ref12 = selectedSavedAddress === null || selectedSavedAddress === void 0 ? void 0 : selectedSavedAddress.address_id) !== null && ref12 !== void 0 ? ref12 : 0);
            }
        }
        // if address List is empty consider it New user and open add delivery Form
        if ((userData === null || userData === void 0 ? void 0 : (ref2 = userData.addressList) === null || ref2 === void 0 ? void 0 : ref2.length) === 0) {
            setNewUser(true);
        }
        // As soon as First address is added the user is no longer a new user. Close add delivery form.
        if ((userData === null || userData === void 0 ? void 0 : (ref3 = userData.addressList) === null || ref3 === void 0 ? void 0 : ref3.length) === 1) {
            dispatch((0,common/* setAddDeliveryForm */.r_)(false));
            setNewUser(false);
        }
        // addressList becomes >1 for any user its old user.
        if ((userData === null || userData === void 0 ? void 0 : (ref4 = userData.addressList) === null || ref4 === void 0 ? void 0 : ref4.length) > 1) setNewUser(false);
        // if savedAddress has missing any mandatory field open Add Delivery form to enter details.
        if ((userData === null || userData === void 0 ? void 0 : userData.isLogin) && (fetchedLatestSavedAddress === null || fetchedLatestSavedAddress === void 0 ? void 0 : (ref5 = fetchedLatestSavedAddress.missing_fields) === null || ref5 === void 0 ? void 0 : ref5.length)) dispatch((0,common/* setAddDeliveryForm */.r_)(true));
        // if user is Logged in And has some addresses get Item Charges in cart and servicable and unservicable addresses.
        if ((userData === null || userData === void 0 ? void 0 : userData.isLogin) && (userData === null || userData === void 0 ? void 0 : (ref6 = userData.addressList) === null || ref6 === void 0 ? void 0 : ref6.length) && (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)()) {
            // if pincode is thier then only call getITemsDelivery corresponding to pincodes
            if (selectedAddressPincode) (0,triggerGetItemDeliveryChages/* triggerGetItemDeliveryCharges */.l)();
            (0,triggerGetServiceableAddressId/* triggerGetServiceableAddressId */.o)();
        }
    }, [
        userData === null || userData === void 0 ? void 0 : userData.savedAddress,
        userData === null || userData === void 0 ? void 0 : userData.addressList,
        userData === null || userData === void 0 ? void 0 : userData.isLogin
    ]);
    (0,react.useEffect)(function() {
        if (showAddressError) {
            document.getElementById("cart-address-section").scrollTo({
                top: 80
            });
        }
    }, [
        showAddressError
    ]);
    var showError = checkClientDeviceType/* IS_DESKTOP */.yn && showAddressError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw- tw-flex tw-flex-col tw-gap-[12px]",
                id: "cart-address-section",
                children: [
                    showError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-mt-[16px] tw-text-sm tw-text-[#F63D60]",
                        children: "Please add a delivery address before placing the order"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressFormContainer, {
                        className: "".concat(showError ? "!tw-border-[#F63D60]" : "md:!tw-mt-[16px]", " "),
                        showBorderTop: props.showTopBorderMobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressTabContainer, {
                                isErrorThrown: (cartData === null || cartData === void 0 ? void 0 : cartData.is_cart_unservicable) || (cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable),
                                toggleAddDeliveryForm: toggleAddDeliveryForm,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutInfoTabLeftContainer, {
                                        children: [
                                            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressTabLeftIcon, {
                                                toggleAddDeliveryForm: toggleAddDeliveryForm,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingTruck, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutInfoTabMiddleContainer, {
                                                cartError: cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex tw-text-[16px] tw-font-semibold md:tw-text-[14px] md:tw-font-medium",
                                                        children: "Delivery Address"
                                                    }),
                                                    !checkClientDeviceType/* IS_DESKTOP */.yn && renderCartNotServicable()
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutInfoTabRightContainer, {
                                        onClick: handleAddressCta,
                                        children: renderAddressCta()
                                    })
                                ]
                            }),
                            renderSelectedAddress(),
                            checkClientDeviceType/* IS_DESKTOP */.yn && renderCartNotServicable(),
                            toggleAddDeliveryForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddDelivery/* default */.Z, {
                                toggleAddDeliveryForm: handleAddDeliveryForm,
                                edit_id: editId,
                                setEditId: handleEditId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryList/* default */.Z, {
                isVisible: showDeliveryList,
                toggleModal: toggleShowDeliveryList,
                toggleAddDeliveryForm: handleAddDeliveryForm,
                edit_id: editId,
                setEditId: handleEditId
            })
        ]
    });
}
/* harmony default export */ var TabAddress = (CheckoutInfoTabAddress);

// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(36623);
;// CONCATENATED MODULE: ./src/assets/svgExports/PageIcon.js

var PageIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.206",
        height: "17.758",
        viewBox: "0 0 14.206 17.758",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "description_FILL0_wght400_GRAD0_opsz48",
            d: "M11.529,17.984h7.147V16.652H11.529Zm0-3.773h7.147V12.879H11.529Zm-2.2,7.547A1.366,1.366,0,0,1,8,20.426V5.332A1.366,1.366,0,0,1,9.332,4h8.013l4.861,4.861V20.426a1.366,1.366,0,0,1-1.332,1.332Zm7.347-12.3V5.332H9.332V20.426H20.874V9.46ZM9.332,5.332v0Z",
            transform: "translate(-8 -4)"
        })
    });
};

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabOrderInstruction/TabOrderInstruction.styles.js

function TabOrderInstruction_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 90%;\n  resize: none;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  margin-top: 16px;\n  border: 1px solid #e8e8e8;\n  min-height: ",
        "px;\n  padding-bottom: ",
        "px;\n  ",
        "px;\n  @media screen and (max-width: 767px) {\n    width: 100vw;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n    border-bottom: 1px solid #e8e8e8;\n    border-radius: 0px;\n    margin-top: 0px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 14px;\n"
    ]);
    TabOrderInstruction_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  font-weight: 600;\n  margin-right: 16px;\n  justify-content: flex-end;\n  margin-bottom: 22px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 500;\n  cursor: pointer;\n  margin-right: 20px;\n  color: #7f7f7f;\n  font-size: 14px;\n"
    ]);
    TabOrderInstruction_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  color: ",
        ";\n  font-weight: 500;\n  font-size: 14px;\n"
    ]);
    TabOrderInstruction_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    TabOrderInstruction_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: ",
        ";\n  font-weight: 500;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 500;\n  margin-right: 20px;\n  color: #7f7f7f;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 20vw;\n  margin-left: 20px;\n  font-size: 14px;\n  color: #7f7f7f;\n"
    ]);
    TabOrderInstruction_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var OrderInstructionTextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    displayName: "OrderInstructionTextArea",
    componentId: "sc-11fc75c2-0"
})(TabOrderInstruction_styles_templateObject());
var OrderInstructionInfoTabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabContainer",
    componentId: "sc-11fc75c2-1"
})(TabOrderInstruction_styles_templateObject1(), function(props) {
    return props.cartSavedOrderText ? "93" : "0";
}, function(props) {
    return props.cartSavedOrderText ? "24" : "0";
}, function(props) {
    return props.isEdit && "padding-bottom : 0";
});
var OrderInstructionInfoTabAddCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabAddCta",
    componentId: "sc-11fc75c2-2"
})(TabOrderInstruction_styles_templateObject2(), function(props) {
    return props.color || "#000000";
}, function(props) {
    return props.background || "transparent";
});
var OrderInstructionInfoTabTypingCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabTypingCta",
    componentId: "sc-11fc75c2-3"
})(TabOrderInstruction_styles_templateObject3());
var OrderInstructionInfoTabTypingCancelCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabTypingCancelCta",
    componentId: "sc-11fc75c2-4"
})(TabOrderInstruction_styles_templateObject4());
var OrderInstructionInfoTabTypingAddCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabTypingAddCta",
    componentId: "sc-11fc75c2-5"
})(TabOrderInstruction_styles_templateObject5(), function(props) {
    return props.color || "#000000";
});
var OrderInstructionInfoTabSavedTextCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabSavedTextCta",
    componentId: "sc-11fc75c2-6"
})(TabOrderInstruction_styles_templateObject6());
var OrderInstructionInfoTabEditCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabEditCta",
    componentId: "sc-11fc75c2-7"
})(TabOrderInstruction_styles_templateObject7(), function(props) {
    return props.color || "#000000";
});
var OrderInstructionInfoTabRemoveCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabRemoveCta",
    componentId: "sc-11fc75c2-8"
})(TabOrderInstruction_styles_templateObject8());
var OrderInstructionInfoTabSavedText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabSavedText",
    componentId: "sc-11fc75c2-9"
})(TabOrderInstruction_styles_templateObject9());

// EXTERNAL MODULE: ./src/components/BasicModal/index.tsx
var BasicModal = __webpack_require__(75868);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabOrderInstruction/TabOrderInstruction.js

















function CheckoutInfoTabOrderInstruction(props) {
    var onOrderInstructionSaveBtnClick = function onOrderInstructionSaveBtnClick() {
        var ref, ref1;
        setOrderText(orderText);
        dispatch((0,actions_cart/* saveorderInstruction */.UE)(orderText));
        triggerSetCart((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
            user_phone: userData === null || userData === void 0 ? void 0 : (ref = userData.data) === null || ref === void 0 ? void 0 : ref.phone,
            phone: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone,
            instructions: orderText
        }));
        setCartSavedOrderText(orderText);
    };
    var handleOrderInstructionInfoTabTypingAddCta = function handleOrderInstructionInfoTabTypingAddCta() {
        onOrderInstructionSaveBtnClick();
        setIsEdit(false);
        handleToggleTextArea();
    };
    var handleOrderText = function handleOrderText(e) {
        if (e.target.value.length < 101) {
            setOrderText(e.target.value);
        }
    };
    var handleToggleTextArea = function handleToggleTextArea() {
        setToggleTextArea(!toggleTextArea);
    };
    var handleOrderInstructionInfoTabEditCta = function handleOrderInstructionInfoTabEditCta(e) {
        e.stopPropagation();
        handleToggleTextArea();
        setIsEdit(true);
        setOrderText(cartSavedOrderText);
    };
    var handleOrderInstructionInfoTabAddCta = function handleOrderInstructionInfoTabAddCta() {
        setOrderText("");
        handleToggleTextArea();
    };
    var handleOrderInstructionTypingCancelCta = function handleOrderInstructionTypingCancelCta() {
        setIsEdit(false);
        handleToggleTextArea();
    };
    var renderTabCTA = function renderTabCTA() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutInfoTabRightContainer, {
            className: "!tw-m-0",
            children: [
                !toggleTextArea && !cartSavedOrderText && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionInfoTabAddCta, {
                    color: themeColor,
                    onClick: (userData === null || userData === void 0 ? void 0 : userData.isLogin) ? handleOrderInstructionInfoTabAddCta : showAuthModal,
                    children: "Add"
                }),
                cartSavedOrderText && !toggleTextArea && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionInfoTabAddCta, {
                    color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
                    onClick: function(e) {
                        return handleOrderInstructionInfoTabEditCta(e);
                    },
                    children: "Edit"
                }),
                checkClientDeviceType/* IS_DESKTOP */.yn && renderButtonWihtTextArea()
            ]
        });
    };
    var ref = (0,react.useContext)(CartContext/* CartContext */.A), _showAuthModal = ref.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), toggleTextArea = ref1[0], setToggleTextArea = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store,
            userData: state.userReducer,
            cartData: state.cartReducer
        };
    }), storeData = ref2.storeData, userData = ref2.userData, cartData = ref2.cartData;
    var ref3 = (0,react.useState)(""), orderText = ref3[0], setOrderText = ref3[1];
    var ref4 = (0,react.useState)(false), isEdit = ref4[0], setIsEdit = ref4[1];
    var ref5 = (0,react.useState)(cartData === null || cartData === void 0 ? void 0 : cartData.instructions), cartSavedOrderText = ref5[0], setCartSavedOrderText = ref5[1];
    var triggerSetCart = (0,customHooks/* default */.Z)().triggerSetCart;
    var renderButtonWihtTextArea = function() {
        return toggleTextArea && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionInfoTabAddCta, {
            className: "tw-rounded-lg tw-py-[12px] tw-text-center !tw-text-sm md:tw-p-0 ",
            color: checkClientDeviceType/* IS_DESKTOP */.yn ? themeColor : "white",
            background: checkClientDeviceType/* IS_DESKTOP */.yn ? "transparent" : themeColor,
            onClick: handleOrderInstructionInfoTabTypingAddCta,
            children: "Save Instructions"
        });
    };
    var renderTextAreaInnerContent = function() {
        return toggleTextArea && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[24px] tw-px-[16px] tw-py-[24px] md:tw-p-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionTextArea, {
                    className: "tw-h-[125px] !tw-w-full tw-rounded-lg tw-border !tw-border-solid !tw-border-[#E2E2E2] tw-p-[12px] tw-text-sm tw-font-medium tw-text-[#7D7D7D] md:tw-h-fit md:tw-rounded-none md:!tw-border-none md:tw-p-0 md:tw-font-normal",
                    placeholder: "Type order instrictions here",
                    value: orderText,
                    onChange: function(e) {
                        return handleOrderText(e);
                    }
                }),
                checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-justify-end tw-text-xs tw-opacity-60",
                    children: [
                        orderText.length,
                        "/ 100"
                    ]
                }),
                !checkClientDeviceType/* IS_DESKTOP */.yn && renderButtonWihtTextArea()
            ]
        });
    };
    var renderTextAreaMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
            show: toggleTextArea,
            onClose: handleOrderInstructionTypingCancelCta,
            heading: (0,getCustomCtaText/* default */.Z)("order_instructions_label"),
            children: renderTextAreaInnerContent()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-border-y tw-border-solid tw-border-[#EAEAEC] md:tw-mb-0 md:tw-mt-[16px] md:tw-rounded-lg md:tw-border",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-justify-between tw-px-[16px] tw-py-[24px] tw-text-sm md:tw-pl-[20px] md:tw-pr-[16px] ".concat(!checkClientDeviceType/* IS_DESKTOP */.yn && cartSavedOrderText && !isEdit ? "!tw-pb-[12px]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-flex tw-items-center tw-gap-[12px] tw-text-[16px] tw-font-semibold md:tw-text-[14px] md:tw-font-medium",
                        children: [
                            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageIcon, {}),
                            " ",
                            (0,getCustomCtaText/* default */.Z)("order_instructions_label")
                        ]
                    }),
                    renderTabCTA()
                ]
            }),
            cartSavedOrderText && !isEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-text-wrap tw-border-t tw-border-none tw-border-[#EAEAEC] tw-px-[16px] tw-pb-[24px] md:tw-border-solid md:tw-py-[16px] md:tw-pl-[46px] md:tw-pr-[32px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionInfoTabSavedText, {
                    className: "!tw-m-0 !tw-w-full !tw-flex-wrap tw-text-sm",
                    children: cartSavedOrderText
                })
            }),
            checkClientDeviceType/* IS_DESKTOP */.yn && toggleTextArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-border-t tw-border-solid tw-border-[#EAEAEC] tw-pb-[8px] tw-pl-[46px] tw-pr-[8px] tw-pt-[16px] ",
                children: renderTextAreaInnerContent()
            }) : renderTextAreaMobile()
        ]
    });
}
/* harmony default export */ var TabOrderInstruction = (CheckoutInfoTabOrderInstruction);

// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(68615);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/index.tsx
var Common = __webpack_require__(92134);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/TabsContainer/index.tsx
var TabsContainer = __webpack_require__(1325);
// EXTERNAL MODULE: ./node_modules/@mui/material/Snackbar/Snackbar.js + 3 modules
var Snackbar = __webpack_require__(26379);
// EXTERNAL MODULE: ./node_modules/@mui/material/SnackbarContent/snackbarContentClasses.js
var snackbarContentClasses = __webpack_require__(40416);
// EXTERNAL MODULE: ./src/components/BasicModal/Transition.tsx
var Transition = __webpack_require__(75513);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(78678);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(85578);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/Common/index.tsx














var SectionHeader = function(param) {
    var activeTabIndex = param.activeTabIndex, setActiveTabIndex = param.setActiveTabIndex, tabsData = param.tabsData, _hasPaymentOffers = param.hasPaymentOffers, hasPaymentOffers = _hasPaymentOffers === void 0 ? false : _hasPaymentOffers, _isCouponApplied = param.isCouponApplied, isCouponApplied = _isCouponApplied === void 0 ? false : _isCouponApplied, _UnopenedTabText = param.UnopenedTabText, UnopenedTabText = _UnopenedTabText === void 0 ? "" : _UnopenedTabText, _openDropDown = param.openDropDown, openDropDown = _openDropDown === void 0 ? false : _openDropDown, _handleDropDown = param.handleDropDown, handleDropDown = _handleDropDown === void 0 ? null : _handleDropDown;
    var showTabs = checkClientDeviceType/* IS_DESKTOP */.yn || openDropDown;
    return (checkClientDeviceType/* IS_DESKTOP */.yn || !isCouponApplied) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(showTabs ? "border-b-grey1" : "", " tw-flex tw-flex-col"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-justify-between tw-px-[16px] tw-py-[22px] md:tw-px-[18px]",
                onClick: function() {
                    return !checkClientDeviceType/* IS_DESKTOP */.yn && (handleDropDown === null || handleDropDown === void 0 ? void 0 : handleDropDown());
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-[10px] tw-text-[16px]/[20px] tw-font-semibold md:tw-text-[14px]/[17px] md:tw-font-medium",
                        children: [
                            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripOfferIcon */.YT, {
                                iconSize: 18,
                                customClasses: "tw-flex"
                            }),
                            "Available offers"
                        ]
                    }),
                    !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-[12px]",
                        children: [
                            UnopenedTabText && !openDropDown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-rounded-[4px] tw-bg-[#D6F4DF] tw-px-[7px] tw-py-[4px] tw-text-[14px]/[17px] tw-text-[#017424]",
                                children: UnopenedTabText
                            }),
                            openDropDown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {})
                        ]
                    })
                ]
            }),
            showTabs && hasPaymentOffers && !isCouponApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer/* default */.Z, {
                activeTabIndex: activeTabIndex,
                setActiveTabIndex: setActiveTabIndex,
                tabsData: tabsData
            })
        ]
    });
};
var CustomPromo = function(param) {
    var cartData = param.cartData, storeId = param.storeId, userId = param.userId, setSuccessPopupState = param.setSuccessPopupState, showAuthModal = param.showAuthModal;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), manualPromoCode = ref[0], setManualPromoCode = ref[1];
    var ref1 = (0,react.useState)(""), errorText = ref1[0], setErrorText = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            isUserLoggedIn: state.userReducer.isLogin,
            latestSyncedCart: state.commonReducer.latestSyncedCart
        };
    }), isUserLoggedIn = ref2.isUserLoggedIn, latestSyncedCart = ref2.latestSyncedCart;
    (0,react.useEffect)(function() {
        errorText && setErrorText("");
    }, [
        latestSyncedCart
    ]);
    var onApplyCustomPromo = function() {
        if (!isUserLoggedIn) {
            showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal();
            return;
        }
        var payload = {
            cart: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
                store_id: storeId,
                user_id: userId,
                store_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData.store_offer || {}), {
                    promo_code: manualPromoCode
                })
            })
        };
        dispatch((0,promo/* applyPromo */.RM)(payload, function(resp) {
            if (resp.data.status) {
                var ref;
                var errorText = (ref = resp.data.data) === null || ref === void 0 ? void 0 : ref.reason;
                if (!errorText) {
                    setSuccessPopupState({
                        show: true,
                        appliedPromoCode: manualPromoCode
                    });
                } else {
                    setErrorText(errorText);
                }
            } else {
                setErrorText("Invalid coupon");
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-[24px] tw-rounded-[8px] tw-border tw-border-solid tw-border-[#B4B4B4] tw-p-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: manualPromoCode,
                        onChange: function(e) {
                            errorText && setErrorText("");
                            setManualPromoCode(e.target.value);
                        },
                        className: "tw-flex-1 tw-border-none tw-text-[14px]/[17px] placeholder:tw-text-[#00000099]",
                        placeholder: "Enter Coupon Code"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripCTA */.iQ, {
                        ctaTextOrIcon: "Apply",
                        onClick: onApplyCustomPromo,
                        isDisabled: !manualPromoCode || !!errorText
                    })
                ]
            }),
            !!errorText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-m-0 tw-mt-[8px] tw-text-[14px]/[17px] tw-text-[#F63D60]",
                children: errorText
            })
        ]
    });
};
var ExpandOrShrinkButton = function(param) {
    var show = param.show, showAllPromos = param.showAllPromos, setShowAllPromos = param.setShowAllPromos;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    return show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "tw-m-0 tw-cursor-pointer tw-text-center tw-text-[16px]/[20px] tw-font-semibold md:tw-text-left md:tw-text-[15px]/[20px]",
        style: {
            color: themeColor
        },
        onClick: function() {
            return setShowAllPromos(!showAllPromos);
        },
        children: [
            "View ",
            showAllPromos ? "less" : "all",
            " offers"
        ]
    });
};
var SuccessMessage = function(param) {
    var show = param.show, message = param.message, onClose = param.onClose;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
        open: show,
        onClose: onClose,
        autoHideDuration: 3000,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: checkClientDeviceType/* IS_DESKTOP */.yn ? "left" : "center"
        },
        message: message,
        sx: (_obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(snackbarContentClasses/* default.root */.Z.root), {
            minWidth: "auto",
            padding: "0px 0px",
            backgroundColor: "#24AC21"
        }), (0,_define_property/* default */.Z)(_obj, "& .".concat(snackbarContentClasses/* default.message */.Z.message), {
            width: "100%",
            padding: "16px 18px",
            borderRadius: "6px"
        }), _obj),
        TransitionComponent: Transition/* default */.Z,
        transitionDuration: 100
    });
};

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/BankOffers/index.tsx
var BankOffers = __webpack_require__(11110);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/OfferNotAppliedView/OffersSections/BankOffersSection.tsx





var BankOffersSection = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BankOffers/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        isCartPage: true
    }));
};
/* harmony default export */ var OffersSections_BankOffersSection = (BankOffersSection);

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/CartPromosContainer.tsx
var CartPromosContainer = __webpack_require__(62856);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/OfferNotAppliedView/OffersSections/StoreOffersSection.tsx










var StoreOffersSection = function(param) {
    var _showAllPromos = param.showAllPromos, showAllPromos = _showAllPromos === void 0 ? false : _showAllPromos, _cartStorePromos = param.cartStorePromos, cartStorePromos = _cartStorePromos === void 0 ? [] : _cartStorePromos, _cartData = param.cartData, cartData = _cartData === void 0 ? {} : _cartData, setSuccessPopupState = param.setSuccessPopupState;
    var onStoreOfferDetailClick = function onStoreOfferDetailClick(promoId) {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoId
        }));
    };
    var onStoreOfferApplyClick = function onStoreOfferApplyClick(promoId) {
        if (!isUserLoggedIn) {
            showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal();
            return;
        }
        var coupon = cartStorePromos === null || cartStorePromos === void 0 ? void 0 : cartStorePromos.find(function(promo) {
            return (promo === null || promo === void 0 ? void 0 : promo.id) === promoId;
        });
        var payload = {
            cart: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
                store_id: storeId,
                user_id: userId,
                store_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData.store_offer || {}), {
                    promo_id: coupon.id,
                    promo_code: coupon.code
                })
            })
        };
        dispatch((0,promo/* applyPromo */.RM)(payload, function(resp) {
            if (resp.data.status) {
                var ref;
                var errorText = (ref = resp.data.data) === null || ref === void 0 ? void 0 : ref.reason;
                if (!errorText) {
                    setSuccessPopupState({
                        show: true,
                        appliedPromoCode: coupon.code
                    });
                } else {
                    (0,Toast/* toastNotifyError */.Lu)(errorText);
                }
            } else {
                (0,Toast/* toastNotifyError */.Lu)(resp.message);
            }
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useContext)(CartContext/* CartContext */.A), _showAuthModal = ref.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return {
            storeId: state.storeReducer.store.store_id,
            isUserLoggedIn: (ref = state.userReducer) === null || ref === void 0 ? void 0 : ref.isLogin,
            userId: (ref1 = state.userReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.user_id
        };
    }), storeId = ref1.storeId, isUserLoggedIn = ref1.isUserLoggedIn, userId = ref1.userId;
    var promosToShow = showAllPromos ? cartStorePromos : cartStorePromos.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPromo, {
                cartData: cartData,
                storeId: storeId,
                userId: userId,
                setSuccessPopupState: setSuccessPopupState,
                showAuthModal: showAuthModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPromosContainer/* CartPromosContainer */.e, {
                promos: promosToShow,
                onDetailClick: onStoreOfferDetailClick,
                onApplyClick: onStoreOfferApplyClick,
                isStorePromos: true
            })
        ]
    });
};
/* harmony default export */ var OffersSections_StoreOffersSection = (StoreOffersSection);

// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/OfferNotAppliedView/index.tsx








function getCartPromos(cartData, dispatch, callabck) {
    var payload = {
        cart: cartData
    };
    dispatch((0,promo/* getCartPagePromos */.go)(payload, callabck));
}
var debouncedGetCartPromos = (0,debounce/* debounce */.D)(getCartPromos, 300);
var OfferNotAppliedView = function(param) {
    var activeTabIndex = param.activeTabIndex, setSuccessPopupState = param.setSuccessPopupState, showView = param.showView, setUnOpenedTabText = param.setUnOpenedTabText;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), showAllPromos = ref[0], setShowAllPromos = ref[1];
    var ref1 = (0,react.useState)([]), cartStorePromos = ref1[0], setCartStorePromos = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            paymentOffersList: state.promoReducer.paymentOffersList || [],
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            latestSyncedCart: state.commonReducer.latestSyncedCart
        };
    }), paymentOffersList = ref2.paymentOffersList, storeData = ref2.storeData, cartData = ref2.cartData, latestSyncedCart = ref2.latestSyncedCart;
    (0,react.useEffect)(function() {
        var ref;
        if (latestSyncedCart && (latestSyncedCart === null || latestSyncedCart === void 0 ? void 0 : (ref = latestSyncedCart.items) === null || ref === void 0 ? void 0 : ref.length) && (storeData === null || storeData === void 0 ? void 0 : storeData.store_id)) {
            debouncedGetCartPromos(cartData, dispatch, function(allPromos) {
                return setCartStorePromos(allPromos);
            });
        }
    }, [
        latestSyncedCart,
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    ]);
    (0,react.useEffect)(function() {
        if ((cartStorePromos === null || cartStorePromos === void 0 ? void 0 : cartStorePromos.length) || (paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length)) {
            setUnOpenedTabText("".concat((cartStorePromos === null || cartStorePromos === void 0 ? void 0 : cartStorePromos.length) + (paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length), " Offers Available"));
        }
    }, [
        cartStorePromos,
        paymentOffersList
    ]);
    (0,react.useEffect)(function() {
        if (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) {
            dispatch((0,promo/* getPaymentOffersList */.Xu)(storeData.store_id));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    ]);
    var isStoreOfferTabActive = activeTabIndex === 0;
    return showView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[18px] tw-px-[12px] tw-py-[16px] md:tw-gap-[16px] md:tw-p-[24px]",
        children: [
            isStoreOfferTabActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersSections_StoreOffersSection, {
                showAllPromos: showAllPromos,
                cartStorePromos: cartStorePromos,
                cartData: cartData,
                setSuccessPopupState: setSuccessPopupState
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersSections_BankOffersSection, {
                showAllPromos: showAllPromos,
                paymentOffersList: paymentOffersList,
                cartData: cartData,
                setSuccessPopupState: setSuccessPopupState
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandOrShrinkButton, {
                showAllPromos: showAllPromos,
                setShowAllPromos: setShowAllPromos,
                show: isStoreOfferTabActive ? (cartStorePromos === null || cartStorePromos === void 0 ? void 0 : cartStorePromos.length) > 3 : (paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length) > 3
            })
        ]
    });
};
/* harmony default export */ var AllCartPagePromos_OfferNotAppliedView = (OfferNotAppliedView);

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/CartPromoStrip/index.tsx
var CartPromoStrip = __webpack_require__(53149);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/OfferAppliedView/index.tsx







var OfferAppliedView = function(param) {
    var cartData = param.cartData, isBankOfferApplied = param.isBankOfferApplied, bankOfferDataFromCart = param.bankOfferDataFromCart, storeOfferDataFromCart = param.storeOfferDataFromCart;
    var getAppliedOffer = function getAppliedOffer() {
        var ref;
        return (ref = isBankOfferApplied ? bankOfferDataFromCart === null || bankOfferDataFromCart === void 0 ? void 0 : bankOfferDataFromCart.promo_code : storeOfferDataFromCart === null || storeOfferDataFromCart === void 0 ? void 0 : storeOfferDataFromCart.promo_code) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    };
    var getAppliedOfferDiscount = function getAppliedOfferDiscount() {
        return isBankOfferApplied ? bankOfferDataFromCart === null || bankOfferDataFromCart === void 0 ? void 0 : bankOfferDataFromCart.promo_discount : storeOfferDataFromCart === null || storeOfferDataFromCart === void 0 ? void 0 : storeOfferDataFromCart.promo_discount;
    };
    var triggerSetCart = (0,customHooks/* default */.Z)().triggerSetCart;
    var removePaymentCoupon = function() {
        var tempPayload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
            payment_offer: {},
            store_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData.store_offer), {
                promo_code: "",
                promo_id: 0,
                promo_discount: 0
            })
        });
        triggerSetCart(tempPayload);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-flex tw-flex-col tw-gap-[18px] tw-px-[12px] tw-py-[16px] md:tw-gap-[16px] md:tw-p-[24px]",
        children: checkClientDeviceType/* IS_DESKTOP */.yn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPromoStrip/* default */.Z, {
            primaryText: getAppliedOffer(),
            secondaryText: "Offer Applied",
            onApplyOrRemoveClick: removePaymentCoupon,
            savingAmount: getAppliedOfferDiscount(),
            primaryButtonText: "Remove",
            primaryButtonClasses: "!tw-pr-0",
            isOfferApplied: true
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common/* StripContainer */.P6, {
            customClasses: "!tw-flex-row tw-justify-between tw-items-center tw-border-none tw-px-[6px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripIconInfoWrapper */.To, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-[16px]/[20px] tw-font-semibold",
                                children: "Offer Applied"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "tw-m-0 tw-flex tw-flex-col tw-gap-[8px] tw-text-[14px]/[20px] tw-font-medium tw-text-[#0D9738]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-w-fit tw-bg-[#E2FFEB] tw-px-[4px] tw-py-[1px]",
                                        children: getAppliedOffer()
                                    }),
                                    !!getAppliedOfferDiscount() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-text-[14px]/[20px] tw-font-semibold md:tw-text-[14px]/[20px]",
                                        children: [
                                            "Save ₹",
                                            getAppliedOfferDiscount()
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripCTA */.iQ, {
                    ctaTextOrIcon: "Remove",
                    onClick: removePaymentCoupon
                })
            ]
        })
    });
};
/* harmony default export */ var AllCartPagePromos_OfferAppliedView = (OfferAppliedView);

;// CONCATENATED MODULE: ./src/assets/svgExports/SuccessIconWhite.js

var SuccessIconWhite = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.35498 7.98717L6.72105 10.0011L11.3784 5.87109",
                stroke: "#24AC21",
                "stroke-width": "1.3",
                "stroke-linecap": "square"
            })
        ]
    });
};
/* harmony default export */ var svgExports_SuccessIconWhite = (SuccessIconWhite);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/index.tsx











var AllCartPagePromos = function() {
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            paymentOffersList: state.promoReducer.paymentOffersList,
            cartData: state.cartReducer
        };
    }), paymentOffersList = ref.paymentOffersList, cartData = ref.cartData;
    var ref1 = (0,react.useState)(0), activeTabIndex = ref1[0], setActiveTabIndex = ref1[1];
    var ref2 = (0,react.useState)({
        show: false,
        appliedPromoCode: null
    }), successPopupState = ref2[0], setSuccessPopupState = ref2[1];
    var ref3 = (0,react.useState)(false), openDropdown = ref3[0], setOpenDropdown = ref3[1];
    var ref4 = (0,react.useState)(""), unopenedTabText = ref4[0], setUnopenedTabText = ref4[1];
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    var hasPaymentOffers = !!(paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length);
    var tabsData = [
        {
            text: "Store Offers"
        },
        {
            text: "Bank Offers"
        }, 
    ];
    var storeOfferDataFromCart = cartData === null || cartData === void 0 ? void 0 : cartData.store_offer;
    var bankOfferDataFromCart = cartData === null || cartData === void 0 ? void 0 : cartData.payment_offer;
    var isBankOfferApplied = !!(bankOfferDataFromCart === null || bankOfferDataFromCart === void 0 ? void 0 : bankOfferDataFromCart.promo_id);
    var isStoreOfferApplied = !!(storeOfferDataFromCart === null || storeOfferDataFromCart === void 0 ? void 0 : storeOfferDataFromCart.promo_code);
    var isOfferApplied = isBankOfferApplied || isStoreOfferApplied;
    var getSuccessMessage = function(promoCode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-items-center tw-gap-[8px] tw-text-sm tw-text-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_SuccessIconWhite, {}),
                " Coupon",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "tw-flex tw-items-center tw-font-bold",
                    children: [
                        promoCode,
                        " "
                    ]
                }),
                "applied successfully."
            ]
        });
    };
    return !isCouponsFeatureLocked && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col md:tw-rounded-[8px] md:tw-border md:tw-border-solid md:tw-border-[#EAEAEC]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                        activeTabIndex: activeTabIndex,
                        setActiveTabIndex: setActiveTabIndex,
                        tabsData: tabsData,
                        hasPaymentOffers: hasPaymentOffers,
                        isCouponApplied: isOfferApplied,
                        UnopenedTabText: unopenedTabText,
                        openDropDown: openDropdown,
                        handleDropDown: function() {
                            return setOpenDropdown(!openDropdown);
                        }
                    }),
                    isOfferApplied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCartPagePromos_OfferAppliedView, {
                        cartData: cartData,
                        isBankOfferApplied: isBankOfferApplied,
                        bankOfferDataFromCart: bankOfferDataFromCart,
                        storeOfferDataFromCart: storeOfferDataFromCart
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCartPagePromos_OfferNotAppliedView, {
                        activeTabIndex: activeTabIndex,
                        setSuccessPopupState: setSuccessPopupState,
                        showView: checkClientDeviceType/* IS_DESKTOP */.yn || openDropdown,
                        setUnOpenedTabText: setUnopenedTabText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessMessage, {
                show: successPopupState.show,
                onClose: function() {
                    return setSuccessPopupState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, successPopupState), {
                        show: false
                    }));
                },
                message: getSuccessMessage(successPopupState.appliedPromoCode)
            })
        ]
    });
};
/* harmony default export */ var CouponsAndVouchers_AllCartPagePromos = (AllCartPagePromos);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabPromo/TabPromo.js





function CheckoutInfoTabPromo(props) {
    var storeId = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            storeId: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.store_id
        };
    }).storeId;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (storeId) {
            dispatch((0,promo/* getPaymentOffersList */.Xu)(storeId));
        }
    }, [
        storeId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsAndVouchers_AllCartPagePromos, {});
}
/* harmony default export */ var TabPromo = (CheckoutInfoTabPromo);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/CartAdditionalInfo.styles.js

function CartAdditionalInfo_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  overflow: visible;\n  @media screen and (min-width: 767px) {\n    padding: 0 32px;\n    margin: 0 auto;\n    max-width: 55%;\n    overflow: scroll;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n"
    ]);
    CartAdditionalInfo_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartAdditionalInfo_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 6px;\n  padding-bottom: 40px;\n  @media screen and (max-width: 767px) {\n    margin-top: 0px;\n    padding-bottom: 0px;\n  }\n"
    ]);
    CartAdditionalInfo_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartAdditionalInfo_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    CartAdditionalInfo_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CheckoutAdditionalInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutAdditionalInfoContainer",
    componentId: "sc-731c9d0f-0"
})(CartAdditionalInfo_styles_templateObject());
var CheckoutAdditionalInfoTabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutAdditionalInfoTabContainer",
    componentId: "sc-731c9d0f-1"
})(CartAdditionalInfo_styles_templateObject1());
var CheckoutAdditionalInfoHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutAdditionalInfoHeaderContainer",
    componentId: "sc-731c9d0f-2"
})(CartAdditionalInfo_styles_templateObject2());

// EXTERNAL MODULE: ./src/utils/isStoreServiceBased.js
var isStoreServiceBased = __webpack_require__(66466);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
;// CONCATENATED MODULE: ./src/utils/isAddressMandatoryForService.js


function isAddressMandatoryForService() {
    return (0,getStoreType/* getStoreType */.K)() === constants/* STORE_CUSTOMIZATION.SERVICE_BASED_WITH_ADDRESS_ENABLED */.DO.SERVICE_BASED_WITH_ADDRESS_ENABLED;
}

// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(68037);
;// CONCATENATED MODULE: ./src/containers/Cart/SVGs/index.tsx

var ShieldIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 16 : _height, _width = param.width, width = _width === void 0 ? 16 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.2678 1.79263L8.28223 0.0577139C8.11014 -0.019238 7.91051 -0.019238 7.73842 0.0577139L3.75282 1.79263C2.99562 2.12142 2.5 2.88395 2.5 3.72342V7.10231C2.5 9.01212 3.41552 10.824 4.94368 11.9363L7.60075 13.8671C7.71777 13.951 7.86233 14 8 14C8.13767 14 8.28223 13.958 8.39925 13.8671L11.0563 11.9363C12.5914 10.824 13.5 9.01911 13.5 7.10231V3.72342C13.5 2.88395 13.0113 2.12842 12.2472 1.79263H12.2678ZM10.5676 6.09494L7.81414 8.89319C7.67647 9.0331 7.50438 9.09606 7.32541 9.09606C7.14643 9.09606 6.97434 9.02611 6.83667 8.89319L5.45995 7.49407C5.19149 7.22124 5.19149 6.78051 5.45995 6.50768C5.72841 6.23485 6.16208 6.23485 6.43054 6.50768L7.31852 7.41012L9.58323 5.10856C9.85169 4.83573 10.2854 4.83573 10.5538 5.10856C10.8223 5.38139 10.8223 5.82211 10.5538 6.09494H10.5676Z",
            fill: "black"
        })
    });
};
var VerifiedIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 16 : _height, _width = param.width, width = _width === void 0 ? 16 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_14_12063)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.4099 10.9757C10.2135 11.0576 9.98162 11.301 9.75738 11.5364C9.35432 11.9596 8.89743 12.4393 8.26148 12.4393C7.62554 12.4393 7.16865 11.9596 6.76559 11.5364C6.54138 11.301 6.30952 11.0576 6.11311 10.9757C5.89978 10.8868 5.55097 10.8924 5.21364 10.8976C5.16858 10.8984 5.123 10.8991 5.07715 10.8996V14.5606C5.07715 14.7081 5.15115 14.8457 5.2742 14.9271C5.39722 15.0085 5.5529 15.0227 5.6886 14.965L8.26151 13.8707L10.8344 14.965C10.8896 14.9885 10.9481 15 11.0063 15C11.0913 15 11.1758 14.9754 11.2488 14.9271C11.3718 14.8457 11.4458 14.7081 11.4458 14.5606V10.8996C11.4 10.899 11.3544 10.8983 11.3093 10.8976C10.9721 10.8923 10.6232 10.8868 10.4099 10.9757Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.0239 5.78019C14.0239 5.52073 13.7042 5.2152 13.3952 4.91974C13.094 4.63181 12.7825 4.33409 12.6305 3.96583C12.4722 3.58213 12.481 3.13957 12.4895 2.71154C12.4978 2.29482 12.5064 1.86395 12.3396 1.69635C12.1722 1.52815 11.7408 1.53504 11.3235 1.54151C10.8962 1.54831 10.4545 1.55522 10.0722 1.39594C9.70504 1.24292 9.40832 0.931406 9.12136 0.630117C8.82634 0.320361 8.52124 0 8.26193 0C8.00263 0 7.69753 0.320361 7.40248 0.630147C7.11552 0.931406 6.8188 1.24295 6.45165 1.39594C6.06935 1.55525 5.62768 1.54831 5.20026 1.54154C4.78313 1.53495 4.35168 1.52821 4.18428 1.69635C4.01746 1.86398 4.02604 2.29485 4.03434 2.71151C4.04286 3.13954 4.05168 3.58216 3.89333 3.96586C3.74137 4.33406 3.42994 4.63178 3.12871 4.91974C2.81963 5.2152 2.5 5.52073 2.5 5.78019C2.5 6.03961 2.8196 6.34515 3.12868 6.6406C3.42991 6.92853 3.74137 7.22628 3.89336 7.59454C4.05168 7.97824 4.04289 8.4208 4.03436 8.84883C4.02607 9.26555 4.01749 9.69641 4.18431 9.86402C4.35171 10.0322 4.7831 10.0255 5.20029 10.0188C5.28678 10.0175 5.37391 10.0161 5.46095 10.0161C5.80401 10.0161 6.14673 10.0374 6.45165 10.1644C6.8188 10.3174 7.11552 10.6289 7.40248 10.9302C7.69753 11.24 8.00263 11.5603 8.26193 11.5603C8.52124 11.5603 8.82634 11.24 9.12139 10.9302C9.40835 10.629 9.70507 10.3174 10.0722 10.1644C10.4545 10.0051 10.8964 10.0122 11.3236 10.0188C11.7407 10.0254 12.1722 10.0322 12.3396 9.86399C12.5064 9.69636 12.4978 9.26549 12.4895 8.84886C12.481 8.42083 12.4722 7.97821 12.6305 7.59451C12.7825 7.22631 13.0939 6.92856 13.3952 6.6406C13.7043 6.34515 14.0239 6.03961 14.0239 5.78019ZM8.9141 6.19565C9.56628 4.56522 6.6315 7.48837 6.6315 5.74515C6.6315 4.00192 6.52351 4.23913 8.26193 4.23913C10.0004 4.23913 5.20026 3.47417 5.20026 5.21739C5.20026 6.96061 10.6525 6.19565 8.9141 6.19565Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "8.28687",
                        cy: "5.53101",
                        r: "2.60132",
                        fill: "#F1F1F1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.26174 1.95654C6.28392 1.95654 4.6748 3.56562 4.6748 5.54348C4.6748 7.52134 6.28392 9.13046 8.26174 9.13046C10.2396 9.13046 11.8487 7.52134 11.8487 5.54348C11.8487 3.56562 10.2396 1.95654 8.26174 1.95654ZM10.3214 4.93762L8.06793 7.19111C7.97212 7.28693 7.84475 7.33966 7.70925 7.33966C7.57376 7.33966 7.44639 7.28693 7.35057 7.19111L6.20206 6.0426C6.10624 5.94678 6.05347 5.81941 6.05347 5.68391C6.05347 5.54838 6.10624 5.42101 6.20206 5.32519C6.29784 5.22938 6.42521 5.1766 6.56074 5.1766C6.69624 5.1766 6.82364 5.22938 6.91942 5.32523L7.70921 6.11498L9.60399 4.22021C9.6998 4.1244 9.82717 4.07166 9.96267 4.07166C10.0982 4.07166 10.2255 4.1244 10.3214 4.22021C10.5192 4.41806 10.5192 4.73984 10.3214 4.93762Z",
                        fill: "black"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_14_12063",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "15",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
};
var UncheckedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
            cx: "9",
            cy: "9",
            r: "8.5",
            fill: "white",
            stroke: "black"
        })
    });
};
var CheckedIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "8.5",
                fill: "white",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "5",
                fill: color
            })
        ]
    });
};
var PickupIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "15",
        viewBox: "0 0 17 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.8606 4.37849L15.8169 1.3195C15.5476 0.530298 14.8132 0 13.9896 0H3.01043C2.18679 0 1.45237 0.530298 1.18307 1.3195L0.139379 4.37849C-0.108522 5.10486 -0.0229276 5.84556 0.373755 6.41024C0.781339 6.99048 1.47599 7.32306 2.27965 7.32306C3.06776 7.32306 3.8583 7.00296 4.46695 6.46673C4.93692 7.0003 5.64267 7.32306 6.42655 7.32306C7.21931 7.32306 7.96402 7.00419 8.49999 6.46734C9.03597 7.00419 9.78089 7.32306 10.5734 7.32306C11.3575 7.32306 12.0633 7.0003 12.5332 6.46673C13.0345 6.90848 13.6596 7.20013 14.3049 7.29039V12.596C14.3049 13.228 13.7974 13.7425 13.1736 13.7425H11.0115V10.9279C11.0115 9.58527 9.93431 8.49316 8.60981 8.49316H8.42793C7.10363 8.49316 6.02623 9.58527 6.02623 10.9279V13.7425H3.82621C3.20262 13.7425 2.69511 13.228 2.69511 12.596V8.85501C2.69511 8.50789 2.41753 8.22627 2.07495 8.22627C1.73237 8.22627 1.45479 8.50789 1.45479 8.85501V12.596C1.45479 13.9214 2.51867 15 3.82621 15H6.64639H10.3914H13.1736C14.4813 15 15.5452 13.9214 15.5452 12.596V7.19384C15.991 7.04699 16.367 6.77921 16.6264 6.41024C17.0229 5.84535 17.1085 5.10486 16.8606 4.37849ZM7.26654 13.7425V10.9279C7.26654 10.2787 7.78758 9.75064 8.42793 9.75064H8.60981C9.25036 9.75064 9.7712 10.2787 9.7712 10.9279V13.7425H7.26654ZM15.6159 5.6808C15.4414 5.92886 15.1237 6.06558 14.7203 6.06558C14.0441 6.06558 13.3339 5.66115 12.9531 5.05901C12.8381 4.87706 12.6406 4.76961 12.4311 4.76961C12.4028 4.76961 12.3746 4.77166 12.3459 4.77555C12.1061 4.80932 11.9078 4.98124 11.8376 5.21599C11.6833 5.73217 11.1871 6.06558 10.5734 6.06558C9.92906 6.06558 9.32142 5.6896 9.061 5.13003C8.95845 4.91001 8.74002 4.76961 8.49999 4.76961C8.25997 4.76961 8.04154 4.91001 7.93919 5.13003C7.67857 5.6896 7.07073 6.06558 6.42655 6.06558C5.81305 6.06558 5.31684 5.73197 5.16241 5.21599C5.09216 4.98124 4.89372 4.80932 4.65409 4.77555C4.41386 4.74321 4.17726 4.85271 4.04665 5.05922C3.66632 5.66115 2.95613 6.06558 2.27965 6.06558C1.87651 6.06558 1.55835 5.92886 1.38393 5.6808C1.22062 5.44809 1.19478 5.13167 1.31146 4.78946L2.35515 1.73068C2.45185 1.44763 2.71509 1.25749 3.01043 1.25749H13.9896C14.2847 1.25749 14.5479 1.44763 14.6444 1.73048L15.6881 4.78967C15.8052 5.13167 15.7794 5.44809 15.6159 5.6808Z",
            fill: "black"
        })
    });
};

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/OrderTypeSelector/index.tsx














var OrderTypeSelector = function() {
    var ref;
    var ref1 = (0,react.useContext)(CartContext/* CartContext */.A), _showAuthModal = ref1.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal;
    var dispatch = (0,es/* useDispatch */.I0)();
    var themeColor = (0,getThemeColor/* getThemeColor */.p)() || "#000000";
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer,
            userData: state.userReducer
        };
    }), cart = ref2.cart, userData = ref2.userData;
    var ref3 = (0,react.useState)({
        show: false,
        text: ""
    }), toastState = ref3[0], setToastState = ref3[1];
    (0,react.useEffect)(function() {
        var ref;
        if (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_flag) {
            var ref1, ref2;
            if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.min_order_value) > 0 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.min_order_value) > cart.items_total) {
                var ref3;
                if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.pickup_flag) === 0) {
                    var ref4;
                    onCartDeliveryInfoHandle("Shop for ₹".concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.services) === null || ref4 === void 0 ? void 0 : ref4.min_order_value) - cart.items_total, " more for home delivery"));
                } else {
                    if (cart.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY) {
                        togglePickupDeliverySwitch(constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP);
                    }
                }
            }
        }
    }, []);
    var onCartDeliveryInfoHandle = function(text) {
        setToastState({
            show: true,
            text: text
        });
        setTimeout(function() {
            setToastState({
                show: false,
                text: ""
            });
        }, 3000);
    };
    /**
   * Helper function to return a
   * delivery charge
   * @param {string} orderTypeCheck
   * @return {number}
   */ var togglePickupDeliverySwitch = function(value) {
        var ref;
        if (value === cart.order_type) {
            return;
        }
        if (value === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP && (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.services.pickup_flag) === 0) {
            onCartDeliveryInfoHandle("We are not accepting pickup orders right now");
            return;
        }
        if (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_flag) {
            var ref1, ref2;
            if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.min_order_value) > 0 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.min_order_value) > cart.pay_amount && value === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY) {
                var ref3;
                onCartDeliveryInfoHandle("Shop for ₹".concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.min_order_value) - cart.pay_amount, " more for home delivery"));
            } else {
                dispatch((0,actions_cart/* setCart */.RV)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cart), {
                    order_type: value,
                    store_id: storeInfo.store_id,
                    user_phone: cart.phone,
                    cart_id: cart.cart_id
                })));
            }
        } else {
            onCartDeliveryInfoHandle("Store is currently not delivering to your area");
        }
    };
    var switchesData = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingTruck, {}),
            heading: "Deliver this to an address",
            desc: "Get estimated delivery time after you add the address",
            value: constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY,
            isActive: cart.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupIcon, {}),
            heading: "Pickup from store",
            desc: "Check with store if pickup is available today",
            value: constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
            isActive: cart.order_type === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP
        }, 
    ];
    return !!(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.services.pickup_flag) && !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_flag) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative tw-border-t tw-border-solid tw-border-[#E2E2E2] md:tw-border-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mx-[16px] tw-mb-[8px] tw-mt-[16px] tw-flex tw-flex-col tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid md:tw-mx-0 md:tw-mb-0 md:tw-flex-row",
                style: {
                    borderColor: themeColor
                },
                children: switchesData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-1 tw-cursor-pointer tw-flex-row-reverse tw-justify-between tw-gap-[16px] tw-border-b tw-border-solid tw-border-[#E2E2E2] tw-px-[20px] tw-py-[20px] md:tw-flex-row md:tw-justify-start md:tw-border-r md:tw-py-[24px] ".concat(data.isActive ? "tw-bg-[#F7F7F7]" : ""),
                        onClick: function() {
                            !(userData === null || userData === void 0 ? void 0 : userData.isLogin) ? showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal() : togglePickupDeliverySwitch(data.value);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    color: themeColor
                                },
                                children: data.isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedIcon, {
                                    color: themeColor
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UncheckedIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-h-fit tw-items-center tw-gap-[12px]",
                                children: [
                                    !checkClientDeviceType/* IS_DESKTOP */.yn && data.icon,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-gap-[4px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "tw-m-0 tw-text-sm ".concat(data.isActive ? "tw-font-semibold" : "tw-font-medium"),
                                                children: data.heading
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "tw-m-0 tw-hidden tw-text-xs tw-text-[#666666] md:tw-block",
                                                children: data.desc
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            toastState.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDeliveryTooltip, {
                children: toastState.text
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: toastState.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDeliveryTooltip, {
            children: toastState.text
        })
    });
};
/* harmony default export */ var Components_OrderTypeSelector = (OrderTypeSelector);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/utils/getContactDetails.js
var getContactDetails = __webpack_require__(60492);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabPickup/index.tsx







var TabPickup = function(props) {
    var getPickupAvailableText = function getPickupAvailableText() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "tw-m-0 tw-flex tw-pt-[12px] tw-text-xs tw-italic md:tw-p-0",
            children: "Check with store if pickup is available today"
        });
    };
    var ref;
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var ref1 = (0,getContactDetails/* default */.ZP)(storeData, true), storeAddress = ref1.storeAddress, storePhone = ref1.storePhone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-mb-[16px] tw-rounded-lg md:tw-border ".concat(props.showTopBorderMobile ? "tw-border-t tw-border-solid" : "tw-bodrer-none", " tw-border-[#EAEAEC] md:tw-mb-0 md:tw-mt-[16px]   md:tw-border-solid"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-justify-between tw-px-[16px] tw-py-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-flex tw-items-center tw-gap-[12px] tw-text-[16px] tw-font-semibold md:tw-text-sm md:tw-font-medium",
                        children: [
                            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupIcon, {}),
                            "Store Location"
                        ]
                    }),
                    checkClientDeviceType/* IS_DESKTOP */.yn && getPickupAvailableText()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-px-[16px] md:tw-border-t md:tw-border-solid md:tw-border-[#EAEAEC] md:tw-px-[32px] md:tw-pb-[24px] md:tw-pt-[24px] ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-[12px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E2E2E2] tw-pt-[12px] md:tw-border-none md:tw-p-0 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-[4px] tw-px-[16px] md:tw-p-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-sm",
                                    children: (0,lodash.capitalize)((ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.name)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-sm tw-text-[#7D7D7D]",
                                    children: storePhone
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-sm tw-text-[#7D7D7D]",
                                    children: storeAddress
                                }),
                                !checkClientDeviceType/* IS_DESKTOP */.yn && getPickupAvailableText()
                            ]
                        }),
                        !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-divide-x tw-border-t tw-border-solid tw-border-[#E2E2E2] md:tw-flex-row-reverse md:tw-gap-[16px] md:tw-border-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "tw-flex tw-flex-1 tw-cursor-pointer tw-justify-center tw-border-r tw-border-solid tw-border-[#E2E2E2] tw-px-[16px] tw-py-[12px] tw-text-sm tw-font-semibold tw-no-underline last:tw-border-none md:tw-flex-none md:tw-border-none md:tw-p-0",
                                style: {
                                    color: (0,getThemeColor/* getThemeColor */.p)()
                                },
                                href: "tel:".concat(storePhone),
                                children: "Call Store"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Components_TabPickup = (TabPickup);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/CartAdditionalInfo.js
















function CheckoutAdditionalInfo(props) {
    var getOrderTypeText = function getOrderTypeText() {
        switch(cartData === null || cartData === void 0 ? void 0 : cartData.order_type){
            case constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP:
                return "Pickup Order";
            case constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY:
                return "Delivery Order";
            default:
                return null;
        }
    };
    var ref, ref1, ref2;
    var cartData = (0,es/* useSelector */.v9)(function(state) {
        return state.cartReducer;
    });
    var storeInfo = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var shouldShowAddressField = (cartData === null || cartData === void 0 ? void 0 : cartData.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY || (0,isStoreServiceBased/* isStoreServiceBased */.A)() && isAddressMandatoryForService();
    var shouldShowPickuptab = (cartData === null || cartData === void 0 ? void 0 : cartData.order_type) === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP;
    var showTopBorderMobile = !(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.pickup_flag) || !(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.delivery_flag);
    var _renderAddressField = function() {
        return shouldShowAddressField ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TabAddress, {
            showTopBorderMobile: showTopBorderMobile
        }) : null;
    };
    var _renderPickupTab = function() {
        return shouldShowPickuptab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_TabPickup, {
            showTopBorderMobile: shouldShowAddressField
        }) : null;
    };
    var selectedOrderTypeText = getOrderTypeText();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutAdditionalInfoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutAdditionalInfoHeaderContainer, {
                        children: !!((ref2 = props.allItems) === null || ref2 === void 0 ? void 0 : ref2.length) && checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartOption, {
                            className: "tw-flex tw-items-center tw-justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    children: "Cart"
                                }),
                                selectedOrderTypeText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    className: "!tw-text-sm !tw-font-medium",
                                    children: selectedOrderTypeText
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutAdditionalInfoTabContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPromo, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-gap-[]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_OrderTypeSelector, {}),
                                    _renderPickupTab(),
                                    _renderAddressField()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabOrderInstruction, {})
                        ]
                    })
                ]
            }),
            checkClientDeviceType/* IS_DESKTOP */.yn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPaymentModal/* default */.ZP, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentModal/* default */.Z, {})
        ]
    });
}
/* harmony default export */ var CartAdditionalInfo = (CheckoutAdditionalInfo);

// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(71778);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/index.js + 7 modules
var ProductCustomizationPopUp = __webpack_require__(24648);
// EXTERNAL MODULE: ./src/assets/svgExports/ZeroCart.js
var ZeroCart = __webpack_require__(86350);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(86423);
// EXTERNAL MODULE: ./src/utils/canDisablePlaceOrder.ts
var canDisablePlaceOrder = __webpack_require__(96930);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/EmptyCartView/index.tsx













var EmptyCartView = function() {
    var ref;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref1 = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            collections: state.catalogReducer.collections
        };
    }), storeInfo = ref1.storeInfo, collections = ref1.collections;
    var shopButtonClick = function() {
        if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
            return;
        }
        if (collections === null || collections === void 0 ? void 0 : collections.length) {
            var ref;
            router_default().push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        } else {
            var ref1;
            if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : ref1.theme_class)) {
                var ref2, ref3, ref4;
                if (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : ref2.custom_theme_flag) router_default().push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.store_info) === null || ref3 === void 0 ? void 0 : ref3.domain));
                else router_default().push((0,routes.getRoute)(routes.PATH.SHOP, storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.store_info) === null || ref4 === void 0 ? void 0 : ref4.domain));
            } else {
                var ref5;
                router_default().push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.domain));
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoItemInCart, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoItemInCartSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZeroCart/* ZeroCart */.N, {
                        height: deviceWidth/* deviceWidth */.o >= 767 ? 184.32 : 123,
                        width: deviceWidth/* deviceWidth */.o >= 767 ? 226.77 : 151
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoItemInCartText, {
                        children: "Your cart is empty, Go ahead and add something to the cart"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                px: checkClientDeviceType/* IS_DESKTOP */.yn ? "75px" : "26px",
                py: "18px",
                fontColor: "#ffffff",
                roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness,
                backgroundColor: themeColor,
                label: (0,getCustomCtaText/* default */.Z)("cart_cta"),
                variant: "solid",
                fontSize: deviceWidth/* deviceWidth */.o >= 767 ? 20 : 18,
                onClick: shopButtonClick
            })
        ]
    });
};
/* harmony default export */ var Components_EmptyCartView = (EmptyCartView);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/CartItemsAndCheckoutSectionHeading.tsx





var CartItemsAndCheckoutSectionHeading = function(param) {
    var showSummary = param.showSummary, hanldeSummary = param.hanldeSummary, _summeryClasses = param.summeryClasses, summeryClasses = _summeryClasses === void 0 ? "" : _summeryClasses, _showDropdown = param.showDropdown, showDropdown = _showDropdown === void 0 ? false : _showDropdown;
    return !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemHeading, {
        onClick: function() {
            return showDropdown && hanldeSummary();
        },
        showSummery: showSummary,
        showDropdown: showDropdown,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummaryText, {
                    className: "".concat(showDropdown ? "tw-text-[18px]/[22px]" : "tw-text-[16px]/[20px]", " tw-font-semibold md:tw-font-medium ").concat(summeryClasses),
                    children: (0,getCustomCtaText/* default */.Z)("order_summary_heading")
                })
            }),
            !checkClientDeviceType/* IS_DESKTOP */.yn && showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalDropDownArrowContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowSummary, {
                    showOrderSummary: showSummary,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {})
                })
            })
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_CartItemsAndCheckoutSectionHeading = (CartItemsAndCheckoutSectionHeading);

// EXTERNAL MODULE: ./src/assets/svgExports/DropDownArrow.js
var DropDownArrow = __webpack_require__(75172);
;// CONCATENATED MODULE: ./src/hooks/useOnScrollDownCta.js

/**
 * This Custom Hook Calculates if an Overflow div
 * is Scrolled To the end by User. USed in Cart.
 * @param {*} props
 * @returns -> False : When User reaches end of the Div. else False.
 */ function useOnScrollDownCta(props) {
    var removeScrollEventListener = function removeScrollEventListener() {
        var ref;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", checkIfScrolledDown);
    };
    var removeClickEvent = function removeClickEvent() {
        var ref;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", checkScrollHeight);
    };
    var checkScrollHeight = function checkScrollHeight() {
        var ref;
        if ((referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.scrollHeight) < 700) {
            setShowScrollDownHelper(false);
            removeScrollEventListener();
            removeClickEvent();
        }
    };
    var checkIfScrolledDown = function checkIfScrolledDown() {
        var ref, ref1, ref2;
        if ((referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) + (referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref1 = referenceToCheckScrollHeight.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTop) + 20 >= (referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref2 = referenceToCheckScrollHeight.current) === null || ref2 === void 0 ? void 0 : ref2.scrollHeight)) {
            setShowScrollDownHelper(false);
            removeScrollEventListener();
            removeClickEvent();
        }
    };
    var ref = (0,react.useState)(true), showScrollDownHelper = ref[0], setShowScrollDownHelper = ref[1];
    var referenceToCheckScrollHeight = props.referenceToCheckScrollHeight;
    (0,react.useEffect)(function() {
        var ref, ref1;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", checkIfScrolledDown);
        checkIfScrolledDown();
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref1 = referenceToCheckScrollHeight.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", checkScrollHeight);
        return function() {
            removeScrollEventListener();
            removeClickEvent();
        };
    }, []);
    return showScrollDownHelper;
}

;// CONCATENATED MODULE: ./src/components/Scroll/Scroll.styles.js

function Scroll_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  position: sticky;\n  bottom: 2%;\n  left: 40%;\n"
    ]);
    Scroll_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Scroll_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #383838;\n  opacity: 0.76;\n  display: flex;\n  justify-content: center;\n  max-width: 10vw;\n  border-radius: 18px;\n"
    ]);
    Scroll_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Scroll_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 12px;\n  padding: 10px 16px 10px 16px;\n  color: white;\n"
    ]);
    Scroll_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Scroll_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 9px;\n  margin-top: 4px;\n"
    ]);
    Scroll_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var ScrollContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollContainer",
    componentId: "sc-1ab23cfb-0"
})(Scroll_styles_templateObject());
var ScrollButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollButton",
    componentId: "sc-1ab23cfb-1"
})(Scroll_styles_templateObject1());
var ScrollTextIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollTextIconContainer",
    componentId: "sc-1ab23cfb-2"
})(Scroll_styles_templateObject2());
var ScrollIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollIcon",
    componentId: "sc-1ab23cfb-3"
})(Scroll_styles_templateObject3());

;// CONCATENATED MODULE: ./src/components/Scroll/Scroll.js






/**
 * Scroll Tab Provides User With Information That
 * current List of Items is Scrollable
 * removes after list is scrolled to the end.
 * @param {*} referenceToCheckScrollHeight
 * @returns
 */ function Scroll(referenceToCheckScrollHeight) {
    var showScrollDownHelper = useOnScrollDownCta(referenceToCheckScrollHeight);
    if (deviceWidth/* deviceWidth */.o < 767) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showScrollDownHelper && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollTextIconContainer, {
                    children: [
                        "Scroll",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrow/* DropDownArrow */.s, {
                                fillColor: "#ffffff",
                                width: 9,
                                height: 5
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var Scroll_Scroll = (Scroll);

// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(53716);
// EXTERNAL MODULE: ./src/utils/mutateItemObjectWithCartData.js
var mutateItemObjectWithCartData = __webpack_require__(22787);
// EXTERNAL MODULE: ./src/utils/mutateVariantItemWithCartData.js
var mutateVariantItemWithCartData = __webpack_require__(59186);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js
var CartButton = __webpack_require__(8673);
// EXTERNAL MODULE: ./src/config/index.js
var config = __webpack_require__(77733);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CartItem/styles.js

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  box-sizing: border-box;\n  :last-child {\n    border-bottom: none;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-wrap: nowrap;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  margin-right: 10px;\n  border: 0.5px solid #d9d9d9;\n  padding: 2px;\n  border-radius: 8px;\n\n  & > img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (min-width: 767px) {\n    width: 64px;\n    height: 64px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 67px;\n    height: 67px;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 10px;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  height: fit-content;\n  min-width: 12vw;\n  @media screen and (max-width: 767px) {\n    min-width: 38vw;\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  min-height: 15px;\n  height: fit-content;\n  margin-bottom: 7px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #000000;\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 13px;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: 300;\n  padding-bottom: 6px;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  @media screen and (min-width: 767px) {\n    flex-direction: row;\n  }\n\n  @media screen and (max-width: 766px) {\n    flex-direction: column;\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  margin-bottom: 4.5px;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row wrap;\n  flex: 0;\n  width: fit-content;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 0;\n  margin-right: 10px;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n\n  & > p {\n    font-size: 12px;\n    margin: 0 0 2px 0;\n    word-break: break-all;\n\n    &.heading {\n      color: #808080;\n    }\n\n    &:not(.heading) {\n      cursor: pointer;\n    }\n  }\n\n  @media screen and (min-width: 767px) {\n    max-width: 380px;\n\n    & > p {\n      margin: 0 0 4px 0;\n    }\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #000000;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: rgba(112, 112, 112, 0.43);\n  text-decoration: line-through;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #0dbf44;\n  margin: 0;\n  @media screen and (min-width: 767px) {\n    width: 5vw;\n  }\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  text-align: right;\n  height: fit-content;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  height: fit-content;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #7e7e7e;\n  font-size: 12px;\n  margin-top: 4px;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}

var Item = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Item",
    componentId: "sc-b16f4d97-0"
})(styles_templateObject());
var ItemInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemInfo",
    componentId: "sc-b16f4d97-1"
})(styles_templateObject1());
var ItemImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemImage",
    componentId: "sc-b16f4d97-2"
})(styles_templateObject2());
var ItemDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemDetails",
    componentId: "sc-b16f4d97-3"
})(styles_templateObject3());
var ItemName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ItemName",
    componentId: "sc-b16f4d97-4"
})(styles_templateObject4());
var ItemVariantName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemVariantName",
    componentId: "sc-b16f4d97-5"
})(styles_templateObject5());
var ItemSub = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemSub",
    componentId: "sc-b16f4d97-6"
})(styles_templateObject6());
var ItemPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemPrice",
    componentId: "sc-b16f4d97-7"
})(styles_templateObject7());
var AmountText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "AmountText",
    componentId: "sc-b16f4d97-8"
})(styles_templateObject8());
var ItemRemarksWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemRemarksWrapper",
    componentId: "sc-b16f4d97-9"
})(styles_templateObject9());
var DiscountedPrice = (0,styled_components_browser_esm/* default */.ZP)(AmountText).withConfig({
    displayName: "DiscountedPrice",
    componentId: "sc-b16f4d97-10"
})(styles_templateObject10());
var ActualPrice = (0,styled_components_browser_esm/* default */.ZP)(AmountText).withConfig({
    displayName: "ActualPrice",
    componentId: "sc-b16f4d97-11"
})(styles_templateObject11());
var ItemDiscount = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ItemDiscount",
    componentId: "sc-b16f4d97-12"
})(styles_templateObject12());
var ItemTotalValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemTotalValue",
    componentId: "sc-b16f4d97-13"
})(styles_templateObject13());
var CartButtonItemValueContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartButtonItemValueContainer",
    componentId: "sc-b16f4d97-14"
})(styles_templateObject14());
var DeliveryCharges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryCharges",
    componentId: "sc-b16f4d97-15"
})(styles_templateObject15());
var styles_ItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemContainer",
    componentId: "sc-b16f4d97-16"
})(styles_templateObject16());

// EXTERNAL MODULE: ./src/redux/store/index.js + 43 modules
var store = __webpack_require__(24686);
;// CONCATENATED MODULE: ./src/utils/removeItemFromCart.js




/**
 * removes a itemId from cart.
 */ function removeItemFromCart(productItem) {
    var ref;
    var cartData = store/* default.getState */.Z.getState().cartReducer;
    var items = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return (productItem === null || productItem === void 0 ? void 0 : productItem.item_id) !== (item === null || item === void 0 ? void 0 : item.item_id);
    });
    var newCart = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
        items: items
    });
    store/* default.dispatch */.Z.dispatch((0,actions_cart/* setCart */.RV)(newCart));
}

;// CONCATENATED MODULE: ./src/assets/svgExports/SimpleCloseIcon.js

var SimpleCloseIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Icon_material-close",
            "data-name": "Icon material-close",
            d: "M15.5,8.306,14.694,7.5,11.5,10.694,8.306,7.5,7.5,8.306,10.694,11.5,7.5,14.694l.806.806L11.5,12.306,14.694,15.5l.806-.806L12.306,11.5Z",
            transform: "translate(-7.5 -7.5)",
            fill: "#fc3d3d"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/CartRemoveCta/CartRemoveCta.styles.js

function CartRemoveCta_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  margin-left: ",
        "px;\n  margin-right: ",
        "px;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    CartRemoveCta_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartRemoveCta_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: ",
        "px;\n  margin-right: ",
        "px;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    CartRemoveCta_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartRemoveCta_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: ",
        "px;\n  color: #fc3d3d;\n"
    ]);
    CartRemoveCta_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CartRemoveCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartRemoveCtaContainer",
    componentId: "sc-a4e39d4-0"
})(CartRemoveCta_styles_templateObject(), function(props) {
    return props.customStyles.ml;
}, function(props) {
    return props.customStyles.mr;
}, function(props) {
    return props.customStyles.mt;
}, function(props) {
    return props.customStyles.mb;
});
var CartRemoveIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartRemoveIcon",
    componentId: "sc-a4e39d4-1"
})(CartRemoveCta_styles_templateObject1(), function(props) {
    return props.mli || 0;
}, function(props) {
    return props.mri || 0;
}, function(props) {
    return props.mti || 0;
}, function(props) {
    return props.mbi || 0;
});
var CartRemoveText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartRemoveText",
    componentId: "sc-a4e39d4-2"
})(CartRemoveCta_styles_templateObject2(), function(props) {
    return props.fontSize || 12;
});

;// CONCATENATED MODULE: ./src/components/CartRemoveCta/CartRemoveCta.js





function CartRemoveCta(props) {
    var handleRemoveCta = function handleRemoveCta() {
        removeItemFromCart(props === null || props === void 0 ? void 0 : props.item);
        (0,triggerGetServiceableAddressId/* triggerGetServiceableAddressId */.o)();
    };
    var cartRemoveCtaContainerStyles = {
        ml: props.ml ? props.ml : 0,
        mt: props.mt ? props.mt : 0,
        mb: props.mb ? props.mb : 0,
        mr: props.mr ? props.mr : 0
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartRemoveCtaContainer, {
        customStyles: cartRemoveCtaContainerStyles,
        onClick: handleRemoveCta,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartRemoveIcon, {
                mti: 2,
                mri: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleCloseIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartRemoveText, {
                fontSize: props.fontSize,
                children: "Remove"
            })
        ]
    });
}
/* harmony default export */ var CartRemoveCta_CartRemoveCta = (CartRemoveCta);

// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(91240);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/components/ReadMoreReadLess.js
var ReadMoreReadLess = __webpack_require__(19976);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CartItem/ItemPersonalizationDetails.js


var ItemPersonalizationDetails = function(param) {
    var storeData = param.storeData, personalizationsData = param.personalizationsData, handleEditClick = param.handleEditClick;
    var ref;
    if (!(personalizationsData === null || personalizationsData === void 0 ? void 0 : personalizationsData.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-mt-[16px] tw-flex tw-flex-col tw-gap-3 xs:tw-w-[90vw] md:tw-min-w-[100%] md:tw-max-w-[20vw]",
        children: personalizationsData === null || personalizationsData === void 0 ? void 0 : (ref = personalizationsData.map) === null || ref === void 0 ? void 0 : ref.call(personalizationsData, function(data, idx) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-flex tw-gap-[0.5rem]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-text-[12px] tw-font-normal tw-text-[#242121] md:tw-text-[0.875rem]",
                                        children: [
                                            " ",
                                            "Personalisation details",
                                            " "
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-text-[12px] tw-font-normal tw-text-[#868686] md:tw-text-[0.875rem]",
                                        children: [
                                            "(Qty: ",
                                            data === null || data === void 0 ? void 0 : data.quantity,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-ml-auto tw-cursor-pointer tw-text-[12px] tw-font-semibold tw-leading-5 tw-text-[#1F1F1F] md:tw-text-[0.875rem]",
                                style: {
                                    color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) || "#1F1F1F"
                                },
                                onClick: function() {
                                    return handleEditClick(data, idx);
                                },
                                children: "Edit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-[0.75rem] tw-flex tw-flex-col tw-gap-[0.5rem]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-[16px]",
                            children: [
                                !!(data === null || data === void 0 ? void 0 : (ref2 = data.images) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-[6px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-[0.75rem] tw-font-normal tw-text-[#4E4E4E]",
                                            children: "Image"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-flex tw-flex-wrap tw-gap-[0.625rem]",
                                            children: data === null || data === void 0 ? void 0 : (ref3 = data.images) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.map) === null || ref4 === void 0 ? void 0 : ref4.call(ref3, function(imgUrl, idx) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: imgUrl,
                                                    alt: "".concat(imgUrl, "-image"),
                                                    className: "tw-rounded",
                                                    width: "40px",
                                                    height: "40px",
                                                    style: {
                                                        border: "1px solid #eaeaec"
                                                    }
                                                }, idx);
                                            })
                                        })
                                    ]
                                }),
                                !!(data === null || data === void 0 ? void 0 : (ref5 = data.texts) === null || ref5 === void 0 ? void 0 : ref5.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-[2px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-[0.75rem] tw-font-normal tw-text-[#4E4E4E]",
                                            children: "Text"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreReadLess/* default */.Z, {
                                            text: (data === null || data === void 0 ? void 0 : (ref6 = data.texts) === null || ref6 === void 0 ? void 0 : ref6[0]) || "",
                                            color: "#999",
                                            maxChar: 80
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }, idx);
        })
    });
};
/* harmony default export */ var CartItem_ItemPersonalizationDetails = (ItemPersonalizationDetails);

// EXTERNAL MODULE: ./src/components/ItemSchedulingInfo/index.tsx + 2 modules
var ItemSchedulingInfo = __webpack_require__(95350);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CartItem/index.js





















var CartItem = function(props) {
    var pincodeBasedDeliveryServicableCheck = function pincodeBasedDeliveryServicableCheck() {
        if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && (userData === null || userData === void 0 ? void 0 : userData.user_id)) {
            if (cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable) return false;
            return productItem === null || productItem === void 0 ? void 0 : productItem.is_unserviceable;
        }
        return false;
    };
    var showDeliveryCharges = function showDeliveryCharges(item) {
        if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && (item === null || item === void 0 ? void 0 : item.delivery_charges) > 0) return true;
        return false;
    };
    var ref, ref1;
    var _data = props.data, _name = _data.name, name = _name === void 0 ? props.data.name || props.data.item_name : _name, _price = _data.price, price = _price === void 0 ? props.data.price || props.data.actual_price : _price, discounted_price = _data.discounted_price, quantity = _data.quantity;
    var ref2 = (0,react.useState)(props.data), productItem = ref2[0], setProductItem = ref2[1];
    var ref3 = (0,react.useState)(false), viewCompleteRemarks = ref3[0], setViewCompleteRemarks = ref3[1];
    var ref4 = (0,react.useState)(0), discountPercent = ref4[0], setDiscountPercent = ref4[1];
    var ref5 = (0,react.useState)(null), personalizationsData = ref5[0], setPersonalizationsData = ref5[1];
    var ref6 = (0,react.useState)(false), isItemUpdating = ref6[0], setIsItemUpdating = ref6[1];
    var ref7 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            userData: state.userReducer.data,
            setCartLoader: state.commonReducer.setCartLoader
        };
    }), cartData = ref7.cartData, storeData = ref7.storeData, userData = ref7.userData, setCartLoader = ref7.setCartLoader;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref8 = (0,useCartHandler/* useCartHandlers */.u)(), handleSetProductCustomizationCount = ref8.handleSetProductCustomizationCount, handleIncreamentClick = ref8.handleIncreamentClick, handleDecreamentClick = ref8.handleDecreamentClick, handleSetProductData = ref8.handleSetProductData;
    (0,react.useEffect)(function() {
        if (!setCartLoader && isItemUpdating) {
            setIsItemUpdating(false);
        }
    }, [
        setCartLoader
    ]);
    (0,react.useEffect)(function() {
        var percent = 0;
        var _tempItem = (0,_object_spread/* default */.Z)({}, props.data);
        var personalizations = [];
        /** If this is a variant product */ if (props.variant) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            _tempItem.discounted_price = props === null || props === void 0 ? void 0 : (ref = props.variant) === null || ref === void 0 ? void 0 : ref.discounted_price;
            _tempItem.price = props === null || props === void 0 ? void 0 : (ref1 = props.variant) === null || ref1 === void 0 ? void 0 : ref1.price;
            _tempItem.quantity = (props === null || props === void 0 ? void 0 : (ref2 = props.variant) === null || ref2 === void 0 ? void 0 : ref2.quantity) || 0;
            _tempItem.available_quantity = (props === null || props === void 0 ? void 0 : (ref3 = props.variant) === null || ref3 === void 0 ? void 0 : ref3.available_quantity) || 0;
            _tempItem.thumbnail_url = (ref4 = props.variant) === null || ref4 === void 0 ? void 0 : ref4.thumbnail_url;
            var ref7;
            personalizations = (ref7 = props === null || props === void 0 ? void 0 : (ref5 = props.variant) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.personalization_info) === null || ref6 === void 0 ? void 0 : ref6.personalizations) !== null && ref7 !== void 0 ? ref7 : [];
            /** If variant has image */ if (props.variant.images) {
                var ref8, ref9, ref10;
                _tempItem.image_url = (ref8 = props.variant) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.images) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.image_url;
            }
            percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(props.variant.price, props.variant.discounted_price);
        } else {
            var ref11, ref12, ref13, ref14;
            var ref15;
            personalizations = (ref15 = (ref11 = props.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.personalization_info) === null || ref12 === void 0 ? void 0 : ref12.personalizations) !== null && ref15 !== void 0 ? ref15 : [];
            _tempItem.quantity = (props === null || props === void 0 ? void 0 : (ref13 = props.data) === null || ref13 === void 0 ? void 0 : ref13.quantity) || 0;
            _tempItem.available_quantity = (props === null || props === void 0 ? void 0 : (ref14 = props.data) === null || ref14 === void 0 ? void 0 : ref14.available_quantity) || 0;
            percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(price, discounted_price);
        }
        if (personalizations && (personalizations === null || personalizations === void 0 ? void 0 : personalizations.length)) {
            var ref16;
            dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                item_id: (ref16 = props.data) === null || ref16 === void 0 ? void 0 : ref16.item_id,
                src: "cart_item"
            }, true, function(data) {
                _tempItem["available"] = data.available;
                _tempItem["variants"] = data.variants;
                _tempItem["product_personalization"] = data.product_personalization;
                _tempItem["variants_count"] = data.variants_count;
                dispatch((0,common/* setVariantModalVisibility */.VZ)(false));
            }));
        }
        /** set the discount percentage & product item */ setDiscountPercent(percent ? percent : 0);
        setProductItem(_tempItem);
        setPersonalizationsData(personalizations);
    }, [
        cartData.items
    ]);
    (0,react.useEffect)(function() {
        if (productItem === null || productItem === void 0 ? void 0 : productItem.product_personalization) {
            handleSetProductData(productItem);
        }
    }, [
        productItem
    ]);
    var handleAddRemoveItem = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var ref;
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : userData.phone
            }
        }));
        if (props.variant) {
            var newCart = (0,mutateVariantItemWithCartData/* mutateVariantItemWithCartData */.I)(type, props.data, props.variant, cartData, null, null, null, count);
            dispatch((0,actions_cart/* saveCart */.FP)(newCart));
            return;
        }
        var newState = (0,mutateItemObjectWithCartData/* mutateItemObjectWithCartData */.L)(type, props.data, cartData, null, null, null, count);
        dispatch((0,actions_cart/* saveCart */.FP)(newState));
    };
    var toggleCompleteRemarks = function() {
        return setViewCompleteRemarks(function(val) {
            return !val;
        });
    };
    var getTruncatedText = function(remark) {
        var TRUNCATED_CHAR_LIMIT = 40;
        if ((remark === null || remark === void 0 ? void 0 : remark.length) < TRUNCATED_CHAR_LIMIT) return remark;
        else return !viewCompleteRemarks ? "".concat(remark === null || remark === void 0 ? void 0 : remark.substr(0, TRUNCATED_CHAR_LIMIT), "...") : remark;
    };
    var getAdditionalRemarkText = function() {
        var ref;
        return ((ref = props.variant) === null || ref === void 0 ? void 0 : ref.additional_remark) || (productItem === null || productItem === void 0 ? void 0 : productItem.additional_remark);
    };
    var isItemAdditionDisabled = function() {
        if (productItem === null || productItem === void 0 ? void 0 : productItem.managed_inventory) return !((productItem === null || productItem === void 0 ? void 0 : productItem.quantity) < (productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity));
        else return false;
    };
    var handleEditClick = function(data, idx) {
        var ref;
        handleSetProductCustomizationCount(productItem);
        handleSetProductData(productItem);
        checkRenderEnv/* IS_CLIENT */.kc && localStorage.setItem("activeVariantId", props === null || props === void 0 ? void 0 : (ref = props.variant) === null || ref === void 0 ? void 0 : ref.variant_id);
        var itemData = (props === null || props === void 0 ? void 0 : props.variant) || (props === null || props === void 0 ? void 0 : props.data) || {};
        dispatch((0,catalog/* editCartProductPersonalization */.lF)({
            personalizedProductData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemData), {
                index: idx
            }),
            editableData: {
                images: data === null || data === void 0 ? void 0 : data.images,
                texts: data === null || data === void 0 ? void 0 : data.texts
            }
        }));
    };
    var updateCartItemForPersonalisedProduct = function(type) {
        handleSetProductCustomizationCount(productItem);
        handleSetProductData(productItem);
        if (productItem === null || productItem === void 0 ? void 0 : productItem.variants_count) {
            var ref;
            checkRenderEnv/* IS_CLIENT */.kc && localStorage.setItem("activeVariantId", props === null || props === void 0 ? void 0 : (ref = props.variant) === null || ref === void 0 ? void 0 : ref.variant_id);
        }
        switch(type){
            case "inc":
                handleIncreamentClick(type, productItem);
                break;
            case "dec":
                handleDecreamentClick(type, productItem);
                break;
            // this case would occur on personalised item deletion
            case "custom":
                handleAddRemoveItem(type, 0);
            default:
                break;
        }
    };
    var handleCartItemUpdate = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!(productItem === null || productItem === void 0 ? void 0 : productItem.product_personalization)) {
            handleAddRemoveItem(type, count);
            return;
        }
        updateCartItemForPersonalisedProduct(type, count);
    };
    var handleItemChange = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, reset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        if (count && (productItem === null || productItem === void 0 ? void 0 : productItem.managed_inventory) && (productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity) < count) {
            dispatch((0,common/* setUnavailableQuantityAlertState */.K6)({
                show: true,
                availableQuantity: productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity,
                onConfirm: function() {
                    setIsItemUpdating(true);
                    handleCartItemUpdate(type, productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity);
                },
                onCancel: reset
            }));
        } else {
            setIsItemUpdating(true);
            handleCartItemUpdate(type, count);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ItemContainer, {
        className: "tw-relative !tw-border-none",
        children: [
            pincodeBasedDeliveryServicableCheck() && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError_CartError, {
                text: "This item can’t be delivered to the selected address",
                iconWidth: 14,
                iconHeight: 14,
                mri: 8,
                width: deviceWidth/* deviceWidth */.o < 767 ? "100vw" : "24.48vw",
                fontSize: 12,
                mt: 12,
                mb: 12
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                imageUrl: productItem === null || productItem === void 0 ? void 0 : productItem.image_url,
                children: [
                    (storeData === null || storeData === void 0 ? void 0 : storeData.premium) === 1 && (productItem === null || productItem === void 0 ? void 0 : productItem.thumbnail_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImage, {
                        className: "tw-flex-shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: productItem === null || productItem === void 0 ? void 0 : productItem.thumbnail_url
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-1 tw-flex-col tw-gap-[16px] md:tw-flex-row md:tw-gap-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemInfo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemDetails, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemName, {
                                            children: name
                                        }),
                                        (props === null || props === void 0 ? void 0 : props.variant) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemVariantName, {
                                            children: props.variant.variant_name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemSub, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPrice, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountedPrice, {
                                                            children: "".concat(config/* CURRENCY_SYMBOL */.o).concat(productItem === null || productItem === void 0 ? void 0 : productItem.discounted_price)
                                                        }),
                                                        discountPercent !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActualPrice, {
                                                            children: "".concat(config/* CURRENCY_SYMBOL */.o).concat((productItem === null || productItem === void 0 ? void 0 : productItem.price) || (productItem === null || productItem === void 0 ? void 0 : productItem.actual_price))
                                                        })
                                                    ]
                                                }),
                                                discountPercent !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemDiscount, {
                                                    children: [
                                                        "".concat(discountPercent),
                                                        "% OFF"
                                                    ]
                                                })
                                            ]
                                        }),
                                        showDeliveryCharges(productItem) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryCharges, {
                                            children: [
                                                "Delivery: ",
                                                "".concat(config/* CURRENCY_SYMBOL */.o).concat(productItem === null || productItem === void 0 ? void 0 : productItem.delivery_charges)
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartButtonItemValueContainer, {
                                className: "tw-flex-1 !tw-justify-between md:!tw-justify-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton/* default */.Z, {
                                        isUpdating: isItemUpdating,
                                        customClasses: "tw-h-fit !tw-relative !tw-w-[132px] md:!tw-w-fit",
                                        allowItemDeletion: true,
                                        allowCustomInput: !(productItem === null || productItem === void 0 ? void 0 : productItem.product_personalization),
                                        disableAddition: isItemAdditionDisabled(),
                                        quantity: props.variant ? props.variant.quantity : quantity,
                                        onChange: handleItemChange,
                                        fontSize: 14
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemTotalValue, {
                                        className: "tw-w-[80px]",
                                        children: [
                                            config/* CURRENCY_SYMBOL */.o,
                                            props.variant ? props === null || props === void 0 ? void 0 : (ref = props.variant) === null || ref === void 0 ? void 0 : ref.amount : productItem === null || productItem === void 0 ? void 0 : productItem.amount
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, props === null || props === void 0 ? void 0 : props.key),
            !!getAdditionalRemarkText() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemRemarksWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "heading",
                        children: "Additional Remarks: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "cp",
                        onClick: toggleCompleteRemarks,
                        children: [
                            '"',
                            getTruncatedText(getAdditionalRemarkText()),
                            '"'
                        ]
                    })
                ]
            }),
            pincodeBasedDeliveryServicableCheck() && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartRemoveCta_CartRemoveCta, {
                item: productItem,
                mt: 8
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSchedulingInfo/* default */.Z, {
                schedulingInfo: props === null || props === void 0 ? void 0 : (ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.schedule_info
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItem_ItemPersonalizationDetails, {
                storeData: storeData,
                personalizationsData: personalizationsData,
                handleEditClick: handleEditClick
            })
        ]
    });
};
/* harmony default export */ var DesignSystem_CartItem = (CartItem);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/AllCartItems.tsx






var AllCartItems = function(param) {
    var referenceToCheckScrollHeight = param.referenceToCheckScrollHeight, allItems = param.allItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContainer, {
        className: "!tw-max-w-[100vw]",
        children: [
            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPrecursor, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPrecursorText, {
                        children: (0,getCustomCtaText/* default */.Z)("item_details_heading")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPrecursorText, {
                        style: {
                            marginRight: "6px"
                        },
                        children: "Quantity"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemList, {
                children: [
                    (allItems === null || allItems === void 0 ? void 0 : allItems.length) > 0 && allItems.filter(function(item) {
                        return item.item_type === "catalog";
                    }).map(function(item, i) {
                        var ref;
                        if ((item === null || item === void 0 ? void 0 : (ref = item.variants_selected) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                            var ref1;
                            return item === null || item === void 0 ? void 0 : (ref1 = item.variants_selected) === null || ref1 === void 0 ? void 0 : ref1.map(function(_var, varIdx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_CartItem, {
                                    data: item,
                                    variant: _var
                                }, _var.variant_id);
                            });
                        } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_CartItem, {
                            data: item
                        }, "".concat(i, "-cart-item"));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Scroll_Scroll, {
                        referenceToCheckScrollHeight: referenceToCheckScrollHeight
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_AllCartItems = (AllCartItems);

;// CONCATENATED MODULE: ./src/components/DeliveryChargeList/DeliveryChargeList.styles.js

function DeliveryChargeList_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 6px;\n  flex-direction: column;\n"
    ]);
    DeliveryChargeList_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DeliveryChargeList_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #7e7e7e;\n  width: 100%;\n  margin-top: 6px;\n"
    ]);
    DeliveryChargeList_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DeliveryChargeList_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 14px;\n  color: #7e7e7e;\n"
    ]);
    DeliveryChargeList_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var DeliveryChargeListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryChargeListContainer",
    componentId: "sc-ff02a544-0"
})(DeliveryChargeList_styles_templateObject());
var DeliveryChargeRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryChargeRow",
    componentId: "sc-ff02a544-1"
})(DeliveryChargeList_styles_templateObject1());
var DeliveryPriceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryPriceContainer",
    componentId: "sc-ff02a544-2"
})(DeliveryChargeList_styles_templateObject2());

;// CONCATENATED MODULE: ./src/components/DeliveryChargeList/DeliveryChargeList.js





function DeliveryChargeList() {
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            items: state.cartReducer.items,
            otherDeliveryCharges: state.cartReducer.other_delivery_charges,
            cartData: state.cartReducer
        };
    }), items = ref.items, otherDeliveryCharges = ref.otherDeliveryCharges, cartData = ref.cartData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryChargeListContainer, {
        children: [
            (items === null || items === void 0 ? void 0 : items.length) > 0 ? items === null || items === void 0 ? void 0 : items.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: item.delivery_charges > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryChargeRow, {
                        children: [
                            item.item_name,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryPriceContainer, {
                                children: [
                                    config/* CURRENCY_SYMBOL */.o,
                                    item.delivery_charges
                                ]
                            })
                        ]
                    }) : null
                }, item.item_id);
            }) : null,
            otherDeliveryCharges > 0 && otherDeliveryCharges !== (cartData === null || cartData === void 0 ? void 0 : cartData.delivery_charge) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryChargeRow, {
                children: [
                    "Other Delivery Charges",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryPriceContainer, {
                        children: [
                            config/* CURRENCY_SYMBOL */.o,
                            otherDeliveryCharges
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DeliveryChargeList_DeliveryChargeList = (DeliveryChargeList);

// EXTERNAL MODULE: ./src/utils/storeGSTStatus.js
var storeGSTStatus = __webpack_require__(41359);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/GrandTotal.tsx




var GrandTotal_GrandTotal = function(param) {
    var cart = param.cart;
    var _renderGstInclusivePrice = function _renderGstInclusivePrice() {
        return (0,storeGSTStatus/* isStoreGstIncluded */.u)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GstIncludesContainer, {
            children: "(Incl. ₹ ".concat(cart === null || cart === void 0 ? void 0 : cart.total_gst_paid, " GST)")
        }) : null;
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountRow, {
        className: "tw-mb-[16px] tw-w-full md:tw-mb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalText, {
                fontWeight: 600,
                className: "!tw-text-[16px]/[20px]",
                children: [
                    "Grand Total",
                    _renderGstInclusivePrice()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                fontWeight: 600,
                className: "!tw-text-[18px]/[22px] md:!tw-text-[16px]/[20px]",
                children: (cart === null || cart === void 0 ? void 0 : cart.buyer_pay_value) && "".concat(config/* CURRENCY_SYMBOL */.o, " ").concat(cart === null || cart === void 0 ? void 0 : (ref = cart.buyer_pay_value) === null || ref === void 0 ? void 0 : ref.toFixed(2))
            })
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_GrandTotal = (GrandTotal_GrandTotal);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/OrderAmountInfo.tsx













var OrderAmountInfo = function(param) {
    var _showGrandTotal = param.showGrandTotal, showGrandTotal = _showGrandTotal === void 0 ? false : _showGrandTotal;
    var handleDeliveryChargeList = function handleDeliveryChargeList() {
        setShowDeliveryChargeList(!showDeliveryChargeList);
    };
    var _renderGstExclusivePrice = function _renderGstExclusivePrice() {
        return (0,storeGSTStatus/* isStoreGstExcluded */.n)() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(GstExcludesContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "GST"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "₹ ",
                        cart === null || cart === void 0 ? void 0 : cart.total_gst_paid
                    ]
                })
            ]
        }) : null;
    };
    var _renderDeliveryRelatedInfo = function _renderDeliveryRelatedInfo() {
        var ref, ref1, ref2;
        var isOrderBasedStoreType = (0,getStoreType/* getStoreType */.K)(storeInfo) === constants/* STORE_CUSTOMIZATION.ORDER_BASED */.DO.ORDER_BASED;
        var isDeliveryOrder = cart.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY;
        var minDeliveryCharge = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_charge_min;
        var maxDeliveryCharge = storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.delivery_charge_max;
        var approxDeliveryTime = storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.delivery_time_approx;
        var isDeliveryChargeInfoAvailable = !!minDeliveryCharge && !!maxDeliveryCharge;
        var isDeliveryTimeInfoAvailable = !!approxDeliveryTime;
        var isDeliveryInfoAvaiable = isDeliveryChargeInfoAvailable || isDeliveryTimeInfoAvailable;
        var showDeliveryInfo = isOrderBasedStoreType && isDeliveryOrder && isDeliveryInfoAvaiable;
        return showDeliveryInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "flex justify-center items-start pt4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/images/information@2x.png",
                        alt: "info ocon",
                        className: "img h1"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-auto f7 black-50 ph2 lh-title",
                    children: [
                        isDeliveryChargeInfoAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                marginBottom: 10
                            },
                            children: "Delivery charges may apply, approx delivery charge ₹ ".concat(minDeliveryCharge, " to ₹ ").concat(maxDeliveryCharge, ". Exact amount will be reflected in your final bill")
                        }),
                        isDeliveryTimeInfoAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Typically arrives in ".concat(approxDeliveryTime, ". Final ETA will be shared once we get your order ready.")
                        })
                    ]
                })
            ]
        });
    };
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            cart: state.cartReducer
        };
    }), cart = ref1.cart, storeInfo = ref1.storeInfo;
    var ref2 = (0,react.useState)(false), showDeliveryChargeList = ref2[0], setShowDeliveryChargeList = ref2[1];
    var checkDeliveryChargeTypeComparison = function() {
        var ref, ref1, ref2, ref3;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_charge_type) === constants/* DELIVERY_CHARGE_TYPE.FREE */.zy.FREE || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.delivery_charge_type) === constants/* DELIVERY_CHARGE_TYPE.FIXED */.zy.FIXED) return true;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.delivery_charge_type) === constants/* DELIVERY_CHARGE_TYPE.NOT_VALID */.zy.NOT_VALID || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.delivery_charge_type) === constants/* DELIVERY_CHARGE_TYPE.CUSTOM */.zy.CUSTOM) {
            var ref4, ref5;
            return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.services) === null || ref4 === void 0 ? void 0 : ref4.free_delivery_above) ? cart.items_total > (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.services) === null || ref5 === void 0 ? void 0 : ref5.free_delivery_above) : false;
        }
        return true;
    };
    var _renderPromoDiscountBox = function() {
        var ref, ref1, ref2, ref3;
        return (cart === null || cart === void 0 ? void 0 : (ref = cart.store_offer) === null || ref === void 0 ? void 0 : ref.promo_code) && (cart === null || cart === void 0 ? void 0 : (ref1 = cart.store_offer) === null || ref1 === void 0 ? void 0 : ref1.promo_discount) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "flex justify-between items-center f6 lime-green-color",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Promo Discount"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(-) ₹",
                        cart === null || cart === void 0 ? void 0 : (ref2 = cart.store_offer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.promo_discount) === null || ref3 === void 0 ? void 0 : ref3.toFixed(2)
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    var _renderPaymentPromoDiscountBox = function() {
        var ref;
        return cart.payment_offer && cart.payment_offer.promo_discount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "flex justify-between items-center f6 lime-green-color",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Bank Discount"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(-) ₹",
                        (ref = cart.payment_offer.promo_discount) === null || ref === void 0 ? void 0 : ref.toFixed(2)
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                        fontWeight: 400,
                        children: (0,getCustomCtaText/* default */.Z)("item_total_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                        fontWeight: 400,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: cart.items_total && "".concat(config/* CURRENCY_SYMBOL */.o).concat(cart === null || cart === void 0 ? void 0 : (ref = cart.items_total) === null || ref === void 0 ? void 0 : ref.toFixed(2))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AmountRow, {
                style: {
                    flexDirection: "column",
                    alignItems: "space-between",
                    justifyContent: "center"
                },
                children: cart.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && checkDeliveryChargeTypeComparison() && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    style: {
                        width: "100%"
                    },
                    className: "cart-totalAmt__deliveryCharge flex justify-between items-start premium-deliver--charge mt2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-column w-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryChargeDropDownContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalText, {
                                        fontWeight: 400,
                                        children: [
                                            "Delivery fees",
                                            (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && cart.delivery_charge > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowContainer, {
                                                onClick: handleDeliveryChargeList,
                                                showDeliveryChargeList: showDeliveryChargeList,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrow/* DropDownArrow */.s, {
                                                    width: 12,
                                                    height: 6
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                                        fontWeight: 400,
                                        children: cart.delivery_charge === 0 ? "Free" : "".concat(config/* CURRENCY_SYMBOL */.o, " ").concat(cart.delivery_charge)
                                    })
                                ]
                            }),
                            showDeliveryChargeList && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryChargeList_DeliveryChargeList, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100 mv2",
                children: _renderPromoDiscountBox()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100 mv2",
                children: _renderPaymentPromoDiscountBox()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100 mv2",
                children: _renderGstExclusivePrice()
            }),
            showGrandTotal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100 mv2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_GrandTotal, {
                    cart: cart
                })
            }),
            _renderDeliveryRelatedInfo()
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_OrderAmountInfo = (OrderAmountInfo);

;// CONCATENATED MODULE: ./src/hooks/useOnScrollRemoveShadow.js

/**
 * this useEffect returns a variable that toggles
 * when we scroll to the bottom and top
 * @param {*} referenceToCheckScrollHeight
 * @returns
 */ function useOnScrollRemoveShadow(referenceToCheckScrollHeight) {
    var removeScrollEventListener = function removeScrollEventListener() {
        var ref;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", checkIfScrolledDownTop);
    };
    var checkIfScrolledDownTop = function checkIfScrolledDownTop() {
        var ref, ref1, ref2;
        if ((referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) + (referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref1 = referenceToCheckScrollHeight.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTop) >= (referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref2 = referenceToCheckScrollHeight.current) === null || ref2 === void 0 ? void 0 : ref2.scrollHeight)) {
            setShowScrollDownShadow(false);
        } else setShowScrollDownShadow(true);
    };
    var ref = (0,react.useState)(true), showScrollDownShadow = ref[0], setShowScrollDownShadow = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", checkIfScrolledDownTop);
        checkIfScrolledDownTop();
        return function() {
            removeScrollEventListener();
        };
    }, []);
    return showScrollDownShadow;
}

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CustomerAssurityBadges/index.tsx



var KYC_DONE_FLAG = 3;
var CustomerAssurityBadges = function() {
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var isKycDone = (storeData === null || storeData === void 0 ? void 0 : storeData.kyc_status) === KYC_DONE_FLAG;
    var assurityData = [
        {
            show: true,
            Icon: ShieldIcon,
            boldText: "Secured",
            normalText: "Payment"
        },
        {
            show: isKycDone,
            Icon: VerifiedIcon,
            boldText: "Verified",
            normalText: "Merchant"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-flex tw-items-center tw-justify-center tw-gap-[20px] tw-text-[14px] tw-opacity-60 md:tw-pt-[4px]",
        children: assurityData.map(function(param, index) {
            var show = param.show, Icon = param.Icon, boldText = param.boldText, normalText = param.normalText;
            return show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "tw-flex tw-gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        height: 16,
                        width: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-font-bold",
                        children: boldText
                    }),
                    " ",
                    normalText
                ]
            }, index);
        })
    });
};
/* harmony default export */ var Components_CustomerAssurityBadges = (CustomerAssurityBadges);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/CartCheckoutCTA.tsx
















var PLACE_ORDER_BUTTON_OPACITY = "20";
var CartCheckoutCTA = function(param) {
    var allItems = param.allItems, referenceToCheckScrollHeight = param.referenceToCheckScrollHeight;
    var getCtalabel = function getCtalabel() {
        var ref;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) === constants/* PREPAID_POSTPAID_METHODS.PREPAID */.R9.PREPAID) return "Pay Now";
        return (0,getCustomCtaText/* default */.Z)("cart_cta");
    };
    var getIsCtaDisabled = function getIsCtaDisabled() {
        var ref;
        switch(true){
            case cart === null || cart === void 0 ? void 0 : cart.is_order_blocked:
            case prepaidLimitDisablePayNow:
            case (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && (cart === null || cart === void 0 ? void 0 : cart.is_cart_unserviceable):
            case (userData === null || userData === void 0 ? void 0 : userData.isLogin) && (cart === null || cart === void 0 ? void 0 : cart.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && !((ref = cart.delivery_info) === null || ref === void 0 ? void 0 : ref.address1):
            case (cart === null || cart === void 0 ? void 0 : cart.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && toggleAddDeliveryForm:
                return true;
            default:
                return false;
        }
    };
    var getPlaceOrderCtaColor = function getPlaceOrderCtaColor() {
        if (getIsCtaDisabled()) {
            return themeColor + PLACE_ORDER_BUTTON_OPACITY;
        } else {
            return themeColor;
        }
    };
    var renderTextBelowPlaceOrderCta = function renderTextBelowPlaceOrderCta() {
        var ref, ref1, ref2;
        var invalidAddressText = (userData === null || userData === void 0 ? void 0 : userData.isLogin) && (cart === null || cart === void 0 ? void 0 : cart.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && !((ref = cart.delivery_info) === null || ref === void 0 ? void 0 : ref.address1) ? "Add valid address and phone number to proceed" : "";
        if (getIsCtaDisabled() && !!invalidAddressText) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f12px mt12px tw-text-red-600",
                children: invalidAddressText
            });
        }
        var paymentInfoText = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.partial_payment_flag) ? "You can choose partial payment in the next step" : (0,isStoreServiceBased/* isStoreServiceBased */.A)() ? "You can make payment once you avail the service" : null;
        return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.payment_method) !== constants/* PREPAID_POSTPAID_METHODS.PREPAID */.R9.PREPAID && !!paymentInfoText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-text-[12px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tc",
                children: paymentInfoText
            })
        });
    };
    var ref;
    var showScrollDownShadow = useOnScrollRemoveShadow(referenceToCheckScrollHeight);
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer,
            storeInfo: state.storeReducer.store,
            prepaidLimitDisablePayNow: state.commonReducer.prepaidLimitDisablePayNow,
            userData: state.userReducer,
            toggleAddDeliveryForm: state.commonReducer.toggleAddDeliveryForm
        };
    }), cart = ref1.cart, storeInfo = ref1.storeInfo, prepaidLimitDisablePayNow = ref1.prepaidLimitDisablePayNow, userData = ref1.userData, toggleAddDeliveryForm = ref1.toggleAddDeliveryForm;
    var onCartPlaceOrderBtnHandle = (0,react.useContext)(CartContext/* CartContext */.A).onCartPlaceOrderBtnHandle;
    return (allItems === null || allItems === void 0 ? void 0 : allItems.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomContainer, {
        storeUnserviceable: cart.is_store_unserviceable,
        showScrollDownShadow: showScrollDownShadow,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_GrandTotal, {
                cart: cart
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-w-full tw-flex-col tw-gap-[12px]",
                children: !cart.is_store_unserviceable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAbutton, {
                            fluid: true,
                            roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness,
                            backgroundColor: getPlaceOrderCtaColor(),
                            fontColor: "#ffffff",
                            fontSize: checkClientDeviceType/* IS_DESKTOP */.yn ? 14 : 16,
                            fontWeight: 700,
                            textTransform: "capitalize",
                            label: getCtalabel(),
                            variant: "solid",
                            disabled: getIsCtaDisabled(),
                            borderWidth: "0px",
                            onClick: function() {
                                if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
                                    return;
                                }
                                onCartPlaceOrderBtnHandle === null || onCartPlaceOrderBtnHandle === void 0 ? void 0 : onCartPlaceOrderBtnHandle();
                            },
                            className: "tw-py-[18px] md:tw-py-[16px]"
                        }),
                        renderTextBelowPlaceOrderCta()
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError_CartError, {
                    text: "Sorry, we are currently unserviceable at this pincode",
                    iconWidth: 14,
                    iconHeight: 14,
                    fontSize: !checkClientDeviceType/* IS_DESKTOP */.yn ? 12 : 14,
                    customClasses: "tw-justify-center"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_CustomerAssurityBadges, {})
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_CartCheckoutCTA = (CartCheckoutCTA);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/index.tsx








var CartSummery = function(param) {
    var showOrderSummary = param.showOrderSummary, handleOrderSummary = param.handleOrderSummary, _referenceToCheckScrollHeight = param.referenceToCheckScrollHeight, referenceToCheckScrollHeight = _referenceToCheckScrollHeight === void 0 ? null : _referenceToCheckScrollHeight, _summeryClasses = param.summeryClasses, summeryClasses = _summeryClasses === void 0 ? "" : _summeryClasses, _showDropdown = param.showDropdown, showDropdown = _showDropdown === void 0 ? false : _showDropdown, allItems = param.allItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_CartItemsAndCheckoutSectionHeading, {
                showSummary: showOrderSummary,
                hanldeSummary: handleOrderSummary,
                summeryClasses: summeryClasses,
                showDropdown: showDropdown
            }),
            showOrderSummary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemAmountContainer, {
                ref: referenceToCheckScrollHeight,
                showOrderSummary: showOrderSummary,
                showDropdown: showDropdown,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_AllCartItems, {
                        allItems: allItems,
                        referenceToCheckScrollHeight: referenceToCheckScrollHeight
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_OrderAmountInfo, {
                        showGrandTotal: showDropdown
                    })
                ]
            })
        ]
    });
};
var CartItemsAndCheckout = function(param) {
    var allItems = param.allItems;
    var handleOrderSummary = function handleOrderSummary() {
        if (!checkClientDeviceType/* IS_DESKTOP */.yn) setShowOrderSummary(!showOrderSummary);
    };
    var ref = (0,react.useState)(true), showOrderSummary = ref[0], setShowOrderSummary = ref[1];
    var referenceToCheckScrollHeight = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartBodyRightSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartSummery, {
                showOrderSummary: showOrderSummary,
                handleOrderSummary: handleOrderSummary,
                referenceToCheckScrollHeight: referenceToCheckScrollHeight,
                allItems: allItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_CartCheckoutCTA, {
                allItems: allItems,
                referenceToCheckScrollHeight: referenceToCheckScrollHeight
            })
        ]
    });
};
/* harmony default export */ var Components_CartItemsAndCheckout = (CartItemsAndCheckout);

// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(98616);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(53978);
// EXTERNAL MODULE: ./src/assets/svgExports/BackArrow.js
var BackArrow = __webpack_require__(85946);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/PageHeader/index.tsx










var PageHeader = function(param) {
    var isEmptyCart = param.isEmptyCart;
    var ref, ref1, ref2;
    var storeInfo = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    return !checkClientDeviceType/* IS_DESKTOP */.yn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartHeader, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHeaderBack, {
                onClick: function() {
                    var ref;
                    if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
                        var ref1;
                        router_default().push((0,routes.getRoute)(routes.PATH.SHOP, storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
                    } else {
                        var ref2;
                        router_default().push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackArrow/* BackArrow */.D, {
                    width: 16,
                    height: 16
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHeaderData, {
                children: !isEmptyCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeaderInner, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHeaderText, {
                        children: "Cart"
                    })
                }) : null
            })
        ]
    }) : (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
        return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
    });
};
/* harmony default export */ var Components_PageHeader = (PageHeader);

// EXTERNAL MODULE: ./src/utils/getPaymentMethodUsedByCustomer.js
var getPaymentMethodUsedByCustomer = __webpack_require__(10203);
;// CONCATENATED MODULE: ./src/containers/Cart/Hooks/useCartPageLandingEvent.tsx






var useCartPageLandingEvent = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer
        };
    }).userData;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        dispatch((0,common/* setPrepaidLimitDisablePayNow */.cv)(false));
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_Cart_Page",
            data: {
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                device: checkClientDeviceType/* IS_DESKTOP */.yn ? "Desktop" : "Mobile",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone,
                payment_method: (0,getPaymentMethodUsedByCustomer/* getPaymentMethodUsedByCustomer */.R)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.payment_method)
            }
        }));
    }, []);
};
/* harmony default export */ var Hooks_useCartPageLandingEvent = (useCartPageLandingEvent);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/ModifiedCartNotificationBar/index.tsx

var ModifiedCartNotificationBar = function(param) {
    var cartValidationData = param.cartValidationData, showValidationError = param.showValidationError;
    return (cartValidationData === null || cartValidationData === void 0 ? void 0 : cartValidationData.is_cart_modified) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "cart-update-notifier flex justify-center items-center bg-black w-100 white f7 fw3 pv2 ph3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/assets/images/cart-change-icon.png",
                className: "img h1 pr2"
            }),
            "There are updates in your cart",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "f7 fw3 bb b--dotted mh2",
                onClick: showValidationError,
                children: "View Details"
            })
        ]
    });
};
/* harmony default export */ var Components_ModifiedCartNotificationBar = (ModifiedCartNotificationBar);

;// CONCATENATED MODULE: ./src/containers/Cart/Hooks/useTriggerPixelEvent.tsx


var useTriggerCartPixelEvent = function(param) {
    var orderButtonClickCount = param.orderButtonClickCount;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer,
            userData: state.userReducer
        };
    }), cart = ref.cart, userData = ref.userData;
    (0,react.useEffect)(function() {
        if (typeof window.fbq === "function" && orderButtonClickCount == 1) {
            var ref, ref1, ref2, ref3;
            var pixelObject = {
                contents: cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                    return {
                        id: (item === null || item === void 0 ? void 0 : item.id) || (item === null || item === void 0 ? void 0 : item.item_id),
                        name: (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.item_name),
                        price: (item === null || item === void 0 ? void 0 : item.price) || (item === null || item === void 0 ? void 0 : item.actual_price),
                        quantity: item === null || item === void 0 ? void 0 : item.quantity
                    };
                }),
                currency: "INR",
                num_items: cart === null || cart === void 0 ? void 0 : (ref1 = cart.items) === null || ref1 === void 0 ? void 0 : ref1.length,
                value: cart === null || cart === void 0 ? void 0 : cart.pay_amount,
                user_id: userData === null || userData === void 0 ? void 0 : (ref2 = userData.data) === null || ref2 === void 0 ? void 0 : ref2.user_id,
                phone: userData === null || userData === void 0 ? void 0 : (ref3 = userData.data) === null || ref3 === void 0 ? void 0 : ref3.phone
            };
            window.fbq("track", "Purchase", pixelObject);
        }
    }, [
        orderButtonClickCount
    ]);
    return null;
};
/* harmony default export */ var useTriggerPixelEvent = (useTriggerCartPixelEvent);

;// CONCATENATED MODULE: ./src/components/CartItemDeletionAlert/index.tsx





var CartItemDeletionAlert = function() {
    var onClose = function onClose() {
        setDeletionAlertState === null || setDeletionAlertState === void 0 ? void 0 : setDeletionAlertState({
            show: false,
            callback: null
        });
    };
    var onConfirm = function onConfirm() {
        var ref;
        deletionAlertState === null || deletionAlertState === void 0 ? void 0 : (ref = deletionAlertState.callback) === null || ref === void 0 ? void 0 : ref.call(deletionAlertState);
        onClose();
    };
    var ref = (0,react.useContext)(CartContext/* CartContext */.A), deletionAlertState = ref.deletionAlertState, setDeletionAlertState = ref.setDeletionAlertState;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)() || "#000000";
    (0,react.useEffect)(function() {
        return function() {
            return onClose();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
        show: true,
        onClose: onClose,
        heading: "Remove Item",
        headingClasses: "!tw-border-none !tw-pt-[32px] !tw-px-[16px] md:!tw-px-[24px]",
        customClasses: "!tw-max-w-[440px] !tw-min-w-[300px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[24px] tw-px-[16px] tw-pb-[22px] md:tw-px-[24px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "tw-m-0 tw-text-sm tw-text-[#606060]",
                    children: "Are you sure you want to remove this item from the cart? This will also remove any associated coupon applied on this item."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-justify-end tw-gap-[16px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: onClose,
                            className: "tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid !tw-border-[#E3E3E3] tw-bg-transparent tw-p-[12px]",
                            style: {
                                color: themeColor
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: onConfirm,
                            className: "tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid tw-border-[#FF0000] tw-bg-transparent tw-p-[12px] tw-text-[#FF0000]",
                            children: "Remove Item"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_CartItemDeletionAlert = (CartItemDeletionAlert);

// EXTERNAL MODULE: ./src/components/QuntityUnavailableAlert/index.tsx
var QuntityUnavailableAlert = __webpack_require__(27913);
;// CONCATENATED MODULE: ./src/containers/Cart/index.js








































var STORE_CLOSE_FLAG = 0;
var DELIVERY_UNAVILABLE_FLAG = 0;
var PICKUP_UNAVILABLE_FLAG = 0;
var CART_ORDER_TYPE_TEXT = {
    SERVICE: "service",
    DELIVERY: "deliver",
    PICKUP: "pickup"
};
function getOrderTypeTextForCart(orderType) {
    switch(orderType){
        case constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE:
            return CART_ORDER_TYPE_TEXT.SERVICE;
        case constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY:
            return CART_ORDER_TYPE_TEXT.DELIVERY;
        default:
            CART_ORDER_TYPE_TEXT.PICKUP;
    }
}
// export const CartContext = createContext({});
var PreCartPage = function() {
    var handleCloseButton = function handleCloseButton() {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            showAuthModel: false
        }));
    };
    var setAddressDetails = function setAddressDetails() {
        var orderData = (0,addDeliveryInfoInCart/* addDeliveryInfoInCart */.$)(cart, (0,getStringifyAddress/* getStringifyAddress */.H)());
        dispatch((0,actions_cart/* setCart */.RV)(orderData, function() {
            dispatch((0,order/* placeOrder */.s1)((0,_object_spread/* default */.Z)({}, orderData), router));
        }));
    };
    var ref;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var triggerSetCart = (0,customHooks/* default */.Z)().triggerSetCart;
    var ref1 = (0,react.useState)({
        showAuthModel: false,
        showOrderInstructionModal: false,
        orderInstructionText: "",
        showPaymentModal: true,
        isPhoneNumber: false
    }), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(false), orderConfirmLoaderToggle = ref2[0], setOrderConfirmLoaderToggle = ref2[1];
    var ref3 = (0,react.useState)(0), orderButtonClickCount = ref3[0], setOrderButtonClickCount = ref3[1];
    var ref4 = (0,react.useState)(false), showAddressError = ref4[0], setShowAddressError = ref4[1];
    var ref5 = (0,react.useState)({
        show: false,
        callback: null
    }), deletionAlertState = ref5[0], setDeletionAlertState = ref5[1];
    var ref6 = (0,react.useState)(false), showSummeryMobile = ref6[0], setShowSummeryMobile = ref6[1];
    var ref7 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            storeInfo: state.storeReducer.store,
            personalizedProduct: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.personalizedProduct
        };
    }), storeInfo = ref7.storeInfo, personalizedProduct = ref7.personalizedProduct;
    var ref8 = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer,
            list: state.commonReducer.createList,
            userData: state.userReducer,
            setCartLoader: state.commonReducer.setCartLoader,
            cartValidationData: state.errorReducer.cart.cartValidationData
        };
    }), cart = ref8.cart, list = ref8.list, userData = ref8.userData, setCartLoader = ref8.setCartLoader, cartValidationData = ref8.cartValidationData;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    Hooks_useCartPageLandingEvent();
    useTriggerPixelEvent(orderButtonClickCount);
    (0,react.useEffect)(function() {
        if (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token")) {
            var authData = {
                auth_token: localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token"),
                service: ""
            };
            dispatch((0,auth/* authenticateUser */.So)(authData));
            setCartAction();
        } else {
            dispatch((0,user/* setLogout */.wt)());
        }
    }, [
        userData === null || userData === void 0 ? void 0 : userData.isLogin,
        userData === null || userData === void 0 ? void 0 : userData.savedAddress
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_flag) === STORE_CLOSE_FLAG) {
            var ref1;
            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
        }
    }, [
        storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_flag
    ]);
    (0,react.useEffect)(function() {
        if (!setCartLoader) setCartAction();
    }, [
        cart.pay_amount,
        cart.amount
    ]);
    var allItems = (0,_to_consumable_array/* default */.Z)(cart.items).concat((0,_to_consumable_array/* default */.Z)(list));
    var setCartAction = function() {
        var ref, ref1, ref2;
        var cartWithDeliveryInfo = !((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && !(userData === null || userData === void 0 ? void 0 : (ref = userData.savedAddress) === null || ref === void 0 ? void 0 : ref.pincode)) ? (0,addDeliveryInfoInCart/* addDeliveryInfoInCart */.$)(cart, (0,getStringifyAddress/* getStringifyAddress */.H)()) : {};
        triggerSetCart((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cart, cartWithDeliveryInfo), {
            user_phone: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone,
            phone: userData === null || userData === void 0 ? void 0 : (ref2 = userData.data) === null || ref2 === void 0 ? void 0 : ref2.phone
        }));
    };
    var toggleAuthModal = function() {
        var phone = (0,localStorageFunctions/* getLeadData */.X5)();
        var phoneReg = /(6|7|8|9)\d{9}/;
        if ((allItems === null || allItems === void 0 ? void 0 : allItems.length) && phone && phone.length === 10 && phone.match(phoneReg)) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModel: !state.showAuthModel,
                    isPhoneNumber: true
                });
            });
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModel: !state.showAuthModel
                });
            });
        }
    };
    var onDeliverHereBtnHandle = function() {
        var ref;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) === 0 && (0,getAuthToken/* getAuthToken */.b)() && !orderConfirmLoaderToggle) {
            setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
        } else {
            setAddressDetails();
        }
    };
    var submitCart = function() {
        var type = getOrderTypeTextForCart(cart.order_type);
        var isFormValid = true;
        var atleastOneProductPresent = false;
        var errorMessage = "Please create your product list";
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("deliveryType", type);
        allItems === null || allItems === void 0 ? void 0 : allItems.map(function(el) {
            if (el.item_name && el.quantity === "") {
                isFormValid = false;
                errorMessage = "Please enter the product quantity.";
            } else if (el.quantity === 0) {
                isFormValid = false;
                errorMessage = "Please enter the product quantity greater than 0.";
            }
            if (el.item_name) {
                atleastOneProductPresent = true;
            }
            return;
        });
        if (isFormValid && atleastOneProductPresent) {
            var ref;
            if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_flag) === DELIVERY_UNAVILABLE_FLAG && type === CART_ORDER_TYPE_TEXT.DELIVERY) {
                (0,Toast/* toastNotifyError */.Lu)("Sorry! Delivery not available currently.");
                return;
            }
            if (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token")) {
                if (type === CART_ORDER_TYPE_TEXT.PICKUP || type === CART_ORDER_TYPE_TEXT.SERVICE) {
                    dispatch((0,order/* placeOrder */.s1)(cart, router));
                } else {
                    dispatch((0,actions_cart/* saveCart */.FP)((0,_object_spread/* default */.Z)({}, cart)));
                    onDeliverHereBtnHandle();
                }
            } else {
                dispatch((0,actions_cart/* saveCart */.FP)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cart), {
                    items: allItems,
                    instructions: state.orderInstructionText
                })));
                toggleAuthModal();
            }
        } else {
            (0,Toast/* toastNotifyError */.Lu)(errorMessage);
        }
    };
    var onCartPlaceOrderBtnHandle = function() {
        setOrderButtonClickCount(function(count) {
            return count + 1;
        });
        if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
            return;
        }
        if (!(cart === null || cart === void 0 ? void 0 : cart.store_id)) {
            cart.store_id = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id;
        }
        (userData === null || userData === void 0 ? void 0 : userData.isLogin) ? dispatch((0,actions_cart/* validateCart */.ir)(cart, onCartValidationSuccess)) : toggleAuthModal();
    };
    var onCartValidationSuccess = function(validateCartData) {
        var ref;
        if (!(validateCartData === null || validateCartData === void 0 ? void 0 : (ref = validateCartData.message_list) === null || ref === void 0 ? void 0 : ref.length)) {
            var ref1, ref2, ref3, ref4, ref5, ref6;
            var type = getOrderTypeTextForCart(cart.order_type);
            if (type === CART_ORDER_TYPE_TEXT.DELIVERY && (userData === null || userData === void 0 ? void 0 : userData.isLogin) && !((ref1 = cart.delivery_info) === null || ref1 === void 0 ? void 0 : ref1.address1)) {
                setShowAddressError(true);
                return;
            }
            if (type === CART_ORDER_TYPE_TEXT.PICKUP && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.pickup_flag) === PICKUP_UNAVILABLE_FLAG) {
                (0,Toast/* toastNotifyError */.Lu)("We do not accept Pickup orders currently");
                return;
            }
            if (type === CART_ORDER_TYPE_TEXT.DELIVERY && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.delivery_flag) === 1 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.services) === null || ref4 === void 0 ? void 0 : ref4.min_order_value) > 0 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.services) === null || ref5 === void 0 ? void 0 : ref5.min_order_value) > cart.items_total) {
                var ref7;
                (0,Toast/* toastNotifyError */.Lu)("Shop for ₹".concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.services) === null || ref7 === void 0 ? void 0 : ref7.min_order_value) - cart.items_total, " more for home delivery"));
                return;
            }
            if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref6 = storeInfo.services) === null || ref6 === void 0 ? void 0 : ref6.payment_method) === 0 && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token")) && cart.order_type === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP) {
                setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
            } else submitCart();
        }
    };
    var showValidationError = function() {
        (userData === null || userData === void 0 ? void 0 : userData.isLogin) ? dispatch((0,error/* setCartValidationErrorMsgModalVisibility */.sn)(true)) : toggleAuthModal();
    };
    var contextValue = {
        allItems: allItems,
        userData: userData,
        storeInfo: storeInfo,
        showAuthModal: toggleAuthModal,
        isLogin: !!(userData === null || userData === void 0 ? void 0 : userData.isLogin),
        showAddressError: showAddressError,
        setShowAddressError: setShowAddressError,
        deletionAlertState: deletionAlertState,
        setDeletionAlertState: setDeletionAlertState,
        onCartPlaceOrderBtnHandle: onCartPlaceOrderBtnHandle
    };
    var isEmptyCart = !(allItems === null || allItems === void 0 ? void 0 : allItems.length) && isComponentMounted;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContext/* CartContext.Provider */.A.Provider, {
            value: contextValue,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartPage, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_PageHeader, {
                        isEmptyCart: isEmptyCart
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_ModifiedCartNotificationBar, {
                        cartValidationData: cartValidationData,
                        showValidationError: showValidationError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBody, {
                        children: isEmptyCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_EmptyCartView, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartSummery, {
                                    summeryClasses: "tw-text-[16px] tw-font-semibold",
                                    showDropdown: true,
                                    showOrderSummary: showSummeryMobile,
                                    handleOrderSummary: function() {
                                        return setShowSummeryMobile(!showSummeryMobile);
                                    },
                                    referenceToCheckScrollHeight: null,
                                    allItems: allItems
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartAdditionalInfo, {
                                    allItems: allItems
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_CartItemsAndCheckout, {
                                    allItems: allItems
                                })
                            ]
                        })
                    }),
                    state.showAuthModel && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthPopUp["default"], {
                        toggleModal: toggleAuthModal,
                        submitCart: submitCart,
                        isVisible: state.showAuthModel,
                        redirection: false,
                        isPhoneNumber: state.isPhoneNumber,
                        handleOnCloseButton: handleCloseButton,
                        isFromCart: true
                    }),
                    orderConfirmLoaderToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderConfirmLoader/* default */.Z, {
                        orderType: cart.order_type,
                        isVisible: orderConfirmLoaderToggle,
                        toggleModal: function() {
                            if (cart.order_type) setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
                        },
                        closeModal: function() {
                            return setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
                        },
                        submitAction: submitCart,
                        deliveryType: cart.order_type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_CartValidationErrorMsgModal, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotAcceptingOrderPopUp, {}),
                    deviceWidth/* deviceWidth */.o > 990 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPaymentModal/* default */.ZP, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentModal/* default */.Z, {}),
                    (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCustomizationPopUp/* ProductCustomizationPopUp */.X, {}),
                    deletionAlertState.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CartItemDeletionAlert, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuntityUnavailableAlert/* default */.Z, {})
                ]
            }, "cartPagePremium")
        })
    });
};
/* harmony default export */ var Cart = (PreCartPage);


/***/ }),

/***/ 30876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_DeliveryList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/utils/addDeliveryInfoInCart.js
var addDeliveryInfoInCart = __webpack_require__(68068);
// EXTERNAL MODULE: ./src/utils/isDeliveryPincodeBased.js
var isDeliveryPincodeBased = __webpack_require__(84110);
// EXTERNAL MODULE: ./src/utils/getStringifyAddress.js
var getStringifyAddress = __webpack_require__(97978);
;// CONCATENATED MODULE: ./src/utils/setUserSavedAddress.js



/**
 * utility function to check for saved address of logged in user
 * @param {*} userAddress
 * @return {*} Object
 */ var setUserSavedAddress = function(userAddress) {
    if (userAddress && Object.keys(userAddress).length) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userAddress), {
            user_name: (ref11 = (ref10 = userAddress === null || userAddress === void 0 ? void 0 : (ref = userAddress.user_name) === null || ref === void 0 ? void 0 : ref.text) !== null && ref10 !== void 0 ? ref10 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.user_name) !== null && ref11 !== void 0 ? ref11 : "",
            landmark: (ref13 = (ref12 = userAddress === null || userAddress === void 0 ? void 0 : (ref1 = userAddress.landmark) === null || ref1 === void 0 ? void 0 : ref1.text) !== null && ref12 !== void 0 ? ref12 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.landmark) !== null && ref13 !== void 0 ? ref13 : "",
            pincode: (ref15 = (ref14 = userAddress === null || userAddress === void 0 ? void 0 : (ref2 = userAddress.pincode) === null || ref2 === void 0 ? void 0 : ref2.text) !== null && ref14 !== void 0 ? ref14 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.pincode) !== null && ref15 !== void 0 ? ref15 : "",
            city: (ref17 = (ref16 = userAddress === null || userAddress === void 0 ? void 0 : (ref3 = userAddress.city) === null || ref3 === void 0 ? void 0 : ref3.text) !== null && ref16 !== void 0 ? ref16 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.city) !== null && ref17 !== void 0 ? ref17 : "",
            state: (ref19 = (ref18 = userAddress === null || userAddress === void 0 ? void 0 : (ref4 = userAddress.state) === null || ref4 === void 0 ? void 0 : ref4.text) !== null && ref18 !== void 0 ? ref18 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.state) !== null && ref19 !== void 0 ? ref19 : "",
            country: (ref21 = (ref20 = userAddress === null || userAddress === void 0 ? void 0 : (ref5 = userAddress.country) === null || ref5 === void 0 ? void 0 : ref5.text) !== null && ref20 !== void 0 ? ref20 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.country) !== null && ref21 !== void 0 ? ref21 : "",
            address1: (ref23 = (ref22 = userAddress === null || userAddress === void 0 ? void 0 : (ref6 = userAddress.address1) === null || ref6 === void 0 ? void 0 : ref6.text) !== null && ref22 !== void 0 ? ref22 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.address1) !== null && ref23 !== void 0 ? ref23 : "",
            address2: (ref25 = (ref24 = userAddress === null || userAddress === void 0 ? void 0 : (ref7 = userAddress.address2) === null || ref7 === void 0 ? void 0 : ref7.text) !== null && ref24 !== void 0 ? ref24 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.address2) !== null && ref25 !== void 0 ? ref25 : "",
            address_id: userAddress === null || userAddress === void 0 ? void 0 : userAddress.address_id,
            latitude: (ref26 = userAddress === null || userAddress === void 0 ? void 0 : userAddress.latitude) !== null && ref26 !== void 0 ? ref26 : 0,
            longitude: (ref27 = userAddress === null || userAddress === void 0 ? void 0 : userAddress.longitude) !== null && ref27 !== void 0 ? ref27 : 0,
            alternate_phone: (ref29 = (ref28 = userAddress === null || userAddress === void 0 ? void 0 : (ref8 = userAddress.alternate_phone) === null || ref8 === void 0 ? void 0 : ref8.text) !== null && ref28 !== void 0 ? ref28 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.alternate_phone) !== null && ref29 !== void 0 ? ref29 : "",
            email_id: (ref31 = (ref30 = userAddress === null || userAddress === void 0 ? void 0 : (ref9 = userAddress.email_id) === null || ref9 === void 0 ? void 0 : ref9.text) !== null && ref30 !== void 0 ? ref30 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.email_id) !== null && ref31 !== void 0 ? ref31 : "",
            custom_field_data_list: (0,getStringifyAddress/* getCustomFieldPayload */.C)(userAddress === null || userAddress === void 0 ? void 0 : userAddress.custom_field_data_list),
            missing_fields: (ref32 = userAddress === null || userAddress === void 0 ? void 0 : userAddress.missing_fields) !== null && ref32 !== void 0 ? ref32 : []
        });
    }
    return {};
};

// EXTERNAL MODULE: ./src/redux/store/index.js + 43 modules
var store = __webpack_require__(24686);
;// CONCATENATED MODULE: ./src/utils/getAddressByServiceabilityUnserviceabilty.js

/**
 * object containing unservicble , servicable and pincode required addresses
 * @returns {object} Properties -> Servicable, unservicable , pincode , Address Id's
 */ function getAddressByServiceabilityUnserviceabilty() {
    var ref;
    var pincode_required = [];
    var serviceable_address_ids = [];
    var unserviceable_address_ids = [];
    var addressData = store/* default.getState */.Z.getState().deliveryReducer.addressData;
    var userData = store/* default.getState */.Z.getState().userReducer;
    for(var i = 0; i < (userData === null || userData === void 0 ? void 0 : (ref = userData.addressList) === null || ref === void 0 ? void 0 : ref.length); i++){
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        if (addressData === null || addressData === void 0 ? void 0 : (ref1 = addressData.pincode_required) === null || ref1 === void 0 ? void 0 : ref1.includes(userData === null || userData === void 0 ? void 0 : (ref2 = userData.addressList) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[i]) === null || ref3 === void 0 ? void 0 : ref3.address_id)) {
            var ref10;
            pincode_required.push(userData === null || userData === void 0 ? void 0 : (ref10 = userData.addressList) === null || ref10 === void 0 ? void 0 : ref10[i]);
        } else if (addressData === null || addressData === void 0 ? void 0 : (ref4 = addressData.serviceable_address_ids) === null || ref4 === void 0 ? void 0 : ref4.includes(userData === null || userData === void 0 ? void 0 : (ref5 = userData.addressList) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[i]) === null || ref6 === void 0 ? void 0 : ref6.address_id)) {
            var ref11;
            serviceable_address_ids.push(userData === null || userData === void 0 ? void 0 : (ref11 = userData.addressList) === null || ref11 === void 0 ? void 0 : ref11[i]);
        } else if (addressData === null || addressData === void 0 ? void 0 : (ref7 = addressData.unserviceable_address_ids) === null || ref7 === void 0 ? void 0 : ref7.includes(userData === null || userData === void 0 ? void 0 : (ref8 = userData.addressList) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[i]) === null || ref9 === void 0 ? void 0 : ref9.address_id)) {
            var ref12;
            unserviceable_address_ids.push(userData === null || userData === void 0 ? void 0 : (ref12 = userData.addressList) === null || ref12 === void 0 ? void 0 : ref12[i]);
        }
    }
    return {
        pincode_required: pincode_required,
        serviceable_address_ids: serviceable_address_ids,
        unserviceable_address_ids: unserviceable_address_ids
    };
}

// EXTERNAL MODULE: ./src/utils/triggerGetItemDeliveryChages.js + 1 modules
var triggerGetItemDeliveryChages = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/containers/DeliveryList/DeliveryList.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: #6c6c6c;\n  letter-spacing: 0.9px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ListHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ListHeading",
    componentId: "sc-82c72e6e-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
// EXTERNAL MODULE: ./src/components/UserAddressCard/index.tsx + 3 modules
var UserAddressCard = __webpack_require__(25269);
// EXTERNAL MODULE: ./src/components/BasicModal/index.tsx
var BasicModal = __webpack_require__(75868);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
;// CONCATENATED MODULE: ./src/containers/DeliveryList/index.js
/**
 * Delivery Address List page
 */ 
















var ADDRESS_TYPE = {
    SERVICABLE: "SERVICABLE ADDRESSES",
    UNSERVICABLE: "NON-SERVICABLE ADDRESSES",
    PINCODE_REQUIRED: "PINCODE REQUIRED",
    SAVED_ADDRESS: "SAVED ADDRESSES"
};
var DeliveryList = function(props) {
    var renderAddressDetails = function renderAddressDetails(addressDetails, addressType) {
        var isUnserviceable = addressType === ADDRESS_TYPE.UNSERVICABLE;
        var isIncomplete = addressType === ADDRESS_TYPE.PINCODE_REQUIRED;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (isUnserviceable ? "o-40" : "") + " tw-mb-[4px] tw-flex tw-flex-col tw-gap-[16px]",
            children: (userData === null || userData === void 0 ? void 0 : userData.savedAddress) && (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.map(function(item, index) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAddressCard/* default */.Z, {
                    onEditClick: !isUnserviceable ? function() {
                        return onEditClick((item === null || item === void 0 ? void 0 : item.address_id) || 0);
                    } : null,
                    onDeliverClick: !isUnserviceable && !isIncomplete ? function() {
                        return setAddressValue(item, addressType);
                    } : null,
                    isIncomplete: isIncomplete,
                    isUnserviceable: isUnserviceable,
                    userName: item === null || item === void 0 ? void 0 : (ref = item.user_name) === null || ref === void 0 ? void 0 : ref.text,
                    addressType: item === null || item === void 0 ? void 0 : item.address_type,
                    addressName: item === null || item === void 0 ? void 0 : item.address_name,
                    alternatePhone: item === null || item === void 0 ? void 0 : (ref1 = item.alternate_phone) === null || ref1 === void 0 ? void 0 : ref1.text,
                    address1: item === null || item === void 0 ? void 0 : (ref2 = item.address1) === null || ref2 === void 0 ? void 0 : ref2.text,
                    address2: item === null || item === void 0 ? void 0 : (ref3 = item.address2) === null || ref3 === void 0 ? void 0 : ref3.text,
                    city: item === null || item === void 0 ? void 0 : (ref4 = item.city) === null || ref4 === void 0 ? void 0 : ref4.text,
                    state: item === null || item === void 0 ? void 0 : (ref5 = item.state) === null || ref5 === void 0 ? void 0 : ref5.text,
                    pincode: item === null || item === void 0 ? void 0 : (ref6 = item.pincode) === null || ref6 === void 0 ? void 0 : ref6.text,
                    customClasses: "md:!tw-border-solid md:!tw-px-[24px] md:!tw-py-[14px] md:!tw-rounded"
                }, index);
            }))
        });
    };
    var renderListHeading = function renderListHeading(headingText) {
        var ref, ref1, ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-mb-[12px] tw-flex tw-flex-col-reverse tw-justify-between tw-gap-[20px] md:tw-flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListHeading, {
                    children: headingText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                    textTransform: "capitalize",
                    roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness,
                    className: "!tw-w-full tw-py-[15px] !tw-text-sm !tw-font-semibold md:!tw-w-fit md:!tw-border-none md:tw-p-0",
                    label: "Add New Address",
                    fontColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color,
                    variant: "outline",
                    onClick: onAddNewAddressBtnHandle
                })
            ]
        });
    };
    var pincodeBasedDeliveryList = function pincodeBasedDeliveryList() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (serviceable_address_ids === null || serviceable_address_ids === void 0 ? void 0 : serviceable_address_ids.length) > 0 && renderListHeading(ADDRESS_TYPE.SERVICABLE),
                renderAddressDetails(serviceable_address_ids, ADDRESS_TYPE.SERVICABLE),
                renderAddressDetails(pincode_required, ADDRESS_TYPE.PINCODE_REQUIRED),
                renderAddressDetails(unserviceable_address_ids, ADDRESS_TYPE.UNSERVICABLE)
            ]
        });
    };
    var userAddressList = function userAddressList() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col",
            children: [
                (userData === null || userData === void 0 ? void 0 : (ref = userData.addressList) === null || ref === void 0 ? void 0 : ref.length) > 0 && renderListHeading(ADDRESS_TYPE.SAVED_ADDRESS),
                renderAddressDetails(userData === null || userData === void 0 ? void 0 : userData.addressList, ADDRESS_TYPE.SAVED_ADDRESS)
            ]
        });
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return state.userReducer;
    });
    var cartData = (0,es/* useSelector */.v9)(function(state) {
        return state.cartReducer;
    });
    var ref = getAddressByServiceabilityUnserviceabilty(), serviceable_address_ids = ref.serviceable_address_ids, pincode_required = ref.pincode_required, unserviceable_address_ids = ref.unserviceable_address_ids;
    (0,react.useEffect)(function() {
        if (props.isVisible) {
            dispatch((0,auth/* saveSelectedAddress */.z)({}));
        }
    }, []);
    var setAddressValue = function(selectedAddFromUsersAddList, addressType) {
        var ref;
        if (addressType === ADDRESS_TYPE.UNSERVICABLE) {
            return;
        }
        if ((selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.missing_fields[0]) && ((ref = selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.missing_fields[0]) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            dispatch((0,auth/* saveSelectedAddress */.z)(setUserSavedAddress(selectedAddFromUsersAddList)));
            props.setEditId(selectedAddFromUsersAddList.address_id);
            props.toggleAddDeliveryForm(true);
            props.toggleModal();
        } else {
            var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            dispatch((0,auth/* saveSelectedAddress */.z)(setUserSavedAddress(selectedAddFromUsersAddList)));
            var cartPayload = (0,addDeliveryInfoInCart/* addDeliveryInfoInCart */.$)(cartData, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedAddFromUsersAddList), {
                user_name: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref1 = selectedAddFromUsersAddList.user_name) === null || ref1 === void 0 ? void 0 : ref1.text) || "",
                landmark: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref2 = selectedAddFromUsersAddList.landmark) === null || ref2 === void 0 ? void 0 : ref2.text) || "",
                pincode: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref3 = selectedAddFromUsersAddList.pincode) === null || ref3 === void 0 ? void 0 : ref3.text) || "",
                city: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref4 = selectedAddFromUsersAddList.city) === null || ref4 === void 0 ? void 0 : ref4.text) || "",
                state: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref5 = selectedAddFromUsersAddList.state) === null || ref5 === void 0 ? void 0 : ref5.text) || "",
                country: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref6 = selectedAddFromUsersAddList.country) === null || ref6 === void 0 ? void 0 : ref6.text) || "",
                address1: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref7 = selectedAddFromUsersAddList.address1) === null || ref7 === void 0 ? void 0 : ref7.text) || "",
                address2: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref8 = selectedAddFromUsersAddList.address2) === null || ref8 === void 0 ? void 0 : ref8.text) || "",
                address_id: selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.address_id,
                latitude: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.latitude) || 0,
                longitude: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.longitude) || 0,
                alternate_phone: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref9 = selectedAddFromUsersAddList.alternate_phone) === null || ref9 === void 0 ? void 0 : ref9.text) || "",
                email_id: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref10 = selectedAddFromUsersAddList.email_id) === null || ref10 === void 0 ? void 0 : ref10.text) || "",
                age: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref11 = selectedAddFromUsersAddList.age) === null || ref11 === void 0 ? void 0 : ref11.text) || "",
                gender: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref12 = selectedAddFromUsersAddList.gender) === null || ref12 === void 0 ? void 0 : ref12.text) || "",
                custom_field_data_list: (0,getStringifyAddress/* getCustomFieldPayload */.C)(selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.custom_field_data_list) || []
            }));
            dispatch((0,cart/* setCart */.RV)(cartPayload));
            if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)()) (0,triggerGetItemDeliveryChages/* triggerGetItemDeliveryCharges */.l)();
            props.toggleModal();
            props.toggleAddDeliveryForm(false);
        }
    };
    var openAddressAdditionForm = function() {
        props.toggleAddDeliveryForm(true);
        props.toggleModal();
    };
    var onAddNewAddressBtnHandle = function() {
        openAddressAdditionForm();
        props.setEditId(0);
    };
    var onEditClick = function(id) {
        openAddressAdditionForm();
        props.setEditId(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
        show: props.isVisible,
        onClose: props.toggleModal,
        heading: "Select Delivery Address",
        showCloseIcon: true,
        customClasses: "!tw-max-h-[80%] md:!tw-max-h-[60%] !tw-font-inter",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-center tw-flex-col tw-gap-[16px] tw-px-[16px] tw-py-[20px] md:tw-px-[24px] md:tw-py-[16px]",
            children: (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() ? pincodeBasedDeliveryList() : userAddressList()
        })
    });
};
/* harmony default export */ var containers_DeliveryList = (DeliveryList);


/***/ }),

/***/ 78383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _utils_themeImports__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53978);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66162);
/* harmony import */ var _components_VariantModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40261);
/* harmony import */ var _components_VariantChooseRepeatModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32948);
/* harmony import */ var _components_VariantSelectedListModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84557);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66871);
/* harmony import */ var _utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98616);
/* harmony import */ var _components_DesignSystem_QuickViewModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75684);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20155);
/* harmony import */ var _components_InstallAppInstructionsOverlay__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(557);
/* harmony import */ var _components_ProductCustomizationPopUp__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24648);
/* harmony import */ var _components_FullPageLoader_FullPageLoader__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15241);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6337);
/* harmony import */ var src_components_CouponsAndVouchers_PromosDrawerAndButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90042);




















// import useSetCart from '@/utils/customHooks';
var Shop = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    // const { triggerSetCart } = useSetCart();
    var storeData = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_11__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref9 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref;
        return {
            cart: state.cartReducer,
            personalizedProduct: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.personalizedProduct
        };
    }), cart = ref9.cart, personalizedProduct = ref9.personalizedProduct;
    var isB2bStore = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_7__/* .getStoreType */ .K)(storeData) === _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var utmSource = urlParams.get("utm_source");
        if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_15__/* .IS_SERVER */ .W6 && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("utm_source")) !== utmSource) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("utm_source", utmSource);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (cart.items && cart.items.length > 0) {
            setCartAsyncCall();
        }
    }, [
        cart.pay_amount
    ]);
    var setCartAsyncCall = function() {
        return new Promise(function(resolve, reject) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .setCart */ .RV)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, cart), {
                order_type: isB2bStore ? _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .ORDER_TYPE.B2B */ .Jm.B2B : cart.order_type,
                order_mode: isB2bStore ? 3 : cart.order_mode,
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                user_phone: cart.phone,
                cart_id: cart.cart_id
            }), function(status) {
                resolve();
            }));
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FullPageLoader_FullPageLoader__WEBPACK_IMPORTED_MODULE_14__/* .FullPageLoader */ .B, {}),
            (ref = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_8__/* .specificThemeRender */ .t)(storeData)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_3__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
            }),
            (ref3 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_8__/* .specificThemeRender */ .t)(storeData)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.PLP) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_3__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                    showATCBtn: true,
                    shopPageBoolean: true
                }, layout));
            }),
            (ref6 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_8__/* .specificThemeRender */ .t)(storeData)) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.components) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Footer) === null || ref8 === void 0 ? void 0 : ref8.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_3__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VariantModal__WEBPACK_IMPORTED_MODULE_4__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VariantChooseRepeatModal__WEBPACK_IMPORTED_MODULE_5__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VariantSelectedListModal__WEBPACK_IMPORTED_MODULE_6__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DesignSystem_QuickViewModal__WEBPACK_IMPORTED_MODULE_9__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InstallAppInstructionsOverlay__WEBPACK_IMPORTED_MODULE_12__["default"], {}),
            (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductCustomizationPopUp__WEBPACK_IMPORTED_MODULE_13__/* .ProductCustomizationPopUp */ .X, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_CouponsAndVouchers_PromosDrawerAndButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Shop);


/***/ }),

/***/ 8623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);

var useUnselectablePaymentOptions = function() {
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        var ref;
        return {
            unselectablePaymentOptionsWithTxnCharge: ((ref = state.paymentReducer.paymentOptionsWithTxnCharge) === null || ref === void 0 ? void 0 : ref.grayed_out_payment_options) || [],
            unselectablePaymentOptions: state.paymentReducer.unselectablePaymentOptions || []
        };
    }), unselectablePaymentOptionsWithTxnCharge = ref.unselectablePaymentOptionsWithTxnCharge, unselectablePaymentOptions = ref.unselectablePaymentOptions;
    var getUnselectablePaymentOptionsToDisplay = function() {
        return (unselectablePaymentOptions === null || unselectablePaymentOptions === void 0 ? void 0 : unselectablePaymentOptions.length) ? unselectablePaymentOptions : (unselectablePaymentOptionsWithTxnCharge === null || unselectablePaymentOptionsWithTxnCharge === void 0 ? void 0 : unselectablePaymentOptionsWithTxnCharge.length) ? unselectablePaymentOptionsWithTxnCharge === null || unselectablePaymentOptionsWithTxnCharge === void 0 ? void 0 : unselectablePaymentOptionsWithTxnCharge.map(function(paymentOption) {
            return paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.payment_option_name;
        }) : [];
    };
    return {
        finalUnselectablePaymentOptions: getUnselectablePaymentOptionsToDisplay()
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useUnselectablePaymentOptions);


/***/ }),

/***/ 19315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55847);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63896);
/* harmony import */ var _containers_Shop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78383);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68037);








var ShopPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name).concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.address) === null || ref1 === void 0 ? void 0 : ref1.city) ? Boolean((storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.address) === null || ref2 === void 0 ? void 0 : ref2.visibility) === 1) ? ", ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.address) === null || ref3 === void 0 ? void 0 : ref3.city) : "" : "", " - Order Online"),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.store_info) === null || ref4 === void 0 ? void 0 : ref4.logo_image,
        metaDescription: storeInfo && (0,_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_7__/* .getMetaDescription */ .w)(storeInfo),
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
        isCustomDomain: props.isCustomDomain
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Shop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShopPage);


/***/ }),

/***/ 96930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ canDisablePlaceOrder; }
/* harmony export */ });
/* harmony import */ var src_redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44541);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23653);
/* harmony import */ var src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40804);




var canDisablePlaceOrder = function() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        showMessage: true,
        message: "This is a demo website, you need a live version to proceed this action."
    };
    var ref, ref1, ref2, // for new stores
    ref3, // for old stores
    ref4;
    var showMessage = args.showMessage, message = args.message;
    var storeInfo = (ref = src_redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.storeReducer) === null || ref1 === void 0 ? void 0 : ref1.store;
    // Enable place order flow for stores having theme and staging environment.
    if ( false || !!(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.premium)) {
        return false;
    }
    var disablePlaceOrder = ((ref2 = window.location.pathname) === null || ref2 === void 0 ? void 0 : ref2.includes(_routes__WEBPACK_IMPORTED_MODULE_1__.PATH.BUILDER_PREVIEW)) || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.theme) === null || ref3 === void 0 ? void 0 : ref3.new_subscription_web_status) === src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_STORE_WEBSITE_STATUS.ACTIVE_NOT_LIVE */ .d6.ACTIVE_NOT_LIVE || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.domain_info) === null || ref4 === void 0 ? void 0 : ref4.domain_type) === 0;
    if (disablePlaceOrder && showMessage && (message === null || message === void 0 ? void 0 : message.trim())) {
        (0,src_components_Common_Toast__WEBPACK_IMPORTED_MODULE_3__/* .toastNotifyError */ .Lu)(message);
    }
    return disablePlaceOrder;
};


/***/ }),

/***/ 8824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ getCardType; },
/* harmony export */   "G9": function() { return /* binding */ isExpiryInvalid; },
/* harmony export */   "TH": function() { return /* binding */ isCardValid; },
/* harmony export */   "Tn": function() { return /* binding */ formatExpiry; },
/* harmony export */   "XW": function() { return /* binding */ cardNumberFormat; },
/* harmony export */   "bX": function() { return /* binding */ formatCvc; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59637);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);



var cardNumberFormat = function(value) {
    var v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || "";
    var parts = [];
    for(var i = 0, len = match.length; i < len; i += 4){
        parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
        return parts.join(" ");
    } else {
        return value;
    }
};
var getCardType = function(cardNum) {
    // accept only digits, dashes or spaces
    var numericDashRegex = /^[\d\-\s]+$/;
    if (!numericDashRegex.test(cardNum)) return "";
    var payCardType = "DebitCard";
    /* var regexMap = [
    {regEx: /^4[0-9]{5}/ig,cardType: "VISA"},
    {regEx: /^5[1-5][0-9]{4}/ig,cardType: "MASTERCARD"},
    {regEx: /^3[47][0-9]{3}/ig,cardType: "AMEX"},
    {regEx: /^(5[06-8]\d{4}|6\d{5})/ig,cardType: "MAESTRO"}
  ];*/ var regexMap = [
        {
            regEx: /^4/gi,
            cardType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.VISA */ .WK.VISA
        },
        {
            regEx: /^5[1-5]/gi,
            cardType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.MASTERCARD */ .WK.MASTERCARD
        },
        {
            regEx: /^3[47]/gi,
            cardType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.AMEX */ .WK.AMEX
        },
        {
            regEx: /^(5[06-8]\d{4}|6\d{5})/gi,
            cardType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .CARD_TYPE.MAESTRO */ .WK.MAESTRO
        }, 
    ];
    for(var j = 0; j < regexMap.length; j++){
        if (cardNum.match(regexMap[j].regEx)) {
            payCardType = regexMap[j].cardType;
            break;
        }
    }
    if (cardNum.indexOf("50") === 0 || cardNum.indexOf("60") === 0 || cardNum.indexOf("65") === 0) {
        var g = "508500-508999|606985-607984|608001-608500|652150-653149";
        var i = g.split("|");
        for(var d = 0; d < i.length; d++){
            var c = parseInt(i[d].split("-")[0], 10);
            var f = parseInt(i[d].split("-")[1], 10);
            if (cardNum.substr(0, 6) >= c && cardNum.substr(0, 6) <= f && cardNum.length >= 6) {
                payCardType = "RUPAY";
                break;
            }
        }
    }
    return payCardType;
};
var isCardValid = function(cardNum) {
    // accept only digits, dashes or spaces
    var numericDashRegex = /^[\d\-\s]+$/;
    if (!numericDashRegex.test(cardNum)) return false;
    // The Luhn Algorithm.
    var nCheck = 0;
    var nDigit = 0;
    var bEven = false;
    var strippedField = cardNum.replace(/\D/g, "");
    for(var n = strippedField.length - 1; n >= 0; n--){
        var cDigit = strippedField.charAt(n);
        nDigit = parseInt(cDigit, 10);
        if (bEven) {
            if ((nDigit *= 2) > 9) nDigit -= 9;
        }
        nCheck += nDigit;
        bEven = !bEven;
    }
    if (nCheck % 10 === 0) return true;
    return false;
};
var formatExpiry = function(event) {
    var eventData = event.nativeEvent && event.nativeEvent.data;
    var prevExpiry = event.target.value.split(" / ").join("/");
    if (!prevExpiry) return null;
    var expiry = prevExpiry;
    if (/^[2-9]$/.test(expiry)) {
        expiry = "0".concat(expiry);
    }
    if (prevExpiry.length === 2 && +prevExpiry > 12) {
        var _prevExpiry = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(prevExpiry), head = _prevExpiry[0], tail = _prevExpiry.slice(1);
        expiry = "0".concat(head, "/").concat(tail.join(""));
    }
    if (/^1[/-]$/.test(expiry)) {
        return "01 / ";
    }
    expiry = expiry.match(/(\d{1,2})/g) || [];
    if (expiry.length === 1) {
        if (!eventData && prevExpiry.includes("/")) {
            return expiry[0];
        }
        if (/\d{2}/.test(expiry)) {
            return "".concat(expiry[0], " / ");
        }
    }
    if (expiry.length > 2) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(expiry.join("").match(/^(\d{2}).*(\d{2})$/) || [], 3), month = ref[1], year = ref[2];
        return [
            month,
            year
        ].join(" / ");
    }
    return expiry.join(" / ");
};
var formatCvc = function(cvc) {
    return (cvc.match(/\d+/g) || []).join("");
};
var ERROR_TEXT__INVALID_EXPIRY_DATE = "Expiry date is invalid";
var ERROR_TEXT__MONTH_OUT_OF_RANGE = "Expiry month must be between 01 and 12";
var ERROR_TEXT__YEAR_OUT_OF_RANGE = "Expiry year cannot be in the past";
var EXPIRY_DATE_REGEX = /^(\d{2})\/(\d{4}|\d{2})$/;
var MONTH_REGEX = /(0[1-9]|1[0-2])/;
var isExpiryInvalid = function(expiryDate) {
    var splitDate = expiryDate.split("/");
    if (!EXPIRY_DATE_REGEX.test(expiryDate)) {
        return ERROR_TEXT__INVALID_EXPIRY_DATE;
    }
    var expiryMonth = splitDate[0];
    if (!MONTH_REGEX.test(expiryMonth)) {
        return ERROR_TEXT__MONTH_OUT_OF_RANGE;
    }
    var expiryYear = splitDate[1];
    var currentYear = new Date().getFullYear();
    currentYear = parseInt(expiryYear.length === 4 ? currentYear : currentYear.toString().substr(-2), 10);
    if (currentYear > parseInt(expiryYear, 10)) {
        return ERROR_TEXT__YEAR_OUT_OF_RANGE;
    }
    return false;
};


/***/ }),

/***/ 42490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ codMethodRender; }
/* harmony export */ });
/* harmony import */ var _checkIfObjectExists__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31891);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);


/**
 * func to check for cod in payment method
 * @param {*} otherMethods
 * @param {*} paymentOptionsWithTxnCharge
 * @param {*} storeInfo
 * @return {*} array of cod method or empty array
 */ var codMethodRender = function(otherMethods, paymentOptionsWithTxnCharge, storeInfo) {
    var ref, ref1, ref2;
    var method = otherMethods;
    if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.mdr_flag) && (0,_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_1__/* .checkIfObjectExists */ .L)(paymentOptionsWithTxnCharge)) method = paymentOptionsWithTxnCharge === null || paymentOptionsWithTxnCharge === void 0 ? void 0 : (ref1 = paymentOptionsWithTxnCharge.others) === null || ref1 === void 0 ? void 0 : ref1.map(function(method) {
        if (method.hasOwnProperty("payment_option_name")) return method["payment_option_name"];
    });
    if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.payment_method) !== _constants__WEBPACK_IMPORTED_MODULE_0__/* .PREPAID_POSTPAID_METHODS.PREPAID */ .R9.PREPAID && (method === null || method === void 0 ? void 0 : method.length) && method.includes(_constants__WEBPACK_IMPORTED_MODULE_0__/* .PAYMENT_TYPE_CONSTANTS.COD */ .Mf.COD)) {
        return method;
    }
    return [];
};


/***/ }),

/***/ 30077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSetCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66162);
/* harmony import */ var _utils_getCurrentOrderType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48071);
/* harmony import */ var _utils_getStringifyAddress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97978);







function useSetCart() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var storeId = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store.store_id;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), cart = ref[0], triggerSetCart = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timerId = setTimeout(setCustomerCart, 300);
        return function() {
            return clearTimeout(timerId);
        };
    }, [
        cart
    ]);
    var setCustomerCart = function() {
        if (Object.keys(cart).length) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setCart */ .RV)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cart), {
                order_type: (0,_utils_getCurrentOrderType__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentOrderType */ .h)(cart.order_type),
                store_id: storeId,
                user_phone: cart.phone,
                cart_id: cart.cart_id,
                delivery_info: (0,_utils_getStringifyAddress__WEBPACK_IMPORTED_MODULE_3__/* .getStringifyAddress */ .H)()
            })));
        }
    };
    return {
        triggerSetCart: triggerSetCart
    };
}


/***/ }),

/***/ 74118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ debounce; }
/* harmony export */ });
function debounce(func, delay) {
    var debounceTimer;
    return function() {
        var context = this;
        var args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
            return func.apply(context, args);
        }, delay);
    };
}


/***/ }),

/***/ 70145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getEncrypDecryptStr; }
/* harmony export */ });
var getEncrypDecryptStr = function(str, type) {
    if (type === "encrypt" || type === "decrypt") {
        return type === "encrypt" ? btoa(encodeURIComponent(str)) : decodeURIComponent(atob(str));
    } else return str;
};


/***/ }),

/***/ 61305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ getAuthToken; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);


var getAuthToken = function() {
    if (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6 && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_1__/* .AUTH_TOKEN */ .UA))) {
        return localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_1__/* .AUTH_TOKEN */ .UA);
    }
    return false;
};


/***/ }),

/***/ 90129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getItemDetailFromCart; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);

function getItemDetailFromCart(itemId) {
    var itemsArray = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().cartReducer.items || [];
    var itemDetail = itemsArray === null || itemsArray === void 0 ? void 0 : itemsArray.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.item_id) === itemId;
    });
    return (itemDetail === null || itemDetail === void 0 ? void 0 : itemDetail.length) ? itemDetail[0] : {};
}


/***/ }),

/***/ 55847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getMetaDescription; }
/* harmony export */ });
/**
 * @param {object} storeInfo
 * @param {object} seoDetails
 * @return {string}
 */ var getMetaDescription = function(storeInfo) {
    var seoDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    if (!storeInfo) return "";
    if (seoDetails) return seoDetails.description;
    var description = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.default_seo) === null || ref === void 0 ? void 0 : ref.meta_description;
    return description || "";
// const businessTypes = storeInfo.store_businesses;
// const isAddresVisible = storeInfo?.address?.visibility === 1 ? true : false;
// let match = 13;
// let description = '';
// // default
// if (businessTypes && businessTypes.length > 1) {
//   match = 11;
// } else if (
//   businessTypes &&
//   businessTypes.length === 1 &&
//   businessTypes[0].business_id === 8
// ) {
//   match = 11;
// } else if (businessTypes && businessTypes.length === 0) {
//   match = 11;
// }
// // Genral store
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 1)
//   match = 1;
// // Pharmacy & Wellness
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 2)
//   match = 2;
// // Mobile & Electronics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 3)
//   match = 3;
// // Clothing & Fashion
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 4)
//   match = 4;
// // Resturants, Food Joints & Bakery
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 5)
//   match = 5;
// // Stationary & Office Supplies
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 6)
//   match = 6;
// // Arts, Jewellery & Collections
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 7)
//   match = 7;
// // Fruits & Vegetables
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 13)
//   match = 8;
// // Furniture & Home Decor
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 14)
//   match = 9;
// // Beauty & Cosmetics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 15)
//   match = 10;
// // real estate
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 16)
//   match = 12;
// switch (match) {
//   case 1:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Grocery & Dairy Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 2:
//     description = `Buy and Order online from  ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Pharmacy & Wellness Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 3:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Mobile & Electronics Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 4:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fashion Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 5:
//     description = `Order Food online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }|  Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     } . Order Now!`;
//     break;
//   case 6:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Stationary Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 7:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Arts, Jewellery & Collections Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 8:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fruits & Vegetables Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 9:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Furniture & Home Decor Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 10:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Beauty & Cosmetics Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 11:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 12:
//     description = `Buy / Sell / Rent your real estate dream property from ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     } | Real Estate Property ${storeInfo.store_info?.name}. Explore Now!`;
//     break;
//   default:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
// }
// return description;
};


/***/ }),

/***/ 94604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getPaymentMethodName; }
/* harmony export */ });
/**
 * Helper function which returns the
 * hardcoded string for the payment method
 * @param {string} method
 * @return {string}
 */ var getPaymentMethodName = function(method) {
    switch(method){
        case "googlepay":
            return "Google Pay";
        case "cod":
            return "Cash";
        case "phonepe":
        case "pswitch":
            return "PhonePe";
        case "payzapp":
            return "PayZapp";
        case "whatsapp":
            return "WhatsApp";
        case "paytm":
            return "Paytm";
        case "paytmupi":
            return "Paytm UPI";
        case "airtel":
            return "Airtel";
        case "creditCard":
            return "Credit Card";
        case "debitCard":
            return "Debit Card";
        case "cemi":
            return "EMI";
        case "dupi":
            return "dupi";
        case "mobikwik":
            return "MobiKwik";
        default:
            return method;
    }
};


/***/ }),

/***/ 10203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getPaymentMethodUsedByCustomer; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);

var getPaymentMethodUsedByCustomer = function(paymentFlag) {
    if (paymentFlag === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_PAYMENT_TYPE.POSTPAID */ .EY.POSTPAID) return "cod";
    if (paymentFlag === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_PAYMENT_TYPE.PREPAID */ .EY.PREPAID) return "prepaid";
    return "both";
};


/***/ }),

/***/ 66466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ isStoreServiceBased; }
/* harmony export */ });
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66871);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);


function isStoreServiceBased() {
    return (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_0__/* .getStoreType */ .K)() !== _constants__WEBPACK_IMPORTED_MODULE_1__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED;
}


/***/ }),

/***/ 73175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ itemQuantityValueComparison; }
/* harmony export */ });
/**
 * function to check if managed inventory is allowed
 * quantity and available_quantity comparison
 * @param {*} stockItem
 * @return {boolean} boolean
 */ var itemQuantityValueComparison = function(stockItem) {
    if (!((stockItem === null || stockItem === void 0 ? void 0 : stockItem.managed_inventory) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.available_quantity) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.quantity))) {
        return false;
    }
    return stockItem.quantity >= stockItem.available_quantity;
};


/***/ }),

/***/ 82983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ selectedVariantFromVariantList; }
/* harmony export */ });
/**
 * get variant from list if selected variants in cart data
 * @param {*} cartData
 * @param {*} itemIndexInCart
 * @param {*} selectedVariantId
 * @return {*} selectedVariant
 */ var selectedVariantFromVariantList = function(cartData, itemIndexInCart, selectedVariantId) {
    if (cartData && itemIndexInCart > -1) {
        var ref, ref1;
        return cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected.find(function(variant) {
            return variant.variant_id === selectedVariantId;
        });
    }
    return 0;
};


/***/ }),

/***/ 98616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ }),

/***/ 41359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ isStoreGstExcluded; },
/* harmony export */   "u": function() { return /* binding */ isStoreGstIncluded; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24686);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);


function isStoreGstIncluded() {
    var ref, ref1;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    if (((ref = storeData.services) === null || ref === void 0 ? void 0 : ref.gst_flag) === _constants__WEBPACK_IMPORTED_MODULE_1__/* .GST_FLAG.ENABLE */ .w9.ENABLE && (storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.gst_info) === null || ref1 === void 0 ? void 0 : ref1.is_gst_included)) return true;
    return false;
}
function isStoreGstExcluded() {
    var ref, ref1;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    if (((ref = storeData.services) === null || ref === void 0 ? void 0 : ref.gst_flag) === _constants__WEBPACK_IMPORTED_MODULE_1__/* .GST_FLAG.ENABLE */ .w9.ENABLE && !(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.gst_info) === null || ref1 === void 0 ? void 0 : ref1.is_gst_included)) return true;
    return false;
}


/***/ }),

/***/ 8527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ triggerGetItemDeliveryCharges; }
});

// EXTERNAL MODULE: ./src/redux/actions/delivery.js
var delivery = __webpack_require__(79977);
// EXTERNAL MODULE: ./src/redux/store/index.js + 43 modules
var store = __webpack_require__(24686);
// EXTERNAL MODULE: ./src/utils/getItemDetailFromCart.js
var getItemDetailFromCart = __webpack_require__(90129);
;// CONCATENATED MODULE: ./src/utils/getItemQuantityNameId.js


// this function is being used in CheckItemDelivery
function getItemQuantityNameId() {
    var item_id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, item_name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (item_id) {
        // assume quantity 1 if item is not added to cart
        var ref = (0,getItemDetailFromCart/* default */.Z)(item_id), _quantity = ref.quantity, quantity = _quantity === void 0 ? 1 : _quantity;
        var item_details = [
            {
                item_id: item_id,
                item_name: item_name,
                quantity: quantity
            }, 
        ];
        return item_details;
    }
    var item_details1 = [];
    var itemsArray = store/* default.getState */.Z.getState().cartReducer.items;
    for(var i = 0; i < (itemsArray === null || itemsArray === void 0 ? void 0 : itemsArray.length); i++){
        item_details1.push({
            item_id: itemsArray[i].item_id,
            item_name: itemsArray[i].item_name,
            quantity: itemsArray[i].quantity
        });
    }
    return item_details1;
}

// EXTERNAL MODULE: ./src/utils/getStringifyAddress.js
var getStringifyAddress = __webpack_require__(97978);
;// CONCATENATED MODULE: ./src/utils/triggerGetItemDeliveryChages.js




function triggerGetItemDeliveryCharges() {
    var defaultPayload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        pincode: "",
        pay_amount: -1,
        item_id: 0,
        item_name: ""
    };
    var cartData = store/* default.getState */.Z.getState().cartReducer;
    var storeData = store/* default.getState */.Z.getState().storeReducer.store;
    var addressDetails = (0,getStringifyAddress/* getStringifyAddress */.H)();
    /** Check if defaultPayload has a pay_amount >= 0, if not, use cartData's pay_amount */ var selectedPayAmount = defaultPayload.pay_amount >= 0 ? defaultPayload.pay_amount : cartData.pay_amount;
    var payload = {
        pincode: (defaultPayload === null || defaultPayload === void 0 ? void 0 : defaultPayload.pincode) ? defaultPayload === null || defaultPayload === void 0 ? void 0 : defaultPayload.pincode : addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.pincode,
        pay_amount: selectedPayAmount,
        item_details: getItemQuantityNameId(defaultPayload === null || defaultPayload === void 0 ? void 0 : defaultPayload.item_id, defaultPayload === null || defaultPayload === void 0 ? void 0 : defaultPayload.item_name),
        store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    };
    if (payload === null || payload === void 0 ? void 0 : payload.pincode) store/* default.dispatch */.Z.dispatch((0,delivery/* getItemDeliveryCharges */.Bo)(payload));
}


/***/ }),

/***/ 71778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/*
  Returns isComponentMounted
  isComponentMounted -> true / Component is Successfully mounted
*/ function useIsComponentMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isComponentMounted = ref[0], setIsComponentMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsComponentMounted(true);
    }, []);
    return isComponentMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsComponentMounted);


/***/ }),

/***/ 85134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo1":"globalLoader_logo1__U4pxQ","logo-1":"globalLoader_logo-1__07zYZ","logo2":"globalLoader_logo2__eivVl","loader-3":"globalLoader_loader-3__8hklP","loader3":"globalLoader_loader3__m47Bj","loader5":"globalLoader_loader5__6NXRf","loader-5-1":"globalLoader_loader-5-1__pESNT","loader-5-2":"globalLoader_loader-5-2__VgxuZ"};

/***/ }),

/***/ 64955:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports["default"] = useConfig;

var _react = __webpack_require__(67294);

function useConfig(config) {
    var _useState = (0, _react.useState)(config.count),
        _useState2 = _slicedToArray(_useState, 2),
        count = _useState2[0],
        setCount = _useState2[1];

    var _useState3 = (0, _react.useState)(config.size),
        _useState4 = _slicedToArray(_useState3, 2),
        size = _useState4[0],
        setSize = _useState4[1];

    var _useState5 = (0, _react.useState)(config.char),
        _useState6 = _slicedToArray(_useState5, 2),
        char = _useState6[0],
        setChar = _useState6[1];

    var _useState7 = (0, _react.useState)(config.color),
        _useState8 = _slicedToArray(_useState7, 2),
        color = _useState8[0],
        setColor = _useState8[1];

    var _useState9 = (0, _react.useState)(config.activeColor),
        _useState10 = _slicedToArray(_useState9, 2),
        activeColor = _useState10[0],
        setActiveColor = _useState10[1];

    var _useState11 = (0, _react.useState)(config.isHalf),
        _useState12 = _slicedToArray(_useState11, 2),
        isHalf = _useState12[0],
        setIsHalf = _useState12[1];

    var _useState13 = (0, _react.useState)(config.edit),
        _useState14 = _slicedToArray(_useState13, 2),
        edit = _useState14[0],
        setEdit = _useState14[1];

    var _useState15 = (0, _react.useState)(config.emptyIcon),
        _useState16 = _slicedToArray(_useState15, 2),
        emptyIcon = _useState16[0],
        setEmptyIcon = _useState16[1];

    var _useState17 = (0, _react.useState)(config.halfIcon),
        _useState18 = _slicedToArray(_useState17, 2),
        halfIcon = _useState18[0],
        setHalfIcon = _useState18[1];

    var _useState19 = (0, _react.useState)(config.filledIcon),
        _useState20 = _slicedToArray(_useState19, 2),
        filledIcon = _useState20[0],
        setFilledIcon = _useState20[1];

    var _useState21 = (0, _react.useState)(config.a11y),
        _useState22 = _slicedToArray(_useState21, 2),
        a11y = _useState22[0],
        setA11y = _useState22[1];

    var configObj = {
        count: count,
        size: size,
        char: char,
        color: color,
        activeColor: activeColor,
        isHalf: isHalf,
        edit: edit,
        emptyIcon: emptyIcon,
        halfIcon: halfIcon,
        filledIcon: filledIcon,
        a11y: a11y
    };

    function setConfig(config) {
        setCount(config.count);
        setSize(config.size);
        setChar(config.char);
        setColor(config.color);
        setActiveColor(config.activeColor);
        setIsHalf(config.isHalf);
        setEdit(config.edit);
        setEmptyIcon(config.emptyIcon);
        setHalfIcon(config.halfIcon);
        setFilledIcon(config.filledIcon);
        setA11y(config.a11y);
    }

    return [configObj, setConfig];
}

/***/ }),

/***/ 11312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _useConfig3 = __webpack_require__(64955);

var _useConfig4 = _interopRequireDefault(_useConfig3);

var _star = __webpack_require__(47719);

var _star2 = _interopRequireDefault(_star);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parentStyles = {
    overflow: "hidden",
    position: "relative"
};

function getHalfStarStyles(color, uniqueness) {
    return '\n    .react-stars-' + uniqueness + ':before {\n      position: absolute;\n      overflow: hidden;\n      display: block;\n      z-index: 1;\n      top: 0; left: 0;\n      width: 50%;\n      content: attr(data-forhalf);\n      color: ' + color + ';\n  }';
}

function getHalfStarStyleForIcons(color) {
    return '\n          span.react-stars-half > * {\n          color: ' + color + ';\n      }';
};

function ReactStars(props) {
    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        uniqueness = _useState2[0],
        setUniqueness = _useState2[1];

    var _useState3 = (0, _react.useState)(0),
        _useState4 = _slicedToArray(_useState3, 2),
        currentValue = _useState4[0],
        setCurrentValue = _useState4[1];

    var _useState5 = (0, _react.useState)([]),
        _useState6 = _slicedToArray(_useState5, 2),
        stars = _useState6[0],
        setStars = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        isUsingIcons = _useState8[0],
        setIsUsingIcons = _useState8[1];

    var _useConfig = (0, _useConfig4.default)(props),
        _useConfig2 = _slicedToArray(_useConfig, 2),
        config = _useConfig2[0],
        setConfig = _useConfig2[1];

    var _useState9 = (0, _react.useState)(0),
        _useState10 = _slicedToArray(_useState9, 2),
        halfStarAt = _useState10[0],
        setHalfStarAt = _useState10[1];

    var _useState11 = (0, _react.useState)(false),
        _useState12 = _slicedToArray(_useState11, 2),
        halfStarHidden = _useState12[0],
        setHalfStarHidden = _useState12[1];

    var _useState13 = (0, _react.useState)(''),
        _useState14 = _slicedToArray(_useState13, 2),
        classNames = _useState14[0],
        setClassNames = _useState14[1];

    function iconsUsed(config) {
        return !config.isHalf && config.emptyIcon && config.filledIcon || config.isHalf && config.emptyIcon && config.halfIcon && config.filledIcon;
    }

    function createUniqueness() {
        setUniqueness((Math.random() + "").replace(".", ""));
    }

    (0, _react.useEffect)(function () {
        addClassNames();
        validateInitialValue(props.value, props.count);
        setStars(getStars(props.value));
        setConfig(props);
        createUniqueness();
        setIsUsingIcons(iconsUsed(props));
        setHalfStarAt(Math.floor(props.value));
        setHalfStarHidden(props.isHalf && props.value % 1 < 0.5);
    }, []);

    function validateInitialValue(value, count) {
        if (value < 0 || value > count) {
            setCurrentValue(0);
        } else {
            setCurrentValue(value);
        }
    }

    function addClassNames() {
        var reactStarsClass = 'react-stars';
        setClassNames(props.classNames + (' ' + reactStarsClass));
    }

    function isDecimal(value) {
        return value % 1 === 0;
    }

    function getRate() {
        return config.isHalf ? Math.floor(currentValue) : Math.round(currentValue);
    }

    function getStars(activeCount) {
        if (typeof activeCount === 'undefined') {
            activeCount = getRate();
        }

        var stars = [];
        for (var i = 0; i < config.count; i++) {
            stars.push({
                active: i <= activeCount - 1
            });
        }
        return stars;
    }

    function mouseOver(event) {
        if (!config.edit) return;

        var index = Number(event.currentTarget.getAttribute('data-index'));

        if (config.isHalf) {
            var isAtHalf = moreThanHalf(event);
            setHalfStarHidden(isAtHalf);
            if (isAtHalf) index += 1;
            setHalfStarAt(index);
        } else {
            index += 1;
        }

        updateStars(index);
    }

    function updateStars(index) {
        var currentActive = stars.filter(function (x) {
            return x.active;
        });
        if (index !== currentActive.length) {
            setStars(getStars(index));
        }
    }

    function moreThanHalf(event) {
        var target = event.target;

        var boundingClientRect = target.getBoundingClientRect();
        var mouseAt = event.clientX - boundingClientRect.left;
        mouseAt = Math.round(Math.abs(mouseAt));

        return mouseAt > boundingClientRect.width / 2;
    }

    function mouseLeave() {
        if (!config.edit) return;

        updateHalfStarValues(currentValue);
        setStars(getStars());
    }

    function updateHalfStarValues(value) {
        if (config.isHalf) {
            setHalfStarHidden(isDecimal(value));
            setHalfStarAt(Math.floor(value));
        }
    }

    function onClick(event) {
        if (!config.edit) return;

        var index = Number(event.currentTarget.getAttribute('data-index'));
        var value = void 0;
        if (config.isHalf) {
            var isAtHalf = moreThanHalf(event);
            setHalfStarHidden(isAtHalf);
            if (isAtHalf) index += 1;
            value = isAtHalf ? index : index + 0.5;
            setHalfStarAt(index);
        } else {
            value = index = index + 1;
        }

        currentValueUpdated(value);
    }

    function renderHalfStarStyleElement() {
        return _react2.default.createElement('style', { dangerouslySetInnerHTML: {
                __html: isUsingIcons ? getHalfStarStyleForIcons(config.activeColor) : getHalfStarStyles(config.activeColor, uniqueness)
            } });
    }

    function currentValueUpdated(value) {
        if (value !== currentValue) {
            setStars(getStars(value));
            setCurrentValue(value);
            props.onChange(value);
        }
    }

    function handleKeyDown(event) {
        if (!config.a11y && !config.edit) return;

        var key = event.key;

        var value = currentValue;

        var keyNumber = Number(key); // e.g. "1" => 1, "ArrowUp" => NaN
        if (keyNumber) {
            if (Number.isInteger(keyNumber) && keyNumber > 0 && keyNumber <= config.count) {
                value = keyNumber;
            }
        } else {
            if ((key === "ArrowUp" || key === "ArrowRight") && value < config.count) {
                event.preventDefault();

                value += config.isHalf ? 0.5 : 1;
            } else if ((key === "ArrowDown" || key === "ArrowLeft") && value > 0.5) {
                event.preventDefault();
                value -= config.isHalf ? 0.5 : 1;
            }
        }

        updateHalfStarValues(value);

        currentValueUpdated(value);
    }

    function renderStars() {
        return stars.map(function (star, i) {
            return _react2.default.createElement(_star2.default, {
                key: i,
                index: i,
                active: star.active,
                config: config,
                onMouseOver: mouseOver,
                onMouseLeave: mouseLeave,
                onClick: onClick,
                halfStarHidden: halfStarHidden,
                halfStarAt: halfStarAt,
                isUsingIcons: isUsingIcons,
                uniqueness: uniqueness
            });
        });
    }

    return _react2.default.createElement(
        'div',
        { className: 'react-stars-wrapper-' + uniqueness,
            style: { display: 'flex' } },
        _react2.default.createElement(
            'div',
            { tabIndex: config.a11y && config.edit ? 0 : null,
                'aria-label': 'add rating by typing an integer from 0 to 5 or pressing arrow keys',
                onKeyDown: handleKeyDown,
                className: classNames,
                style: parentStyles },
            config.isHalf && renderHalfStarStyleElement(),
            renderStars(),
            _react2.default.createElement(
                'p',
                { style: { position: 'absolute', left: '-200rem' }, role: 'status' },
                currentValue
            )
        )
    );
}

ReactStars.propTypes = {
    classNames: _propTypes2.default.string,
    edit: _propTypes2.default.bool,
    half: _propTypes2.default.bool,
    value: _propTypes2.default.number,
    count: _propTypes2.default.number,
    char: _propTypes2.default.string,
    size: _propTypes2.default.number,
    color: _propTypes2.default.string,
    activeColor: _propTypes2.default.string,
    emptyIcon: _propTypes2.default.element,
    halfIcon: _propTypes2.default.element,
    filledIcon: _propTypes2.default.element,
    a11y: _propTypes2.default.bool
};

ReactStars.defaultProps = {
    edit: true,
    half: false,
    value: 0,
    count: 5,
    char: '★',
    size: 15,
    color: 'gray',
    activeColor: '#ffd700',
    a11y: true,

    onChange: function onChange() {}
};

exports.Z = ReactStars;

/***/ }),

/***/ 47719:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = Star;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyles = {
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    display: "block",
    float: "left"
};

function Star(props) {
    var index = props.index,
        active = props.active,
        config = props.config,
        onMouseOver = props.onMouseOver,
        onMouseLeave = props.onMouseLeave,
        onClick = props.onClick,
        halfStarHidden = props.halfStarHidden,
        halfStarAt = props.halfStarAt,
        isUsingIcons = props.isUsingIcons,
        uniqueness = props.uniqueness;
    var color = config.color,
        activeColor = config.activeColor,
        size = config.size,
        char = config.char,
        isHalf = config.isHalf,
        edit = config.edit,
        halfIcon = config.halfIcon,
        emptyIcon = config.emptyIcon,
        filledIcon = config.filledIcon;


    var starClass = '';
    var half = false;

    if (isHalf && !halfStarHidden && halfStarAt === index) {
        if (!isUsingIcons) starClass = "react-stars-" + uniqueness;else starClass = 'react-stars-half';
        half = true;
    }

    var style = _extends({}, defaultStyles, {
        color: active ? activeColor : color,
        cursor: edit ? 'pointer' : 'default',
        fontSize: size + "px"
    });

    function renderIcon() {
        if (!isUsingIcons) {
            return char;
        } else {
            if (active) {
                return filledIcon;
            } else if (!active && half) {
                return halfIcon;
            } else {
                return emptyIcon;
            }
        }
    }

    return _react2.default.createElement(
        "span",
        {
            className: starClass,
            style: style,
            key: index,
            "data-index": index,
            "data-forhalf": filledIcon ? index : char,
            onMouseOver: onMouseOver,
            onMouseMove: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick },
        renderIcon()
    );
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6956,8388,9990,212,7997,1023,8338,6664,8580,6379,4814,6576,7856,9228,1207,8673,7229,9819,6076,1305,9871,9252,4369,3896,3973,274,7563,5684,9774,2888,179], function() { return __webpack_exec__(73276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);